import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  UnsignedInt: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  UUIDv4: { input: string; output: string; }
  UUID: { input: string; output: string; }
  NonEmptyTrimmedString: { input: string; output: string; }
  NonEmptyString: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
};

export type Query = {
  __typename?: 'query';
  /** Retrieves one "Advertisement", throws an error if it does not exist */
  advertisement: Advertisement;
  /** Gets the number of "Advertisements" */
  advertisementCount: Scalars['UnsignedInt']['output'];
  /** Either the "Advertisement" exists or not? */
  advertisementExists: Scalars['Boolean']['output'];
  /** Retrieves one "Advertisement" if it exists, returns null otherwise */
  advertisementIfExists?: Maybe<Advertisement>;
  /** Retrieves a list of "Advertisements" */
  advertisements: Array<Advertisement>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "Advertisements" in the same order, throws an error if one does not exist
   */
  advertisementsInOrder: Array<Advertisement>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Advertisements", or null, in the same order */
  advertisementsInOrderIfExists: Array<Maybe<Advertisement>>;
  /** Retrieves one "AdvertisementVersion", throws an error if it does not exist */
  advertisementVersion: AdvertisementVersion;
  /** Gets the number of "AdvertisementVersions" */
  advertisementVersionCount: Scalars['UnsignedInt']['output'];
  /** Either the "AdvertisementVersion" exists or not? */
  advertisementVersionExists: Scalars['Boolean']['output'];
  /** Retrieves one "AdvertisementVersion" if it exists, returns null otherwise */
  advertisementVersionIfExists?: Maybe<AdvertisementVersion>;
  /** Retrieves a list of "AdvertisementVersions" */
  advertisementVersions: Array<AdvertisementVersion>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "AdvertisementVersions" in the same order, throws an error if one does not exist
   */
  advertisementVersionsInOrder: Array<AdvertisementVersion>;
  /** Given a list of unique-filter's value, retrieves the corresponding "AdvertisementVersions", or null, in the same order */
  advertisementVersionsInOrderIfExists: Array<Maybe<AdvertisementVersion>>;
  /** Retrieves one "ArticleTemplate", throws an error if it does not exist */
  articleTemplate: ArticleTemplate;
  /** Gets the number of "ArticleTemplates" */
  articleTemplateCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleTemplate" exists or not? */
  articleTemplateExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleTemplate" if it exists, returns null otherwise */
  articleTemplateIfExists?: Maybe<ArticleTemplate>;
  /** Retrieves a list of "ArticleTemplates" */
  articleTemplates: Array<ArticleTemplate>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleTemplates" in the same order, throws an error if one does not exist
   */
  articleTemplatesInOrder: Array<ArticleTemplate>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleTemplates", or null, in the same order */
  articleTemplatesInOrderIfExists: Array<Maybe<ArticleTemplate>>;
  /** Retrieves one "Assignment", throws an error if it does not exist */
  assignment: Assignment;
  /** Gets the number of "Assignments" */
  assignmentCount: Scalars['UnsignedInt']['output'];
  /** Either the "Assignment" exists or not? */
  assignmentExists: Scalars['Boolean']['output'];
  /** Retrieves one "Assignment" if it exists, returns null otherwise */
  assignmentIfExists?: Maybe<Assignment>;
  /** Retrieves a list of "Assignments" */
  assignments: Array<Assignment>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "Assignments" in the same order, throws an error if one does not exist
   */
  assignmentsInOrder: Array<Assignment>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Assignments", or null, in the same order */
  assignmentsInOrderIfExists: Array<Maybe<Assignment>>;
  /** Retrieves one "Attachment", throws an error if it does not exist */
  attachment: Attachment;
  /** Gets the number of "Attachments" */
  attachmentCount: Scalars['UnsignedInt']['output'];
  /** Either the "Attachment" exists or not? */
  attachmentExists: Scalars['Boolean']['output'];
  /** Retrieves one "Attachment" if it exists, returns null otherwise */
  attachmentIfExists?: Maybe<Attachment>;
  /** Retrieves a list of "Attachments" */
  attachments: Array<Attachment>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "Attachments" in the same order, throws an error if one does not exist
   */
  attachmentsInOrder: Array<Attachment>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Attachments", or null, in the same order */
  attachmentsInOrderIfExists: Array<Maybe<Attachment>>;
  /** Retrieves one "Brand", throws an error if it does not exist */
  brand: Brand;
  /** Gets the number of "Brands" */
  brandCount: Scalars['UnsignedInt']['output'];
  /** Either the "Brand" exists or not? */
  brandExists: Scalars['Boolean']['output'];
  /** Retrieves one "Brand" if it exists, returns null otherwise */
  brandIfExists?: Maybe<Brand>;
  /** Retrieves a list of "Brands" */
  brands: Array<Brand>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Brands" in
   * the same order, throws an error if one does not exist
   */
  brandsInOrder: Array<Brand>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Brands", or null, in the same order */
  brandsInOrderIfExists: Array<Maybe<Brand>>;
  /** Retrieves one "CenshareTrace", throws an error if it does not exist */
  censhareTrace: CenshareTrace;
  /** Gets the number of "CenshareTraces" */
  censhareTraceCount: Scalars['UnsignedInt']['output'];
  /** Either the "CenshareTrace" exists or not? */
  censhareTraceExists: Scalars['Boolean']['output'];
  /** Retrieves one "CenshareTrace" if it exists, returns null otherwise */
  censhareTraceIfExists?: Maybe<CenshareTrace>;
  /** Retrieves a list of "CenshareTraces" */
  censhareTraces: Array<CenshareTrace>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "CenshareTraces" in the same order, throws an error if one does not exist
   */
  censhareTracesInOrder: Array<CenshareTrace>;
  /** Given a list of unique-filter's value, retrieves the corresponding "CenshareTraces", or null, in the same order */
  censhareTracesInOrderIfExists: Array<Maybe<CenshareTrace>>;
  /** Retrieves one "File", throws an error if it does not exist */
  file: File;
  /** Gets the number of "Files" */
  fileCount: Scalars['UnsignedInt']['output'];
  /** Either the "File" exists or not? */
  fileExists: Scalars['Boolean']['output'];
  /** Retrieves one "File" if it exists, returns null otherwise */
  fileIfExists?: Maybe<File>;
  /** Retrieves a list of "Files" */
  files: Array<File>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Files" in
   * the same order, throws an error if one does not exist
   */
  filesInOrder: Array<File>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Files", or null, in the same order */
  filesInOrderIfExists: Array<Maybe<File>>;
  /** Retrieves one "FileVersion", throws an error if it does not exist */
  fileVersion: FileVersion;
  /** Gets the number of "FileVersions" */
  fileVersionCount: Scalars['UnsignedInt']['output'];
  /** Either the "FileVersion" exists or not? */
  fileVersionExists: Scalars['Boolean']['output'];
  /** Retrieves one "FileVersion" if it exists, returns null otherwise */
  fileVersionIfExists?: Maybe<FileVersion>;
  /** Retrieves a list of "FileVersions" */
  fileVersions: Array<FileVersion>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "FileVersions" in the same order, throws an error if one does not exist
   */
  fileVersionsInOrder: Array<FileVersion>;
  /** Given a list of unique-filter's value, retrieves the corresponding "FileVersions", or null, in the same order */
  fileVersionsInOrderIfExists: Array<Maybe<FileVersion>>;
  /** Retrieves one "FlatAssignment", throws an error if it does not exist */
  flatAssignment: FlatAssignment;
  /** Gets the number of "FlatAssignments" */
  flatAssignmentCount: Scalars['UnsignedInt']['output'];
  /** Either the "FlatAssignment" exists or not? */
  flatAssignmentExists: Scalars['Boolean']['output'];
  /** Retrieves one "FlatAssignment" if it exists, returns null otherwise */
  flatAssignmentIfExists?: Maybe<FlatAssignment>;
  /** Retrieves a list of "FlatAssignments" */
  flatAssignments: Array<FlatAssignment>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "FlatAssignments" in the same order, throws an error if one does not exist
   */
  flatAssignmentsInOrder: Array<FlatAssignment>;
  /** Given a list of unique-filter's value, retrieves the corresponding "FlatAssignments", or null, in the same order */
  flatAssignmentsInOrderIfExists: Array<Maybe<FlatAssignment>>;
  /** get Censhare railroad content */
  getCenshareRailroad: CenshareRailroadResultType;
  /** get Censhare railroad content */
  getCenshareRailroadByName?: Maybe<CenshareRailroadByNameResultType>;
  /** generate print Template drafts */
  getElisaPdf: PdfPreviewResultType;
  /** Retrieves one "Layout", throws an error if it does not exist */
  layout: Layout;
  /** Retrieves one "LayoutAsset", throws an error if it does not exist */
  layoutAsset: LayoutAsset;
  /** Gets the number of "LayoutAssets" */
  layoutAssetCount: Scalars['UnsignedInt']['output'];
  /** Either the "LayoutAsset" exists or not? */
  layoutAssetExists: Scalars['Boolean']['output'];
  /** Retrieves one "LayoutAsset" if it exists, returns null otherwise */
  layoutAssetIfExists?: Maybe<LayoutAsset>;
  /** Retrieves a list of "LayoutAssets" */
  layoutAssets: Array<LayoutAsset>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "LayoutAssets" in the same order, throws an error if one does not exist
   */
  layoutAssetsInOrder: Array<LayoutAsset>;
  /** Given a list of unique-filter's value, retrieves the corresponding "LayoutAssets", or null, in the same order */
  layoutAssetsInOrderIfExists: Array<Maybe<LayoutAsset>>;
  /** Gets the number of "Layouts" */
  layoutCount: Scalars['UnsignedInt']['output'];
  /** Either the "Layout" exists or not? */
  layoutExists: Scalars['Boolean']['output'];
  /** Retrieves one "Layout" if it exists, returns null otherwise */
  layoutIfExists?: Maybe<Layout>;
  /** Retrieves a list of "Layouts" */
  layouts: Array<Layout>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Layouts"
   * in the same order, throws an error if one does not exist
   */
  layoutsInOrder: Array<Layout>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Layouts", or null, in the same order */
  layoutsInOrderIfExists: Array<Maybe<Layout>>;
  /** Retrieves one "Mockup", throws an error if it does not exist */
  mockup: Mockup;
  /** Gets the number of "Mockups" */
  mockupCount: Scalars['UnsignedInt']['output'];
  /** Either the "Mockup" exists or not? */
  mockupExists: Scalars['Boolean']['output'];
  /** Retrieves one "Mockup" if it exists, returns null otherwise */
  mockupIfExists?: Maybe<Mockup>;
  /** Retrieves a list of "Mockups" */
  mockups: Array<Mockup>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Mockups"
   * in the same order, throws an error if one does not exist
   */
  mockupsInOrder: Array<Mockup>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Mockups", or null, in the same order */
  mockupsInOrderIfExists: Array<Maybe<Mockup>>;
  /** Retrieves one "MockupVersion", throws an error if it does not exist */
  mockupVersion: MockupVersion;
  /** Gets the number of "MockupVersions" */
  mockupVersionCount: Scalars['UnsignedInt']['output'];
  /** Either the "MockupVersion" exists or not? */
  mockupVersionExists: Scalars['Boolean']['output'];
  /** Retrieves one "MockupVersion" if it exists, returns null otherwise */
  mockupVersionIfExists?: Maybe<MockupVersion>;
  /** Retrieves a list of "MockupVersions" */
  mockupVersions: Array<MockupVersion>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "MockupVersions" in the same order, throws an error if one does not exist
   */
  mockupVersionsInOrder: Array<MockupVersion>;
  /** Given a list of unique-filter's value, retrieves the corresponding "MockupVersions", or null, in the same order */
  mockupVersionsInOrderIfExists: Array<Maybe<MockupVersion>>;
  /** Retrieves one "PrintHeading", throws an error if it does not exist */
  printHeading: PrintHeading;
  /** Gets the number of "PrintHeadings" */
  printHeadingCount: Scalars['UnsignedInt']['output'];
  /** Either the "PrintHeading" exists or not? */
  printHeadingExists: Scalars['Boolean']['output'];
  /** Retrieves one "PrintHeading" if it exists, returns null otherwise */
  printHeadingIfExists?: Maybe<PrintHeading>;
  /** Retrieves one "PrintHeadingPrintTemplate", throws an error if it does not exist */
  printHeadingPrintTemplate: PrintHeadingPrintTemplate;
  /** Gets the number of "PrintHeadingPrintTemplates" */
  printHeadingPrintTemplateCount: Scalars['UnsignedInt']['output'];
  /** Either the "PrintHeadingPrintTemplate" exists or not? */
  printHeadingPrintTemplateExists: Scalars['Boolean']['output'];
  /** Retrieves one "PrintHeadingPrintTemplate" if it exists, returns null otherwise */
  printHeadingPrintTemplateIfExists?: Maybe<PrintHeadingPrintTemplate>;
  /** Retrieves a list of "PrintHeadingPrintTemplates" */
  printHeadingPrintTemplates: Array<PrintHeadingPrintTemplate>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "PrintHeadingPrintTemplates" in the same order, throws an error if one does not exist
   */
  printHeadingPrintTemplatesInOrder: Array<PrintHeadingPrintTemplate>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "PrintHeadingPrintTemplates", or null, in the same order
   */
  printHeadingPrintTemplatesInOrderIfExists: Array<Maybe<PrintHeadingPrintTemplate>>;
  /** Retrieves a list of "PrintHeadings" */
  printHeadings: Array<PrintHeading>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "PrintHeadings" in the same order, throws an error if one does not exist
   */
  printHeadingsInOrder: Array<PrintHeading>;
  /** Given a list of unique-filter's value, retrieves the corresponding "PrintHeadings", or null, in the same order */
  printHeadingsInOrderIfExists: Array<Maybe<PrintHeading>>;
  /** Retrieves one "PrintIssue", throws an error if it does not exist */
  printIssue: PrintIssue;
  /** Gets the number of "PrintIssues" */
  printIssueCount: Scalars['UnsignedInt']['output'];
  /** Either the "PrintIssue" exists or not? */
  printIssueExists: Scalars['Boolean']['output'];
  /** Retrieves one "PrintIssue" if it exists, returns null otherwise */
  printIssueIfExists?: Maybe<PrintIssue>;
  /** Retrieves one "PrintIssueRailroad", throws an error if it does not exist */
  printIssueRailroad: PrintIssueRailroad;
  /** Gets the number of "PrintIssueRailroads" */
  printIssueRailroadCount: Scalars['UnsignedInt']['output'];
  /** Either the "PrintIssueRailroad" exists or not? */
  printIssueRailroadExists: Scalars['Boolean']['output'];
  /** Retrieves one "PrintIssueRailroad" if it exists, returns null otherwise */
  printIssueRailroadIfExists?: Maybe<PrintIssueRailroad>;
  /** Retrieves a list of "PrintIssueRailroads" */
  printIssueRailroads: Array<PrintIssueRailroad>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "PrintIssueRailroads" in the same order, throws an error if one does not exist
   */
  printIssueRailroadsInOrder: Array<PrintIssueRailroad>;
  /** Given a list of unique-filter's value, retrieves the corresponding "PrintIssueRailroads", or null, in the same order */
  printIssueRailroadsInOrderIfExists: Array<Maybe<PrintIssueRailroad>>;
  /** Retrieves a list of "PrintIssues" */
  printIssues: Array<PrintIssue>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "PrintIssues" in the same order, throws an error if one does not exist
   */
  printIssuesInOrder: Array<PrintIssue>;
  /** Given a list of unique-filter's value, retrieves the corresponding "PrintIssues", or null, in the same order */
  printIssuesInOrderIfExists: Array<Maybe<PrintIssue>>;
  /** Retrieves one "PrintPublication", throws an error if it does not exist */
  printPublication: PrintPublication;
  /** Gets the number of "PrintPublications" */
  printPublicationCount: Scalars['UnsignedInt']['output'];
  /** Either the "PrintPublication" exists or not? */
  printPublicationExists: Scalars['Boolean']['output'];
  /** Retrieves one "PrintPublication" if it exists, returns null otherwise */
  printPublicationIfExists?: Maybe<PrintPublication>;
  /** Retrieves a list of "PrintPublications" */
  printPublications: Array<PrintPublication>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "PrintPublications" in the same order, throws an error if one does not exist
   */
  printPublicationsInOrder: Array<PrintPublication>;
  /** Given a list of unique-filter's value, retrieves the corresponding "PrintPublications", or null, in the same order */
  printPublicationsInOrderIfExists: Array<Maybe<PrintPublication>>;
  /** Retrieves one "PrintTemplate", throws an error if it does not exist */
  printTemplate: PrintTemplate;
  /** Gets the number of "PrintTemplates" */
  printTemplateCount: Scalars['UnsignedInt']['output'];
  /** print Template download signed url */
  printTemplateDownload: PrintTemplateDownloadResultType;
  /** generate print Template drafts */
  printTemplateDrafts: PrintTemplateDraftsResultType;
  /** Either the "PrintTemplate" exists or not? */
  printTemplateExists: Scalars['Boolean']['output'];
  /** Retrieves one "PrintTemplate" if it exists, returns null otherwise */
  printTemplateIfExists?: Maybe<PrintTemplate>;
  /** print Template preview signed urls */
  printTemplatePreviewUrls: Array<Scalars['String']['output']>;
  /** Retrieves a list of "PrintTemplates" */
  printTemplates: Array<PrintTemplate>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "PrintTemplates" in the same order, throws an error if one does not exist
   */
  printTemplatesInOrder: Array<PrintTemplate>;
  /** Given a list of unique-filter's value, retrieves the corresponding "PrintTemplates", or null, in the same order */
  printTemplatesInOrderIfExists: Array<Maybe<PrintTemplate>>;
  /** print Template upload signed url */
  printTemplateUpload: PrintTemplateUploadResultType;
  /** Retrieves one "RailroadPage", throws an error if it does not exist */
  railroadPage: RailroadPage;
  /** Gets the number of "RailroadPages" */
  railroadPageCount: Scalars['UnsignedInt']['output'];
  /** Either the "RailroadPage" exists or not? */
  railroadPageExists: Scalars['Boolean']['output'];
  /** Retrieves one "RailroadPage" if it exists, returns null otherwise */
  railroadPageIfExists?: Maybe<RailroadPage>;
  /** Retrieves a list of "RailroadPages" */
  railroadPages: Array<RailroadPage>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "RailroadPages" in the same order, throws an error if one does not exist
   */
  railroadPagesInOrder: Array<RailroadPage>;
  /** Given a list of unique-filter's value, retrieves the corresponding "RailroadPages", or null, in the same order */
  railroadPagesInOrderIfExists: Array<Maybe<RailroadPage>>;
  /** Retrieves one "RawArticle", throws an error if it does not exist */
  rawArticle: RawArticle;
  /** Gets the number of "RawArticles" */
  rawArticleCount: Scalars['UnsignedInt']['output'];
  /** Either the "RawArticle" exists or not? */
  rawArticleExists: Scalars['Boolean']['output'];
  /** Retrieves one "RawArticle" if it exists, returns null otherwise */
  rawArticleIfExists?: Maybe<RawArticle>;
  /** Retrieves a list of "RawArticles" */
  rawArticles: Array<RawArticle>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "RawArticles" in the same order, throws an error if one does not exist
   */
  rawArticlesInOrder: Array<RawArticle>;
  /** Given a list of unique-filter's value, retrieves the corresponding "RawArticles", or null, in the same order */
  rawArticlesInOrderIfExists: Array<Maybe<RawArticle>>;
  /** Retrieves one "RawArticleVersion", throws an error if it does not exist */
  rawArticleVersion: RawArticleVersion;
  /** Gets the number of "RawArticleVersions" */
  rawArticleVersionCount: Scalars['UnsignedInt']['output'];
  /** Either the "RawArticleVersion" exists or not? */
  rawArticleVersionExists: Scalars['Boolean']['output'];
  /** Retrieves one "RawArticleVersion" if it exists, returns null otherwise */
  rawArticleVersionIfExists?: Maybe<RawArticleVersion>;
  /** Retrieves a list of "RawArticleVersions" */
  rawArticleVersions: Array<RawArticleVersion>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "RawArticleVersions" in the same order, throws an error if one does not exist
   */
  rawArticleVersionsInOrder: Array<RawArticleVersion>;
  /** Given a list of unique-filter's value, retrieves the corresponding "RawArticleVersions", or null, in the same order */
  rawArticleVersionsInOrderIfExists: Array<Maybe<RawArticleVersion>>;
  /** Retrieves one "Subject", throws an error if it does not exist */
  subject: Subject;
  /** Retrieves a list of "SubjectCategories" */
  subjectCategories: Array<SubjectCategory>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "SubjectCategories" in the same order, throws an error if one does not exist
   */
  subjectCategoriesInOrder: Array<SubjectCategory>;
  /** Given a list of unique-filter's value, retrieves the corresponding "SubjectCategories", or null, in the same order */
  subjectCategoriesInOrderIfExists: Array<Maybe<SubjectCategory>>;
  /** Retrieves one "SubjectCategory", throws an error if it does not exist */
  subjectCategory: SubjectCategory;
  /** Gets the number of "SubjectCategories" */
  subjectCategoryCount: Scalars['UnsignedInt']['output'];
  /** Either the "SubjectCategory" exists or not? */
  subjectCategoryExists: Scalars['Boolean']['output'];
  /** Retrieves one "SubjectCategory" if it exists, returns null otherwise */
  subjectCategoryIfExists?: Maybe<SubjectCategory>;
  /** Gets the number of "Subjects" */
  subjectCount: Scalars['UnsignedInt']['output'];
  /** Either the "Subject" exists or not? */
  subjectExists: Scalars['Boolean']['output'];
  /** Retrieves one "Subject" if it exists, returns null otherwise */
  subjectIfExists?: Maybe<Subject>;
  /** Retrieves a list of "Subjects" */
  subjects: Array<Subject>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Subjects"
   * in the same order, throws an error if one does not exist
   */
  subjectsInOrder: Array<Subject>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Subjects", or null, in the same order */
  subjectsInOrderIfExists: Array<Maybe<Subject>>;
  /** Retrieves one "SubjectUser", throws an error if it does not exist */
  subjectUser: SubjectUser;
  /** Gets the number of "SubjectUsers" */
  subjectUserCount: Scalars['UnsignedInt']['output'];
  /** Either the "SubjectUser" exists or not? */
  subjectUserExists: Scalars['Boolean']['output'];
  /** Retrieves one "SubjectUser" if it exists, returns null otherwise */
  subjectUserIfExists?: Maybe<SubjectUser>;
  /** Retrieves a list of "SubjectUsers" */
  subjectUsers: Array<SubjectUser>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "SubjectUsers" in the same order, throws an error if one does not exist
   */
  subjectUsersInOrder: Array<SubjectUser>;
  /** Given a list of unique-filter's value, retrieves the corresponding "SubjectUsers", or null, in the same order */
  subjectUsersInOrderIfExists: Array<Maybe<SubjectUser>>;
  /** Retrieves one "SubSubject", throws an error if it does not exist */
  subSubject: SubSubject;
  /** Gets the number of "SubSubjects" */
  subSubjectCount: Scalars['UnsignedInt']['output'];
  /** Either the "SubSubject" exists or not? */
  subSubjectExists: Scalars['Boolean']['output'];
  /** Retrieves one "SubSubject" if it exists, returns null otherwise */
  subSubjectIfExists?: Maybe<SubSubject>;
  /** Retrieves a list of "SubSubjects" */
  subSubjects: Array<SubSubject>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "SubSubjects" in the same order, throws an error if one does not exist
   */
  subSubjectsInOrder: Array<SubSubject>;
  /** Given a list of unique-filter's value, retrieves the corresponding "SubSubjects", or null, in the same order */
  subSubjectsInOrderIfExists: Array<Maybe<SubSubject>>;
  /** Retrieves one "TopicFotowebPige", throws an error if it does not exist */
  topicFotowebPige: TopicFotowebPige;
  /** Gets the number of "TopicFotowebPiges" */
  topicFotowebPigeCount: Scalars['UnsignedInt']['output'];
  /** Either the "TopicFotowebPige" exists or not? */
  topicFotowebPigeExists: Scalars['Boolean']['output'];
  /** Retrieves one "TopicFotowebPige" if it exists, returns null otherwise */
  topicFotowebPigeIfExists?: Maybe<TopicFotowebPige>;
  /** Retrieves a list of "TopicFotowebPiges" */
  topicFotowebPiges: Array<TopicFotowebPige>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "TopicFotowebPiges" in the same order, throws an error if one does not exist
   */
  topicFotowebPigesInOrder: Array<TopicFotowebPige>;
  /** Given a list of unique-filter's value, retrieves the corresponding "TopicFotowebPiges", or null, in the same order */
  topicFotowebPigesInOrderIfExists: Array<Maybe<TopicFotowebPige>>;
  /** Retrieves one "Unit", throws an error if it does not exist */
  unit: Unit;
  /** Gets the number of "Units" */
  unitCount: Scalars['UnsignedInt']['output'];
  /** Either the "Unit" exists or not? */
  unitExists: Scalars['Boolean']['output'];
  /** Retrieves one "Unit" if it exists, returns null otherwise */
  unitIfExists?: Maybe<Unit>;
  /** Retrieves a list of "Units" */
  units: Array<Unit>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Units" in
   * the same order, throws an error if one does not exist
   */
  unitsInOrder: Array<Unit>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Units", or null, in the same order */
  unitsInOrderIfExists: Array<Maybe<Unit>>;
  /** Retrieves one "Website", throws an error if it does not exist */
  website: Website;
  /** Gets the number of "Websites" */
  websiteCount: Scalars['UnsignedInt']['output'];
  /** Either the "Website" exists or not? */
  websiteExists: Scalars['Boolean']['output'];
  /** Retrieves one "Website" if it exists, returns null otherwise */
  websiteIfExists?: Maybe<Website>;
  /** Retrieves a list of "Websites" */
  websites: Array<Website>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Websites"
   * in the same order, throws an error if one does not exist
   */
  websitesInOrder: Array<Website>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Websites", or null, in the same order */
  websitesInOrderIfExists: Array<Maybe<Website>>;
};


export type QueryAdvertisementArgs = {
  subset?: InputMaybe<AdvertisementFilterInput>;
  where: AdvertisementUniqueFilterInput;
};


export type QueryAdvertisementCountArgs = {
  where?: InputMaybe<AdvertisementFilterInput>;
};


export type QueryAdvertisementExistsArgs = {
  subset?: InputMaybe<AdvertisementFilterInput>;
  where: AdvertisementUniqueFilterInput;
};


export type QueryAdvertisementIfExistsArgs = {
  subset?: InputMaybe<AdvertisementFilterInput>;
  where: AdvertisementUniqueFilterInput;
};


export type QueryAdvertisementsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AdvertisementOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AdvertisementFilterInput>;
};


export type QueryAdvertisementsInOrderArgs = {
  subset?: InputMaybe<AdvertisementFilterInput>;
  where: Array<AdvertisementUniqueFilterInput>;
};


export type QueryAdvertisementsInOrderIfExistsArgs = {
  subset?: InputMaybe<AdvertisementFilterInput>;
  where: Array<AdvertisementUniqueFilterInput>;
};


export type QueryAdvertisementVersionArgs = {
  subset?: InputMaybe<AdvertisementVersionFilterInput>;
  where: AdvertisementVersionUniqueFilterInput;
};


export type QueryAdvertisementVersionCountArgs = {
  where?: InputMaybe<AdvertisementVersionFilterInput>;
};


export type QueryAdvertisementVersionExistsArgs = {
  subset?: InputMaybe<AdvertisementVersionFilterInput>;
  where: AdvertisementVersionUniqueFilterInput;
};


export type QueryAdvertisementVersionIfExistsArgs = {
  subset?: InputMaybe<AdvertisementVersionFilterInput>;
  where: AdvertisementVersionUniqueFilterInput;
};


export type QueryAdvertisementVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AdvertisementVersionOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AdvertisementVersionFilterInput>;
};


export type QueryAdvertisementVersionsInOrderArgs = {
  subset?: InputMaybe<AdvertisementVersionFilterInput>;
  where: Array<AdvertisementVersionUniqueFilterInput>;
};


export type QueryAdvertisementVersionsInOrderIfExistsArgs = {
  subset?: InputMaybe<AdvertisementVersionFilterInput>;
  where: Array<AdvertisementVersionUniqueFilterInput>;
};


export type QueryArticleTemplateArgs = {
  subset?: InputMaybe<ArticleTemplateFilterInput>;
  where: ArticleTemplateUniqueFilterInput;
};


export type QueryArticleTemplateCountArgs = {
  where?: InputMaybe<ArticleTemplateFilterInput>;
};


export type QueryArticleTemplateExistsArgs = {
  subset?: InputMaybe<ArticleTemplateFilterInput>;
  where: ArticleTemplateUniqueFilterInput;
};


export type QueryArticleTemplateIfExistsArgs = {
  subset?: InputMaybe<ArticleTemplateFilterInput>;
  where: ArticleTemplateUniqueFilterInput;
};


export type QueryArticleTemplatesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTemplateOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleTemplateFilterInput>;
};


export type QueryArticleTemplatesInOrderArgs = {
  subset?: InputMaybe<ArticleTemplateFilterInput>;
  where: Array<ArticleTemplateUniqueFilterInput>;
};


export type QueryArticleTemplatesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleTemplateFilterInput>;
  where: Array<ArticleTemplateUniqueFilterInput>;
};


export type QueryAssignmentArgs = {
  subset?: InputMaybe<AssignmentFilterInput>;
  where: AssignmentUniqueFilterInput;
};


export type QueryAssignmentCountArgs = {
  where?: InputMaybe<AssignmentFilterInput>;
};


export type QueryAssignmentExistsArgs = {
  subset?: InputMaybe<AssignmentFilterInput>;
  where: AssignmentUniqueFilterInput;
};


export type QueryAssignmentIfExistsArgs = {
  subset?: InputMaybe<AssignmentFilterInput>;
  where: AssignmentUniqueFilterInput;
};


export type QueryAssignmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AssignmentFilterInput>;
};


export type QueryAssignmentsInOrderArgs = {
  subset?: InputMaybe<AssignmentFilterInput>;
  where: Array<AssignmentUniqueFilterInput>;
};


export type QueryAssignmentsInOrderIfExistsArgs = {
  subset?: InputMaybe<AssignmentFilterInput>;
  where: Array<AssignmentUniqueFilterInput>;
};


export type QueryAttachmentArgs = {
  subset?: InputMaybe<AttachmentFilterInput>;
  where: AttachmentUniqueFilterInput;
};


export type QueryAttachmentCountArgs = {
  where?: InputMaybe<AttachmentFilterInput>;
};


export type QueryAttachmentExistsArgs = {
  subset?: InputMaybe<AttachmentFilterInput>;
  where: AttachmentUniqueFilterInput;
};


export type QueryAttachmentIfExistsArgs = {
  subset?: InputMaybe<AttachmentFilterInput>;
  where: AttachmentUniqueFilterInput;
};


export type QueryAttachmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AttachmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AttachmentFilterInput>;
};


export type QueryAttachmentsInOrderArgs = {
  subset?: InputMaybe<AttachmentFilterInput>;
  where: Array<AttachmentUniqueFilterInput>;
};


export type QueryAttachmentsInOrderIfExistsArgs = {
  subset?: InputMaybe<AttachmentFilterInput>;
  where: Array<AttachmentUniqueFilterInput>;
};


export type QueryBrandArgs = {
  subset?: InputMaybe<BrandFilterInput>;
  where: BrandUniqueFilterInput;
};


export type QueryBrandCountArgs = {
  where?: InputMaybe<BrandFilterInput>;
};


export type QueryBrandExistsArgs = {
  subset?: InputMaybe<BrandFilterInput>;
  where: BrandUniqueFilterInput;
};


export type QueryBrandIfExistsArgs = {
  subset?: InputMaybe<BrandFilterInput>;
  where: BrandUniqueFilterInput;
};


export type QueryBrandsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<BrandOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<BrandFilterInput>;
};


export type QueryBrandsInOrderArgs = {
  subset?: InputMaybe<BrandFilterInput>;
  where: Array<BrandUniqueFilterInput>;
};


export type QueryBrandsInOrderIfExistsArgs = {
  subset?: InputMaybe<BrandFilterInput>;
  where: Array<BrandUniqueFilterInput>;
};


export type QueryCenshareTraceArgs = {
  subset?: InputMaybe<CenshareTraceFilterInput>;
  where: CenshareTraceUniqueFilterInput;
};


export type QueryCenshareTraceCountArgs = {
  where?: InputMaybe<CenshareTraceFilterInput>;
};


export type QueryCenshareTraceExistsArgs = {
  subset?: InputMaybe<CenshareTraceFilterInput>;
  where: CenshareTraceUniqueFilterInput;
};


export type QueryCenshareTraceIfExistsArgs = {
  subset?: InputMaybe<CenshareTraceFilterInput>;
  where: CenshareTraceUniqueFilterInput;
};


export type QueryCenshareTracesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CenshareTraceOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CenshareTraceFilterInput>;
};


export type QueryCenshareTracesInOrderArgs = {
  subset?: InputMaybe<CenshareTraceFilterInput>;
  where: Array<CenshareTraceUniqueFilterInput>;
};


export type QueryCenshareTracesInOrderIfExistsArgs = {
  subset?: InputMaybe<CenshareTraceFilterInput>;
  where: Array<CenshareTraceUniqueFilterInput>;
};


export type QueryFileArgs = {
  subset?: InputMaybe<FileFilterInput>;
  where: FileUniqueFilterInput;
};


export type QueryFileCountArgs = {
  where?: InputMaybe<FileFilterInput>;
};


export type QueryFileExistsArgs = {
  subset?: InputMaybe<FileFilterInput>;
  where: FileUniqueFilterInput;
};


export type QueryFileIfExistsArgs = {
  subset?: InputMaybe<FileFilterInput>;
  where: FileUniqueFilterInput;
};


export type QueryFilesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FileOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FileFilterInput>;
};


export type QueryFilesInOrderArgs = {
  subset?: InputMaybe<FileFilterInput>;
  where: Array<FileUniqueFilterInput>;
};


export type QueryFilesInOrderIfExistsArgs = {
  subset?: InputMaybe<FileFilterInput>;
  where: Array<FileUniqueFilterInput>;
};


export type QueryFileVersionArgs = {
  subset?: InputMaybe<FileVersionFilterInput>;
  where: FileVersionUniqueFilterInput;
};


export type QueryFileVersionCountArgs = {
  where?: InputMaybe<FileVersionFilterInput>;
};


export type QueryFileVersionExistsArgs = {
  subset?: InputMaybe<FileVersionFilterInput>;
  where: FileVersionUniqueFilterInput;
};


export type QueryFileVersionIfExistsArgs = {
  subset?: InputMaybe<FileVersionFilterInput>;
  where: FileVersionUniqueFilterInput;
};


export type QueryFileVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FileVersionOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FileVersionFilterInput>;
};


export type QueryFileVersionsInOrderArgs = {
  subset?: InputMaybe<FileVersionFilterInput>;
  where: Array<FileVersionUniqueFilterInput>;
};


export type QueryFileVersionsInOrderIfExistsArgs = {
  subset?: InputMaybe<FileVersionFilterInput>;
  where: Array<FileVersionUniqueFilterInput>;
};


export type QueryFlatAssignmentArgs = {
  subset?: InputMaybe<FlatAssignmentFilterInput>;
  where: FlatAssignmentUniqueFilterInput;
};


export type QueryFlatAssignmentCountArgs = {
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


export type QueryFlatAssignmentExistsArgs = {
  subset?: InputMaybe<FlatAssignmentFilterInput>;
  where: FlatAssignmentUniqueFilterInput;
};


export type QueryFlatAssignmentIfExistsArgs = {
  subset?: InputMaybe<FlatAssignmentFilterInput>;
  where: FlatAssignmentUniqueFilterInput;
};


export type QueryFlatAssignmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FlatAssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


export type QueryFlatAssignmentsInOrderArgs = {
  subset?: InputMaybe<FlatAssignmentFilterInput>;
  where: Array<FlatAssignmentUniqueFilterInput>;
};


export type QueryFlatAssignmentsInOrderIfExistsArgs = {
  subset?: InputMaybe<FlatAssignmentFilterInput>;
  where: Array<FlatAssignmentUniqueFilterInput>;
};


export type QueryGetCenshareRailroadArgs = {
  brandKey: Scalars['String']['input'];
  issue: Scalars['String']['input'];
};


export type QueryGetCenshareRailroadByNameArgs = {
  brandKey: Scalars['String']['input'];
  issue: Scalars['String']['input'];
};


export type QueryGetElisaPdfArgs = {
  brandKey: Scalars['String']['input'];
  issue: Scalars['Int']['input'];
};


export type QueryLayoutArgs = {
  subset?: InputMaybe<LayoutFilterInput>;
  where: LayoutUniqueFilterInput;
};


export type QueryLayoutAssetArgs = {
  subset?: InputMaybe<LayoutAssetFilterInput>;
  where: LayoutAssetUniqueFilterInput;
};


export type QueryLayoutAssetCountArgs = {
  where?: InputMaybe<LayoutAssetFilterInput>;
};


export type QueryLayoutAssetExistsArgs = {
  subset?: InputMaybe<LayoutAssetFilterInput>;
  where: LayoutAssetUniqueFilterInput;
};


export type QueryLayoutAssetIfExistsArgs = {
  subset?: InputMaybe<LayoutAssetFilterInput>;
  where: LayoutAssetUniqueFilterInput;
};


export type QueryLayoutAssetsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutAssetOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};


export type QueryLayoutAssetsInOrderArgs = {
  subset?: InputMaybe<LayoutAssetFilterInput>;
  where: Array<LayoutAssetUniqueFilterInput>;
};


export type QueryLayoutAssetsInOrderIfExistsArgs = {
  subset?: InputMaybe<LayoutAssetFilterInput>;
  where: Array<LayoutAssetUniqueFilterInput>;
};


export type QueryLayoutCountArgs = {
  where?: InputMaybe<LayoutFilterInput>;
};


export type QueryLayoutExistsArgs = {
  subset?: InputMaybe<LayoutFilterInput>;
  where: LayoutUniqueFilterInput;
};


export type QueryLayoutIfExistsArgs = {
  subset?: InputMaybe<LayoutFilterInput>;
  where: LayoutUniqueFilterInput;
};


export type QueryLayoutsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LayoutFilterInput>;
};


export type QueryLayoutsInOrderArgs = {
  subset?: InputMaybe<LayoutFilterInput>;
  where: Array<LayoutUniqueFilterInput>;
};


export type QueryLayoutsInOrderIfExistsArgs = {
  subset?: InputMaybe<LayoutFilterInput>;
  where: Array<LayoutUniqueFilterInput>;
};


export type QueryMockupArgs = {
  subset?: InputMaybe<MockupFilterInput>;
  where: MockupUniqueFilterInput;
};


export type QueryMockupCountArgs = {
  where?: InputMaybe<MockupFilterInput>;
};


export type QueryMockupExistsArgs = {
  subset?: InputMaybe<MockupFilterInput>;
  where: MockupUniqueFilterInput;
};


export type QueryMockupIfExistsArgs = {
  subset?: InputMaybe<MockupFilterInput>;
  where: MockupUniqueFilterInput;
};


export type QueryMockupsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MockupOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<MockupFilterInput>;
};


export type QueryMockupsInOrderArgs = {
  subset?: InputMaybe<MockupFilterInput>;
  where: Array<MockupUniqueFilterInput>;
};


export type QueryMockupsInOrderIfExistsArgs = {
  subset?: InputMaybe<MockupFilterInput>;
  where: Array<MockupUniqueFilterInput>;
};


export type QueryMockupVersionArgs = {
  subset?: InputMaybe<MockupVersionFilterInput>;
  where: MockupVersionUniqueFilterInput;
};


export type QueryMockupVersionCountArgs = {
  where?: InputMaybe<MockupVersionFilterInput>;
};


export type QueryMockupVersionExistsArgs = {
  subset?: InputMaybe<MockupVersionFilterInput>;
  where: MockupVersionUniqueFilterInput;
};


export type QueryMockupVersionIfExistsArgs = {
  subset?: InputMaybe<MockupVersionFilterInput>;
  where: MockupVersionUniqueFilterInput;
};


export type QueryMockupVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MockupVersionOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<MockupVersionFilterInput>;
};


export type QueryMockupVersionsInOrderArgs = {
  subset?: InputMaybe<MockupVersionFilterInput>;
  where: Array<MockupVersionUniqueFilterInput>;
};


export type QueryMockupVersionsInOrderIfExistsArgs = {
  subset?: InputMaybe<MockupVersionFilterInput>;
  where: Array<MockupVersionUniqueFilterInput>;
};


export type QueryPrintHeadingArgs = {
  subset?: InputMaybe<PrintHeadingFilterInput>;
  where: PrintHeadingUniqueFilterInput;
};


export type QueryPrintHeadingCountArgs = {
  where?: InputMaybe<PrintHeadingFilterInput>;
};


export type QueryPrintHeadingExistsArgs = {
  subset?: InputMaybe<PrintHeadingFilterInput>;
  where: PrintHeadingUniqueFilterInput;
};


export type QueryPrintHeadingIfExistsArgs = {
  subset?: InputMaybe<PrintHeadingFilterInput>;
  where: PrintHeadingUniqueFilterInput;
};


export type QueryPrintHeadingPrintTemplateArgs = {
  subset?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  where: PrintHeadingPrintTemplateUniqueFilterInput;
};


export type QueryPrintHeadingPrintTemplateCountArgs = {
  where?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
};


export type QueryPrintHeadingPrintTemplateExistsArgs = {
  subset?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  where: PrintHeadingPrintTemplateUniqueFilterInput;
};


export type QueryPrintHeadingPrintTemplateIfExistsArgs = {
  subset?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  where: PrintHeadingPrintTemplateUniqueFilterInput;
};


export type QueryPrintHeadingPrintTemplatesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintHeadingPrintTemplateOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
};


export type QueryPrintHeadingPrintTemplatesInOrderArgs = {
  subset?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  where: Array<PrintHeadingPrintTemplateUniqueFilterInput>;
};


export type QueryPrintHeadingPrintTemplatesInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  where: Array<PrintHeadingPrintTemplateUniqueFilterInput>;
};


export type QueryPrintHeadingsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintHeadingOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintHeadingFilterInput>;
};


export type QueryPrintHeadingsInOrderArgs = {
  subset?: InputMaybe<PrintHeadingFilterInput>;
  where: Array<PrintHeadingUniqueFilterInput>;
};


export type QueryPrintHeadingsInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintHeadingFilterInput>;
  where: Array<PrintHeadingUniqueFilterInput>;
};


export type QueryPrintIssueArgs = {
  subset?: InputMaybe<PrintIssueFilterInput>;
  where: PrintIssueUniqueFilterInput;
};


export type QueryPrintIssueCountArgs = {
  where?: InputMaybe<PrintIssueFilterInput>;
};


export type QueryPrintIssueExistsArgs = {
  subset?: InputMaybe<PrintIssueFilterInput>;
  where: PrintIssueUniqueFilterInput;
};


export type QueryPrintIssueIfExistsArgs = {
  subset?: InputMaybe<PrintIssueFilterInput>;
  where: PrintIssueUniqueFilterInput;
};


export type QueryPrintIssueRailroadArgs = {
  subset?: InputMaybe<PrintIssueRailroadFilterInput>;
  where: PrintIssueRailroadUniqueFilterInput;
};


export type QueryPrintIssueRailroadCountArgs = {
  where?: InputMaybe<PrintIssueRailroadFilterInput>;
};


export type QueryPrintIssueRailroadExistsArgs = {
  subset?: InputMaybe<PrintIssueRailroadFilterInput>;
  where: PrintIssueRailroadUniqueFilterInput;
};


export type QueryPrintIssueRailroadIfExistsArgs = {
  subset?: InputMaybe<PrintIssueRailroadFilterInput>;
  where: PrintIssueRailroadUniqueFilterInput;
};


export type QueryPrintIssueRailroadsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintIssueRailroadOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintIssueRailroadFilterInput>;
};


export type QueryPrintIssueRailroadsInOrderArgs = {
  subset?: InputMaybe<PrintIssueRailroadFilterInput>;
  where: Array<PrintIssueRailroadUniqueFilterInput>;
};


export type QueryPrintIssueRailroadsInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintIssueRailroadFilterInput>;
  where: Array<PrintIssueRailroadUniqueFilterInput>;
};


export type QueryPrintIssuesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintIssueOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintIssueFilterInput>;
};


export type QueryPrintIssuesInOrderArgs = {
  subset?: InputMaybe<PrintIssueFilterInput>;
  where: Array<PrintIssueUniqueFilterInput>;
};


export type QueryPrintIssuesInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintIssueFilterInput>;
  where: Array<PrintIssueUniqueFilterInput>;
};


export type QueryPrintPublicationArgs = {
  subset?: InputMaybe<PrintPublicationFilterInput>;
  where: PrintPublicationUniqueFilterInput;
};


export type QueryPrintPublicationCountArgs = {
  where?: InputMaybe<PrintPublicationFilterInput>;
};


export type QueryPrintPublicationExistsArgs = {
  subset?: InputMaybe<PrintPublicationFilterInput>;
  where: PrintPublicationUniqueFilterInput;
};


export type QueryPrintPublicationIfExistsArgs = {
  subset?: InputMaybe<PrintPublicationFilterInput>;
  where: PrintPublicationUniqueFilterInput;
};


export type QueryPrintPublicationsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintPublicationOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintPublicationFilterInput>;
};


export type QueryPrintPublicationsInOrderArgs = {
  subset?: InputMaybe<PrintPublicationFilterInput>;
  where: Array<PrintPublicationUniqueFilterInput>;
};


export type QueryPrintPublicationsInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintPublicationFilterInput>;
  where: Array<PrintPublicationUniqueFilterInput>;
};


export type QueryPrintTemplateArgs = {
  subset?: InputMaybe<PrintTemplateFilterInput>;
  where: PrintTemplateUniqueFilterInput;
};


export type QueryPrintTemplateCountArgs = {
  where?: InputMaybe<PrintTemplateFilterInput>;
};


export type QueryPrintTemplateDownloadArgs = {
  printTemplateId: Scalars['String']['input'];
};


export type QueryPrintTemplateDraftsArgs = {
  embedRessources?: InputMaybe<Scalars['Boolean']['input']>;
  fieldsData?: InputMaybe<Array<InputMaybe<PrintTemplateDraftFieldsDataType>>>;
  format: PrintTemplateDraftFormatType;
  pages?: InputMaybe<Array<Scalars['Int']['input']>>;
  printHeadingId: Scalars['String']['input'];
  printTemplateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPrintTemplateExistsArgs = {
  subset?: InputMaybe<PrintTemplateFilterInput>;
  where: PrintTemplateUniqueFilterInput;
};


export type QueryPrintTemplateIfExistsArgs = {
  subset?: InputMaybe<PrintTemplateFilterInput>;
  where: PrintTemplateUniqueFilterInput;
};


export type QueryPrintTemplatePreviewUrlsArgs = {
  printTemplateId: Scalars['String']['input'];
};


export type QueryPrintTemplatesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintTemplateOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintTemplateFilterInput>;
};


export type QueryPrintTemplatesInOrderArgs = {
  subset?: InputMaybe<PrintTemplateFilterInput>;
  where: Array<PrintTemplateUniqueFilterInput>;
};


export type QueryPrintTemplatesInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintTemplateFilterInput>;
  where: Array<PrintTemplateUniqueFilterInput>;
};


export type QueryPrintTemplateUploadArgs = {
  filename: Scalars['String']['input'];
  S3ObjectId: Scalars['String']['input'];
};


export type QueryRailroadPageArgs = {
  subset?: InputMaybe<RailroadPageFilterInput>;
  where: RailroadPageUniqueFilterInput;
};


export type QueryRailroadPageCountArgs = {
  where?: InputMaybe<RailroadPageFilterInput>;
};


export type QueryRailroadPageExistsArgs = {
  subset?: InputMaybe<RailroadPageFilterInput>;
  where: RailroadPageUniqueFilterInput;
};


export type QueryRailroadPageIfExistsArgs = {
  subset?: InputMaybe<RailroadPageFilterInput>;
  where: RailroadPageUniqueFilterInput;
};


export type QueryRailroadPagesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RailroadPageOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<RailroadPageFilterInput>;
};


export type QueryRailroadPagesInOrderArgs = {
  subset?: InputMaybe<RailroadPageFilterInput>;
  where: Array<RailroadPageUniqueFilterInput>;
};


export type QueryRailroadPagesInOrderIfExistsArgs = {
  subset?: InputMaybe<RailroadPageFilterInput>;
  where: Array<RailroadPageUniqueFilterInput>;
};


export type QueryRawArticleArgs = {
  subset?: InputMaybe<RawArticleFilterInput>;
  where: RawArticleUniqueFilterInput;
};


export type QueryRawArticleCountArgs = {
  where?: InputMaybe<RawArticleFilterInput>;
};


export type QueryRawArticleExistsArgs = {
  subset?: InputMaybe<RawArticleFilterInput>;
  where: RawArticleUniqueFilterInput;
};


export type QueryRawArticleIfExistsArgs = {
  subset?: InputMaybe<RawArticleFilterInput>;
  where: RawArticleUniqueFilterInput;
};


export type QueryRawArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RawArticleOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<RawArticleFilterInput>;
};


export type QueryRawArticlesInOrderArgs = {
  subset?: InputMaybe<RawArticleFilterInput>;
  where: Array<RawArticleUniqueFilterInput>;
};


export type QueryRawArticlesInOrderIfExistsArgs = {
  subset?: InputMaybe<RawArticleFilterInput>;
  where: Array<RawArticleUniqueFilterInput>;
};


export type QueryRawArticleVersionArgs = {
  subset?: InputMaybe<RawArticleVersionFilterInput>;
  where: RawArticleVersionUniqueFilterInput;
};


export type QueryRawArticleVersionCountArgs = {
  where?: InputMaybe<RawArticleVersionFilterInput>;
};


export type QueryRawArticleVersionExistsArgs = {
  subset?: InputMaybe<RawArticleVersionFilterInput>;
  where: RawArticleVersionUniqueFilterInput;
};


export type QueryRawArticleVersionIfExistsArgs = {
  subset?: InputMaybe<RawArticleVersionFilterInput>;
  where: RawArticleVersionUniqueFilterInput;
};


export type QueryRawArticleVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RawArticleVersionOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<RawArticleVersionFilterInput>;
};


export type QueryRawArticleVersionsInOrderArgs = {
  subset?: InputMaybe<RawArticleVersionFilterInput>;
  where: Array<RawArticleVersionUniqueFilterInput>;
};


export type QueryRawArticleVersionsInOrderIfExistsArgs = {
  subset?: InputMaybe<RawArticleVersionFilterInput>;
  where: Array<RawArticleVersionUniqueFilterInput>;
};


export type QuerySubjectArgs = {
  subset?: InputMaybe<SubjectFilterInput>;
  where: SubjectUniqueFilterInput;
};


export type QuerySubjectCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectCategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SubjectCategoryFilterInput>;
};


export type QuerySubjectCategoriesInOrderArgs = {
  subset?: InputMaybe<SubjectCategoryFilterInput>;
  where: Array<SubjectCategoryUniqueFilterInput>;
};


export type QuerySubjectCategoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<SubjectCategoryFilterInput>;
  where: Array<SubjectCategoryUniqueFilterInput>;
};


export type QuerySubjectCategoryArgs = {
  subset?: InputMaybe<SubjectCategoryFilterInput>;
  where: SubjectCategoryUniqueFilterInput;
};


export type QuerySubjectCategoryCountArgs = {
  where?: InputMaybe<SubjectCategoryFilterInput>;
};


export type QuerySubjectCategoryExistsArgs = {
  subset?: InputMaybe<SubjectCategoryFilterInput>;
  where: SubjectCategoryUniqueFilterInput;
};


export type QuerySubjectCategoryIfExistsArgs = {
  subset?: InputMaybe<SubjectCategoryFilterInput>;
  where: SubjectCategoryUniqueFilterInput;
};


export type QuerySubjectCountArgs = {
  where?: InputMaybe<SubjectFilterInput>;
};


export type QuerySubjectExistsArgs = {
  subset?: InputMaybe<SubjectFilterInput>;
  where: SubjectUniqueFilterInput;
};


export type QuerySubjectIfExistsArgs = {
  subset?: InputMaybe<SubjectFilterInput>;
  where: SubjectUniqueFilterInput;
};


export type QuerySubjectsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SubjectFilterInput>;
};


export type QuerySubjectsInOrderArgs = {
  subset?: InputMaybe<SubjectFilterInput>;
  where: Array<SubjectUniqueFilterInput>;
};


export type QuerySubjectsInOrderIfExistsArgs = {
  subset?: InputMaybe<SubjectFilterInput>;
  where: Array<SubjectUniqueFilterInput>;
};


export type QuerySubjectUserArgs = {
  subset?: InputMaybe<SubjectUserFilterInput>;
  where: SubjectUserUniqueFilterInput;
};


export type QuerySubjectUserCountArgs = {
  where?: InputMaybe<SubjectUserFilterInput>;
};


export type QuerySubjectUserExistsArgs = {
  subset?: InputMaybe<SubjectUserFilterInput>;
  where: SubjectUserUniqueFilterInput;
};


export type QuerySubjectUserIfExistsArgs = {
  subset?: InputMaybe<SubjectUserFilterInput>;
  where: SubjectUserUniqueFilterInput;
};


export type QuerySubjectUsersArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectUserOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SubjectUserFilterInput>;
};


export type QuerySubjectUsersInOrderArgs = {
  subset?: InputMaybe<SubjectUserFilterInput>;
  where: Array<SubjectUserUniqueFilterInput>;
};


export type QuerySubjectUsersInOrderIfExistsArgs = {
  subset?: InputMaybe<SubjectUserFilterInput>;
  where: Array<SubjectUserUniqueFilterInput>;
};


export type QuerySubSubjectArgs = {
  subset?: InputMaybe<SubSubjectFilterInput>;
  where: SubSubjectUniqueFilterInput;
};


export type QuerySubSubjectCountArgs = {
  where?: InputMaybe<SubSubjectFilterInput>;
};


export type QuerySubSubjectExistsArgs = {
  subset?: InputMaybe<SubSubjectFilterInput>;
  where: SubSubjectUniqueFilterInput;
};


export type QuerySubSubjectIfExistsArgs = {
  subset?: InputMaybe<SubSubjectFilterInput>;
  where: SubSubjectUniqueFilterInput;
};


export type QuerySubSubjectsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubSubjectOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SubSubjectFilterInput>;
};


export type QuerySubSubjectsInOrderArgs = {
  subset?: InputMaybe<SubSubjectFilterInput>;
  where: Array<SubSubjectUniqueFilterInput>;
};


export type QuerySubSubjectsInOrderIfExistsArgs = {
  subset?: InputMaybe<SubSubjectFilterInput>;
  where: Array<SubSubjectUniqueFilterInput>;
};


export type QueryTopicFotowebPigeArgs = {
  subset?: InputMaybe<TopicFotowebPigeFilterInput>;
  where: TopicFotowebPigeUniqueFilterInput;
};


export type QueryTopicFotowebPigeCountArgs = {
  where?: InputMaybe<TopicFotowebPigeFilterInput>;
};


export type QueryTopicFotowebPigeExistsArgs = {
  subset?: InputMaybe<TopicFotowebPigeFilterInput>;
  where: TopicFotowebPigeUniqueFilterInput;
};


export type QueryTopicFotowebPigeIfExistsArgs = {
  subset?: InputMaybe<TopicFotowebPigeFilterInput>;
  where: TopicFotowebPigeUniqueFilterInput;
};


export type QueryTopicFotowebPigesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TopicFotowebPigeOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<TopicFotowebPigeFilterInput>;
};


export type QueryTopicFotowebPigesInOrderArgs = {
  subset?: InputMaybe<TopicFotowebPigeFilterInput>;
  where: Array<TopicFotowebPigeUniqueFilterInput>;
};


export type QueryTopicFotowebPigesInOrderIfExistsArgs = {
  subset?: InputMaybe<TopicFotowebPigeFilterInput>;
  where: Array<TopicFotowebPigeUniqueFilterInput>;
};


export type QueryUnitArgs = {
  subset?: InputMaybe<UnitFilterInput>;
  where: UnitUniqueFilterInput;
};


export type QueryUnitCountArgs = {
  where?: InputMaybe<UnitFilterInput>;
};


export type QueryUnitExistsArgs = {
  subset?: InputMaybe<UnitFilterInput>;
  where: UnitUniqueFilterInput;
};


export type QueryUnitIfExistsArgs = {
  subset?: InputMaybe<UnitFilterInput>;
  where: UnitUniqueFilterInput;
};


export type QueryUnitsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<UnitOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<UnitFilterInput>;
};


export type QueryUnitsInOrderArgs = {
  subset?: InputMaybe<UnitFilterInput>;
  where: Array<UnitUniqueFilterInput>;
};


export type QueryUnitsInOrderIfExistsArgs = {
  subset?: InputMaybe<UnitFilterInput>;
  where: Array<UnitUniqueFilterInput>;
};


export type QueryWebsiteArgs = {
  subset?: InputMaybe<WebsiteFilterInput>;
  where: WebsiteUniqueFilterInput;
};


export type QueryWebsiteCountArgs = {
  where?: InputMaybe<WebsiteFilterInput>;
};


export type QueryWebsiteExistsArgs = {
  subset?: InputMaybe<WebsiteFilterInput>;
  where: WebsiteUniqueFilterInput;
};


export type QueryWebsiteIfExistsArgs = {
  subset?: InputMaybe<WebsiteFilterInput>;
  where: WebsiteUniqueFilterInput;
};


export type QueryWebsitesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<WebsiteOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<WebsiteFilterInput>;
};


export type QueryWebsitesInOrderArgs = {
  subset?: InputMaybe<WebsiteFilterInput>;
  where: Array<WebsiteUniqueFilterInput>;
};


export type QueryWebsitesInOrderIfExistsArgs = {
  subset?: InputMaybe<WebsiteFilterInput>;
  where: Array<WebsiteUniqueFilterInput>;
};

/** The "Advertisement" nodes' filter */
export type AdvertisementFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<AdvertisementFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  layoutAssetCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssets_every?: InputMaybe<LayoutAssetFilterInput>;
  layoutAssets_none?: InputMaybe<LayoutAssetFilterInput>;
  layoutAssets_some?: InputMaybe<LayoutAssetFilterInput>;
  NOT?: InputMaybe<AdvertisementFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<AdvertisementFilterInput>>>;
  printIssue?: InputMaybe<PrintIssueFilterInput>;
  printIssue_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printIssue_not?: InputMaybe<PrintIssueFilterInput>;
  printPublication?: InputMaybe<PrintPublicationFilterInput>;
  printPublication_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printPublication_not?: InputMaybe<PrintPublicationFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  versionCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versions_every?: InputMaybe<AdvertisementVersionFilterInput>;
  versions_none?: InputMaybe<AdvertisementVersionFilterInput>;
  versions_some?: InputMaybe<AdvertisementVersionFilterInput>;
};

/** The "LayoutAsset" nodes' filter */
export type LayoutAssetFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  advertisement?: InputMaybe<AdvertisementFilterInput>;
  advertisement_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  advertisement_not?: InputMaybe<AdvertisementFilterInput>;
  AND?: InputMaybe<Array<InputMaybe<LayoutAssetFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  file?: InputMaybe<FileFilterInput>;
  file_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  file_not?: InputMaybe<FileFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  layout?: InputMaybe<LayoutFilterInput>;
  layout_not?: InputMaybe<LayoutFilterInput>;
  mockup?: InputMaybe<MockupFilterInput>;
  mockup_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  mockup_not?: InputMaybe<MockupFilterInput>;
  NOT?: InputMaybe<LayoutAssetFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<LayoutAssetFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  printHeading?: InputMaybe<PrintHeadingFilterInput>;
  printHeading_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printHeading_not?: InputMaybe<PrintHeadingFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "File" nodes' filter */
export type FileFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<FileFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  layoutAssetCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssets_every?: InputMaybe<LayoutAssetFilterInput>;
  layoutAssets_none?: InputMaybe<LayoutAssetFilterInput>;
  layoutAssets_some?: InputMaybe<LayoutAssetFilterInput>;
  NOT?: InputMaybe<FileFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<FileFilterInput>>>;
  printIssue?: InputMaybe<PrintIssueFilterInput>;
  printIssue_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printIssue_not?: InputMaybe<PrintIssueFilterInput>;
  printPublication?: InputMaybe<PrintPublicationFilterInput>;
  printPublication_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printPublication_not?: InputMaybe<PrintPublicationFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  versionCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versions_every?: InputMaybe<FileVersionFilterInput>;
  versions_none?: InputMaybe<FileVersionFilterInput>;
  versions_some?: InputMaybe<FileVersionFilterInput>;
};

/** The "PrintIssue" nodes' filter */
export type PrintIssueFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  advertisementCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisementCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisementCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisementCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisementCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisementCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisements_every?: InputMaybe<AdvertisementFilterInput>;
  advertisements_none?: InputMaybe<AdvertisementFilterInput>;
  advertisements_some?: InputMaybe<AdvertisementFilterInput>;
  AND?: InputMaybe<Array<InputMaybe<PrintIssueFilterInput>>>;
  assignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments_every?: InputMaybe<AssignmentFilterInput>;
  assignments_none?: InputMaybe<AssignmentFilterInput>;
  assignments_some?: InputMaybe<AssignmentFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  fileCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  files_every?: InputMaybe<FileFilterInput>;
  files_none?: InputMaybe<FileFilterInput>;
  files_some?: InputMaybe<FileFilterInput>;
  flatAssignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignments_every?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_none?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_some?: InputMaybe<FlatAssignmentFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  layoutCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layouts_every?: InputMaybe<LayoutFilterInput>;
  layouts_none?: InputMaybe<LayoutFilterInput>;
  layouts_some?: InputMaybe<LayoutFilterInput>;
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  legacyId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  mockupCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockupCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockupCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockupCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockupCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockupCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockups_every?: InputMaybe<MockupFilterInput>;
  mockups_none?: InputMaybe<MockupFilterInput>;
  mockups_some?: InputMaybe<MockupFilterInput>;
  NOT?: InputMaybe<PrintIssueFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<PrintIssueFilterInput>>>;
  printHeadingCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadings_every?: InputMaybe<PrintHeadingFilterInput>;
  printHeadings_none?: InputMaybe<PrintHeadingFilterInput>;
  printHeadings_some?: InputMaybe<PrintHeadingFilterInput>;
  printIssueRailroad?: InputMaybe<PrintIssueRailroadFilterInput>;
  printIssueRailroad_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printIssueRailroad_not?: InputMaybe<PrintIssueRailroadFilterInput>;
  printPublication?: InputMaybe<PrintPublicationFilterInput>;
  printPublication_not?: InputMaybe<PrintPublicationFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "Assignment" nodes' filter */
export type AssignmentFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<AssignmentFilterInput>>>;
  articleTemplate?: InputMaybe<ArticleTemplateFilterInput>;
  articleTemplate_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  articleTemplate_not?: InputMaybe<ArticleTemplateFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  flatAssignment?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignment_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  flatAssignment_not?: InputMaybe<FlatAssignmentFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  legacyId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  mediaSearchStatus_in?: InputMaybe<Array<MediaSearchStatus>>;
  mediaSearchStatus_not?: InputMaybe<MediaSearchStatus>;
  mediaSearchStatus_not_in?: InputMaybe<Array<MediaSearchStatus>>;
  NOT?: InputMaybe<AssignmentFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<AssignmentFilterInput>>>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageNumber_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageNumber_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageNumber_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  pageNumber_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageNumber_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageNumber_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  printHeading?: InputMaybe<PrintHeadingFilterInput>;
  printHeading_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printHeading_not?: InputMaybe<PrintHeadingFilterInput>;
  printIssue?: InputMaybe<PrintIssueFilterInput>;
  printIssue_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printIssue_not?: InputMaybe<PrintIssueFilterInput>;
  printPublication?: InputMaybe<PrintPublicationFilterInput>;
  printPublication_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printPublication_not?: InputMaybe<PrintPublicationFilterInput>;
  printTemplate?: InputMaybe<PrintTemplateFilterInput>;
  printTemplate_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printTemplate_not?: InputMaybe<PrintTemplateFilterInput>;
  rawArticle?: InputMaybe<RawArticleFilterInput>;
  rawArticle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  rawArticle_not?: InputMaybe<RawArticleFilterInput>;
  subject?: InputMaybe<SubjectFilterInput>;
  subject_not?: InputMaybe<SubjectFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  website?: InputMaybe<WebsiteFilterInput>;
  website_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  website_not?: InputMaybe<WebsiteFilterInput>;
};

/** The "ArticleTemplate" nodes' filter */
export type ArticleTemplateFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<ArticleTemplateFilterInput>>>;
  assignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments_every?: InputMaybe<AssignmentFilterInput>;
  assignments_none?: InputMaybe<AssignmentFilterInput>;
  assignments_some?: InputMaybe<AssignmentFilterInput>;
  block?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  block_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  block_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  block_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  block_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  block_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  block_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  block_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  block_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  block_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  block_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  label?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  label_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  label_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  label_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  label_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  label_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<ArticleTemplateFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleTemplateFilterInput>>>;
  printTemplate?: InputMaybe<PrintTemplateFilterInput>;
  printTemplate_not?: InputMaybe<PrintTemplateFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "PrintTemplate" nodes' filter */
export type PrintTemplateFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<PrintTemplateFilterInput>>>;
  articleTemplateCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplateCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplateCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplateCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplateCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplateCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplates_every?: InputMaybe<ArticleTemplateFilterInput>;
  articleTemplates_none?: InputMaybe<ArticleTemplateFilterInput>;
  articleTemplates_some?: InputMaybe<ArticleTemplateFilterInput>;
  assignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments_every?: InputMaybe<AssignmentFilterInput>;
  assignments_none?: InputMaybe<AssignmentFilterInput>;
  assignments_some?: InputMaybe<AssignmentFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  data?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  data_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  data_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  data_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  data_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  data_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  data_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  data_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  data_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  data_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  extVersion?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  extVersion_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  extVersion_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  extVersion_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  extVersion_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  extVersion_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  extVersion_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  extVersion_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  extVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  extVersion_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  extVersion_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  filename_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  filename_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  filename_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  filename_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filesize?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  filesize_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  filesize_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  flatAssignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignments_every?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_none?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_some?: InputMaybe<FlatAssignmentFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  label?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  label_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  label_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  label_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  label_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<PrintTemplateFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<PrintTemplateFilterInput>>>;
  pageCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  pageCount_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  pageCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  printHeadingCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadings_every?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  printHeadings_none?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  printHeadings_some?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  S3ObjectId?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  S3ObjectId_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  S3ObjectId_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  S3ObjectId_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  S3ObjectId_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  S3ObjectId_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  S3ObjectId_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  S3ObjectId_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  S3ObjectId_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  S3ObjectId_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<TemplateType>;
  type_in?: InputMaybe<Array<InputMaybe<TemplateType>>>;
  type_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  type_not?: InputMaybe<TemplateType>;
  type_not_in?: InputMaybe<Array<InputMaybe<TemplateType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "FlatAssignment" nodes' filter */
export type FlatAssignmentFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<FlatAssignmentFilterInput>>>;
  assignment?: InputMaybe<AssignmentFilterInput>;
  assignment_not?: InputMaybe<AssignmentFilterInput>;
  assignmentMediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  assignmentMediaSearchStatus_in?: InputMaybe<Array<MediaSearchStatus>>;
  assignmentMediaSearchStatus_not?: InputMaybe<MediaSearchStatus>;
  assignmentMediaSearchStatus_not_in?: InputMaybe<Array<MediaSearchStatus>>;
  assignmentPageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentPageNumber_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentPageNumber_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentPageNumber_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  assignmentPageNumber_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  assignmentPageNumber_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentPageNumber_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentPageNumber_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentPageNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  brand?: InputMaybe<BrandFilterInput>;
  brand_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  brand_not?: InputMaybe<BrandFilterInput>;
  location?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  location_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  location_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  location_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  location_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  location_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  location_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  location_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  location_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  location_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  NOT?: InputMaybe<FlatAssignmentFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<FlatAssignmentFilterInput>>>;
  printHeading?: InputMaybe<PrintHeadingFilterInput>;
  printHeading_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printHeading_not?: InputMaybe<PrintHeadingFilterInput>;
  printIssue?: InputMaybe<PrintIssueFilterInput>;
  printIssue_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printIssue_not?: InputMaybe<PrintIssueFilterInput>;
  printPublication?: InputMaybe<PrintPublicationFilterInput>;
  printPublication_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printPublication_not?: InputMaybe<PrintPublicationFilterInput>;
  printTemplate?: InputMaybe<PrintTemplateFilterInput>;
  printTemplate_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printTemplate_not?: InputMaybe<PrintTemplateFilterInput>;
  rawArticle?: InputMaybe<RawArticleFilterInput>;
  rawArticle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  rawArticle_not?: InputMaybe<RawArticleFilterInput>;
  subject?: InputMaybe<SubjectFilterInput>;
  subject_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  subject_not?: InputMaybe<SubjectFilterInput>;
  website?: InputMaybe<WebsiteFilterInput>;
  website_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  website_not?: InputMaybe<WebsiteFilterInput>;
};

export enum MediaSearchStatus {
  Ready = 'Ready',
  Sent = 'Sent',
  Started = 'Started',
  Waiting = 'Waiting'
}

/** The "Brand" nodes' filter */
export type BrandFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<BrandFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  flatAssignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignments_every?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_none?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_some?: InputMaybe<FlatAssignmentFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<BrandFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<BrandFilterInput>>>;
  printPublicationCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printPublicationCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printPublicationCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printPublicationCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printPublicationCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printPublicationCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printPublications_every?: InputMaybe<PrintPublicationFilterInput>;
  printPublications_none?: InputMaybe<PrintPublicationFilterInput>;
  printPublications_some?: InputMaybe<PrintPublicationFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  unit?: InputMaybe<UnitFilterInput>;
  unit_not?: InputMaybe<UnitFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  websiteCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  websiteCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  websiteCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  websiteCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  websiteCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  websiteCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  websites_every?: InputMaybe<WebsiteFilterInput>;
  websites_none?: InputMaybe<WebsiteFilterInput>;
  websites_some?: InputMaybe<WebsiteFilterInput>;
};

/** The "PrintPublication" nodes' filter */
export type PrintPublicationFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  advertisementCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisementCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisementCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisementCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisementCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisementCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisements_every?: InputMaybe<AdvertisementFilterInput>;
  advertisements_none?: InputMaybe<AdvertisementFilterInput>;
  advertisements_some?: InputMaybe<AdvertisementFilterInput>;
  AND?: InputMaybe<Array<InputMaybe<PrintPublicationFilterInput>>>;
  assignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments_every?: InputMaybe<AssignmentFilterInput>;
  assignments_none?: InputMaybe<AssignmentFilterInput>;
  assignments_some?: InputMaybe<AssignmentFilterInput>;
  brand?: InputMaybe<BrandFilterInput>;
  brand_not?: InputMaybe<BrandFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  fileCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  files_every?: InputMaybe<FileFilterInput>;
  files_none?: InputMaybe<FileFilterInput>;
  files_some?: InputMaybe<FileFilterInput>;
  flatAssignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignments_every?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_none?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_some?: InputMaybe<FlatAssignmentFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  key?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  key_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  key_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  key_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  key_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  key_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  key_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  key_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  key_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  key_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  layoutCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layouts_every?: InputMaybe<LayoutFilterInput>;
  layouts_none?: InputMaybe<LayoutFilterInput>;
  layouts_some?: InputMaybe<LayoutFilterInput>;
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  legacyId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  mockupCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockupCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockupCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockupCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockupCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockupCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockups_every?: InputMaybe<MockupFilterInput>;
  mockups_none?: InputMaybe<MockupFilterInput>;
  mockups_some?: InputMaybe<MockupFilterInput>;
  NOT?: InputMaybe<PrintPublicationFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<PrintPublicationFilterInput>>>;
  printHeadingCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadingCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadings_every?: InputMaybe<PrintHeadingFilterInput>;
  printHeadings_none?: InputMaybe<PrintHeadingFilterInput>;
  printHeadings_some?: InputMaybe<PrintHeadingFilterInput>;
  printIssueCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssueCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssueCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssueCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssueCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssueCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssues_every?: InputMaybe<PrintIssueFilterInput>;
  printIssues_none?: InputMaybe<PrintIssueFilterInput>;
  printIssues_some?: InputMaybe<PrintIssueFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "Layout" nodes' filter */
export type LayoutFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<LayoutFilterInput>>>;
  assetCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assetCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assetCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assetCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assetCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assetCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assets_every?: InputMaybe<LayoutAssetFilterInput>;
  assets_none?: InputMaybe<LayoutAssetFilterInput>;
  assets_some?: InputMaybe<LayoutAssetFilterInput>;
  childCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  children_every?: InputMaybe<LayoutFilterInput>;
  children_none?: InputMaybe<LayoutFilterInput>;
  children_some?: InputMaybe<LayoutFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<LayoutFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<LayoutFilterInput>>>;
  parent?: InputMaybe<LayoutFilterInput>;
  parent_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  parent_not?: InputMaybe<LayoutFilterInput>;
  printIssue?: InputMaybe<PrintIssueFilterInput>;
  printIssue_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printIssue_not?: InputMaybe<PrintIssueFilterInput>;
  printPublication?: InputMaybe<PrintPublicationFilterInput>;
  printPublication_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printPublication_not?: InputMaybe<PrintPublicationFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "Mockup" nodes' filter */
export type MockupFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<MockupFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  layoutAssetCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssets_every?: InputMaybe<LayoutAssetFilterInput>;
  layoutAssets_none?: InputMaybe<LayoutAssetFilterInput>;
  layoutAssets_some?: InputMaybe<LayoutAssetFilterInput>;
  NOT?: InputMaybe<MockupFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<MockupFilterInput>>>;
  printHeading?: InputMaybe<PrintHeadingFilterInput>;
  printHeading_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printHeading_not?: InputMaybe<PrintHeadingFilterInput>;
  printIssue?: InputMaybe<PrintIssueFilterInput>;
  printIssue_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printIssue_not?: InputMaybe<PrintIssueFilterInput>;
  printPublication?: InputMaybe<PrintPublicationFilterInput>;
  printPublication_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printPublication_not?: InputMaybe<PrintPublicationFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  versionCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versions_every?: InputMaybe<MockupVersionFilterInput>;
  versions_none?: InputMaybe<MockupVersionFilterInput>;
  versions_some?: InputMaybe<MockupVersionFilterInput>;
};

/** The "PrintHeading" nodes' filter */
export type PrintHeadingFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<PrintHeadingFilterInput>>>;
  assignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments_every?: InputMaybe<AssignmentFilterInput>;
  assignments_none?: InputMaybe<AssignmentFilterInput>;
  assignments_some?: InputMaybe<AssignmentFilterInput>;
  autoPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  autoPrototype_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  autoPrototype_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  autoPrototype_not?: InputMaybe<Scalars['Boolean']['input']>;
  autoPrototype_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  flatAssignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignments_every?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_none?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_some?: InputMaybe<FlatAssignmentFilterInput>;
  hasAutomaticSubject?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutomaticSubject_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  layoutAssetCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssetCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  layoutAssets_every?: InputMaybe<LayoutAssetFilterInput>;
  layoutAssets_none?: InputMaybe<LayoutAssetFilterInput>;
  layoutAssets_some?: InputMaybe<LayoutAssetFilterInput>;
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  legacyId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  mockup?: InputMaybe<MockupFilterInput>;
  mockup_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  mockup_not?: InputMaybe<MockupFilterInput>;
  NOT?: InputMaybe<PrintHeadingFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<PrintHeadingFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  printIssue?: InputMaybe<PrintIssueFilterInput>;
  printIssue_not?: InputMaybe<PrintIssueFilterInput>;
  printPublication?: InputMaybe<PrintPublicationFilterInput>;
  printPublication_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printPublication_not?: InputMaybe<PrintPublicationFilterInput>;
  printTemplateCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printTemplateCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printTemplateCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printTemplateCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printTemplateCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printTemplateCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printTemplates_every?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  printTemplates_none?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  printTemplates_some?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "PrintHeadingPrintTemplate" nodes' filter */
export type PrintHeadingPrintTemplateFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  AND?: InputMaybe<Array<InputMaybe<PrintHeadingPrintTemplateFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<PrintHeadingPrintTemplateFilterInput>>>;
  printHeading?: InputMaybe<PrintHeadingFilterInput>;
  printHeading_not?: InputMaybe<PrintHeadingFilterInput>;
  printTemplate?: InputMaybe<PrintTemplateFilterInput>;
  printTemplate_not?: InputMaybe<PrintTemplateFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "MockupVersion" nodes' filter */
export type MockupVersionFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<MockupVersionFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  mockup?: InputMaybe<MockupFilterInput>;
  mockup_not?: InputMaybe<MockupFilterInput>;
  nextVersion?: InputMaybe<MockupVersionFilterInput>;
  nextVersion_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  nextVersion_not?: InputMaybe<MockupVersionFilterInput>;
  NOT?: InputMaybe<MockupVersionFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<MockupVersionFilterInput>>>;
  path?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  path_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  path_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  path_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  previousVersion?: InputMaybe<MockupVersionFilterInput>;
  previousVersion_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  previousVersion_not?: InputMaybe<MockupVersionFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

/** The "Unit" nodes' filter */
export type UnitFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<UnitFilterInput>>>;
  brandCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brands_every?: InputMaybe<BrandFilterInput>;
  brands_none?: InputMaybe<BrandFilterInput>;
  brands_some?: InputMaybe<BrandFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<UnitFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<UnitFilterInput>>>;
  subjectCategories_every?: InputMaybe<SubjectCategoryFilterInput>;
  subjectCategories_none?: InputMaybe<SubjectCategoryFilterInput>;
  subjectCategories_some?: InputMaybe<SubjectCategoryFilterInput>;
  subjectCategoryCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCategoryCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCategoryCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCategoryCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCategoryCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCategoryCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjects_every?: InputMaybe<SubjectFilterInput>;
  subjects_none?: InputMaybe<SubjectFilterInput>;
  subjects_some?: InputMaybe<SubjectFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "SubjectCategory" nodes' filter */
export type SubjectCategoryFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<SubjectCategoryFilterInput>>>;
  childCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  children_every?: InputMaybe<SubjectCategoryFilterInput>;
  children_none?: InputMaybe<SubjectCategoryFilterInput>;
  children_some?: InputMaybe<SubjectCategoryFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  legacyId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  NOT?: InputMaybe<SubjectCategoryFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<SubjectCategoryFilterInput>>>;
  parent?: InputMaybe<SubjectCategoryFilterInput>;
  parent_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  parent_not?: InputMaybe<SubjectCategoryFilterInput>;
  subjectCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjects_every?: InputMaybe<SubjectFilterInput>;
  subjects_none?: InputMaybe<SubjectFilterInput>;
  subjects_some?: InputMaybe<SubjectFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  unit?: InputMaybe<UnitFilterInput>;
  unit_not?: InputMaybe<UnitFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "Subject" nodes' filter */
export type SubjectFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<SubjectFilterInput>>>;
  assignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments_every?: InputMaybe<AssignmentFilterInput>;
  assignments_none?: InputMaybe<AssignmentFilterInput>;
  assignments_some?: InputMaybe<AssignmentFilterInput>;
  attachmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attachmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attachmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attachmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attachmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attachmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attachments_every?: InputMaybe<AttachmentFilterInput>;
  attachments_none?: InputMaybe<AttachmentFilterInput>;
  attachments_some?: InputMaybe<AttachmentFilterInput>;
  comment?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  comment_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  comment_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  comment_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  comment_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  comment_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  flatAssignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignments_every?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_none?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_some?: InputMaybe<FlatAssignmentFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isAuto?: InputMaybe<Scalars['Boolean']['input']>;
  isAuto_not?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified_not?: InputMaybe<Scalars['Boolean']['input']>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  legacyId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  mediaRequest?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  mediaRequest_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  mediaRequest_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  mediaRequest_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  mediaRequest_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  mediaRequest_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  mediaRequest_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  mediaRequest_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  mediaRequest_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  mediaRequest_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  mediaRequest_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  NOT?: InputMaybe<SubjectFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<SubjectFilterInput>>>;
  subjectCategory?: InputMaybe<SubjectCategoryFilterInput>;
  subjectCategory_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  subjectCategory_not?: InputMaybe<SubjectCategoryFilterInput>;
  subjectUserCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectUserCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectUserCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectUserCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectUserCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectUserCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjectUsers_every?: InputMaybe<SubjectUserFilterInput>;
  subjectUsers_none?: InputMaybe<SubjectUserFilterInput>;
  subjectUsers_some?: InputMaybe<SubjectUserFilterInput>;
  subSubjectCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subSubjectCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subSubjectCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subSubjectCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subSubjectCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subSubjectCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subSubjects_every?: InputMaybe<SubSubjectFilterInput>;
  subSubjects_none?: InputMaybe<SubSubjectFilterInput>;
  subSubjects_some?: InputMaybe<SubSubjectFilterInput>;
  synopsis?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  synopsis_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  synopsis_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  synopsis_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  synopsis_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  synopsis_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  synopsis_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  synopsis_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  synopsis_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  synopsis_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  synopsis_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  unit?: InputMaybe<UnitFilterInput>;
  unit_not?: InputMaybe<UnitFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "Attachment" nodes' filter */
export type AttachmentFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<AttachmentFilterInput>>>;
  contentType?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  contentType_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  contentType_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  contentType_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  contentType_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  contentType_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  contentType_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  etag?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  etag_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  etag_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  etag_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  etag_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  etag_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  etag_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  etag_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  etag_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  etag_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  etag_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  filename_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  filename_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  filename_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  filename_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filename_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  filesize?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  filesize_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  filesize_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  filesize_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isUploaded_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded_not?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<AttachmentFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<AttachmentFilterInput>>>;
  subject?: InputMaybe<SubjectFilterInput>;
  subject_not?: InputMaybe<SubjectFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  versionId?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  versionId_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  versionId_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  versionId_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  versionId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  versionId_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  versionId_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  versionId_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  versionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  versionId_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  versionId_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

/** The "SubjectUser" nodes' filter */
export type SubjectUserFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<SubjectUserFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<SubjectUserFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<SubjectUserFilterInput>>>;
  subject?: InputMaybe<SubjectFilterInput>;
  subject_not?: InputMaybe<SubjectFilterInput>;
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
  userId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  userId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
};

/** The "SubSubject" nodes' filter */
export type SubSubjectFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<SubSubjectFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<SubSubjectFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<SubSubjectFilterInput>>>;
  subject?: InputMaybe<SubjectFilterInput>;
  subject_not?: InputMaybe<SubjectFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "Website" nodes' filter */
export type WebsiteFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<WebsiteFilterInput>>>;
  assignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments_every?: InputMaybe<AssignmentFilterInput>;
  assignments_none?: InputMaybe<AssignmentFilterInput>;
  assignments_some?: InputMaybe<AssignmentFilterInput>;
  brand?: InputMaybe<BrandFilterInput>;
  brand_not?: InputMaybe<BrandFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  flatAssignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignments_every?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_none?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_some?: InputMaybe<FlatAssignmentFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  key?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  key_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  key_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  key_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  key_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  key_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  key_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  key_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  key_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  key_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  key_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  key_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  key_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  key_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  legacyId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  NOT?: InputMaybe<WebsiteFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<WebsiteFilterInput>>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "RawArticle" nodes' filter */
export type RawArticleFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<RawArticleFilterInput>>>;
  assignment?: InputMaybe<AssignmentFilterInput>;
  assignment_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  assignment_not?: InputMaybe<AssignmentFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  flatAssignmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  flatAssignments_every?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_none?: InputMaybe<FlatAssignmentFilterInput>;
  flatAssignments_some?: InputMaybe<FlatAssignmentFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  legacyId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  legacyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  NOT?: InputMaybe<RawArticleFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<RawArticleFilterInput>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  versionCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versionCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versions_every?: InputMaybe<RawArticleVersionFilterInput>;
  versions_none?: InputMaybe<RawArticleVersionFilterInput>;
  versions_some?: InputMaybe<RawArticleVersionFilterInput>;
};

/** The "RawArticleVersion" nodes' filter */
export type RawArticleVersionFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<RawArticleVersionFilterInput>>>;
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  body_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  body_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  body_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  comment_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  comment_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  comment_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  comment_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  comment_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  editorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  editorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  editorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  editorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  forkChilrenCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  forkChilrenCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  forkChilrenCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  forkChilrenCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  forkChilrenCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  forkChilrenCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  forkChilrens_every?: InputMaybe<RawArticleVersionFilterInput>;
  forkChilrens_none?: InputMaybe<RawArticleVersionFilterInput>;
  forkChilrens_some?: InputMaybe<RawArticleVersionFilterInput>;
  forkOf?: InputMaybe<RawArticleVersionFilterInput>;
  forkOf_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  forkOf_not?: InputMaybe<RawArticleVersionFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lead?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  lead_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lead_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lead_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  lead_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lead_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  lead_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lead_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lead_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  lead_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lead_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  leftOver?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  leftOver_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  leftOver_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  leftOver_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  leftOver_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  leftOver_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  leftOver_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  leftOver_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  leftOver_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  leftOver_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  leftOver_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  nextVersion?: InputMaybe<RawArticleVersionFilterInput>;
  nextVersion_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  nextVersion_not?: InputMaybe<RawArticleVersionFilterInput>;
  NOT?: InputMaybe<RawArticleVersionFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<RawArticleVersionFilterInput>>>;
  previousVersion?: InputMaybe<RawArticleVersionFilterInput>;
  previousVersion_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  previousVersion_not?: InputMaybe<RawArticleVersionFilterInput>;
  rawArticle?: InputMaybe<RawArticleFilterInput>;
  rawArticle_not?: InputMaybe<RawArticleFilterInput>;
  signature?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  signature_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  signature_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  signature_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  signature_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  signature_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  status?: InputMaybe<RawArticleStatus>;
  status_in?: InputMaybe<Array<RawArticleStatus>>;
  status_not?: InputMaybe<RawArticleStatus>;
  status_not_in?: InputMaybe<Array<RawArticleStatus>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  title_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export enum RawArticleStatus {
  Correcting = 'Correcting',
  Correction = 'Correction',
  Editing = 'Editing',
  Mockup = 'Mockup',
  Validating = 'Validating',
  Validation = 'Validation'
}

export enum TemplateType {
  ARTICLE_TEMPLATE = 'ARTICLE_TEMPLATE',
  GAME_TEMPLATE = 'GAME_TEMPLATE',
  MULTIPLE_ARTICLE_TEMPLATE = 'MULTIPLE_ARTICLE_TEMPLATE'
}

/** The "PrintIssueRailroad" nodes' filter */
export type PrintIssueRailroadFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<PrintIssueRailroadFilterInput>>>;
  censhareCreationDate?: InputMaybe<Scalars['DateTime']['input']>;
  censhareCreationDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  censhareCreationDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  censhareCreationDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  censhareCreationDate_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  censhareCreationDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  censhareCreationDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  censhareCreationDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  censhareCreationDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  censhareUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  censhareUpdateDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  censhareUpdateDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  censhareUpdateDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  censhareUpdateDate_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  censhareUpdateDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  censhareUpdateDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  censhareUpdateDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  censhareUpdateDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  comment?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  comment_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  comment_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  comment_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  comment_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  comment_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  comment_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  name?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  name_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  NOT?: InputMaybe<PrintIssueRailroadFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<PrintIssueRailroadFilterInput>>>;
  pageCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  pageCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pageCount_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  printIssue?: InputMaybe<PrintIssueFilterInput>;
  printIssue_not?: InputMaybe<PrintIssueFilterInput>;
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  publicationDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  publicationDate_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  railroadPageCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  railroadPageCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  railroadPageCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  railroadPageCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  railroadPageCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  railroadPageCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  railroadPages_every?: InputMaybe<RailroadPageFilterInput>;
  railroadPages_none?: InputMaybe<RailroadPageFilterInput>;
  railroadPages_some?: InputMaybe<RailroadPageFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "RailroadPage" nodes' filter */
export type RailroadPageFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<RailroadPageFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  indesignFilename?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  indesignFilename_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  indesignFilename_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  indesignFilename_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  indesignFilename_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  indesignFilename_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  indesignFilename_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  indesignFilename_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  indesignFilename_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  indesignFilename_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  indesignFilename_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  indesignFilename_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  indesignFilename_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  indesignFilename_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<RailroadPageFilterInput>;
  number?: InputMaybe<Scalars['UnsignedInt']['input']>;
  number_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  number_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  number_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  number_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  number_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  number_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  number_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  OR?: InputMaybe<Array<InputMaybe<RailroadPageFilterInput>>>;
  printIssueRailroad?: InputMaybe<PrintIssueRailroadFilterInput>;
  printIssueRailroad_not?: InputMaybe<PrintIssueRailroadFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  visual?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  visual_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  visual_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  visual_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  visual_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  visual_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  visual_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  visual_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  visual_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  visual_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowName?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowName_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowName_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowName_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowName_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowName_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  workflowName_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowName_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowName_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowName_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowName_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowName_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  workflowName_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowName_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowStage?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowStage_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowStage_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowStage_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowStage_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowStage_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  workflowStage_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowStage_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowStage_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflowStage_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowStage_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowStage_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  workflowStage_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflowStage_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

/** The "FileVersion" nodes' filter */
export type FileVersionFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<FileVersionFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  file?: InputMaybe<FileFilterInput>;
  file_not?: InputMaybe<FileFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  nextVersion?: InputMaybe<FileVersionFilterInput>;
  nextVersion_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  nextVersion_not?: InputMaybe<FileVersionFilterInput>;
  NOT?: InputMaybe<FileVersionFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<FileVersionFilterInput>>>;
  path?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  path_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  path_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  path_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  previousVersion?: InputMaybe<FileVersionFilterInput>;
  previousVersion_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  previousVersion_not?: InputMaybe<FileVersionFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflow_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  workflow_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflow_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  workflow_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

/** The "AdvertisementVersion" nodes' filter */
export type AdvertisementVersionFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  advertisement?: InputMaybe<AdvertisementFilterInput>;
  advertisement_not?: InputMaybe<AdvertisementFilterInput>;
  AND?: InputMaybe<Array<InputMaybe<AdvertisementVersionFilterInput>>>;
  campaign?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  campaign_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  campaign_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  campaign_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  campaign_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  campaign_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  campaign_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  campaign_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  campaign_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  campaign_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  campaign_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  nextVersion?: InputMaybe<AdvertisementVersionFilterInput>;
  nextVersion_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  nextVersion_not?: InputMaybe<AdvertisementVersionFilterInput>;
  NOT?: InputMaybe<AdvertisementVersionFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<AdvertisementVersionFilterInput>>>;
  path?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  path_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  path_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  path_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  picbiId?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  picbiId_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  picbiId_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  picbiId_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  picbiId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  picbiId_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  picbiId_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  picbiId_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  picbiId_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  picbiId_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  picbiId_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  previousVersion?: InputMaybe<AdvertisementVersionFilterInput>;
  previousVersion_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  previousVersion_not?: InputMaybe<AdvertisementVersionFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflow_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  workflow_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  workflow_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  workflow_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  workflow_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

/** Identifies exactly one "Advertisement" by "_id" or "id" */
export type AdvertisementUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** An advertisement page */
export type Advertisement = {
  __typename?: 'Advertisement';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  lastVersion?: Maybe<AdvertisementVersion>;
  /** Number of "layoutAssets" */
  layoutAssetCount: Scalars['UnsignedInt']['output'];
  layoutAssets: Array<LayoutAsset>;
  printIssue?: Maybe<PrintIssue>;
  printPublication?: Maybe<PrintPublication>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  /** Number of "versions" */
  versionCount: Scalars['UnsignedInt']['output'];
  versions: Array<AdvertisementVersion>;
};


/** An advertisement page */
export type AdvertisementLayoutAssetCountArgs = {
  where?: InputMaybe<LayoutAssetFilterInput>;
};


/** An advertisement page */
export type AdvertisementLayoutAssetsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutAssetOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};


/** An advertisement page */
export type AdvertisementVersionCountArgs = {
  where?: InputMaybe<AdvertisementVersionFilterInput>;
};


/** An advertisement page */
export type AdvertisementVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AdvertisementVersionOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AdvertisementVersionFilterInput>;
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['EmailAddress']['output'];
  id: Scalars['UUIDv4']['output'];
  name: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

/** An advertisement's version */
export type AdvertisementVersion = {
  __typename?: 'AdvertisementVersion';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  advertisement: Advertisement;
  campaign?: Maybe<Scalars['String']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  nextVersion?: Maybe<AdvertisementVersion>;
  path?: Maybe<Scalars['String']['output']>;
  picbiId?: Maybe<Scalars['String']['output']>;
  previousVersion?: Maybe<AdvertisementVersion>;
  title: Scalars['String']['output'];
  workflow?: Maybe<Scalars['String']['output']>;
};

/** Order the "LayoutAsset" nodes */
export enum LayoutAssetOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** A layout asset, can be a mockup or an advertisement page or a generic file */
export type LayoutAsset = {
  __typename?: 'LayoutAsset';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  advertisement?: Maybe<Advertisement>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  file?: Maybe<File>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  layout: Layout;
  mockup?: Maybe<Mockup>;
  order: Scalars['UnsignedInt']['output'];
  printHeading?: Maybe<PrintHeading>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

/** An generic file */
export type File = {
  __typename?: 'File';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  lastVersion?: Maybe<FileVersion>;
  /** Number of "layoutAssets" */
  layoutAssetCount: Scalars['UnsignedInt']['output'];
  layoutAssets: Array<LayoutAsset>;
  printIssue?: Maybe<PrintIssue>;
  printPublication?: Maybe<PrintPublication>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  /** Number of "versions" */
  versionCount: Scalars['UnsignedInt']['output'];
  versions: Array<FileVersion>;
};


/** An generic file */
export type FileLayoutAssetCountArgs = {
  where?: InputMaybe<LayoutAssetFilterInput>;
};


/** An generic file */
export type FileLayoutAssetsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutAssetOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};


/** An generic file */
export type FileVersionCountArgs = {
  where?: InputMaybe<FileVersionFilterInput>;
};


/** An generic file */
export type FileVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FileVersionOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FileVersionFilterInput>;
};

/** A file's version */
export type FileVersion = {
  __typename?: 'FileVersion';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  file: File;
  /** The public ID */
  id: Scalars['UUID']['output'];
  nextVersion?: Maybe<FileVersion>;
  path?: Maybe<Scalars['String']['output']>;
  previousVersion?: Maybe<FileVersion>;
  title: Scalars['String']['output'];
  workflow?: Maybe<Scalars['String']['output']>;
};

/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssue = {
  __typename?: 'PrintIssue';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** Number of "advertisements" */
  advertisementCount: Scalars['UnsignedInt']['output'];
  advertisements: Array<Advertisement>;
  /** Number of "assignments" */
  assignmentCount: Scalars['UnsignedInt']['output'];
  assignments: Array<Assignment>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** Number of "files" */
  fileCount: Scalars['UnsignedInt']['output'];
  files: Array<File>;
  /** Number of "flatAssignments" */
  flatAssignmentCount: Scalars['UnsignedInt']['output'];
  flatAssignments: Array<FlatAssignment>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  /** Number of "layouts" */
  layoutCount: Scalars['UnsignedInt']['output'];
  layouts: Array<Layout>;
  /** The legacy ID */
  legacyId?: Maybe<Scalars['UnsignedInt']['output']>;
  /** Number of "mockups" */
  mockupCount: Scalars['UnsignedInt']['output'];
  mockups: Array<Mockup>;
  /** Number of "printHeadings" */
  printHeadingCount: Scalars['UnsignedInt']['output'];
  printHeadings: Array<PrintHeading>;
  printIssueRailroad?: Maybe<PrintIssueRailroad>;
  printPublication: PrintPublication;
  title: Scalars['String']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueAdvertisementCountArgs = {
  where?: InputMaybe<AdvertisementFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueAdvertisementsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AdvertisementOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AdvertisementFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueAssignmentCountArgs = {
  where?: InputMaybe<AssignmentFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AssignmentFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueFileCountArgs = {
  where?: InputMaybe<FileFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueFilesArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FileOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FileFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueFlatAssignmentCountArgs = {
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueFlatAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FlatAssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueLayoutCountArgs = {
  where?: InputMaybe<LayoutFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueLayoutsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LayoutFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueMockupCountArgs = {
  where?: InputMaybe<MockupFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssueMockupsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MockupOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<MockupFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssuePrintHeadingCountArgs = {
  where?: InputMaybe<PrintHeadingFilterInput>;
};


/** An issue of a Print Publication (number 101, special summer,...) */
export type PrintIssuePrintHeadingsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintHeadingOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintHeadingFilterInput>;
};

/** Order the "Advertisement" nodes */
export enum AdvertisementOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "layoutAssets" to the highest */
  layoutAssetCount_ASC = 'layoutAssetCount_ASC',
  /** from the highest number of "layoutAssets" to the lowest */
  layoutAssetCount_DESC = 'layoutAssetCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC',
  /** from the lowest number of "versions" to the highest */
  versionCount_ASC = 'versionCount_ASC',
  /** from the highest number of "versions" to the lowest */
  versionCount_DESC = 'versionCount_DESC'
}

/** Order the "Assignment" nodes */
export enum AssignmentOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "legacyId" to the highest */
  legacyId_ASC = 'legacyId_ASC',
  /** from the highest "legacyId" to the lowest */
  legacyId_DESC = 'legacyId_DESC',
  /** from the lowest "pageNumber" to the highest */
  pageNumber_ASC = 'pageNumber_ASC',
  /** from the highest "pageNumber" to the lowest */
  pageNumber_DESC = 'pageNumber_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Assignment of a subject on a printPublication, a printIssue or a printHeading */
export type Assignment = {
  __typename?: 'Assignment';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  articleTemplate?: Maybe<ArticleTemplate>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  flatAssignment?: Maybe<FlatAssignment>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  /** The legacy ID */
  legacyId?: Maybe<Scalars['UnsignedInt']['output']>;
  mediaSearchStatus: MediaSearchStatus;
  pageNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  printHeading?: Maybe<PrintHeading>;
  printIssue?: Maybe<PrintIssue>;
  printPublication?: Maybe<PrintPublication>;
  printTemplate?: Maybe<PrintTemplate>;
  rawArticle?: Maybe<RawArticle>;
  subject: Subject;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  website?: Maybe<Website>;
};

/** Article template data */
export type ArticleTemplate = {
  __typename?: 'ArticleTemplate';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** Number of "assignments" */
  assignmentCount: Scalars['UnsignedInt']['output'];
  assignments: Array<Assignment>;
  /** The raw datas */
  block?: Maybe<Scalars['String']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  fields: Array<Maybe<PrintTemplateField>>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The article template label */
  label?: Maybe<Scalars['String']['output']>;
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  printTemplate: PrintTemplate;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** Article template data */
export type ArticleTemplateAssignmentCountArgs = {
  where?: InputMaybe<AssignmentFilterInput>;
};


/** Article template data */
export type ArticleTemplateAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AssignmentFilterInput>;
};

export type PrintTemplateField = {
  __typename?: 'PrintTemplateField';
  characterStyles: Array<PrintTemplateFieldStyle>;
  coordinates: PrintTemplateObjectCoords;
  data: Scalars['String']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  page: PrintTemplatePage;
  paragraphStyles: Array<PrintTemplateFieldStyle>;
  type: PrintTemplateFieldType;
  typeVariation: Scalars['String']['output'];
};

export type PrintTemplateFieldStyle = {
  __typename?: 'PrintTemplateFieldStyle';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PrintTemplateObjectCoords = {
  __typename?: 'PrintTemplateObjectCoords';
  height?: Maybe<Scalars['Float']['output']>;
  rotation?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type PrintTemplatePage = {
  __typename?: 'PrintTemplatePage';
  coordinates: PrintTemplateObjectCoords;
  number: Scalars['String']['output'];
  offset: Scalars['Int']['output'];
};

export enum PrintTemplateFieldType {
  GRAPHIC_TYPE = 'GRAPHIC_TYPE',
  TEXT_TYPE = 'TEXT_TYPE',
  UNASSIGNED = 'UNASSIGNED'
}

/** print templates definition */
export type PrintTemplate = {
  __typename?: 'PrintTemplate';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** Number of "articleTemplates" */
  articleTemplateCount: Scalars['UnsignedInt']['output'];
  articleTemplates: Array<ArticleTemplate>;
  /** Number of "assignments" */
  assignmentCount: Scalars['UnsignedInt']['output'];
  assignments: Array<Assignment>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** KAMI extension data */
  data: Scalars['String']['output'];
  /** KAMI extension version */
  extVersion?: Maybe<Scalars['String']['output']>;
  fields: Array<Maybe<PrintTemplateField>>;
  /** InDesign file name */
  filename: Scalars['String']['output'];
  /** InDesign file size */
  filesize?: Maybe<Scalars['UnsignedInt']['output']>;
  /** Number of "flatAssignments" */
  flatAssignmentCount: Scalars['UnsignedInt']['output'];
  flatAssignments: Array<FlatAssignment>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** template label */
  label: Scalars['String']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  /** Template page count */
  pageCount?: Maybe<Scalars['UnsignedInt']['output']>;
  /** Number of "printHeadings" */
  printHeadingCount: Scalars['UnsignedInt']['output'];
  printHeadings: Array<PrintHeadingPrintTemplate>;
  /** associated S3 object id */
  S3ObjectId: Scalars['String']['output'];
  /** template type */
  type?: Maybe<TemplateType>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** print templates definition */
export type PrintTemplateArticleTemplateCountArgs = {
  where?: InputMaybe<ArticleTemplateFilterInput>;
};


/** print templates definition */
export type PrintTemplateArticleTemplatesArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTemplateOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleTemplateFilterInput>;
};


/** print templates definition */
export type PrintTemplateAssignmentCountArgs = {
  where?: InputMaybe<AssignmentFilterInput>;
};


/** print templates definition */
export type PrintTemplateAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AssignmentFilterInput>;
};


/** print templates definition */
export type PrintTemplateFlatAssignmentCountArgs = {
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** print templates definition */
export type PrintTemplateFlatAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FlatAssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** print templates definition */
export type PrintTemplatePrintHeadingCountArgs = {
  where?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
};


/** print templates definition */
export type PrintTemplatePrintHeadingsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintHeadingPrintTemplateOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
};

/** Order the "ArticleTemplate" nodes */
export enum ArticleTemplateOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest number of "assignments" to the highest */
  assignmentCount_ASC = 'assignmentCount_ASC',
  /** from the highest number of "assignments" to the lowest */
  assignmentCount_DESC = 'assignmentCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Order the "FlatAssignment" nodes */
export enum FlatAssignmentOrderingInput {
  /** from the lowest "assignmentPageNumber" to the highest */
  assignmentPageNumber_ASC = 'assignmentPageNumber_ASC',
  /** from the highest "assignmentPageNumber" to the lowest */
  assignmentPageNumber_DESC = 'assignmentPageNumber_DESC'
}

/** Read-only view to shortcut assignment joins */
export type FlatAssignment = {
  __typename?: 'FlatAssignment';
  assignment: Assignment;
  assignmentMediaSearchStatus: MediaSearchStatus;
  assignmentPageNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  brand?: Maybe<Brand>;
  /** The assignation location */
  location: Scalars['String']['output'];
  printHeading?: Maybe<PrintHeading>;
  printIssue?: Maybe<PrintIssue>;
  printPublication?: Maybe<PrintPublication>;
  printTemplate?: Maybe<PrintTemplate>;
  rawArticle?: Maybe<RawArticle>;
  subject?: Maybe<Subject>;
  website?: Maybe<Website>;
};

/** A Brand: FAC, CAC, T2S, TEL */
export type Brand = {
  __typename?: 'Brand';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** Number of "flatAssignments" */
  flatAssignmentCount: Scalars['UnsignedInt']['output'];
  flatAssignments: Array<FlatAssignment>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  /** Number of "printPublications" */
  printPublicationCount: Scalars['UnsignedInt']['output'];
  printPublications: Array<PrintPublication>;
  title: Scalars['String']['output'];
  unit: Unit;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  /** Number of "websites" */
  websiteCount: Scalars['UnsignedInt']['output'];
  websites: Array<Website>;
};


/** A Brand: FAC, CAC, T2S, TEL */
export type BrandFlatAssignmentCountArgs = {
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A Brand: FAC, CAC, T2S, TEL */
export type BrandFlatAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FlatAssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A Brand: FAC, CAC, T2S, TEL */
export type BrandPrintPublicationCountArgs = {
  where?: InputMaybe<PrintPublicationFilterInput>;
};


/** A Brand: FAC, CAC, T2S, TEL */
export type BrandPrintPublicationsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintPublicationOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintPublicationFilterInput>;
};


/** A Brand: FAC, CAC, T2S, TEL */
export type BrandWebsiteCountArgs = {
  where?: InputMaybe<WebsiteFilterInput>;
};


/** A Brand: FAC, CAC, T2S, TEL */
export type BrandWebsitesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<WebsiteOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<WebsiteFilterInput>;
};

/** Order the "PrintPublication" nodes */
export enum PrintPublicationOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest number of "advertisements" to the highest */
  advertisementCount_ASC = 'advertisementCount_ASC',
  /** from the highest number of "advertisements" to the lowest */
  advertisementCount_DESC = 'advertisementCount_DESC',
  /** from the lowest number of "assignments" to the highest */
  assignmentCount_ASC = 'assignmentCount_ASC',
  /** from the highest number of "assignments" to the lowest */
  assignmentCount_DESC = 'assignmentCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest number of "files" to the highest */
  fileCount_ASC = 'fileCount_ASC',
  /** from the highest number of "files" to the lowest */
  fileCount_DESC = 'fileCount_DESC',
  /** from the lowest number of "flatAssignments" to the highest */
  flatAssignmentCount_ASC = 'flatAssignmentCount_ASC',
  /** from the highest number of "flatAssignments" to the lowest */
  flatAssignmentCount_DESC = 'flatAssignmentCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "layouts" to the highest */
  layoutCount_ASC = 'layoutCount_ASC',
  /** from the highest number of "layouts" to the lowest */
  layoutCount_DESC = 'layoutCount_DESC',
  /** from the lowest "legacyId" to the highest */
  legacyId_ASC = 'legacyId_ASC',
  /** from the highest "legacyId" to the lowest */
  legacyId_DESC = 'legacyId_DESC',
  /** from the lowest number of "mockups" to the highest */
  mockupCount_ASC = 'mockupCount_ASC',
  /** from the highest number of "mockups" to the lowest */
  mockupCount_DESC = 'mockupCount_DESC',
  /** from the lowest number of "printHeadings" to the highest */
  printHeadingCount_ASC = 'printHeadingCount_ASC',
  /** from the highest number of "printHeadings" to the lowest */
  printHeadingCount_DESC = 'printHeadingCount_DESC',
  /** from the lowest number of "printIssues" to the highest */
  printIssueCount_ASC = 'printIssueCount_ASC',
  /** from the highest number of "printIssues" to the lowest */
  printIssueCount_DESC = 'printIssueCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublication = {
  __typename?: 'PrintPublication';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** Number of "advertisements" */
  advertisementCount: Scalars['UnsignedInt']['output'];
  advertisements: Array<Advertisement>;
  /** Number of "assignments" */
  assignmentCount: Scalars['UnsignedInt']['output'];
  assignments: Array<Assignment>;
  brand: Brand;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** Number of "files" */
  fileCount: Scalars['UnsignedInt']['output'];
  files: Array<File>;
  /** Number of "flatAssignments" */
  flatAssignmentCount: Scalars['UnsignedInt']['output'];
  flatAssignments: Array<FlatAssignment>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  /** Number of "layouts" */
  layoutCount: Scalars['UnsignedInt']['output'];
  layouts: Array<Layout>;
  /** The legacy ID */
  legacyId?: Maybe<Scalars['UnsignedInt']['output']>;
  /** Number of "mockups" */
  mockupCount: Scalars['UnsignedInt']['output'];
  mockups: Array<Mockup>;
  /** Number of "printHeadings" */
  printHeadingCount: Scalars['UnsignedInt']['output'];
  printHeadings: Array<PrintHeading>;
  /** Number of "printIssues" */
  printIssueCount: Scalars['UnsignedInt']['output'];
  printIssues: Array<PrintIssue>;
  title: Scalars['String']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationAdvertisementCountArgs = {
  where?: InputMaybe<AdvertisementFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationAdvertisementsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AdvertisementOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AdvertisementFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationAssignmentCountArgs = {
  where?: InputMaybe<AssignmentFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AssignmentFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationFileCountArgs = {
  where?: InputMaybe<FileFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationFilesArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FileOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FileFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationFlatAssignmentCountArgs = {
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationFlatAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FlatAssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationLayoutCountArgs = {
  where?: InputMaybe<LayoutFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationLayoutsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LayoutFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationMockupCountArgs = {
  where?: InputMaybe<MockupFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationMockupsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MockupOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<MockupFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationPrintHeadingCountArgs = {
  where?: InputMaybe<PrintHeadingFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationPrintHeadingsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintHeadingOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintHeadingFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationPrintIssueCountArgs = {
  where?: InputMaybe<PrintIssueFilterInput>;
};


/** A Print Publication: Femme Actuelle, Télé-loisir, Capital */
export type PrintPublicationPrintIssuesArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintIssueOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintIssueFilterInput>;
};

/** Order the "File" nodes */
export enum FileOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "layoutAssets" to the highest */
  layoutAssetCount_ASC = 'layoutAssetCount_ASC',
  /** from the highest number of "layoutAssets" to the lowest */
  layoutAssetCount_DESC = 'layoutAssetCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC',
  /** from the lowest number of "versions" to the highest */
  versionCount_ASC = 'versionCount_ASC',
  /** from the highest number of "versions" to the lowest */
  versionCount_DESC = 'versionCount_DESC'
}

/** Order the "Layout" nodes */
export enum LayoutOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest number of "assets" to the highest */
  assetCount_ASC = 'assetCount_ASC',
  /** from the highest number of "assets" to the lowest */
  assetCount_DESC = 'assetCount_DESC',
  /** from the lowest number of "children" to the highest */
  childCount_ASC = 'childCount_ASC',
  /** from the highest number of "children" to the lowest */
  childCount_DESC = 'childCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** A layout is the structure of a print issue, organizing its assets */
export type Layout = {
  __typename?: 'Layout';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** Number of "assets" */
  assetCount: Scalars['UnsignedInt']['output'];
  assets: Array<LayoutAsset>;
  /** Number of "children" */
  childCount: Scalars['UnsignedInt']['output'];
  /** The layouts that are based on this one */
  children: Array<Layout>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  /** The layout this one is based on, if any */
  parent?: Maybe<Layout>;
  printIssue?: Maybe<PrintIssue>;
  printPublication?: Maybe<PrintPublication>;
  title: Scalars['String']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** A layout is the structure of a print issue, organizing its assets */
export type LayoutAssetCountArgs = {
  where?: InputMaybe<LayoutAssetFilterInput>;
};


/** A layout is the structure of a print issue, organizing its assets */
export type LayoutAssetsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutAssetOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};


/** A layout is the structure of a print issue, organizing its assets */
export type LayoutChildCountArgs = {
  where?: InputMaybe<LayoutFilterInput>;
};


/** A layout is the structure of a print issue, organizing its assets */
export type LayoutChildrenArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LayoutFilterInput>;
};

/** Order the "Mockup" nodes */
export enum MockupOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "layoutAssets" to the highest */
  layoutAssetCount_ASC = 'layoutAssetCount_ASC',
  /** from the highest number of "layoutAssets" to the lowest */
  layoutAssetCount_DESC = 'layoutAssetCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC',
  /** from the lowest number of "versions" to the highest */
  versionCount_ASC = 'versionCount_ASC',
  /** from the highest number of "versions" to the lowest */
  versionCount_DESC = 'versionCount_DESC'
}

/** An indesign mockup */
export type Mockup = {
  __typename?: 'Mockup';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  lastVersion?: Maybe<MockupVersion>;
  /** Number of "layoutAssets" */
  layoutAssetCount: Scalars['UnsignedInt']['output'];
  layoutAssets: Array<LayoutAsset>;
  printHeading?: Maybe<PrintHeading>;
  printIssue?: Maybe<PrintIssue>;
  printPublication?: Maybe<PrintPublication>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  /** Number of "versions" */
  versionCount: Scalars['UnsignedInt']['output'];
  versions: Array<MockupVersion>;
};


/** An indesign mockup */
export type MockupLayoutAssetCountArgs = {
  where?: InputMaybe<LayoutAssetFilterInput>;
};


/** An indesign mockup */
export type MockupLayoutAssetsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutAssetOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};


/** An indesign mockup */
export type MockupVersionCountArgs = {
  where?: InputMaybe<MockupVersionFilterInput>;
};


/** An indesign mockup */
export type MockupVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MockupVersionOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<MockupVersionFilterInput>;
};

/** A mockup's version */
export type MockupVersion = {
  __typename?: 'MockupVersion';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  mockup: Mockup;
  nextVersion?: Maybe<MockupVersion>;
  path?: Maybe<Scalars['String']['output']>;
  previousVersion?: Maybe<MockupVersion>;
  title: Scalars['String']['output'];
};

/** A header of a particular Print Issue */
export type PrintHeading = {
  __typename?: 'PrintHeading';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** Number of "assignments" */
  assignmentCount: Scalars['UnsignedInt']['output'];
  assignments: Array<Assignment>;
  autoPrototype?: Maybe<Scalars['Boolean']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** Number of "flatAssignments" */
  flatAssignmentCount: Scalars['UnsignedInt']['output'];
  flatAssignments: Array<FlatAssignment>;
  hasAutomaticSubject: Scalars['Boolean']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  /** Number of "layoutAssets" */
  layoutAssetCount: Scalars['UnsignedInt']['output'];
  layoutAssets: Array<LayoutAsset>;
  /** The legacy ID */
  legacyId?: Maybe<Scalars['UnsignedInt']['output']>;
  mockup?: Maybe<Mockup>;
  order: Scalars['UnsignedInt']['output'];
  printIssue: PrintIssue;
  printPublication?: Maybe<PrintPublication>;
  /** Number of "printTemplates" */
  printTemplateCount: Scalars['UnsignedInt']['output'];
  printTemplates: Array<PrintHeadingPrintTemplate>;
  title: Scalars['String']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** A header of a particular Print Issue */
export type PrintHeadingAssignmentCountArgs = {
  where?: InputMaybe<AssignmentFilterInput>;
};


/** A header of a particular Print Issue */
export type PrintHeadingAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AssignmentFilterInput>;
};


/** A header of a particular Print Issue */
export type PrintHeadingFlatAssignmentCountArgs = {
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A header of a particular Print Issue */
export type PrintHeadingFlatAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FlatAssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A header of a particular Print Issue */
export type PrintHeadingLayoutAssetCountArgs = {
  where?: InputMaybe<LayoutAssetFilterInput>;
};


/** A header of a particular Print Issue */
export type PrintHeadingLayoutAssetsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutAssetOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};


/** A header of a particular Print Issue */
export type PrintHeadingPrintTemplateCountArgs = {
  where?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
};


/** A header of a particular Print Issue */
export type PrintHeadingPrintTemplatesArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintHeadingPrintTemplateOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
};

/** Order the "PrintHeadingPrintTemplate" nodes */
export enum PrintHeadingPrintTemplateOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PrintHeadingPrintTemplate = {
  __typename?: 'PrintHeadingPrintTemplate';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  active: Scalars['Boolean']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  printHeading: PrintHeading;
  printTemplate: PrintTemplate;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

/** Order the "MockupVersion" nodes */
export enum MockupVersionOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC'
}

/** Order the "PrintHeading" nodes */
export enum PrintHeadingOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest number of "assignments" to the highest */
  assignmentCount_ASC = 'assignmentCount_ASC',
  /** from the highest number of "assignments" to the lowest */
  assignmentCount_DESC = 'assignmentCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest number of "flatAssignments" to the highest */
  flatAssignmentCount_ASC = 'flatAssignmentCount_ASC',
  /** from the highest number of "flatAssignments" to the lowest */
  flatAssignmentCount_DESC = 'flatAssignmentCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "layoutAssets" to the highest */
  layoutAssetCount_ASC = 'layoutAssetCount_ASC',
  /** from the highest number of "layoutAssets" to the lowest */
  layoutAssetCount_DESC = 'layoutAssetCount_DESC',
  /** from the lowest "legacyId" to the highest */
  legacyId_ASC = 'legacyId_ASC',
  /** from the highest "legacyId" to the lowest */
  legacyId_DESC = 'legacyId_DESC',
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC',
  /** from the lowest number of "printTemplates" to the highest */
  printTemplateCount_ASC = 'printTemplateCount_ASC',
  /** from the highest number of "printTemplates" to the lowest */
  printTemplateCount_DESC = 'printTemplateCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Order the "PrintIssue" nodes */
export enum PrintIssueOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest number of "advertisements" to the highest */
  advertisementCount_ASC = 'advertisementCount_ASC',
  /** from the highest number of "advertisements" to the lowest */
  advertisementCount_DESC = 'advertisementCount_DESC',
  /** from the lowest number of "assignments" to the highest */
  assignmentCount_ASC = 'assignmentCount_ASC',
  /** from the highest number of "assignments" to the lowest */
  assignmentCount_DESC = 'assignmentCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest number of "files" to the highest */
  fileCount_ASC = 'fileCount_ASC',
  /** from the highest number of "files" to the lowest */
  fileCount_DESC = 'fileCount_DESC',
  /** from the lowest number of "flatAssignments" to the highest */
  flatAssignmentCount_ASC = 'flatAssignmentCount_ASC',
  /** from the highest number of "flatAssignments" to the lowest */
  flatAssignmentCount_DESC = 'flatAssignmentCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "layouts" to the highest */
  layoutCount_ASC = 'layoutCount_ASC',
  /** from the highest number of "layouts" to the lowest */
  layoutCount_DESC = 'layoutCount_DESC',
  /** from the lowest "legacyId" to the highest */
  legacyId_ASC = 'legacyId_ASC',
  /** from the highest "legacyId" to the lowest */
  legacyId_DESC = 'legacyId_DESC',
  /** from the lowest number of "mockups" to the highest */
  mockupCount_ASC = 'mockupCount_ASC',
  /** from the highest number of "mockups" to the lowest */
  mockupCount_DESC = 'mockupCount_DESC',
  /** from the lowest number of "printHeadings" to the highest */
  printHeadingCount_ASC = 'printHeadingCount_ASC',
  /** from the highest number of "printHeadings" to the lowest */
  printHeadingCount_DESC = 'printHeadingCount_DESC',
  /** from the lowest "title" to the highest */
  title_ASC = 'title_ASC',
  /** from the highest "title" to the lowest */
  title_DESC = 'title_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** A Business Unit (cinema/reality-tv/etc...) */
export type Unit = {
  __typename?: 'Unit';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** Number of "brands" */
  brandCount: Scalars['UnsignedInt']['output'];
  brands: Array<Brand>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  photoArchiveId?: Maybe<Scalars['Int']['output']>;
  subjectCategories: Array<SubjectCategory>;
  /** Number of "subjectCategories" */
  subjectCategoryCount: Scalars['UnsignedInt']['output'];
  /** Number of "subjects" */
  subjectCount: Scalars['UnsignedInt']['output'];
  subjects: Array<Subject>;
  title: Scalars['String']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** A Business Unit (cinema/reality-tv/etc...) */
export type UnitBrandCountArgs = {
  where?: InputMaybe<BrandFilterInput>;
};


/** A Business Unit (cinema/reality-tv/etc...) */
export type UnitBrandsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<BrandOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<BrandFilterInput>;
};


/** A Business Unit (cinema/reality-tv/etc...) */
export type UnitSubjectCategoriesArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectCategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SubjectCategoryFilterInput>;
};


/** A Business Unit (cinema/reality-tv/etc...) */
export type UnitSubjectCategoryCountArgs = {
  where?: InputMaybe<SubjectCategoryFilterInput>;
};


/** A Business Unit (cinema/reality-tv/etc...) */
export type UnitSubjectCountArgs = {
  where?: InputMaybe<SubjectFilterInput>;
};


/** A Business Unit (cinema/reality-tv/etc...) */
export type UnitSubjectsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SubjectFilterInput>;
};

/** Order the "Brand" nodes */
export enum BrandOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest number of "flatAssignments" to the highest */
  flatAssignmentCount_ASC = 'flatAssignmentCount_ASC',
  /** from the highest number of "flatAssignments" to the lowest */
  flatAssignmentCount_DESC = 'flatAssignmentCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "printPublications" to the highest */
  printPublicationCount_ASC = 'printPublicationCount_ASC',
  /** from the highest number of "printPublications" to the lowest */
  printPublicationCount_DESC = 'printPublicationCount_DESC',
  /** from the lowest "title" to the highest */
  title_ASC = 'title_ASC',
  /** from the highest "title" to the lowest */
  title_DESC = 'title_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC',
  /** from the lowest number of "websites" to the highest */
  websiteCount_ASC = 'websiteCount_ASC',
  /** from the highest number of "websites" to the lowest */
  websiteCount_DESC = 'websiteCount_DESC'
}

/** Order the "SubjectCategory" nodes */
export enum SubjectCategoryOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest number of "children" to the highest */
  childCount_ASC = 'childCount_ASC',
  /** from the highest number of "children" to the lowest */
  childCount_DESC = 'childCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "legacyId" to the highest */
  legacyId_ASC = 'legacyId_ASC',
  /** from the highest "legacyId" to the lowest */
  legacyId_DESC = 'legacyId_DESC',
  /** from the lowest number of "subjects" to the highest */
  subjectCount_ASC = 'subjectCount_ASC',
  /** from the highest number of "subjects" to the lowest */
  subjectCount_DESC = 'subjectCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** A subject category */
export type SubjectCategory = {
  __typename?: 'SubjectCategory';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** Number of "children" */
  childCount: Scalars['UnsignedInt']['output'];
  /** This category's children */
  children: Array<SubjectCategory>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  /** The legacy ID */
  legacyId?: Maybe<Scalars['UnsignedInt']['output']>;
  parent?: Maybe<SubjectCategory>;
  /** Number of "subjects" */
  subjectCount: Scalars['UnsignedInt']['output'];
  subjects: Array<Subject>;
  title: Scalars['String']['output'];
  unit: Unit;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** A subject category */
export type SubjectCategoryChildCountArgs = {
  where?: InputMaybe<SubjectCategoryFilterInput>;
};


/** A subject category */
export type SubjectCategoryChildrenArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectCategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SubjectCategoryFilterInput>;
};


/** A subject category */
export type SubjectCategorySubjectCountArgs = {
  where?: InputMaybe<SubjectFilterInput>;
};


/** A subject category */
export type SubjectCategorySubjectsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SubjectFilterInput>;
};

/** Order the "Subject" nodes */
export enum SubjectOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest number of "assignments" to the highest */
  assignmentCount_ASC = 'assignmentCount_ASC',
  /** from the highest number of "assignments" to the lowest */
  assignmentCount_DESC = 'assignmentCount_DESC',
  /** from the lowest number of "attachments" to the highest */
  attachmentCount_ASC = 'attachmentCount_ASC',
  /** from the highest number of "attachments" to the lowest */
  attachmentCount_DESC = 'attachmentCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest number of "flatAssignments" to the highest */
  flatAssignmentCount_ASC = 'flatAssignmentCount_ASC',
  /** from the highest number of "flatAssignments" to the lowest */
  flatAssignmentCount_DESC = 'flatAssignmentCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "legacyId" to the highest */
  legacyId_ASC = 'legacyId_ASC',
  /** from the highest "legacyId" to the lowest */
  legacyId_DESC = 'legacyId_DESC',
  /** from the lowest number of "subjectUsers" to the highest */
  subjectUserCount_ASC = 'subjectUserCount_ASC',
  /** from the highest number of "subjectUsers" to the lowest */
  subjectUserCount_DESC = 'subjectUserCount_DESC',
  /** from the lowest number of "subSubjects" to the highest */
  subSubjectCount_ASC = 'subSubjectCount_ASC',
  /** from the highest number of "subSubjects" to the lowest */
  subSubjectCount_DESC = 'subSubjectCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** A subject */
export type Subject = {
  __typename?: 'Subject';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** Number of "assignments" */
  assignmentCount: Scalars['UnsignedInt']['output'];
  assignments: Array<Assignment>;
  /** Number of "attachments" */
  attachmentCount: Scalars['UnsignedInt']['output'];
  attachments: Array<Attachment>;
  comment?: Maybe<Scalars['String']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** Number of "flatAssignments" */
  flatAssignmentCount: Scalars['UnsignedInt']['output'];
  flatAssignments: Array<FlatAssignment>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  isAuto: Scalars['Boolean']['output'];
  isClassified: Scalars['Boolean']['output'];
  /** Indicate if title is writable if none of article version has "Mockup" status */
  isTitleWritable: Scalars['Boolean']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  /** The legacy ID */
  legacyId?: Maybe<Scalars['UnsignedInt']['output']>;
  mediaRequest?: Maybe<Scalars['String']['output']>;
  subjectCategory?: Maybe<SubjectCategory>;
  /** Number of "subjectUsers" */
  subjectUserCount: Scalars['UnsignedInt']['output'];
  subjectUsers: Array<SubjectUser>;
  /** Number of "subSubjects" */
  subSubjectCount: Scalars['UnsignedInt']['output'];
  subSubjects: Array<SubSubject>;
  synopsis?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  unit: Unit;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** A subject */
export type SubjectAssignmentCountArgs = {
  where?: InputMaybe<AssignmentFilterInput>;
};


/** A subject */
export type SubjectAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AssignmentFilterInput>;
};


/** A subject */
export type SubjectAttachmentCountArgs = {
  where?: InputMaybe<AttachmentFilterInput>;
};


/** A subject */
export type SubjectAttachmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AttachmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AttachmentFilterInput>;
};


/** A subject */
export type SubjectFlatAssignmentCountArgs = {
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A subject */
export type SubjectFlatAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FlatAssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A subject */
export type SubjectSubjectUserCountArgs = {
  where?: InputMaybe<SubjectUserFilterInput>;
};


/** A subject */
export type SubjectSubjectUsersArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectUserOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SubjectUserFilterInput>;
};


/** A subject */
export type SubjectSubSubjectCountArgs = {
  where?: InputMaybe<SubSubjectFilterInput>;
};


/** A subject */
export type SubjectSubSubjectsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubSubjectOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SubSubjectFilterInput>;
};

/** Order the "Attachment" nodes */
export enum AttachmentOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "filesize" to the highest */
  filesize_ASC = 'filesize_ASC',
  /** from the highest "filesize" to the lowest */
  filesize_DESC = 'filesize_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Stock attachment written by topic using api */
export type Attachment = {
  __typename?: 'Attachment';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** update from S3 */
  contentType?: Maybe<Scalars['String']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** update from S3 */
  etag?: Maybe<Scalars['String']['output']>;
  /** sent from the front */
  filename: Scalars['String']['output'];
  /** update from S3 */
  filesize?: Maybe<Scalars['UnsignedInt']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  subject: Subject;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  /** get presigned url from S3 */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** update from S3 */
  versionId?: Maybe<Scalars['String']['output']>;
};

/** Order the "SubjectUser" nodes */
export enum SubjectUserOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC'
}

/** A subject shared with a user */
export type SubjectUser = {
  __typename?: 'SubjectUser';
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  subject: Subject;
  user?: Maybe<User>;
  userId: Scalars['UUIDv4']['output'];
};

/** Order the "SubSubject" nodes */
export enum SubSubjectOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** A sub subject */
export type SubSubject = {
  __typename?: 'SubSubject';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  subject: Subject;
  title: Scalars['String']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

/** Order the "Website" nodes */
export enum WebsiteOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest number of "assignments" to the highest */
  assignmentCount_ASC = 'assignmentCount_ASC',
  /** from the highest number of "assignments" to the lowest */
  assignmentCount_DESC = 'assignmentCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest number of "flatAssignments" to the highest */
  flatAssignmentCount_ASC = 'flatAssignmentCount_ASC',
  /** from the highest number of "flatAssignments" to the lowest */
  flatAssignmentCount_DESC = 'flatAssignmentCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "key" to the highest */
  key_ASC = 'key_ASC',
  /** from the highest "key" to the lowest */
  key_DESC = 'key_DESC',
  /** from the lowest "legacyId" to the highest */
  legacyId_ASC = 'legacyId_ASC',
  /** from the highest "legacyId" to the lowest */
  legacyId_DESC = 'legacyId_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** A Website: Femme Actuelle, Télé-loisir, Capital */
export type Website = {
  __typename?: 'Website';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** Number of "assignments" */
  assignmentCount: Scalars['UnsignedInt']['output'];
  assignments: Array<Assignment>;
  brand: Brand;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** Number of "flatAssignments" */
  flatAssignmentCount: Scalars['UnsignedInt']['output'];
  flatAssignments: Array<FlatAssignment>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  /** The legacy ID */
  legacyId?: Maybe<Scalars['UnsignedInt']['output']>;
  title: Scalars['String']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** A Website: Femme Actuelle, Télé-loisir, Capital */
export type WebsiteAssignmentCountArgs = {
  where?: InputMaybe<AssignmentFilterInput>;
};


/** A Website: Femme Actuelle, Télé-loisir, Capital */
export type WebsiteAssignmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AssignmentFilterInput>;
};


/** A Website: Femme Actuelle, Télé-loisir, Capital */
export type WebsiteFlatAssignmentCountArgs = {
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A Website: Femme Actuelle, Télé-loisir, Capital */
export type WebsiteFlatAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FlatAssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FlatAssignmentFilterInput>;
};

/** A raw article */
export type RawArticle = {
  __typename?: 'RawArticle';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  assignment?: Maybe<Assignment>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** Number of "flatAssignments" */
  flatAssignmentCount: Scalars['UnsignedInt']['output'];
  flatAssignments: Array<FlatAssignment>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  lastVersion?: Maybe<RawArticleVersion>;
  /** The legacy ID */
  legacyId?: Maybe<Scalars['UnsignedInt']['output']>;
  majorVersions: Array<RawArticleVersion>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  /** Number of "versions" */
  versionCount: Scalars['UnsignedInt']['output'];
  versions: Array<RawArticleVersion>;
};


/** A raw article */
export type RawArticleFlatAssignmentCountArgs = {
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A raw article */
export type RawArticleFlatAssignmentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FlatAssignmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<FlatAssignmentFilterInput>;
};


/** A raw article */
export type RawArticleMajorVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
};


/** A raw article */
export type RawArticleVersionCountArgs = {
  where?: InputMaybe<RawArticleVersionFilterInput>;
};


/** A raw article */
export type RawArticleVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RawArticleVersionOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<RawArticleVersionFilterInput>;
};

/** A raw article's version */
export type RawArticleVersion = {
  __typename?: 'RawArticleVersion';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  allowedStatuses: Array<RawArticleStatus>;
  /** Returns a list of users for whom the transfer is possible */
  allowedTransfers: Array<User>;
  body?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  editor?: Maybe<User>;
  /** The user assigned to the version */
  editorId: Scalars['UUIDv4']['output'];
  /** Number of "forkChilrens" */
  forkChilrenCount: Scalars['UnsignedInt']['output'];
  forkChilrens: Array<RawArticleVersion>;
  forkOf?: Maybe<RawArticleVersion>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  lead?: Maybe<Scalars['String']['output']>;
  /** An array of left over Draft content */
  leftOver?: Maybe<Scalars['String']['output']>;
  nextVersion?: Maybe<RawArticleVersion>;
  previousMinorVersions: Array<RawArticleVersion>;
  previousVersion?: Maybe<RawArticleVersion>;
  rawArticle: RawArticle;
  signature?: Maybe<Scalars['String']['output']>;
  status: RawArticleStatus;
  textIsReadOnly: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


/** A raw article's version */
export type RawArticleVersionAllowedTransfersArgs = {
  name: Scalars['NonEmptyTrimmedString']['input'];
};


/** A raw article's version */
export type RawArticleVersionForkChilrenCountArgs = {
  where?: InputMaybe<RawArticleVersionFilterInput>;
};


/** A raw article's version */
export type RawArticleVersionForkChilrensArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RawArticleVersionOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<RawArticleVersionFilterInput>;
};


/** A raw article's version */
export type RawArticleVersionPreviousMinorVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
};

/** Order the "RawArticleVersion" nodes */
export enum RawArticleVersionOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest number of "forkChilrens" to the highest */
  forkChilrenCount_ASC = 'forkChilrenCount_ASC',
  /** from the highest number of "forkChilrens" to the lowest */
  forkChilrenCount_DESC = 'forkChilrenCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC'
}

/** The railroad from Censhare */
export type PrintIssueRailroad = {
  __typename?: 'PrintIssueRailroad';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  censhareCreationDate?: Maybe<Scalars['DateTime']['output']>;
  censhareUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  name: Scalars['String']['output'];
  pageCount: Scalars['UnsignedInt']['output'];
  printIssue: PrintIssue;
  publicationDate: Scalars['DateTime']['output'];
  /** Number of "railroadPages" */
  railroadPageCount: Scalars['UnsignedInt']['output'];
  railroadPages: Array<RailroadPage>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


/** The railroad from Censhare */
export type PrintIssueRailroadRailroadPageCountArgs = {
  where?: InputMaybe<RailroadPageFilterInput>;
};


/** The railroad from Censhare */
export type PrintIssueRailroadRailroadPagesArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RailroadPageOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<RailroadPageFilterInput>;
};

/** Order the "RailroadPage" nodes */
export enum RailroadPageOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "indesignFilename" to the highest */
  indesignFilename_ASC = 'indesignFilename_ASC',
  /** from the highest "indesignFilename" to the lowest */
  indesignFilename_DESC = 'indesignFilename_DESC',
  /** from the lowest "number" to the highest */
  number_ASC = 'number_ASC',
  /** from the highest "number" to the lowest */
  number_DESC = 'number_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC',
  /** from the lowest "workflowName" to the highest */
  workflowName_ASC = 'workflowName_ASC',
  /** from the highest "workflowName" to the lowest */
  workflowName_DESC = 'workflowName_DESC',
  /** from the lowest "workflowStage" to the highest */
  workflowStage_ASC = 'workflowStage_ASC',
  /** from the highest "workflowStage" to the lowest */
  workflowStage_DESC = 'workflowStage_DESC'
}

/** The pages from a railroad */
export type RailroadPage = {
  __typename?: 'RailroadPage';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  indesignFilename: Scalars['String']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  number: Scalars['UnsignedInt']['output'];
  printIssueRailroad: PrintIssueRailroad;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  visual: Scalars['String']['output'];
  workflowName: Scalars['String']['output'];
  workflowStage: Scalars['String']['output'];
};

/** Order the "FileVersion" nodes */
export enum FileVersionOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC'
}

/** Order the "AdvertisementVersion" nodes */
export enum AdvertisementVersionOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC'
}

/** Identifies exactly one "AdvertisementVersion" by "_id", "id" or "previousVersion" */
export type AdvertisementVersionUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  previousVersion?: InputMaybe<AdvertisementVersionUniqueFilterInput>;
};

/** Identifies exactly one "ArticleTemplate" by "_id" or "id" */
export type ArticleTemplateUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Identifies exactly one "Assignment" by "_id", "id", "subject-legacyId" or "rawArticle" */
export type AssignmentUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  rawArticle?: InputMaybe<RawArticleUniqueFilterInput>;
  subject?: InputMaybe<SubjectUniqueFilterInput>;
};

/** Identifies exactly one "RawArticle" by "_id" or "id" */
export type RawArticleUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Identifies exactly one "Subject" by "_id", "id", "title-unit" or "legacyId-unit" */
export type SubjectUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<UnitUniqueFilterInput>;
};

/** Identifies exactly one "Unit" by "_id" or "id" */
export type UnitUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Identifies exactly one "Attachment" by "_id" or "id" */
export type AttachmentUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Identifies exactly one "Brand" by "_id", "id" or "title" */
export type BrandUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The "CenshareTrace" nodes' filter */
export type CenshareTraceFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<CenshareTraceFilterInput>>>;
  api?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  api_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  api_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  api_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  api_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  api_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  api_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  api_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  api_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  api_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<CenshareTraceFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<CenshareTraceFilterInput>>>;
  params?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  params_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  params_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  params_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  params_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  params_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  params_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  params_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  params_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  params_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  payload?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  payload_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  payload_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  payload_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  payload_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  payload_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  payload_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  payload_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  payload_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  payload_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  payload_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  rawResponse?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  rawResponse_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  rawResponse_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  rawResponse_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  rawResponse_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  rawResponse_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  rawResponse_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  rawResponse_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  rawResponse_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  rawResponse_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  responseCode?: InputMaybe<Scalars['UnsignedInt']['input']>;
  responseCode_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  responseCode_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  responseCode_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  responseCode_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  responseCode_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  responseCode_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  responseCode_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  responseCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Identifies exactly one "CenshareTrace" by "_id" or "id" */
export type CenshareTraceUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** traces censhare api calls result */
export type CenshareTrace = {
  __typename?: 'CenshareTrace';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  /** The censhare used api */
  api: Scalars['String']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  error?: Maybe<Scalars['Boolean']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** http call query params */
  params: Scalars['String']['output'];
  /** http call payload */
  payload?: Maybe<Scalars['String']['output']>;
  /** http call (xml) raw response */
  rawResponse: Scalars['String']['output'];
  /** http call response code */
  responseCode?: Maybe<Scalars['UnsignedInt']['output']>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

/** Order the "CenshareTrace" nodes */
export enum CenshareTraceOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "responseCode" to the highest */
  responseCode_ASC = 'responseCode_ASC',
  /** from the highest "responseCode" to the lowest */
  responseCode_DESC = 'responseCode_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Identifies exactly one "File" by "_id" or "id" */
export type FileUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Identifies exactly one "FileVersion" by "_id", "id" or "previousVersion" */
export type FileVersionUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  previousVersion?: InputMaybe<FileVersionUniqueFilterInput>;
};

/** Identifies exactly one "FlatAssignment" by "assignment" */
export type FlatAssignmentUniqueFilterInput = {
  assignment: AssignmentUniqueFilterInput;
};

export type CenshareRailroadResultType = {
  __typename?: 'CenshareRailroadResultType';
  asset: Scalars['String']['output'];
};

export type CenshareRailroadByNameResultType = {
  __typename?: 'CenshareRailroadByNameResultType';
  censhareCreationDate?: Maybe<CenshareRailroadByNameCreationDateResultType>;
  censhareUpdateDate?: Maybe<CenshareRailroadByNameUpdateDateResultType>;
  comment: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pageCount: Scalars['Int']['output'];
  pages?: Maybe<Array<Maybe<CenshareRailroadByNamePagesResultType>>>;
  publicationDate: Scalars['String']['output'];
  sheets?: Maybe<Scalars['String']['output']>;
};

export type CenshareRailroadByNameCreationDateResultType = {
  __typename?: 'CenshareRailroadByNameCreationDateResultType';
  date?: Maybe<Scalars['String']['output']>;
  label_by?: Maybe<Scalars['String']['output']>;
};

export type CenshareRailroadByNameUpdateDateResultType = {
  __typename?: 'CenshareRailroadByNameUpdateDateResultType';
  date?: Maybe<Scalars['String']['output']>;
  label_by?: Maybe<Scalars['String']['output']>;
};

export type CenshareRailroadByNamePagesResultType = {
  __typename?: 'CenshareRailroadByNamePagesResultType';
  filename?: Maybe<Scalars['String']['output']>;
  indesignFilename?: Maybe<Scalars['String']['output']>;
  pageNumber: Scalars['String']['output'];
  workflow?: Maybe<Scalars['String']['output']>;
};

export type PdfPreviewResultType = {
  __typename?: 'PdfPreviewResultType';
  link: Scalars['String']['output'];
};

/** Identifies exactly one "Layout" by "_id" or "id" */
export type LayoutUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Identifies exactly one "LayoutAsset" by "_id", "id", "layout-order",
 * "layout-printHeading", "layout-mockup", "layout-file" or "layout-advertisement"
 */
export type LayoutAssetUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisement?: InputMaybe<AdvertisementUniqueFilterInput>;
  file?: InputMaybe<FileUniqueFilterInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  layout?: InputMaybe<LayoutUniqueFilterInput>;
  mockup?: InputMaybe<MockupUniqueFilterInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<PrintHeadingUniqueFilterInput>;
};

/** Identifies exactly one "Mockup" by "_id", "id" or "printHeading" */
export type MockupUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  printHeading?: InputMaybe<PrintHeadingUniqueFilterInput>;
};

/** Identifies exactly one "PrintHeading" by "_id", "id", "legacyId-printIssue", "title-printIssue" or "title-printPublication" */
export type PrintHeadingUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssue?: InputMaybe<PrintIssueUniqueFilterInput>;
  printPublication?: InputMaybe<PrintPublicationUniqueFilterInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "PrintIssue" by "_id", "id", "legacyId-printPublication" or "title-printPublication" */
export type PrintIssueUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printPublication?: InputMaybe<PrintPublicationUniqueFilterInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "PrintPublication" by "_id", "id", "key", "legacyId-brand" or "title-brand" */
export type PrintPublicationUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brand?: InputMaybe<BrandUniqueFilterInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MockupVersion" by "_id", "id" or "previousVersion" */
export type MockupVersionUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  previousVersion?: InputMaybe<MockupVersionUniqueFilterInput>;
};

/** Identifies exactly one "PrintHeadingPrintTemplate" by "_id", "id" or "printHeading-printTemplate" */
export type PrintHeadingPrintTemplateUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  printHeading?: InputMaybe<PrintHeadingUniqueFilterInput>;
  printTemplate?: InputMaybe<PrintTemplateUniqueFilterInput>;
};

/** Identifies exactly one "PrintTemplate" by "_id", "id" or "S3ObjectId" */
export type PrintTemplateUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** associated S3 object id */
  S3ObjectId?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "PrintIssueRailroad" by "_id", "id" or "printIssue" */
export type PrintIssueRailroadUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  printIssue?: InputMaybe<PrintIssueUniqueFilterInput>;
};

/** Order the "PrintIssueRailroad" nodes */
export enum PrintIssueRailroadOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "censhareCreationDate" to the highest */
  censhareCreationDate_ASC = 'censhareCreationDate_ASC',
  /** from the highest "censhareCreationDate" to the lowest */
  censhareCreationDate_DESC = 'censhareCreationDate_DESC',
  /** from the lowest "censhareUpdateDate" to the highest */
  censhareUpdateDate_ASC = 'censhareUpdateDate_ASC',
  /** from the highest "censhareUpdateDate" to the lowest */
  censhareUpdateDate_DESC = 'censhareUpdateDate_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "name" to the highest */
  name_ASC = 'name_ASC',
  /** from the highest "name" to the lowest */
  name_DESC = 'name_DESC',
  /** from the lowest "pageCount" to the highest */
  pageCount_ASC = 'pageCount_ASC',
  /** from the highest "pageCount" to the lowest */
  pageCount_DESC = 'pageCount_DESC',
  /** from the lowest "publicationDate" to the highest */
  publicationDate_ASC = 'publicationDate_ASC',
  /** from the highest "publicationDate" to the lowest */
  publicationDate_DESC = 'publicationDate_DESC',
  /** from the lowest number of "railroadPages" to the highest */
  railroadPageCount_ASC = 'railroadPageCount_ASC',
  /** from the highest number of "railroadPages" to the lowest */
  railroadPageCount_DESC = 'railroadPageCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PrintTemplateDownloadResultType = {
  __typename?: 'PrintTemplateDownloadResultType';
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PrintTemplateDraftFieldsDataType = {
  id: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export enum PrintTemplateDraftFormatType {
  INDD = 'INDD',
  PDF = 'PDF',
  PNG = 'PNG'
}

export type PrintTemplateDraftsResultType = {
  __typename?: 'PrintTemplateDraftsResultType';
  artifacts: Array<PrintTemplateDraftArtifactType>;
  draftId: Scalars['String']['output'];
};

export type PrintTemplateDraftArtifactType = {
  __typename?: 'PrintTemplateDraftArtifactType';
  page: Scalars['Int']['output'];
  S3ObjectId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Order the "PrintTemplate" nodes */
export enum PrintTemplateOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest number of "articleTemplates" to the highest */
  articleTemplateCount_ASC = 'articleTemplateCount_ASC',
  /** from the highest number of "articleTemplates" to the lowest */
  articleTemplateCount_DESC = 'articleTemplateCount_DESC',
  /** from the lowest number of "assignments" to the highest */
  assignmentCount_ASC = 'assignmentCount_ASC',
  /** from the highest number of "assignments" to the lowest */
  assignmentCount_DESC = 'assignmentCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "filesize" to the highest */
  filesize_ASC = 'filesize_ASC',
  /** from the highest "filesize" to the lowest */
  filesize_DESC = 'filesize_DESC',
  /** from the lowest number of "flatAssignments" to the highest */
  flatAssignmentCount_ASC = 'flatAssignmentCount_ASC',
  /** from the highest number of "flatAssignments" to the lowest */
  flatAssignmentCount_DESC = 'flatAssignmentCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "pageCount" to the highest */
  pageCount_ASC = 'pageCount_ASC',
  /** from the highest "pageCount" to the lowest */
  pageCount_DESC = 'pageCount_DESC',
  /** from the lowest number of "printHeadings" to the highest */
  printHeadingCount_ASC = 'printHeadingCount_ASC',
  /** from the highest number of "printHeadings" to the lowest */
  printHeadingCount_DESC = 'printHeadingCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PrintTemplateUploadResultType = {
  __typename?: 'PrintTemplateUploadResultType';
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Identifies exactly one "RailroadPage" by "_id" or "id" */
export type RailroadPageUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Order the "RawArticle" nodes */
export enum RawArticleOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest number of "flatAssignments" to the highest */
  flatAssignmentCount_ASC = 'flatAssignmentCount_ASC',
  /** from the highest number of "flatAssignments" to the lowest */
  flatAssignmentCount_DESC = 'flatAssignmentCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "legacyId" to the highest */
  legacyId_ASC = 'legacyId_ASC',
  /** from the highest "legacyId" to the lowest */
  legacyId_DESC = 'legacyId_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC',
  /** from the lowest number of "versions" to the highest */
  versionCount_ASC = 'versionCount_ASC',
  /** from the highest number of "versions" to the lowest */
  versionCount_DESC = 'versionCount_DESC'
}

/** Identifies exactly one "RawArticleVersion" by "_id", "id" or "previousVersion" */
export type RawArticleVersionUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  previousVersion?: InputMaybe<RawArticleVersionUniqueFilterInput>;
};

/** Identifies exactly one "SubjectCategory" by "_id" or "id" */
export type SubjectCategoryUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Identifies exactly one "SubjectUser" by "userId-subject" */
export type SubjectUserUniqueFilterInput = {
  subject: SubjectUniqueFilterInput;
  userId: Scalars['UUIDv4']['input'];
};

/** Identifies exactly one "SubSubject" by "_id", "id" or "title-subject" */
export type SubSubjectUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  subject?: InputMaybe<SubjectUniqueFilterInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The "TopicFotowebPige" nodes' filter */
export type TopicFotowebPigeFilterInput = {
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  _id_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  AND?: InputMaybe<Array<InputMaybe<TopicFotowebPigeFilterInput>>>;
  caption?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  caption_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  caption_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  caption_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  caption_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  caption_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  caption_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  caption_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  caption_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  copyright?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  copyright_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  copyright_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  copyright_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  copyright_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  copyright_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  copyright_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  copyright_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  copyright_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  copyright_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  copyright_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  credit?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  credit_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  credit_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  credit_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  credit_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  credit_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  credit_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  credit_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  credit_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  credit_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  credit_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  dimensions?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  dimensions_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  dimensions_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  dimensions_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  dimensions_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  dimensions_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  dimensions_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  dimensions_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  dimensions_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  dimensions_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  dimensions_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fileName?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  fileName_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fileName_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  fileName_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  fileName_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  fileName_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fileName_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  fileName_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fileName_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fotowebId?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  fotowebId_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fotowebId_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fotowebId_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  fotowebId_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  fotowebId_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fotowebId_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fotowebId_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  fotowebId_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  fotowebId_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  headline?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  headline_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  headline_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  headline_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  headline_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  headline_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  headline_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  headline_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  headline_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lastOperatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  lastOperatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lastOperatorId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  NOT?: InputMaybe<TopicFotowebPigeFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<TopicFotowebPigeFilterInput>>>;
  originalName?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  originalName_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  originalName_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  originalName_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  originalName_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  originalName_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  originalName_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  originalName_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  originalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  originalName_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  originalName_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  page?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  page_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  page_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  page_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  page_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  page_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  page_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  page_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  page_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  page_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  page_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priceLevel?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  priceLevel_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priceLevel_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priceLevel_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  priceLevel_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  priceLevel_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  priceLevel_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priceLevel_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priceLevel_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  priceLevel_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  priceLevel_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printIssueTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  printIssueTitle_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printIssueTitle_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printIssueTitle_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  printIssueTitle_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  printIssueTitle_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printIssueTitle_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printIssueTitle_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  printIssueTitle_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printIssueTitle_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printPublicationKey?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  printPublicationKey_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printPublicationKey_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printPublicationKey_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  printPublicationKey_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  printPublicationKey_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printPublicationKey_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printPublicationKey_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  printPublicationKey_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  printPublicationKey_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  source?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  source_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  source_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  source_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  source_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  source_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  source_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  source_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  source_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  source_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  source_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Identifies exactly one "TopicFotowebPige" by "_id", "id" or "fileName-page" */
export type TopicFotowebPigeUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
};

/** Stock topic piges written by colorfactory using odbc */
export type TopicFotowebPige = {
  __typename?: 'TopicFotowebPige';
  /** The private ID */
  _id: Scalars['UnsignedInt']['output'];
  caption?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The ID of the user who created the document */
  creatorId: Scalars['UUIDv4']['output'];
  credit?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fotowebId: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The ID of the user who last updated the document */
  lastOperatorId: Scalars['UUIDv4']['output'];
  originalName?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['String']['output']>;
  priceLevel?: Maybe<Scalars['String']['output']>;
  printIssueTitle: Scalars['String']['output'];
  printPublicationKey: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

/** Order the "TopicFotowebPige" nodes */
export enum TopicFotowebPigeOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Order the "Unit" nodes */
export enum UnitOrderingInput {
  /** from the lowest "_id" to the highest */
  _id_ASC = '_id_ASC',
  /** from the highest "_id" to the lowest */
  _id_DESC = '_id_DESC',
  /** from the lowest number of "brands" to the highest */
  brandCount_ASC = 'brandCount_ASC',
  /** from the highest number of "brands" to the lowest */
  brandCount_DESC = 'brandCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "subjectCategories" to the highest */
  subjectCategoryCount_ASC = 'subjectCategoryCount_ASC',
  /** from the highest number of "subjectCategories" to the lowest */
  subjectCategoryCount_DESC = 'subjectCategoryCount_DESC',
  /** from the lowest number of "subjects" to the highest */
  subjectCount_ASC = 'subjectCount_ASC',
  /** from the highest number of "subjects" to the lowest */
  subjectCount_DESC = 'subjectCount_DESC',
  /** from the lowest "title" to the highest */
  title_ASC = 'title_ASC',
  /** from the highest "title" to the lowest */
  title_DESC = 'title_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Identifies exactly one "Website" by "_id", "id", "key", "legacyId-brand" or "title-brand" */
export type WebsiteUniqueFilterInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brand?: InputMaybe<BrandUniqueFilterInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'mutation';
  /** Creates one "Advertisement", throws an error if it already exists */
  createAdvertisement: Advertisement;
  /** Creates one "Advertisement" if it does not exist, returns the existing otherwise */
  createAdvertisementIfNotExists: Advertisement;
  /** Creates some "Advertisement", throws an error if they already exist */
  createAdvertisements: Array<Advertisement>;
  /** Creates one "AdvertisementVersion", throws an error if it already exists */
  createAdvertisementVersion: AdvertisementVersion;
  /** Creates one "AdvertisementVersion" if it does not exist, returns the existing otherwise */
  createAdvertisementVersionIfNotExists: AdvertisementVersion;
  /** Creates some "AdvertisementVersion", throws an error if they already exist */
  createAdvertisementVersions: Array<AdvertisementVersion>;
  /** Creates one "ArticleTemplate", throws an error if it already exists */
  createArticleTemplate: ArticleTemplate;
  /** Creates one "ArticleTemplate" if it does not exist, returns the existing otherwise */
  createArticleTemplateIfNotExists: ArticleTemplate;
  /** Creates some "ArticleTemplate", throws an error if they already exist */
  createArticleTemplates: Array<ArticleTemplate>;
  /** Creates one "Assignment", throws an error if it already exists */
  createAssignment: Assignment;
  /** Creates one "Assignment" if it does not exist, returns the existing otherwise */
  createAssignmentIfNotExists: Assignment;
  /** Creates some "Assignment", throws an error if they already exist */
  createAssignments: Array<Assignment>;
  /** Creates one "Attachment", throws an error if it already exists */
  createAttachment: Attachment;
  /** Creates one "Attachment" if it does not exist, returns the existing otherwise */
  createAttachmentIfNotExists: Attachment;
  /** Creates some "Attachment", throws an error if they already exist */
  createAttachments: Array<Attachment>;
  /** Creates one "Brand", throws an error if it already exists */
  createBrand: Brand;
  /** Creates one "Brand" if it does not exist, returns the existing otherwise */
  createBrandIfNotExists: Brand;
  /** Creates some "Brand", throws an error if they already exist */
  createBrands: Array<Brand>;
  /** Creates one "CenshareTrace", throws an error if it already exists */
  createCenshareTrace: CenshareTrace;
  /** Creates one "CenshareTrace" if it does not exist, returns the existing otherwise */
  createCenshareTraceIfNotExists: CenshareTrace;
  /** Creates some "CenshareTrace", throws an error if they already exist */
  createCenshareTraces: Array<CenshareTrace>;
  /** Creates one "File", throws an error if it already exists */
  createFile: File;
  /** Creates one "File" if it does not exist, returns the existing otherwise */
  createFileIfNotExists: File;
  /** Creates some "File", throws an error if they already exist */
  createFiles: Array<File>;
  /** Creates one "FileVersion", throws an error if it already exists */
  createFileVersion: FileVersion;
  /** Creates one "FileVersion" if it does not exist, returns the existing otherwise */
  createFileVersionIfNotExists: FileVersion;
  /** Creates some "FileVersion", throws an error if they already exist */
  createFileVersions: Array<FileVersion>;
  /** Creates one "Layout", throws an error if it already exists */
  createLayout: Layout;
  /** Creates one "LayoutAsset", throws an error if it already exists */
  createLayoutAsset: LayoutAsset;
  /** Creates one "LayoutAsset" if it does not exist, returns the existing otherwise */
  createLayoutAssetIfNotExists: LayoutAsset;
  /** Creates some "LayoutAsset", throws an error if they already exist */
  createLayoutAssets: Array<LayoutAsset>;
  /** Creates one "Layout" if it does not exist, returns the existing otherwise */
  createLayoutIfNotExists: Layout;
  /** Creates some "Layout", throws an error if they already exist */
  createLayouts: Array<Layout>;
  /** Creates one "Mockup", throws an error if it already exists */
  createMockup: Mockup;
  /** Creates one "Mockup" if it does not exist, returns the existing otherwise */
  createMockupIfNotExists: Mockup;
  /** Creates some "Mockup", throws an error if they already exist */
  createMockups: Array<Mockup>;
  /** Creates one "MockupVersion", throws an error if it already exists */
  createMockupVersion: MockupVersion;
  /** Creates one "MockupVersion" if it does not exist, returns the existing otherwise */
  createMockupVersionIfNotExists: MockupVersion;
  /** Creates some "MockupVersion", throws an error if they already exist */
  createMockupVersions: Array<MockupVersion>;
  /** Creates one "PrintHeading", throws an error if it already exists */
  createPrintHeading: PrintHeading;
  /** Creates one "PrintHeading" if it does not exist, returns the existing otherwise */
  createPrintHeadingIfNotExists: PrintHeading;
  /** Creates one "PrintHeadingPrintTemplate", throws an error if it already exists */
  createPrintHeadingPrintTemplate: PrintHeadingPrintTemplate;
  /** Creates one "PrintHeadingPrintTemplate" if it does not exist, returns the existing otherwise */
  createPrintHeadingPrintTemplateIfNotExists: PrintHeadingPrintTemplate;
  /** Creates some "PrintHeadingPrintTemplate", throws an error if they already exist */
  createPrintHeadingPrintTemplates: Array<PrintHeadingPrintTemplate>;
  /** Creates some "PrintHeading", throws an error if they already exist */
  createPrintHeadings: Array<PrintHeading>;
  /** Creates one "PrintIssue", throws an error if it already exists */
  createPrintIssue: PrintIssue;
  /** Creates one "PrintIssue" if it does not exist, returns the existing otherwise */
  createPrintIssueIfNotExists: PrintIssue;
  /** Creates one "PrintIssueRailroad", throws an error if it already exists */
  createPrintIssueRailroad: PrintIssueRailroad;
  /** Creates one "PrintIssueRailroad" if it does not exist, returns the existing otherwise */
  createPrintIssueRailroadIfNotExists: PrintIssueRailroad;
  /** Creates some "PrintIssueRailroad", throws an error if they already exist */
  createPrintIssueRailroads: Array<PrintIssueRailroad>;
  /** Creates some "PrintIssue", throws an error if they already exist */
  createPrintIssues: Array<PrintIssue>;
  /** Creates one "PrintPublication", throws an error if it already exists */
  createPrintPublication: PrintPublication;
  /** Creates one "PrintPublication" if it does not exist, returns the existing otherwise */
  createPrintPublicationIfNotExists: PrintPublication;
  /** Creates some "PrintPublication", throws an error if they already exist */
  createPrintPublications: Array<PrintPublication>;
  /** Creates one "PrintTemplate", throws an error if it already exists */
  createPrintTemplate: PrintTemplate;
  /** Creates one "PrintTemplate" if it does not exist, returns the existing otherwise */
  createPrintTemplateIfNotExists: PrintTemplate;
  /** Creates some "PrintTemplate", throws an error if they already exist */
  createPrintTemplates: Array<PrintTemplate>;
  /** Creates one "RailroadPage", throws an error if it already exists */
  createRailroadPage: RailroadPage;
  /** Creates one "RailroadPage" if it does not exist, returns the existing otherwise */
  createRailroadPageIfNotExists: RailroadPage;
  /** Creates some "RailroadPage", throws an error if they already exist */
  createRailroadPages: Array<RailroadPage>;
  /** Creates one "RawArticle", throws an error if it already exists */
  createRawArticle: RawArticle;
  /** Creates one "RawArticle" if it does not exist, returns the existing otherwise */
  createRawArticleIfNotExists: RawArticle;
  /** Creates some "RawArticle", throws an error if they already exist */
  createRawArticles: Array<RawArticle>;
  /** Creates one "RawArticleVersion", throws an error if it already exists */
  createRawArticleVersion: RawArticleVersion;
  /** Creates one "RawArticleVersion" if it does not exist, returns the existing otherwise */
  createRawArticleVersionIfNotExists: RawArticleVersion;
  /** Creates some "RawArticleVersion", throws an error if they already exist */
  createRawArticleVersions: Array<RawArticleVersion>;
  /** Creates one "Subject", throws an error if it already exists */
  createSubject: Subject;
  /** Creates some "SubjectCategory", throws an error if they already exist */
  createSubjectCategories: Array<SubjectCategory>;
  /** Creates one "SubjectCategory", throws an error if it already exists */
  createSubjectCategory: SubjectCategory;
  /** Creates one "SubjectCategory" if it does not exist, returns the existing otherwise */
  createSubjectCategoryIfNotExists: SubjectCategory;
  /** Creates one "Subject" if it does not exist, returns the existing otherwise */
  createSubjectIfNotExists: Subject;
  /** Creates some "Subject", throws an error if they already exist */
  createSubjects: Array<Subject>;
  /** Creates one "SubjectUser", throws an error if it already exists */
  createSubjectUser: SubjectUser;
  /** Creates one "SubjectUser" if it does not exist, returns the existing otherwise */
  createSubjectUserIfNotExists: SubjectUser;
  /** Creates some "SubjectUser", throws an error if they already exist */
  createSubjectUsers: Array<SubjectUser>;
  /** Creates one "SubSubject", throws an error if it already exists */
  createSubSubject: SubSubject;
  /** Creates one "SubSubject" if it does not exist, returns the existing otherwise */
  createSubSubjectIfNotExists: SubSubject;
  /** Creates some "SubSubject", throws an error if they already exist */
  createSubSubjects: Array<SubSubject>;
  /** Creates one "TopicFotowebPige", throws an error if it already exists */
  createTopicFotowebPige: TopicFotowebPige;
  /** Creates one "TopicFotowebPige" if it does not exist, returns the existing otherwise */
  createTopicFotowebPigeIfNotExists: TopicFotowebPige;
  /** Creates some "TopicFotowebPige", throws an error if they already exist */
  createTopicFotowebPiges: Array<TopicFotowebPige>;
  /** Creates one "Unit", throws an error if it already exists */
  createUnit: Unit;
  /** Creates one "Unit" if it does not exist, returns the existing otherwise */
  createUnitIfNotExists: Unit;
  /** Creates some "Unit", throws an error if they already exist */
  createUnits: Array<Unit>;
  /** Creates one "Website", throws an error if it already exists */
  createWebsite: Website;
  /** Creates one "Website" if it does not exist, returns the existing otherwise */
  createWebsiteIfNotExists: Website;
  /** Creates some "Website", throws an error if they already exist */
  createWebsites: Array<Website>;
  /** Deletes one "Advertisement", throws an error if it does not exists */
  deleteAdvertisement: Advertisement;
  /** Deletes one "Advertisement" if it exists, returns null otherwise */
  deleteAdvertisementIfExists?: Maybe<Advertisement>;
  /** Deletes many "Advertisements" */
  deleteAdvertisements: Array<Advertisement>;
  /** Deletes one "AdvertisementVersion", throws an error if it does not exists */
  deleteAdvertisementVersion: AdvertisementVersion;
  /** Deletes one "AdvertisementVersion" if it exists, returns null otherwise */
  deleteAdvertisementVersionIfExists?: Maybe<AdvertisementVersion>;
  /** Deletes many "AdvertisementVersions" */
  deleteAdvertisementVersions: Array<AdvertisementVersion>;
  /** Deletes one "ArticleTemplate", throws an error if it does not exists */
  deleteArticleTemplate: ArticleTemplate;
  /** Deletes one "ArticleTemplate" if it exists, returns null otherwise */
  deleteArticleTemplateIfExists?: Maybe<ArticleTemplate>;
  /** Deletes many "ArticleTemplates" */
  deleteArticleTemplates: Array<ArticleTemplate>;
  /** Deletes one "Assignment", throws an error if it does not exists */
  deleteAssignment: Assignment;
  /** Deletes one "Assignment" if it exists, returns null otherwise */
  deleteAssignmentIfExists?: Maybe<Assignment>;
  /** Deletes many "Assignments" */
  deleteAssignments: Array<Assignment>;
  /** Deletes one "Attachment", throws an error if it does not exists */
  deleteAttachment: Attachment;
  /** Deletes one "Attachment" if it exists, returns null otherwise */
  deleteAttachmentIfExists?: Maybe<Attachment>;
  /** Deletes many "Attachments" */
  deleteAttachments: Array<Attachment>;
  /** Deletes one "Brand", throws an error if it does not exists */
  deleteBrand: Brand;
  /** Deletes one "Brand" if it exists, returns null otherwise */
  deleteBrandIfExists?: Maybe<Brand>;
  /** Deletes many "Brands" */
  deleteBrands: Array<Brand>;
  /** Deletes one "CenshareTrace", throws an error if it does not exists */
  deleteCenshareTrace: CenshareTrace;
  /** Deletes one "CenshareTrace" if it exists, returns null otherwise */
  deleteCenshareTraceIfExists?: Maybe<CenshareTrace>;
  /** Deletes many "CenshareTraces" */
  deleteCenshareTraces: Array<CenshareTrace>;
  /** Deletes one "File", throws an error if it does not exists */
  deleteFile: File;
  /** Deletes one "File" if it exists, returns null otherwise */
  deleteFileIfExists?: Maybe<File>;
  /** Deletes many "Files" */
  deleteFiles: Array<File>;
  /** Deletes one "FileVersion", throws an error if it does not exists */
  deleteFileVersion: FileVersion;
  /** Deletes one "FileVersion" if it exists, returns null otherwise */
  deleteFileVersionIfExists?: Maybe<FileVersion>;
  /** Deletes many "FileVersions" */
  deleteFileVersions: Array<FileVersion>;
  /** Deletes one "Layout", throws an error if it does not exists */
  deleteLayout: Layout;
  /** Deletes one "LayoutAsset", throws an error if it does not exists */
  deleteLayoutAsset: LayoutAsset;
  /** Deletes one "LayoutAsset" if it exists, returns null otherwise */
  deleteLayoutAssetIfExists?: Maybe<LayoutAsset>;
  /** Deletes many "LayoutAssets" */
  deleteLayoutAssets: Array<LayoutAsset>;
  /** Deletes one "Layout" if it exists, returns null otherwise */
  deleteLayoutIfExists?: Maybe<Layout>;
  /** Deletes many "Layouts" */
  deleteLayouts: Array<Layout>;
  /** Deletes one "Mockup", throws an error if it does not exists */
  deleteMockup: Mockup;
  /** Deletes one "Mockup" if it exists, returns null otherwise */
  deleteMockupIfExists?: Maybe<Mockup>;
  /** Deletes many "Mockups" */
  deleteMockups: Array<Mockup>;
  /** Deletes one "MockupVersion", throws an error if it does not exists */
  deleteMockupVersion: MockupVersion;
  /** Deletes one "MockupVersion" if it exists, returns null otherwise */
  deleteMockupVersionIfExists?: Maybe<MockupVersion>;
  /** Deletes many "MockupVersions" */
  deleteMockupVersions: Array<MockupVersion>;
  /** Deletes one "PrintHeading", throws an error if it does not exists */
  deletePrintHeading: PrintHeading;
  /** Deletes one "PrintHeading" if it exists, returns null otherwise */
  deletePrintHeadingIfExists?: Maybe<PrintHeading>;
  /** Deletes one "PrintHeadingPrintTemplate", throws an error if it does not exists */
  deletePrintHeadingPrintTemplate: PrintHeadingPrintTemplate;
  /** Deletes one "PrintHeadingPrintTemplate" if it exists, returns null otherwise */
  deletePrintHeadingPrintTemplateIfExists?: Maybe<PrintHeadingPrintTemplate>;
  /** Deletes many "PrintHeadingPrintTemplates" */
  deletePrintHeadingPrintTemplates: Array<PrintHeadingPrintTemplate>;
  /** Deletes many "PrintHeadings" */
  deletePrintHeadings: Array<PrintHeading>;
  /** Deletes one "PrintIssue", throws an error if it does not exists */
  deletePrintIssue: PrintIssue;
  /** Deletes one "PrintIssue" if it exists, returns null otherwise */
  deletePrintIssueIfExists?: Maybe<PrintIssue>;
  /** Deletes one "PrintIssueRailroad", throws an error if it does not exists */
  deletePrintIssueRailroad: PrintIssueRailroad;
  /** Deletes one "PrintIssueRailroad" if it exists, returns null otherwise */
  deletePrintIssueRailroadIfExists?: Maybe<PrintIssueRailroad>;
  /** Deletes many "PrintIssueRailroads" */
  deletePrintIssueRailroads: Array<PrintIssueRailroad>;
  /** Deletes many "PrintIssues" */
  deletePrintIssues: Array<PrintIssue>;
  /** Deletes one "PrintPublication", throws an error if it does not exists */
  deletePrintPublication: PrintPublication;
  /** Deletes one "PrintPublication" if it exists, returns null otherwise */
  deletePrintPublicationIfExists?: Maybe<PrintPublication>;
  /** Deletes many "PrintPublications" */
  deletePrintPublications: Array<PrintPublication>;
  /** Deletes one "PrintTemplate", throws an error if it does not exists */
  deletePrintTemplate: PrintTemplate;
  /** Deletes one "PrintTemplate" if it exists, returns null otherwise */
  deletePrintTemplateIfExists?: Maybe<PrintTemplate>;
  /** Deletes many "PrintTemplates" */
  deletePrintTemplates: Array<PrintTemplate>;
  /** Deletes one "RailroadPage", throws an error if it does not exists */
  deleteRailroadPage: RailroadPage;
  /** Deletes one "RailroadPage" if it exists, returns null otherwise */
  deleteRailroadPageIfExists?: Maybe<RailroadPage>;
  /** Deletes many "RailroadPages" */
  deleteRailroadPages: Array<RailroadPage>;
  /** Deletes one "RawArticle", throws an error if it does not exists */
  deleteRawArticle: RawArticle;
  /** Deletes one "RawArticle" if it exists, returns null otherwise */
  deleteRawArticleIfExists?: Maybe<RawArticle>;
  /** Deletes many "RawArticles" */
  deleteRawArticles: Array<RawArticle>;
  /** Deletes one "RawArticleVersion", throws an error if it does not exists */
  deleteRawArticleVersion: RawArticleVersion;
  /** Deletes one "RawArticleVersion" if it exists, returns null otherwise */
  deleteRawArticleVersionIfExists?: Maybe<RawArticleVersion>;
  /** Deletes many "RawArticleVersions" */
  deleteRawArticleVersions: Array<RawArticleVersion>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "Advertisements" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeAdvertisementsInOrder: Array<Advertisement>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "Advertisements" then returns their old values, or null, in the same order
   */
  deleteSomeAdvertisementsInOrderIfExists: Array<Maybe<Advertisement>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "AdvertisementVersions" then returns their old values in the same order,
   * throws an error if one does not exist
   */
  deleteSomeAdvertisementVersionsInOrder: Array<AdvertisementVersion>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "AdvertisementVersions" then returns their old values, or null, in the same order
   */
  deleteSomeAdvertisementVersionsInOrderIfExists: Array<Maybe<AdvertisementVersion>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleTemplates" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeArticleTemplatesInOrder: Array<ArticleTemplate>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleTemplates" then returns their old values, or null, in the same order
   */
  deleteSomeArticleTemplatesInOrderIfExists: Array<Maybe<ArticleTemplate>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Assignments"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeAssignmentsInOrder: Array<Assignment>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Assignments"
   * then returns their old values, or null, in the same order
   */
  deleteSomeAssignmentsInOrderIfExists: Array<Maybe<Assignment>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Attachments"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeAttachmentsInOrder: Array<Attachment>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Attachments"
   * then returns their old values, or null, in the same order
   */
  deleteSomeAttachmentsInOrderIfExists: Array<Maybe<Attachment>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Brands" then
   * returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeBrandsInOrder: Array<Brand>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Brands" then
   * returns their old values, or null, in the same order
   */
  deleteSomeBrandsInOrderIfExists: Array<Maybe<Brand>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "CenshareTraces" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeCenshareTracesInOrder: Array<CenshareTrace>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "CenshareTraces" then returns their old values, or null, in the same order
   */
  deleteSomeCenshareTracesInOrderIfExists: Array<Maybe<CenshareTrace>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Files" then
   * returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeFilesInOrder: Array<File>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Files" then
   * returns their old values, or null, in the same order
   */
  deleteSomeFilesInOrderIfExists: Array<Maybe<File>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "FileVersions" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeFileVersionsInOrder: Array<FileVersion>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "FileVersions" then returns their old values, or null, in the same order
   */
  deleteSomeFileVersionsInOrderIfExists: Array<Maybe<FileVersion>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "LayoutAssets" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeLayoutAssetsInOrder: Array<LayoutAsset>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "LayoutAssets" then returns their old values, or null, in the same order
   */
  deleteSomeLayoutAssetsInOrderIfExists: Array<Maybe<LayoutAsset>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Layouts"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeLayoutsInOrder: Array<Layout>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Layouts"
   * then returns their old values, or null, in the same order
   */
  deleteSomeLayoutsInOrderIfExists: Array<Maybe<Layout>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Mockups"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeMockupsInOrder: Array<Mockup>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Mockups"
   * then returns their old values, or null, in the same order
   */
  deleteSomeMockupsInOrderIfExists: Array<Maybe<Mockup>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "MockupVersions" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeMockupVersionsInOrder: Array<MockupVersion>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "MockupVersions" then returns their old values, or null, in the same order
   */
  deleteSomeMockupVersionsInOrderIfExists: Array<Maybe<MockupVersion>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PrintHeadingPrintTemplates" then returns their old values in the same order,
   * throws an error if one does not exist
   */
  deleteSomePrintHeadingPrintTemplatesInOrder: Array<PrintHeadingPrintTemplate>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PrintHeadingPrintTemplates" then returns their old values, or null, in the same order
   */
  deleteSomePrintHeadingPrintTemplatesInOrderIfExists: Array<Maybe<PrintHeadingPrintTemplate>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PrintHeadings" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomePrintHeadingsInOrder: Array<PrintHeading>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PrintHeadings" then returns their old values, or null, in the same order
   */
  deleteSomePrintHeadingsInOrderIfExists: Array<Maybe<PrintHeading>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PrintIssueRailroads" then returns their old values in the same order, throws
   * an error if one does not exist
   */
  deleteSomePrintIssueRailroadsInOrder: Array<PrintIssueRailroad>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PrintIssueRailroads" then returns their old values, or null, in the same order
   */
  deleteSomePrintIssueRailroadsInOrderIfExists: Array<Maybe<PrintIssueRailroad>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "PrintIssues"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomePrintIssuesInOrder: Array<PrintIssue>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "PrintIssues"
   * then returns their old values, or null, in the same order
   */
  deleteSomePrintIssuesInOrderIfExists: Array<Maybe<PrintIssue>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PrintPublications" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomePrintPublicationsInOrder: Array<PrintPublication>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PrintPublications" then returns their old values, or null, in the same order
   */
  deleteSomePrintPublicationsInOrderIfExists: Array<Maybe<PrintPublication>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PrintTemplates" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomePrintTemplatesInOrder: Array<PrintTemplate>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PrintTemplates" then returns their old values, or null, in the same order
   */
  deleteSomePrintTemplatesInOrderIfExists: Array<Maybe<PrintTemplate>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "RailroadPages" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeRailroadPagesInOrder: Array<RailroadPage>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "RailroadPages" then returns their old values, or null, in the same order
   */
  deleteSomeRailroadPagesInOrderIfExists: Array<Maybe<RailroadPage>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "RawArticles"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeRawArticlesInOrder: Array<RawArticle>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "RawArticles"
   * then returns their old values, or null, in the same order
   */
  deleteSomeRawArticlesInOrderIfExists: Array<Maybe<RawArticle>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "RawArticleVersions" then returns their old values in the same order, throws
   * an error if one does not exist
   */
  deleteSomeRawArticleVersionsInOrder: Array<RawArticleVersion>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "RawArticleVersions" then returns their old values, or null, in the same order
   */
  deleteSomeRawArticleVersionsInOrderIfExists: Array<Maybe<RawArticleVersion>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "SubjectCategories" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeSubjectCategoriesInOrder: Array<SubjectCategory>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "SubjectCategories" then returns their old values, or null, in the same order
   */
  deleteSomeSubjectCategoriesInOrderIfExists: Array<Maybe<SubjectCategory>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Subjects"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeSubjectsInOrder: Array<Subject>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Subjects"
   * then returns their old values, or null, in the same order
   */
  deleteSomeSubjectsInOrderIfExists: Array<Maybe<Subject>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "SubjectUsers" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeSubjectUsersInOrder: Array<SubjectUser>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "SubjectUsers" then returns their old values, or null, in the same order
   */
  deleteSomeSubjectUsersInOrderIfExists: Array<Maybe<SubjectUser>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "SubSubjects"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeSubSubjectsInOrder: Array<SubSubject>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "SubSubjects"
   * then returns their old values, or null, in the same order
   */
  deleteSomeSubSubjectsInOrderIfExists: Array<Maybe<SubSubject>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "TopicFotowebPiges" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeTopicFotowebPigesInOrder: Array<TopicFotowebPige>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "TopicFotowebPiges" then returns their old values, or null, in the same order
   */
  deleteSomeTopicFotowebPigesInOrderIfExists: Array<Maybe<TopicFotowebPige>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Units" then
   * returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeUnitsInOrder: Array<Unit>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Units" then
   * returns their old values, or null, in the same order
   */
  deleteSomeUnitsInOrderIfExists: Array<Maybe<Unit>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Websites"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeWebsitesInOrder: Array<Website>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Websites"
   * then returns their old values, or null, in the same order
   */
  deleteSomeWebsitesInOrderIfExists: Array<Maybe<Website>>;
  /** Deletes one "Subject", throws an error if it does not exists */
  deleteSubject: Subject;
  /** Deletes many "SubjectCategories" */
  deleteSubjectCategories: Array<SubjectCategory>;
  /** Deletes one "SubjectCategory", throws an error if it does not exists */
  deleteSubjectCategory: SubjectCategory;
  /** Deletes one "SubjectCategory" if it exists, returns null otherwise */
  deleteSubjectCategoryIfExists?: Maybe<SubjectCategory>;
  /** Deletes one "Subject" if it exists, returns null otherwise */
  deleteSubjectIfExists?: Maybe<Subject>;
  /** Deletes many "Subjects" */
  deleteSubjects: Array<Subject>;
  /** Deletes one "SubjectUser", throws an error if it does not exists */
  deleteSubjectUser: SubjectUser;
  /** Deletes one "SubjectUser" if it exists, returns null otherwise */
  deleteSubjectUserIfExists?: Maybe<SubjectUser>;
  /** Deletes many "SubjectUsers" */
  deleteSubjectUsers: Array<SubjectUser>;
  /** Deletes one "SubSubject", throws an error if it does not exists */
  deleteSubSubject: SubSubject;
  /** Deletes one "SubSubject" if it exists, returns null otherwise */
  deleteSubSubjectIfExists?: Maybe<SubSubject>;
  /** Deletes many "SubSubjects" */
  deleteSubSubjects: Array<SubSubject>;
  /** Deletes one "TopicFotowebPige", throws an error if it does not exists */
  deleteTopicFotowebPige: TopicFotowebPige;
  /** Deletes one "TopicFotowebPige" if it exists, returns null otherwise */
  deleteTopicFotowebPigeIfExists?: Maybe<TopicFotowebPige>;
  /** Deletes many "TopicFotowebPiges" */
  deleteTopicFotowebPiges: Array<TopicFotowebPige>;
  /** Deletes one "Unit", throws an error if it does not exists */
  deleteUnit: Unit;
  /** Deletes one "Unit" if it exists, returns null otherwise */
  deleteUnitIfExists?: Maybe<Unit>;
  /** Deletes many "Units" */
  deleteUnits: Array<Unit>;
  /** Deletes one "Website", throws an error if it does not exists */
  deleteWebsite: Website;
  /** Deletes one "Website" if it exists, returns null otherwise */
  deleteWebsiteIfExists?: Maybe<Website>;
  /** Deletes many "Websites" */
  deleteWebsites: Array<Website>;
  emailRawArticle: EmailRawArticleResultType;
  emailSubject: EmailSubjectResultType;
  /** Photo print issue headings to censhare */
  exportPrintIssueToCenshare: ExportPrintIssueToCenshareResultType;
  /** Photo photos to censhare */
  exportToCentshare: ExportToCenshareResultType;
  shareSubject?: Maybe<Subject>;
  /** Updates one "Advertisement", throws an error if it does not exists */
  updateAdvertisement: Advertisement;
  /** Updates one "Advertisement" if it exists, returns null otherwise */
  updateAdvertisementIfExists?: Maybe<Advertisement>;
  /** Updates many "Advertisements" */
  updateAdvertisements: Array<Advertisement>;
  /** Updates one "ArticleTemplate", throws an error if it does not exists */
  updateArticleTemplate: ArticleTemplate;
  /** Updates one "ArticleTemplate" if it exists, returns null otherwise */
  updateArticleTemplateIfExists?: Maybe<ArticleTemplate>;
  /** Updates many "ArticleTemplates" */
  updateArticleTemplates: Array<ArticleTemplate>;
  /** Updates one "Assignment", throws an error if it does not exists */
  updateAssignment: Assignment;
  /** Updates one "Assignment" if it exists, returns null otherwise */
  updateAssignmentIfExists?: Maybe<Assignment>;
  /** Updates many "Assignments" */
  updateAssignments: Array<Assignment>;
  /** Updates one "Attachment", throws an error if it does not exists */
  updateAttachment: Attachment;
  /** Updates one "Attachment" if it exists, returns null otherwise */
  updateAttachmentIfExists?: Maybe<Attachment>;
  /** Updates many "Attachments" */
  updateAttachments: Array<Attachment>;
  /** Updates one "Brand", throws an error if it does not exists */
  updateBrand: Brand;
  /** Updates one "Brand" if it exists, returns null otherwise */
  updateBrandIfExists?: Maybe<Brand>;
  /** Updates many "Brands" */
  updateBrands: Array<Brand>;
  /** Updates one "CenshareTrace", throws an error if it does not exists */
  updateCenshareTrace: CenshareTrace;
  /** Updates one "CenshareTrace" if it exists, returns null otherwise */
  updateCenshareTraceIfExists?: Maybe<CenshareTrace>;
  /** Updates many "CenshareTraces" */
  updateCenshareTraces: Array<CenshareTrace>;
  /** Updates one "File", throws an error if it does not exists */
  updateFile: File;
  /** Updates one "File" if it exists, returns null otherwise */
  updateFileIfExists?: Maybe<File>;
  /** Updates many "Files" */
  updateFiles: Array<File>;
  /** Updates one "Layout", throws an error if it does not exists */
  updateLayout: Layout;
  /** Updates one "LayoutAsset", throws an error if it does not exists */
  updateLayoutAsset: LayoutAsset;
  /** Updates one "LayoutAsset" if it exists, returns null otherwise */
  updateLayoutAssetIfExists?: Maybe<LayoutAsset>;
  /** Updates many "LayoutAssets" */
  updateLayoutAssets: Array<LayoutAsset>;
  /** Updates one "Layout" if it exists, returns null otherwise */
  updateLayoutIfExists?: Maybe<Layout>;
  /** Updates many "Layouts" */
  updateLayouts: Array<Layout>;
  /** Updates one "Mockup", throws an error if it does not exists */
  updateMockup: Mockup;
  /** Updates one "Mockup" if it exists, returns null otherwise */
  updateMockupIfExists?: Maybe<Mockup>;
  /** Updates many "Mockups" */
  updateMockups: Array<Mockup>;
  /** Updates one "PrintHeading", throws an error if it does not exists */
  updatePrintHeading: PrintHeading;
  /** Updates one "PrintHeading" if it exists, returns null otherwise */
  updatePrintHeadingIfExists?: Maybe<PrintHeading>;
  /** Updates one "PrintHeadingPrintTemplate", throws an error if it does not exists */
  updatePrintHeadingPrintTemplate: PrintHeadingPrintTemplate;
  /** Updates one "PrintHeadingPrintTemplate" if it exists, returns null otherwise */
  updatePrintHeadingPrintTemplateIfExists?: Maybe<PrintHeadingPrintTemplate>;
  /** Updates many "PrintHeadingPrintTemplates" */
  updatePrintHeadingPrintTemplates: Array<PrintHeadingPrintTemplate>;
  /** Updates many "PrintHeadings" */
  updatePrintHeadings: Array<PrintHeading>;
  /** Updates one "PrintIssue", throws an error if it does not exists */
  updatePrintIssue: PrintIssue;
  /** Updates one "PrintIssue" if it exists, returns null otherwise */
  updatePrintIssueIfExists?: Maybe<PrintIssue>;
  /** Updates one "PrintIssueRailroad", throws an error if it does not exists */
  updatePrintIssueRailroad: PrintIssueRailroad;
  /** Updates one "PrintIssueRailroad" if it exists, returns null otherwise */
  updatePrintIssueRailroadIfExists?: Maybe<PrintIssueRailroad>;
  /** Updates many "PrintIssueRailroads" */
  updatePrintIssueRailroads: Array<PrintIssueRailroad>;
  /** Updates many "PrintIssues" */
  updatePrintIssues: Array<PrintIssue>;
  /** Updates one "PrintPublication", throws an error if it does not exists */
  updatePrintPublication: PrintPublication;
  /** Updates one "PrintPublication" if it exists, returns null otherwise */
  updatePrintPublicationIfExists?: Maybe<PrintPublication>;
  /** Updates many "PrintPublications" */
  updatePrintPublications: Array<PrintPublication>;
  /** Updates one "PrintTemplate", throws an error if it does not exists */
  updatePrintTemplate: PrintTemplate;
  /** Updates one "PrintTemplate" if it exists, returns null otherwise */
  updatePrintTemplateIfExists?: Maybe<PrintTemplate>;
  /** Updates many "PrintTemplates" */
  updatePrintTemplates: Array<PrintTemplate>;
  /** Updates one "RailroadPage", throws an error if it does not exists */
  updateRailroadPage: RailroadPage;
  /** Updates one "RailroadPage" if it exists, returns null otherwise */
  updateRailroadPageIfExists?: Maybe<RailroadPage>;
  /** Updates many "RailroadPages" */
  updateRailroadPages: Array<RailroadPage>;
  /** Updates one "RawArticle", throws an error if it does not exists */
  updateRawArticle: RawArticle;
  /** Updates one "RawArticle" if it exists, returns null otherwise */
  updateRawArticleIfExists?: Maybe<RawArticle>;
  /** Updates many "RawArticles" */
  updateRawArticles: Array<RawArticle>;
  /** Updates one "RawArticleVersion", throws an error if it does not exists */
  updateRawArticleVersion: RawArticleVersion;
  /** Updates one "RawArticleVersion" if it exists, returns null otherwise */
  updateRawArticleVersionIfExists?: Maybe<RawArticleVersion>;
  /** Updates many "RawArticleVersions" */
  updateRawArticleVersions: Array<RawArticleVersion>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "Advertisements" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeAdvertisementsInOrder: Array<Advertisement>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "Advertisements" then returns their new values, or null, in the same order
   */
  updateSomeAdvertisementsInOrderIfExists: Array<Maybe<Advertisement>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleTemplates" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeArticleTemplatesInOrder: Array<ArticleTemplate>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleTemplates" then returns their new values, or null, in the same order
   */
  updateSomeArticleTemplatesInOrderIfExists: Array<Maybe<ArticleTemplate>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Assignments"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeAssignmentsInOrder: Array<Assignment>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Assignments"
   * then returns their new values, or null, in the same order
   */
  updateSomeAssignmentsInOrderIfExists: Array<Maybe<Assignment>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Attachments"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeAttachmentsInOrder: Array<Attachment>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Attachments"
   * then returns their new values, or null, in the same order
   */
  updateSomeAttachmentsInOrderIfExists: Array<Maybe<Attachment>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Brands" then
   * returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeBrandsInOrder: Array<Brand>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Brands" then
   * returns their new values, or null, in the same order
   */
  updateSomeBrandsInOrderIfExists: Array<Maybe<Brand>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "CenshareTraces" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeCenshareTracesInOrder: Array<CenshareTrace>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "CenshareTraces" then returns their new values, or null, in the same order
   */
  updateSomeCenshareTracesInOrderIfExists: Array<Maybe<CenshareTrace>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Files" then
   * returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeFilesInOrder: Array<File>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Files" then
   * returns their new values, or null, in the same order
   */
  updateSomeFilesInOrderIfExists: Array<Maybe<File>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "LayoutAssets" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeLayoutAssetsInOrder: Array<LayoutAsset>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "LayoutAssets" then returns their new values, or null, in the same order
   */
  updateSomeLayoutAssetsInOrderIfExists: Array<Maybe<LayoutAsset>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Layouts"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeLayoutsInOrder: Array<Layout>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Layouts"
   * then returns their new values, or null, in the same order
   */
  updateSomeLayoutsInOrderIfExists: Array<Maybe<Layout>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Mockups"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeMockupsInOrder: Array<Mockup>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Mockups"
   * then returns their new values, or null, in the same order
   */
  updateSomeMockupsInOrderIfExists: Array<Maybe<Mockup>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "PrintHeadingPrintTemplates" then returns their new values in the same order,
   * throws an error if one does not exist
   */
  updateSomePrintHeadingPrintTemplatesInOrder: Array<PrintHeadingPrintTemplate>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "PrintHeadingPrintTemplates" then returns their new values, or null, in the same order
   */
  updateSomePrintHeadingPrintTemplatesInOrderIfExists: Array<Maybe<PrintHeadingPrintTemplate>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "PrintHeadings" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomePrintHeadingsInOrder: Array<PrintHeading>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "PrintHeadings" then returns their new values, or null, in the same order
   */
  updateSomePrintHeadingsInOrderIfExists: Array<Maybe<PrintHeading>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "PrintIssueRailroads" then returns their new values in the same order, throws
   * an error if one does not exist
   */
  updateSomePrintIssueRailroadsInOrder: Array<PrintIssueRailroad>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "PrintIssueRailroads" then returns their new values, or null, in the same order
   */
  updateSomePrintIssueRailroadsInOrderIfExists: Array<Maybe<PrintIssueRailroad>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "PrintIssues"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomePrintIssuesInOrder: Array<PrintIssue>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "PrintIssues"
   * then returns their new values, or null, in the same order
   */
  updateSomePrintIssuesInOrderIfExists: Array<Maybe<PrintIssue>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "PrintPublications" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomePrintPublicationsInOrder: Array<PrintPublication>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "PrintPublications" then returns their new values, or null, in the same order
   */
  updateSomePrintPublicationsInOrderIfExists: Array<Maybe<PrintPublication>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "PrintTemplates" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomePrintTemplatesInOrder: Array<PrintTemplate>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "PrintTemplates" then returns their new values, or null, in the same order
   */
  updateSomePrintTemplatesInOrderIfExists: Array<Maybe<PrintTemplate>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "RailroadPages" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeRailroadPagesInOrder: Array<RailroadPage>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "RailroadPages" then returns their new values, or null, in the same order
   */
  updateSomeRailroadPagesInOrderIfExists: Array<Maybe<RailroadPage>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "RawArticles"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeRawArticlesInOrder: Array<RawArticle>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "RawArticles"
   * then returns their new values, or null, in the same order
   */
  updateSomeRawArticlesInOrderIfExists: Array<Maybe<RawArticle>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "RawArticleVersions" then returns their new values in the same order, throws
   * an error if one does not exist
   */
  updateSomeRawArticleVersionsInOrder: Array<RawArticleVersion>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "RawArticleVersions" then returns their new values, or null, in the same order
   */
  updateSomeRawArticleVersionsInOrderIfExists: Array<Maybe<RawArticleVersion>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "SubjectCategories" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeSubjectCategoriesInOrder: Array<SubjectCategory>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "SubjectCategories" then returns their new values, or null, in the same order
   */
  updateSomeSubjectCategoriesInOrderIfExists: Array<Maybe<SubjectCategory>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Subjects"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeSubjectsInOrder: Array<Subject>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Subjects"
   * then returns their new values, or null, in the same order
   */
  updateSomeSubjectsInOrderIfExists: Array<Maybe<Subject>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "SubSubjects"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeSubSubjectsInOrder: Array<SubSubject>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "SubSubjects"
   * then returns their new values, or null, in the same order
   */
  updateSomeSubSubjectsInOrderIfExists: Array<Maybe<SubSubject>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "TopicFotowebPiges" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeTopicFotowebPigesInOrder: Array<TopicFotowebPige>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "TopicFotowebPiges" then returns their new values, or null, in the same order
   */
  updateSomeTopicFotowebPigesInOrderIfExists: Array<Maybe<TopicFotowebPige>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Units" then
   * returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeUnitsInOrder: Array<Unit>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Units" then
   * returns their new values, or null, in the same order
   */
  updateSomeUnitsInOrderIfExists: Array<Maybe<Unit>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Websites"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeWebsitesInOrder: Array<Website>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Websites"
   * then returns their new values, or null, in the same order
   */
  updateSomeWebsitesInOrderIfExists: Array<Maybe<Website>>;
  /** Updates one "Subject", throws an error if it does not exists */
  updateSubject: Subject;
  /** Updates many "SubjectCategories" */
  updateSubjectCategories: Array<SubjectCategory>;
  /** Updates one "SubjectCategory", throws an error if it does not exists */
  updateSubjectCategory: SubjectCategory;
  /** Updates one "SubjectCategory" if it exists, returns null otherwise */
  updateSubjectCategoryIfExists?: Maybe<SubjectCategory>;
  /** Updates one "Subject" if it exists, returns null otherwise */
  updateSubjectIfExists?: Maybe<Subject>;
  /** Updates many "Subjects" */
  updateSubjects: Array<Subject>;
  /** Updates one "SubSubject", throws an error if it does not exists */
  updateSubSubject: SubSubject;
  /** Updates one "SubSubject" if it exists, returns null otherwise */
  updateSubSubjectIfExists?: Maybe<SubSubject>;
  /** Updates many "SubSubjects" */
  updateSubSubjects: Array<SubSubject>;
  /** Updates one "TopicFotowebPige", throws an error if it does not exists */
  updateTopicFotowebPige: TopicFotowebPige;
  /** Updates one "TopicFotowebPige" if it exists, returns null otherwise */
  updateTopicFotowebPigeIfExists?: Maybe<TopicFotowebPige>;
  /** Updates many "TopicFotowebPiges" */
  updateTopicFotowebPiges: Array<TopicFotowebPige>;
  /** Updates one "Unit", throws an error if it does not exists */
  updateUnit: Unit;
  /** Updates one "Unit" if it exists, returns null otherwise */
  updateUnitIfExists?: Maybe<Unit>;
  /** Updates many "Units" */
  updateUnits: Array<Unit>;
  /** Updates one "Website", throws an error if it does not exists */
  updateWebsite: Website;
  /** Updates one "Website" if it exists, returns null otherwise */
  updateWebsiteIfExists?: Maybe<Website>;
  /** Updates many "Websites" */
  updateWebsites: Array<Website>;
  /** Updates an existing "Advertisement" or creates a new one */
  upsertAdvertisement: Advertisement;
  /** Updates an existing "ArticleTemplate" or creates a new one */
  upsertArticleTemplate: ArticleTemplate;
  /** Updates an existing "Assignment" or creates a new one */
  upsertAssignment: Assignment;
  /** Updates an existing "Attachment" or creates a new one */
  upsertAttachment: Attachment;
  /** Updates an existing "Brand" or creates a new one */
  upsertBrand: Brand;
  /** Updates an existing "CenshareTrace" or creates a new one */
  upsertCenshareTrace: CenshareTrace;
  /** Updates an existing "File" or creates a new one */
  upsertFile: File;
  /** Updates an existing "Layout" or creates a new one */
  upsertLayout: Layout;
  /** Updates an existing "LayoutAsset" or creates a new one */
  upsertLayoutAsset: LayoutAsset;
  /** Updates an existing "Mockup" or creates a new one */
  upsertMockup: Mockup;
  /** Updates an existing "PrintHeading" or creates a new one */
  upsertPrintHeading: PrintHeading;
  /** Updates an existing "PrintHeadingPrintTemplate" or creates a new one */
  upsertPrintHeadingPrintTemplate: PrintHeadingPrintTemplate;
  /** Updates an existing "PrintIssue" or creates a new one */
  upsertPrintIssue: PrintIssue;
  /** Updates an existing "PrintIssueRailroad" or creates a new one */
  upsertPrintIssueRailroad: PrintIssueRailroad;
  /** Updates an existing "PrintPublication" or creates a new one */
  upsertPrintPublication: PrintPublication;
  /** Updates an existing "PrintTemplate" or creates a new one */
  upsertPrintTemplate: PrintTemplate;
  /** Updates an existing "RailroadPage" or creates a new one */
  upsertRailroadPage: RailroadPage;
  /** Updates an existing "RawArticle" or creates a new one */
  upsertRawArticle: RawArticle;
  /** Updates an existing "RawArticleVersion" or creates a new one */
  upsertRawArticleVersion: RawArticleVersion;
  /** Updates an existing "Subject" or creates a new one */
  upsertSubject: Subject;
  /** Updates an existing "SubjectCategory" or creates a new one */
  upsertSubjectCategory: SubjectCategory;
  /** Updates an existing "SubSubject" or creates a new one */
  upsertSubSubject: SubSubject;
  /** Updates an existing "TopicFotowebPige" or creates a new one */
  upsertTopicFotowebPige: TopicFotowebPige;
  /** Updates an existing "Unit" or creates a new one */
  upsertUnit: Unit;
  /** Updates an existing "Website" or creates a new one */
  upsertWebsite: Website;
};


export type MutationCreateAdvertisementArgs = {
  data: AdvertisementCreationInput;
};


export type MutationCreateAdvertisementIfNotExistsArgs = {
  data: AdvertisementCreationInput;
  where: AdvertisementUniqueFilterInput;
};


export type MutationCreateAdvertisementsArgs = {
  data: Array<AdvertisementCreationInput>;
};


export type MutationCreateAdvertisementVersionArgs = {
  data: AdvertisementVersionCreationInput;
};


export type MutationCreateAdvertisementVersionIfNotExistsArgs = {
  data: AdvertisementVersionCreationInput;
  where: AdvertisementVersionUniqueFilterInput;
};


export type MutationCreateAdvertisementVersionsArgs = {
  data: Array<AdvertisementVersionCreationInput>;
};


export type MutationCreateArticleTemplateArgs = {
  data: ArticleTemplateCreationInput;
};


export type MutationCreateArticleTemplateIfNotExistsArgs = {
  data: ArticleTemplateCreationInput;
  where: ArticleTemplateUniqueFilterInput;
};


export type MutationCreateArticleTemplatesArgs = {
  data: Array<ArticleTemplateCreationInput>;
};


export type MutationCreateAssignmentArgs = {
  data: AssignmentCreationInput;
};


export type MutationCreateAssignmentIfNotExistsArgs = {
  data: AssignmentCreationInput;
  where: AssignmentUniqueFilterInput;
};


export type MutationCreateAssignmentsArgs = {
  data: Array<AssignmentCreationInput>;
};


export type MutationCreateAttachmentArgs = {
  data: AttachmentCreationInput;
};


export type MutationCreateAttachmentIfNotExistsArgs = {
  data: AttachmentCreationInput;
  where: AttachmentUniqueFilterInput;
};


export type MutationCreateAttachmentsArgs = {
  data: Array<AttachmentCreationInput>;
};


export type MutationCreateBrandArgs = {
  data: BrandCreationInput;
};


export type MutationCreateBrandIfNotExistsArgs = {
  data: BrandCreationInput;
  where: BrandUniqueFilterInput;
};


export type MutationCreateBrandsArgs = {
  data: Array<BrandCreationInput>;
};


export type MutationCreateCenshareTraceArgs = {
  data: CenshareTraceCreationInput;
};


export type MutationCreateCenshareTraceIfNotExistsArgs = {
  data: CenshareTraceCreationInput;
  where: CenshareTraceUniqueFilterInput;
};


export type MutationCreateCenshareTracesArgs = {
  data: Array<CenshareTraceCreationInput>;
};


export type MutationCreateFileArgs = {
  data: FileCreationInput;
};


export type MutationCreateFileIfNotExistsArgs = {
  data: FileCreationInput;
  where: FileUniqueFilterInput;
};


export type MutationCreateFilesArgs = {
  data: Array<FileCreationInput>;
};


export type MutationCreateFileVersionArgs = {
  data: FileVersionCreationInput;
};


export type MutationCreateFileVersionIfNotExistsArgs = {
  data: FileVersionCreationInput;
  where: FileVersionUniqueFilterInput;
};


export type MutationCreateFileVersionsArgs = {
  data: Array<FileVersionCreationInput>;
};


export type MutationCreateLayoutArgs = {
  data: LayoutCreationInput;
};


export type MutationCreateLayoutAssetArgs = {
  data: LayoutAssetCreationInput;
};


export type MutationCreateLayoutAssetIfNotExistsArgs = {
  data: LayoutAssetCreationInput;
  where: LayoutAssetUniqueFilterInput;
};


export type MutationCreateLayoutAssetsArgs = {
  data: Array<LayoutAssetCreationInput>;
};


export type MutationCreateLayoutIfNotExistsArgs = {
  data: LayoutCreationInput;
  where: LayoutUniqueFilterInput;
};


export type MutationCreateLayoutsArgs = {
  data: Array<LayoutCreationInput>;
};


export type MutationCreateMockupArgs = {
  data: MockupCreationInput;
};


export type MutationCreateMockupIfNotExistsArgs = {
  data: MockupCreationInput;
  where: MockupUniqueFilterInput;
};


export type MutationCreateMockupsArgs = {
  data: Array<MockupCreationInput>;
};


export type MutationCreateMockupVersionArgs = {
  data: MockupVersionCreationInput;
};


export type MutationCreateMockupVersionIfNotExistsArgs = {
  data: MockupVersionCreationInput;
  where: MockupVersionUniqueFilterInput;
};


export type MutationCreateMockupVersionsArgs = {
  data: Array<MockupVersionCreationInput>;
};


export type MutationCreatePrintHeadingArgs = {
  data: PrintHeadingCreationInput;
};


export type MutationCreatePrintHeadingIfNotExistsArgs = {
  data: PrintHeadingCreationInput;
  where: PrintHeadingUniqueFilterInput;
};


export type MutationCreatePrintHeadingPrintTemplateArgs = {
  data: PrintHeadingPrintTemplateCreationInput;
};


export type MutationCreatePrintHeadingPrintTemplateIfNotExistsArgs = {
  data: PrintHeadingPrintTemplateCreationInput;
  where: PrintHeadingPrintTemplateUniqueFilterInput;
};


export type MutationCreatePrintHeadingPrintTemplatesArgs = {
  data: Array<PrintHeadingPrintTemplateCreationInput>;
};


export type MutationCreatePrintHeadingsArgs = {
  data: Array<PrintHeadingCreationInput>;
};


export type MutationCreatePrintIssueArgs = {
  data: PrintIssueCreationInput;
};


export type MutationCreatePrintIssueIfNotExistsArgs = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};


export type MutationCreatePrintIssueRailroadArgs = {
  data: PrintIssueRailroadCreationInput;
};


export type MutationCreatePrintIssueRailroadIfNotExistsArgs = {
  data: PrintIssueRailroadCreationInput;
  where: PrintIssueRailroadUniqueFilterInput;
};


export type MutationCreatePrintIssueRailroadsArgs = {
  data: Array<PrintIssueRailroadCreationInput>;
};


export type MutationCreatePrintIssuesArgs = {
  data: Array<PrintIssueCreationInput>;
};


export type MutationCreatePrintPublicationArgs = {
  data: PrintPublicationCreationInput;
};


export type MutationCreatePrintPublicationIfNotExistsArgs = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};


export type MutationCreatePrintPublicationsArgs = {
  data: Array<PrintPublicationCreationInput>;
};


export type MutationCreatePrintTemplateArgs = {
  data: PrintTemplateCreationInput;
};


export type MutationCreatePrintTemplateIfNotExistsArgs = {
  data: PrintTemplateCreationInput;
  where: PrintTemplateUniqueFilterInput;
};


export type MutationCreatePrintTemplatesArgs = {
  data: Array<PrintTemplateCreationInput>;
};


export type MutationCreateRailroadPageArgs = {
  data: RailroadPageCreationInput;
};


export type MutationCreateRailroadPageIfNotExistsArgs = {
  data: RailroadPageCreationInput;
  where: RailroadPageUniqueFilterInput;
};


export type MutationCreateRailroadPagesArgs = {
  data: Array<RailroadPageCreationInput>;
};


export type MutationCreateRawArticleArgs = {
  data: RawArticleCreationInput;
};


export type MutationCreateRawArticleIfNotExistsArgs = {
  data: RawArticleCreationInput;
  where: RawArticleUniqueFilterInput;
};


export type MutationCreateRawArticlesArgs = {
  data: Array<RawArticleCreationInput>;
};


export type MutationCreateRawArticleVersionArgs = {
  data: RawArticleVersionCreationInput;
};


export type MutationCreateRawArticleVersionIfNotExistsArgs = {
  data: RawArticleVersionCreationInput;
  where: RawArticleVersionUniqueFilterInput;
};


export type MutationCreateRawArticleVersionsArgs = {
  data: Array<RawArticleVersionCreationInput>;
};


export type MutationCreateSubjectArgs = {
  data: SubjectCreationInput;
};


export type MutationCreateSubjectCategoriesArgs = {
  data: Array<SubjectCategoryCreationInput>;
};


export type MutationCreateSubjectCategoryArgs = {
  data: SubjectCategoryCreationInput;
};


export type MutationCreateSubjectCategoryIfNotExistsArgs = {
  data: SubjectCategoryCreationInput;
  where: SubjectCategoryUniqueFilterInput;
};


export type MutationCreateSubjectIfNotExistsArgs = {
  data: SubjectCreationInput;
  where: SubjectUniqueFilterInput;
};


export type MutationCreateSubjectsArgs = {
  data: Array<SubjectCreationInput>;
};


export type MutationCreateSubjectUserArgs = {
  data: SubjectUserCreationInput;
};


export type MutationCreateSubjectUserIfNotExistsArgs = {
  data: SubjectUserCreationInput;
  where: SubjectUserUniqueFilterInput;
};


export type MutationCreateSubjectUsersArgs = {
  data: Array<SubjectUserCreationInput>;
};


export type MutationCreateSubSubjectArgs = {
  data: SubSubjectCreationInput;
};


export type MutationCreateSubSubjectIfNotExistsArgs = {
  data: SubSubjectCreationInput;
  where: SubSubjectUniqueFilterInput;
};


export type MutationCreateSubSubjectsArgs = {
  data: Array<SubSubjectCreationInput>;
};


export type MutationCreateTopicFotowebPigeArgs = {
  data: TopicFotowebPigeCreationInput;
};


export type MutationCreateTopicFotowebPigeIfNotExistsArgs = {
  data: TopicFotowebPigeCreationInput;
  where: TopicFotowebPigeUniqueFilterInput;
};


export type MutationCreateTopicFotowebPigesArgs = {
  data: Array<TopicFotowebPigeCreationInput>;
};


export type MutationCreateUnitArgs = {
  data: UnitCreationInput;
};


export type MutationCreateUnitIfNotExistsArgs = {
  data: UnitCreationInput;
  where: UnitUniqueFilterInput;
};


export type MutationCreateUnitsArgs = {
  data: Array<UnitCreationInput>;
};


export type MutationCreateWebsiteArgs = {
  data: WebsiteCreationInput;
};


export type MutationCreateWebsiteIfNotExistsArgs = {
  data: WebsiteCreationInput;
  where: WebsiteUniqueFilterInput;
};


export type MutationCreateWebsitesArgs = {
  data: Array<WebsiteCreationInput>;
};


export type MutationDeleteAdvertisementArgs = {
  where: AdvertisementUniqueFilterInput;
};


export type MutationDeleteAdvertisementIfExistsArgs = {
  where: AdvertisementUniqueFilterInput;
};


export type MutationDeleteAdvertisementsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AdvertisementOrderingInput>>;
  where?: InputMaybe<AdvertisementFilterInput>;
};


export type MutationDeleteAdvertisementVersionArgs = {
  where: AdvertisementVersionUniqueFilterInput;
};


export type MutationDeleteAdvertisementVersionIfExistsArgs = {
  where: AdvertisementVersionUniqueFilterInput;
};


export type MutationDeleteAdvertisementVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AdvertisementVersionOrderingInput>>;
  where?: InputMaybe<AdvertisementVersionFilterInput>;
};


export type MutationDeleteArticleTemplateArgs = {
  where: ArticleTemplateUniqueFilterInput;
};


export type MutationDeleteArticleTemplateIfExistsArgs = {
  where: ArticleTemplateUniqueFilterInput;
};


export type MutationDeleteArticleTemplatesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTemplateOrderingInput>>;
  where?: InputMaybe<ArticleTemplateFilterInput>;
};


export type MutationDeleteAssignmentArgs = {
  where: AssignmentUniqueFilterInput;
};


export type MutationDeleteAssignmentIfExistsArgs = {
  where: AssignmentUniqueFilterInput;
};


export type MutationDeleteAssignmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AssignmentOrderingInput>>;
  where?: InputMaybe<AssignmentFilterInput>;
};


export type MutationDeleteAttachmentArgs = {
  where: AttachmentUniqueFilterInput;
};


export type MutationDeleteAttachmentIfExistsArgs = {
  where: AttachmentUniqueFilterInput;
};


export type MutationDeleteAttachmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AttachmentOrderingInput>>;
  where?: InputMaybe<AttachmentFilterInput>;
};


export type MutationDeleteBrandArgs = {
  where: BrandUniqueFilterInput;
};


export type MutationDeleteBrandIfExistsArgs = {
  where: BrandUniqueFilterInput;
};


export type MutationDeleteBrandsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<BrandOrderingInput>>;
  where?: InputMaybe<BrandFilterInput>;
};


export type MutationDeleteCenshareTraceArgs = {
  where: CenshareTraceUniqueFilterInput;
};


export type MutationDeleteCenshareTraceIfExistsArgs = {
  where: CenshareTraceUniqueFilterInput;
};


export type MutationDeleteCenshareTracesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CenshareTraceOrderingInput>>;
  where?: InputMaybe<CenshareTraceFilterInput>;
};


export type MutationDeleteFileArgs = {
  where: FileUniqueFilterInput;
};


export type MutationDeleteFileIfExistsArgs = {
  where: FileUniqueFilterInput;
};


export type MutationDeleteFilesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FileOrderingInput>>;
  where?: InputMaybe<FileFilterInput>;
};


export type MutationDeleteFileVersionArgs = {
  where: FileVersionUniqueFilterInput;
};


export type MutationDeleteFileVersionIfExistsArgs = {
  where: FileVersionUniqueFilterInput;
};


export type MutationDeleteFileVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FileVersionOrderingInput>>;
  where?: InputMaybe<FileVersionFilterInput>;
};


export type MutationDeleteLayoutArgs = {
  where: LayoutUniqueFilterInput;
};


export type MutationDeleteLayoutAssetArgs = {
  where: LayoutAssetUniqueFilterInput;
};


export type MutationDeleteLayoutAssetIfExistsArgs = {
  where: LayoutAssetUniqueFilterInput;
};


export type MutationDeleteLayoutAssetsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutAssetOrderingInput>>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};


export type MutationDeleteLayoutIfExistsArgs = {
  where: LayoutUniqueFilterInput;
};


export type MutationDeleteLayoutsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutOrderingInput>>;
  where?: InputMaybe<LayoutFilterInput>;
};


export type MutationDeleteMockupArgs = {
  where: MockupUniqueFilterInput;
};


export type MutationDeleteMockupIfExistsArgs = {
  where: MockupUniqueFilterInput;
};


export type MutationDeleteMockupsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MockupOrderingInput>>;
  where?: InputMaybe<MockupFilterInput>;
};


export type MutationDeleteMockupVersionArgs = {
  where: MockupVersionUniqueFilterInput;
};


export type MutationDeleteMockupVersionIfExistsArgs = {
  where: MockupVersionUniqueFilterInput;
};


export type MutationDeleteMockupVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MockupVersionOrderingInput>>;
  where?: InputMaybe<MockupVersionFilterInput>;
};


export type MutationDeletePrintHeadingArgs = {
  where: PrintHeadingUniqueFilterInput;
};


export type MutationDeletePrintHeadingIfExistsArgs = {
  where: PrintHeadingUniqueFilterInput;
};


export type MutationDeletePrintHeadingPrintTemplateArgs = {
  where: PrintHeadingPrintTemplateUniqueFilterInput;
};


export type MutationDeletePrintHeadingPrintTemplateIfExistsArgs = {
  where: PrintHeadingPrintTemplateUniqueFilterInput;
};


export type MutationDeletePrintHeadingPrintTemplatesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintHeadingPrintTemplateOrderingInput>>;
  where?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
};


export type MutationDeletePrintHeadingsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintHeadingOrderingInput>>;
  where?: InputMaybe<PrintHeadingFilterInput>;
};


export type MutationDeletePrintIssueArgs = {
  where: PrintIssueUniqueFilterInput;
};


export type MutationDeletePrintIssueIfExistsArgs = {
  where: PrintIssueUniqueFilterInput;
};


export type MutationDeletePrintIssueRailroadArgs = {
  where: PrintIssueRailroadUniqueFilterInput;
};


export type MutationDeletePrintIssueRailroadIfExistsArgs = {
  where: PrintIssueRailroadUniqueFilterInput;
};


export type MutationDeletePrintIssueRailroadsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintIssueRailroadOrderingInput>>;
  where?: InputMaybe<PrintIssueRailroadFilterInput>;
};


export type MutationDeletePrintIssuesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintIssueOrderingInput>>;
  where?: InputMaybe<PrintIssueFilterInput>;
};


export type MutationDeletePrintPublicationArgs = {
  where: PrintPublicationUniqueFilterInput;
};


export type MutationDeletePrintPublicationIfExistsArgs = {
  where: PrintPublicationUniqueFilterInput;
};


export type MutationDeletePrintPublicationsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintPublicationOrderingInput>>;
  where?: InputMaybe<PrintPublicationFilterInput>;
};


export type MutationDeletePrintTemplateArgs = {
  where: PrintTemplateUniqueFilterInput;
};


export type MutationDeletePrintTemplateIfExistsArgs = {
  where: PrintTemplateUniqueFilterInput;
};


export type MutationDeletePrintTemplatesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintTemplateOrderingInput>>;
  where?: InputMaybe<PrintTemplateFilterInput>;
};


export type MutationDeleteRailroadPageArgs = {
  where: RailroadPageUniqueFilterInput;
};


export type MutationDeleteRailroadPageIfExistsArgs = {
  where: RailroadPageUniqueFilterInput;
};


export type MutationDeleteRailroadPagesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RailroadPageOrderingInput>>;
  where?: InputMaybe<RailroadPageFilterInput>;
};


export type MutationDeleteRawArticleArgs = {
  where: RawArticleUniqueFilterInput;
};


export type MutationDeleteRawArticleIfExistsArgs = {
  where: RawArticleUniqueFilterInput;
};


export type MutationDeleteRawArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RawArticleOrderingInput>>;
  where?: InputMaybe<RawArticleFilterInput>;
};


export type MutationDeleteRawArticleVersionArgs = {
  where: RawArticleVersionUniqueFilterInput;
};


export type MutationDeleteRawArticleVersionIfExistsArgs = {
  where: RawArticleVersionUniqueFilterInput;
};


export type MutationDeleteRawArticleVersionsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RawArticleVersionOrderingInput>>;
  where?: InputMaybe<RawArticleVersionFilterInput>;
};


export type MutationDeleteSomeAdvertisementsInOrderArgs = {
  subset?: InputMaybe<AdvertisementFilterInput>;
  where: Array<AdvertisementUniqueFilterInput>;
};


export type MutationDeleteSomeAdvertisementsInOrderIfExistsArgs = {
  subset?: InputMaybe<AdvertisementFilterInput>;
  where: Array<AdvertisementUniqueFilterInput>;
};


export type MutationDeleteSomeAdvertisementVersionsInOrderArgs = {
  subset?: InputMaybe<AdvertisementVersionFilterInput>;
  where: Array<AdvertisementVersionUniqueFilterInput>;
};


export type MutationDeleteSomeAdvertisementVersionsInOrderIfExistsArgs = {
  subset?: InputMaybe<AdvertisementVersionFilterInput>;
  where: Array<AdvertisementVersionUniqueFilterInput>;
};


export type MutationDeleteSomeArticleTemplatesInOrderArgs = {
  subset?: InputMaybe<ArticleTemplateFilterInput>;
  where: Array<ArticleTemplateUniqueFilterInput>;
};


export type MutationDeleteSomeArticleTemplatesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleTemplateFilterInput>;
  where: Array<ArticleTemplateUniqueFilterInput>;
};


export type MutationDeleteSomeAssignmentsInOrderArgs = {
  subset?: InputMaybe<AssignmentFilterInput>;
  where: Array<AssignmentUniqueFilterInput>;
};


export type MutationDeleteSomeAssignmentsInOrderIfExistsArgs = {
  subset?: InputMaybe<AssignmentFilterInput>;
  where: Array<AssignmentUniqueFilterInput>;
};


export type MutationDeleteSomeAttachmentsInOrderArgs = {
  subset?: InputMaybe<AttachmentFilterInput>;
  where: Array<AttachmentUniqueFilterInput>;
};


export type MutationDeleteSomeAttachmentsInOrderIfExistsArgs = {
  subset?: InputMaybe<AttachmentFilterInput>;
  where: Array<AttachmentUniqueFilterInput>;
};


export type MutationDeleteSomeBrandsInOrderArgs = {
  subset?: InputMaybe<BrandFilterInput>;
  where: Array<BrandUniqueFilterInput>;
};


export type MutationDeleteSomeBrandsInOrderIfExistsArgs = {
  subset?: InputMaybe<BrandFilterInput>;
  where: Array<BrandUniqueFilterInput>;
};


export type MutationDeleteSomeCenshareTracesInOrderArgs = {
  subset?: InputMaybe<CenshareTraceFilterInput>;
  where: Array<CenshareTraceUniqueFilterInput>;
};


export type MutationDeleteSomeCenshareTracesInOrderIfExistsArgs = {
  subset?: InputMaybe<CenshareTraceFilterInput>;
  where: Array<CenshareTraceUniqueFilterInput>;
};


export type MutationDeleteSomeFilesInOrderArgs = {
  subset?: InputMaybe<FileFilterInput>;
  where: Array<FileUniqueFilterInput>;
};


export type MutationDeleteSomeFilesInOrderIfExistsArgs = {
  subset?: InputMaybe<FileFilterInput>;
  where: Array<FileUniqueFilterInput>;
};


export type MutationDeleteSomeFileVersionsInOrderArgs = {
  subset?: InputMaybe<FileVersionFilterInput>;
  where: Array<FileVersionUniqueFilterInput>;
};


export type MutationDeleteSomeFileVersionsInOrderIfExistsArgs = {
  subset?: InputMaybe<FileVersionFilterInput>;
  where: Array<FileVersionUniqueFilterInput>;
};


export type MutationDeleteSomeLayoutAssetsInOrderArgs = {
  subset?: InputMaybe<LayoutAssetFilterInput>;
  where: Array<LayoutAssetUniqueFilterInput>;
};


export type MutationDeleteSomeLayoutAssetsInOrderIfExistsArgs = {
  subset?: InputMaybe<LayoutAssetFilterInput>;
  where: Array<LayoutAssetUniqueFilterInput>;
};


export type MutationDeleteSomeLayoutsInOrderArgs = {
  subset?: InputMaybe<LayoutFilterInput>;
  where: Array<LayoutUniqueFilterInput>;
};


export type MutationDeleteSomeLayoutsInOrderIfExistsArgs = {
  subset?: InputMaybe<LayoutFilterInput>;
  where: Array<LayoutUniqueFilterInput>;
};


export type MutationDeleteSomeMockupsInOrderArgs = {
  subset?: InputMaybe<MockupFilterInput>;
  where: Array<MockupUniqueFilterInput>;
};


export type MutationDeleteSomeMockupsInOrderIfExistsArgs = {
  subset?: InputMaybe<MockupFilterInput>;
  where: Array<MockupUniqueFilterInput>;
};


export type MutationDeleteSomeMockupVersionsInOrderArgs = {
  subset?: InputMaybe<MockupVersionFilterInput>;
  where: Array<MockupVersionUniqueFilterInput>;
};


export type MutationDeleteSomeMockupVersionsInOrderIfExistsArgs = {
  subset?: InputMaybe<MockupVersionFilterInput>;
  where: Array<MockupVersionUniqueFilterInput>;
};


export type MutationDeleteSomePrintHeadingPrintTemplatesInOrderArgs = {
  subset?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  where: Array<PrintHeadingPrintTemplateUniqueFilterInput>;
};


export type MutationDeleteSomePrintHeadingPrintTemplatesInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  where: Array<PrintHeadingPrintTemplateUniqueFilterInput>;
};


export type MutationDeleteSomePrintHeadingsInOrderArgs = {
  subset?: InputMaybe<PrintHeadingFilterInput>;
  where: Array<PrintHeadingUniqueFilterInput>;
};


export type MutationDeleteSomePrintHeadingsInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintHeadingFilterInput>;
  where: Array<PrintHeadingUniqueFilterInput>;
};


export type MutationDeleteSomePrintIssueRailroadsInOrderArgs = {
  subset?: InputMaybe<PrintIssueRailroadFilterInput>;
  where: Array<PrintIssueRailroadUniqueFilterInput>;
};


export type MutationDeleteSomePrintIssueRailroadsInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintIssueRailroadFilterInput>;
  where: Array<PrintIssueRailroadUniqueFilterInput>;
};


export type MutationDeleteSomePrintIssuesInOrderArgs = {
  subset?: InputMaybe<PrintIssueFilterInput>;
  where: Array<PrintIssueUniqueFilterInput>;
};


export type MutationDeleteSomePrintIssuesInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintIssueFilterInput>;
  where: Array<PrintIssueUniqueFilterInput>;
};


export type MutationDeleteSomePrintPublicationsInOrderArgs = {
  subset?: InputMaybe<PrintPublicationFilterInput>;
  where: Array<PrintPublicationUniqueFilterInput>;
};


export type MutationDeleteSomePrintPublicationsInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintPublicationFilterInput>;
  where: Array<PrintPublicationUniqueFilterInput>;
};


export type MutationDeleteSomePrintTemplatesInOrderArgs = {
  subset?: InputMaybe<PrintTemplateFilterInput>;
  where: Array<PrintTemplateUniqueFilterInput>;
};


export type MutationDeleteSomePrintTemplatesInOrderIfExistsArgs = {
  subset?: InputMaybe<PrintTemplateFilterInput>;
  where: Array<PrintTemplateUniqueFilterInput>;
};


export type MutationDeleteSomeRailroadPagesInOrderArgs = {
  subset?: InputMaybe<RailroadPageFilterInput>;
  where: Array<RailroadPageUniqueFilterInput>;
};


export type MutationDeleteSomeRailroadPagesInOrderIfExistsArgs = {
  subset?: InputMaybe<RailroadPageFilterInput>;
  where: Array<RailroadPageUniqueFilterInput>;
};


export type MutationDeleteSomeRawArticlesInOrderArgs = {
  subset?: InputMaybe<RawArticleFilterInput>;
  where: Array<RawArticleUniqueFilterInput>;
};


export type MutationDeleteSomeRawArticlesInOrderIfExistsArgs = {
  subset?: InputMaybe<RawArticleFilterInput>;
  where: Array<RawArticleUniqueFilterInput>;
};


export type MutationDeleteSomeRawArticleVersionsInOrderArgs = {
  subset?: InputMaybe<RawArticleVersionFilterInput>;
  where: Array<RawArticleVersionUniqueFilterInput>;
};


export type MutationDeleteSomeRawArticleVersionsInOrderIfExistsArgs = {
  subset?: InputMaybe<RawArticleVersionFilterInput>;
  where: Array<RawArticleVersionUniqueFilterInput>;
};


export type MutationDeleteSomeSubjectCategoriesInOrderArgs = {
  subset?: InputMaybe<SubjectCategoryFilterInput>;
  where: Array<SubjectCategoryUniqueFilterInput>;
};


export type MutationDeleteSomeSubjectCategoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<SubjectCategoryFilterInput>;
  where: Array<SubjectCategoryUniqueFilterInput>;
};


export type MutationDeleteSomeSubjectsInOrderArgs = {
  subset?: InputMaybe<SubjectFilterInput>;
  where: Array<SubjectUniqueFilterInput>;
};


export type MutationDeleteSomeSubjectsInOrderIfExistsArgs = {
  subset?: InputMaybe<SubjectFilterInput>;
  where: Array<SubjectUniqueFilterInput>;
};


export type MutationDeleteSomeSubjectUsersInOrderArgs = {
  subset?: InputMaybe<SubjectUserFilterInput>;
  where: Array<SubjectUserUniqueFilterInput>;
};


export type MutationDeleteSomeSubjectUsersInOrderIfExistsArgs = {
  subset?: InputMaybe<SubjectUserFilterInput>;
  where: Array<SubjectUserUniqueFilterInput>;
};


export type MutationDeleteSomeSubSubjectsInOrderArgs = {
  subset?: InputMaybe<SubSubjectFilterInput>;
  where: Array<SubSubjectUniqueFilterInput>;
};


export type MutationDeleteSomeSubSubjectsInOrderIfExistsArgs = {
  subset?: InputMaybe<SubSubjectFilterInput>;
  where: Array<SubSubjectUniqueFilterInput>;
};


export type MutationDeleteSomeTopicFotowebPigesInOrderArgs = {
  subset?: InputMaybe<TopicFotowebPigeFilterInput>;
  where: Array<TopicFotowebPigeUniqueFilterInput>;
};


export type MutationDeleteSomeTopicFotowebPigesInOrderIfExistsArgs = {
  subset?: InputMaybe<TopicFotowebPigeFilterInput>;
  where: Array<TopicFotowebPigeUniqueFilterInput>;
};


export type MutationDeleteSomeUnitsInOrderArgs = {
  subset?: InputMaybe<UnitFilterInput>;
  where: Array<UnitUniqueFilterInput>;
};


export type MutationDeleteSomeUnitsInOrderIfExistsArgs = {
  subset?: InputMaybe<UnitFilterInput>;
  where: Array<UnitUniqueFilterInput>;
};


export type MutationDeleteSomeWebsitesInOrderArgs = {
  subset?: InputMaybe<WebsiteFilterInput>;
  where: Array<WebsiteUniqueFilterInput>;
};


export type MutationDeleteSomeWebsitesInOrderIfExistsArgs = {
  subset?: InputMaybe<WebsiteFilterInput>;
  where: Array<WebsiteUniqueFilterInput>;
};


export type MutationDeleteSubjectArgs = {
  where: SubjectUniqueFilterInput;
};


export type MutationDeleteSubjectCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectCategoryOrderingInput>>;
  where?: InputMaybe<SubjectCategoryFilterInput>;
};


export type MutationDeleteSubjectCategoryArgs = {
  where: SubjectCategoryUniqueFilterInput;
};


export type MutationDeleteSubjectCategoryIfExistsArgs = {
  where: SubjectCategoryUniqueFilterInput;
};


export type MutationDeleteSubjectIfExistsArgs = {
  where: SubjectUniqueFilterInput;
};


export type MutationDeleteSubjectsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectOrderingInput>>;
  where?: InputMaybe<SubjectFilterInput>;
};


export type MutationDeleteSubjectUserArgs = {
  where: SubjectUserUniqueFilterInput;
};


export type MutationDeleteSubjectUserIfExistsArgs = {
  where: SubjectUserUniqueFilterInput;
};


export type MutationDeleteSubjectUsersArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectUserOrderingInput>>;
  where?: InputMaybe<SubjectUserFilterInput>;
};


export type MutationDeleteSubSubjectArgs = {
  where: SubSubjectUniqueFilterInput;
};


export type MutationDeleteSubSubjectIfExistsArgs = {
  where: SubSubjectUniqueFilterInput;
};


export type MutationDeleteSubSubjectsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubSubjectOrderingInput>>;
  where?: InputMaybe<SubSubjectFilterInput>;
};


export type MutationDeleteTopicFotowebPigeArgs = {
  where: TopicFotowebPigeUniqueFilterInput;
};


export type MutationDeleteTopicFotowebPigeIfExistsArgs = {
  where: TopicFotowebPigeUniqueFilterInput;
};


export type MutationDeleteTopicFotowebPigesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TopicFotowebPigeOrderingInput>>;
  where?: InputMaybe<TopicFotowebPigeFilterInput>;
};


export type MutationDeleteUnitArgs = {
  where: UnitUniqueFilterInput;
};


export type MutationDeleteUnitIfExistsArgs = {
  where: UnitUniqueFilterInput;
};


export type MutationDeleteUnitsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<UnitOrderingInput>>;
  where?: InputMaybe<UnitFilterInput>;
};


export type MutationDeleteWebsiteArgs = {
  where: WebsiteUniqueFilterInput;
};


export type MutationDeleteWebsiteIfExistsArgs = {
  where: WebsiteUniqueFilterInput;
};


export type MutationDeleteWebsitesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<WebsiteOrderingInput>>;
  where?: InputMaybe<WebsiteFilterInput>;
};


export type MutationEmailRawArticleArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rawArticle: RawArticleUniqueFilterInput;
  recipients: Array<Scalars['String']['input']>;
};


export type MutationEmailSubjectArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<Scalars['String']['input']>;
  subject: SubjectUniqueFilterInput;
};


export type MutationExportPrintIssueToCenshareArgs = {
  printIssueId: Scalars['String']['input'];
};


export type MutationExportToCentshareArgs = {
  assignment: Scalars['String']['input'];
  brand: Scalars['String']['input'];
  issue: Scalars['String']['input'];
  photos?: InputMaybe<Array<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};


export type MutationShareSubjectArgs = {
  subject: SubjectUniqueFilterInput;
  userIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateAdvertisementArgs = {
  data?: InputMaybe<AdvertisementUpdateInput>;
  where: AdvertisementUniqueFilterInput;
};


export type MutationUpdateAdvertisementIfExistsArgs = {
  data?: InputMaybe<AdvertisementUpdateInput>;
  where: AdvertisementUniqueFilterInput;
};


export type MutationUpdateAdvertisementsArgs = {
  data?: InputMaybe<AdvertisementUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AdvertisementOrderingInput>>;
  where?: InputMaybe<AdvertisementFilterInput>;
};


export type MutationUpdateArticleTemplateArgs = {
  data?: InputMaybe<ArticleTemplateUpdateInput>;
  where: ArticleTemplateUniqueFilterInput;
};


export type MutationUpdateArticleTemplateIfExistsArgs = {
  data?: InputMaybe<ArticleTemplateUpdateInput>;
  where: ArticleTemplateUniqueFilterInput;
};


export type MutationUpdateArticleTemplatesArgs = {
  data?: InputMaybe<ArticleTemplateUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTemplateOrderingInput>>;
  where?: InputMaybe<ArticleTemplateFilterInput>;
};


export type MutationUpdateAssignmentArgs = {
  data?: InputMaybe<AssignmentUpdateInput>;
  where: AssignmentUniqueFilterInput;
};


export type MutationUpdateAssignmentIfExistsArgs = {
  data?: InputMaybe<AssignmentUpdateInput>;
  where: AssignmentUniqueFilterInput;
};


export type MutationUpdateAssignmentsArgs = {
  data?: InputMaybe<AssignmentUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AssignmentOrderingInput>>;
  where?: InputMaybe<AssignmentFilterInput>;
};


export type MutationUpdateAttachmentArgs = {
  data?: InputMaybe<AttachmentUpdateInput>;
  where: AttachmentUniqueFilterInput;
};


export type MutationUpdateAttachmentIfExistsArgs = {
  data?: InputMaybe<AttachmentUpdateInput>;
  where: AttachmentUniqueFilterInput;
};


export type MutationUpdateAttachmentsArgs = {
  data?: InputMaybe<AttachmentUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AttachmentOrderingInput>>;
  where?: InputMaybe<AttachmentFilterInput>;
};


export type MutationUpdateBrandArgs = {
  data?: InputMaybe<BrandUpdateInput>;
  where: BrandUniqueFilterInput;
};


export type MutationUpdateBrandIfExistsArgs = {
  data?: InputMaybe<BrandUpdateInput>;
  where: BrandUniqueFilterInput;
};


export type MutationUpdateBrandsArgs = {
  data?: InputMaybe<BrandUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<BrandOrderingInput>>;
  where?: InputMaybe<BrandFilterInput>;
};


export type MutationUpdateCenshareTraceArgs = {
  data?: InputMaybe<CenshareTraceUpdateInput>;
  where: CenshareTraceUniqueFilterInput;
};


export type MutationUpdateCenshareTraceIfExistsArgs = {
  data?: InputMaybe<CenshareTraceUpdateInput>;
  where: CenshareTraceUniqueFilterInput;
};


export type MutationUpdateCenshareTracesArgs = {
  data?: InputMaybe<CenshareTraceUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CenshareTraceOrderingInput>>;
  where?: InputMaybe<CenshareTraceFilterInput>;
};


export type MutationUpdateFileArgs = {
  data?: InputMaybe<FileUpdateInput>;
  where: FileUniqueFilterInput;
};


export type MutationUpdateFileIfExistsArgs = {
  data?: InputMaybe<FileUpdateInput>;
  where: FileUniqueFilterInput;
};


export type MutationUpdateFilesArgs = {
  data?: InputMaybe<FileUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<FileOrderingInput>>;
  where?: InputMaybe<FileFilterInput>;
};


export type MutationUpdateLayoutArgs = {
  data?: InputMaybe<LayoutUpdateInput>;
  where: LayoutUniqueFilterInput;
};


export type MutationUpdateLayoutAssetArgs = {
  data?: InputMaybe<LayoutAssetUpdateInput>;
  where: LayoutAssetUniqueFilterInput;
};


export type MutationUpdateLayoutAssetIfExistsArgs = {
  data?: InputMaybe<LayoutAssetUpdateInput>;
  where: LayoutAssetUniqueFilterInput;
};


export type MutationUpdateLayoutAssetsArgs = {
  data?: InputMaybe<LayoutAssetUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutAssetOrderingInput>>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};


export type MutationUpdateLayoutIfExistsArgs = {
  data?: InputMaybe<LayoutUpdateInput>;
  where: LayoutUniqueFilterInput;
};


export type MutationUpdateLayoutsArgs = {
  data?: InputMaybe<LayoutUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LayoutOrderingInput>>;
  where?: InputMaybe<LayoutFilterInput>;
};


export type MutationUpdateMockupArgs = {
  data?: InputMaybe<MockupUpdateInput>;
  where: MockupUniqueFilterInput;
};


export type MutationUpdateMockupIfExistsArgs = {
  data?: InputMaybe<MockupUpdateInput>;
  where: MockupUniqueFilterInput;
};


export type MutationUpdateMockupsArgs = {
  data?: InputMaybe<MockupUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MockupOrderingInput>>;
  where?: InputMaybe<MockupFilterInput>;
};


export type MutationUpdatePrintHeadingArgs = {
  data?: InputMaybe<PrintHeadingUpdateInput>;
  where: PrintHeadingUniqueFilterInput;
};


export type MutationUpdatePrintHeadingIfExistsArgs = {
  data?: InputMaybe<PrintHeadingUpdateInput>;
  where: PrintHeadingUniqueFilterInput;
};


export type MutationUpdatePrintHeadingPrintTemplateArgs = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateInput>;
  where: PrintHeadingPrintTemplateUniqueFilterInput;
};


export type MutationUpdatePrintHeadingPrintTemplateIfExistsArgs = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateInput>;
  where: PrintHeadingPrintTemplateUniqueFilterInput;
};


export type MutationUpdatePrintHeadingPrintTemplatesArgs = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintHeadingPrintTemplateOrderingInput>>;
  where?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
};


export type MutationUpdatePrintHeadingsArgs = {
  data?: InputMaybe<PrintHeadingUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintHeadingOrderingInput>>;
  where?: InputMaybe<PrintHeadingFilterInput>;
};


export type MutationUpdatePrintIssueArgs = {
  data?: InputMaybe<PrintIssueUpdateInput>;
  where: PrintIssueUniqueFilterInput;
};


export type MutationUpdatePrintIssueIfExistsArgs = {
  data?: InputMaybe<PrintIssueUpdateInput>;
  where: PrintIssueUniqueFilterInput;
};


export type MutationUpdatePrintIssueRailroadArgs = {
  data?: InputMaybe<PrintIssueRailroadUpdateInput>;
  where: PrintIssueRailroadUniqueFilterInput;
};


export type MutationUpdatePrintIssueRailroadIfExistsArgs = {
  data?: InputMaybe<PrintIssueRailroadUpdateInput>;
  where: PrintIssueRailroadUniqueFilterInput;
};


export type MutationUpdatePrintIssueRailroadsArgs = {
  data?: InputMaybe<PrintIssueRailroadUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintIssueRailroadOrderingInput>>;
  where?: InputMaybe<PrintIssueRailroadFilterInput>;
};


export type MutationUpdatePrintIssuesArgs = {
  data?: InputMaybe<PrintIssueUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintIssueOrderingInput>>;
  where?: InputMaybe<PrintIssueFilterInput>;
};


export type MutationUpdatePrintPublicationArgs = {
  data?: InputMaybe<PrintPublicationUpdateInput>;
  where: PrintPublicationUniqueFilterInput;
};


export type MutationUpdatePrintPublicationIfExistsArgs = {
  data?: InputMaybe<PrintPublicationUpdateInput>;
  where: PrintPublicationUniqueFilterInput;
};


export type MutationUpdatePrintPublicationsArgs = {
  data?: InputMaybe<PrintPublicationUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintPublicationOrderingInput>>;
  where?: InputMaybe<PrintPublicationFilterInput>;
};


export type MutationUpdatePrintTemplateArgs = {
  data?: InputMaybe<PrintTemplateUpdateInput>;
  where: PrintTemplateUniqueFilterInput;
};


export type MutationUpdatePrintTemplateIfExistsArgs = {
  data?: InputMaybe<PrintTemplateUpdateInput>;
  where: PrintTemplateUniqueFilterInput;
};


export type MutationUpdatePrintTemplatesArgs = {
  data?: InputMaybe<PrintTemplateUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PrintTemplateOrderingInput>>;
  where?: InputMaybe<PrintTemplateFilterInput>;
};


export type MutationUpdateRailroadPageArgs = {
  data?: InputMaybe<RailroadPageUpdateInput>;
  where: RailroadPageUniqueFilterInput;
};


export type MutationUpdateRailroadPageIfExistsArgs = {
  data?: InputMaybe<RailroadPageUpdateInput>;
  where: RailroadPageUniqueFilterInput;
};


export type MutationUpdateRailroadPagesArgs = {
  data?: InputMaybe<RailroadPageUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RailroadPageOrderingInput>>;
  where?: InputMaybe<RailroadPageFilterInput>;
};


export type MutationUpdateRawArticleArgs = {
  data?: InputMaybe<RawArticleUpdateInput>;
  where: RawArticleUniqueFilterInput;
};


export type MutationUpdateRawArticleIfExistsArgs = {
  data?: InputMaybe<RawArticleUpdateInput>;
  where: RawArticleUniqueFilterInput;
};


export type MutationUpdateRawArticlesArgs = {
  data?: InputMaybe<RawArticleUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RawArticleOrderingInput>>;
  where?: InputMaybe<RawArticleFilterInput>;
};


export type MutationUpdateRawArticleVersionArgs = {
  data?: InputMaybe<RawArticleVersionUpdateInput>;
  where: RawArticleVersionUniqueFilterInput;
};


export type MutationUpdateRawArticleVersionIfExistsArgs = {
  data?: InputMaybe<RawArticleVersionUpdateInput>;
  where: RawArticleVersionUniqueFilterInput;
};


export type MutationUpdateRawArticleVersionsArgs = {
  data?: InputMaybe<RawArticleVersionUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<RawArticleVersionOrderingInput>>;
  where?: InputMaybe<RawArticleVersionFilterInput>;
};


export type MutationUpdateSomeAdvertisementsInOrderArgs = {
  data?: InputMaybe<AdvertisementUpdateInput>;
  subset?: InputMaybe<AdvertisementFilterInput>;
  where: Array<AdvertisementUniqueFilterInput>;
};


export type MutationUpdateSomeAdvertisementsInOrderIfExistsArgs = {
  data?: InputMaybe<AdvertisementUpdateInput>;
  subset?: InputMaybe<AdvertisementFilterInput>;
  where: Array<AdvertisementUniqueFilterInput>;
};


export type MutationUpdateSomeArticleTemplatesInOrderArgs = {
  data?: InputMaybe<ArticleTemplateUpdateInput>;
  subset?: InputMaybe<ArticleTemplateFilterInput>;
  where: Array<ArticleTemplateUniqueFilterInput>;
};


export type MutationUpdateSomeArticleTemplatesInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleTemplateUpdateInput>;
  subset?: InputMaybe<ArticleTemplateFilterInput>;
  where: Array<ArticleTemplateUniqueFilterInput>;
};


export type MutationUpdateSomeAssignmentsInOrderArgs = {
  data?: InputMaybe<AssignmentUpdateInput>;
  subset?: InputMaybe<AssignmentFilterInput>;
  where: Array<AssignmentUniqueFilterInput>;
};


export type MutationUpdateSomeAssignmentsInOrderIfExistsArgs = {
  data?: InputMaybe<AssignmentUpdateInput>;
  subset?: InputMaybe<AssignmentFilterInput>;
  where: Array<AssignmentUniqueFilterInput>;
};


export type MutationUpdateSomeAttachmentsInOrderArgs = {
  data?: InputMaybe<AttachmentUpdateInput>;
  subset?: InputMaybe<AttachmentFilterInput>;
  where: Array<AttachmentUniqueFilterInput>;
};


export type MutationUpdateSomeAttachmentsInOrderIfExistsArgs = {
  data?: InputMaybe<AttachmentUpdateInput>;
  subset?: InputMaybe<AttachmentFilterInput>;
  where: Array<AttachmentUniqueFilterInput>;
};


export type MutationUpdateSomeBrandsInOrderArgs = {
  data?: InputMaybe<BrandUpdateInput>;
  subset?: InputMaybe<BrandFilterInput>;
  where: Array<BrandUniqueFilterInput>;
};


export type MutationUpdateSomeBrandsInOrderIfExistsArgs = {
  data?: InputMaybe<BrandUpdateInput>;
  subset?: InputMaybe<BrandFilterInput>;
  where: Array<BrandUniqueFilterInput>;
};


export type MutationUpdateSomeCenshareTracesInOrderArgs = {
  data?: InputMaybe<CenshareTraceUpdateInput>;
  subset?: InputMaybe<CenshareTraceFilterInput>;
  where: Array<CenshareTraceUniqueFilterInput>;
};


export type MutationUpdateSomeCenshareTracesInOrderIfExistsArgs = {
  data?: InputMaybe<CenshareTraceUpdateInput>;
  subset?: InputMaybe<CenshareTraceFilterInput>;
  where: Array<CenshareTraceUniqueFilterInput>;
};


export type MutationUpdateSomeFilesInOrderArgs = {
  data?: InputMaybe<FileUpdateInput>;
  subset?: InputMaybe<FileFilterInput>;
  where: Array<FileUniqueFilterInput>;
};


export type MutationUpdateSomeFilesInOrderIfExistsArgs = {
  data?: InputMaybe<FileUpdateInput>;
  subset?: InputMaybe<FileFilterInput>;
  where: Array<FileUniqueFilterInput>;
};


export type MutationUpdateSomeLayoutAssetsInOrderArgs = {
  data?: InputMaybe<LayoutAssetUpdateInput>;
  subset?: InputMaybe<LayoutAssetFilterInput>;
  where: Array<LayoutAssetUniqueFilterInput>;
};


export type MutationUpdateSomeLayoutAssetsInOrderIfExistsArgs = {
  data?: InputMaybe<LayoutAssetUpdateInput>;
  subset?: InputMaybe<LayoutAssetFilterInput>;
  where: Array<LayoutAssetUniqueFilterInput>;
};


export type MutationUpdateSomeLayoutsInOrderArgs = {
  data?: InputMaybe<LayoutUpdateInput>;
  subset?: InputMaybe<LayoutFilterInput>;
  where: Array<LayoutUniqueFilterInput>;
};


export type MutationUpdateSomeLayoutsInOrderIfExistsArgs = {
  data?: InputMaybe<LayoutUpdateInput>;
  subset?: InputMaybe<LayoutFilterInput>;
  where: Array<LayoutUniqueFilterInput>;
};


export type MutationUpdateSomeMockupsInOrderArgs = {
  data?: InputMaybe<MockupUpdateInput>;
  subset?: InputMaybe<MockupFilterInput>;
  where: Array<MockupUniqueFilterInput>;
};


export type MutationUpdateSomeMockupsInOrderIfExistsArgs = {
  data?: InputMaybe<MockupUpdateInput>;
  subset?: InputMaybe<MockupFilterInput>;
  where: Array<MockupUniqueFilterInput>;
};


export type MutationUpdateSomePrintHeadingPrintTemplatesInOrderArgs = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateInput>;
  subset?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  where: Array<PrintHeadingPrintTemplateUniqueFilterInput>;
};


export type MutationUpdateSomePrintHeadingPrintTemplatesInOrderIfExistsArgs = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateInput>;
  subset?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  where: Array<PrintHeadingPrintTemplateUniqueFilterInput>;
};


export type MutationUpdateSomePrintHeadingsInOrderArgs = {
  data?: InputMaybe<PrintHeadingUpdateInput>;
  subset?: InputMaybe<PrintHeadingFilterInput>;
  where: Array<PrintHeadingUniqueFilterInput>;
};


export type MutationUpdateSomePrintHeadingsInOrderIfExistsArgs = {
  data?: InputMaybe<PrintHeadingUpdateInput>;
  subset?: InputMaybe<PrintHeadingFilterInput>;
  where: Array<PrintHeadingUniqueFilterInput>;
};


export type MutationUpdateSomePrintIssueRailroadsInOrderArgs = {
  data?: InputMaybe<PrintIssueRailroadUpdateInput>;
  subset?: InputMaybe<PrintIssueRailroadFilterInput>;
  where: Array<PrintIssueRailroadUniqueFilterInput>;
};


export type MutationUpdateSomePrintIssueRailroadsInOrderIfExistsArgs = {
  data?: InputMaybe<PrintIssueRailroadUpdateInput>;
  subset?: InputMaybe<PrintIssueRailroadFilterInput>;
  where: Array<PrintIssueRailroadUniqueFilterInput>;
};


export type MutationUpdateSomePrintIssuesInOrderArgs = {
  data?: InputMaybe<PrintIssueUpdateInput>;
  subset?: InputMaybe<PrintIssueFilterInput>;
  where: Array<PrintIssueUniqueFilterInput>;
};


export type MutationUpdateSomePrintIssuesInOrderIfExistsArgs = {
  data?: InputMaybe<PrintIssueUpdateInput>;
  subset?: InputMaybe<PrintIssueFilterInput>;
  where: Array<PrintIssueUniqueFilterInput>;
};


export type MutationUpdateSomePrintPublicationsInOrderArgs = {
  data?: InputMaybe<PrintPublicationUpdateInput>;
  subset?: InputMaybe<PrintPublicationFilterInput>;
  where: Array<PrintPublicationUniqueFilterInput>;
};


export type MutationUpdateSomePrintPublicationsInOrderIfExistsArgs = {
  data?: InputMaybe<PrintPublicationUpdateInput>;
  subset?: InputMaybe<PrintPublicationFilterInput>;
  where: Array<PrintPublicationUniqueFilterInput>;
};


export type MutationUpdateSomePrintTemplatesInOrderArgs = {
  data?: InputMaybe<PrintTemplateUpdateInput>;
  subset?: InputMaybe<PrintTemplateFilterInput>;
  where: Array<PrintTemplateUniqueFilterInput>;
};


export type MutationUpdateSomePrintTemplatesInOrderIfExistsArgs = {
  data?: InputMaybe<PrintTemplateUpdateInput>;
  subset?: InputMaybe<PrintTemplateFilterInput>;
  where: Array<PrintTemplateUniqueFilterInput>;
};


export type MutationUpdateSomeRailroadPagesInOrderArgs = {
  data?: InputMaybe<RailroadPageUpdateInput>;
  subset?: InputMaybe<RailroadPageFilterInput>;
  where: Array<RailroadPageUniqueFilterInput>;
};


export type MutationUpdateSomeRailroadPagesInOrderIfExistsArgs = {
  data?: InputMaybe<RailroadPageUpdateInput>;
  subset?: InputMaybe<RailroadPageFilterInput>;
  where: Array<RailroadPageUniqueFilterInput>;
};


export type MutationUpdateSomeRawArticlesInOrderArgs = {
  data?: InputMaybe<RawArticleUpdateInput>;
  subset?: InputMaybe<RawArticleFilterInput>;
  where: Array<RawArticleUniqueFilterInput>;
};


export type MutationUpdateSomeRawArticlesInOrderIfExistsArgs = {
  data?: InputMaybe<RawArticleUpdateInput>;
  subset?: InputMaybe<RawArticleFilterInput>;
  where: Array<RawArticleUniqueFilterInput>;
};


export type MutationUpdateSomeRawArticleVersionsInOrderArgs = {
  data?: InputMaybe<RawArticleVersionUpdateInput>;
  subset?: InputMaybe<RawArticleVersionFilterInput>;
  where: Array<RawArticleVersionUniqueFilterInput>;
};


export type MutationUpdateSomeRawArticleVersionsInOrderIfExistsArgs = {
  data?: InputMaybe<RawArticleVersionUpdateInput>;
  subset?: InputMaybe<RawArticleVersionFilterInput>;
  where: Array<RawArticleVersionUniqueFilterInput>;
};


export type MutationUpdateSomeSubjectCategoriesInOrderArgs = {
  data?: InputMaybe<SubjectCategoryUpdateInput>;
  subset?: InputMaybe<SubjectCategoryFilterInput>;
  where: Array<SubjectCategoryUniqueFilterInput>;
};


export type MutationUpdateSomeSubjectCategoriesInOrderIfExistsArgs = {
  data?: InputMaybe<SubjectCategoryUpdateInput>;
  subset?: InputMaybe<SubjectCategoryFilterInput>;
  where: Array<SubjectCategoryUniqueFilterInput>;
};


export type MutationUpdateSomeSubjectsInOrderArgs = {
  data?: InputMaybe<SubjectUpdateInput>;
  subset?: InputMaybe<SubjectFilterInput>;
  where: Array<SubjectUniqueFilterInput>;
};


export type MutationUpdateSomeSubjectsInOrderIfExistsArgs = {
  data?: InputMaybe<SubjectUpdateInput>;
  subset?: InputMaybe<SubjectFilterInput>;
  where: Array<SubjectUniqueFilterInput>;
};


export type MutationUpdateSomeSubSubjectsInOrderArgs = {
  data?: InputMaybe<SubSubjectUpdateInput>;
  subset?: InputMaybe<SubSubjectFilterInput>;
  where: Array<SubSubjectUniqueFilterInput>;
};


export type MutationUpdateSomeSubSubjectsInOrderIfExistsArgs = {
  data?: InputMaybe<SubSubjectUpdateInput>;
  subset?: InputMaybe<SubSubjectFilterInput>;
  where: Array<SubSubjectUniqueFilterInput>;
};


export type MutationUpdateSomeTopicFotowebPigesInOrderArgs = {
  data?: InputMaybe<TopicFotowebPigeUpdateInput>;
  subset?: InputMaybe<TopicFotowebPigeFilterInput>;
  where: Array<TopicFotowebPigeUniqueFilterInput>;
};


export type MutationUpdateSomeTopicFotowebPigesInOrderIfExistsArgs = {
  data?: InputMaybe<TopicFotowebPigeUpdateInput>;
  subset?: InputMaybe<TopicFotowebPigeFilterInput>;
  where: Array<TopicFotowebPigeUniqueFilterInput>;
};


export type MutationUpdateSomeUnitsInOrderArgs = {
  data?: InputMaybe<UnitUpdateInput>;
  subset?: InputMaybe<UnitFilterInput>;
  where: Array<UnitUniqueFilterInput>;
};


export type MutationUpdateSomeUnitsInOrderIfExistsArgs = {
  data?: InputMaybe<UnitUpdateInput>;
  subset?: InputMaybe<UnitFilterInput>;
  where: Array<UnitUniqueFilterInput>;
};


export type MutationUpdateSomeWebsitesInOrderArgs = {
  data?: InputMaybe<WebsiteUpdateInput>;
  subset?: InputMaybe<WebsiteFilterInput>;
  where: Array<WebsiteUniqueFilterInput>;
};


export type MutationUpdateSomeWebsitesInOrderIfExistsArgs = {
  data?: InputMaybe<WebsiteUpdateInput>;
  subset?: InputMaybe<WebsiteFilterInput>;
  where: Array<WebsiteUniqueFilterInput>;
};


export type MutationUpdateSubjectArgs = {
  data?: InputMaybe<SubjectUpdateInput>;
  where: SubjectUniqueFilterInput;
};


export type MutationUpdateSubjectCategoriesArgs = {
  data?: InputMaybe<SubjectCategoryUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectCategoryOrderingInput>>;
  where?: InputMaybe<SubjectCategoryFilterInput>;
};


export type MutationUpdateSubjectCategoryArgs = {
  data?: InputMaybe<SubjectCategoryUpdateInput>;
  where: SubjectCategoryUniqueFilterInput;
};


export type MutationUpdateSubjectCategoryIfExistsArgs = {
  data?: InputMaybe<SubjectCategoryUpdateInput>;
  where: SubjectCategoryUniqueFilterInput;
};


export type MutationUpdateSubjectIfExistsArgs = {
  data?: InputMaybe<SubjectUpdateInput>;
  where: SubjectUniqueFilterInput;
};


export type MutationUpdateSubjectsArgs = {
  data?: InputMaybe<SubjectUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubjectOrderingInput>>;
  where?: InputMaybe<SubjectFilterInput>;
};


export type MutationUpdateSubSubjectArgs = {
  data?: InputMaybe<SubSubjectUpdateInput>;
  where: SubSubjectUniqueFilterInput;
};


export type MutationUpdateSubSubjectIfExistsArgs = {
  data?: InputMaybe<SubSubjectUpdateInput>;
  where: SubSubjectUniqueFilterInput;
};


export type MutationUpdateSubSubjectsArgs = {
  data?: InputMaybe<SubSubjectUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SubSubjectOrderingInput>>;
  where?: InputMaybe<SubSubjectFilterInput>;
};


export type MutationUpdateTopicFotowebPigeArgs = {
  data?: InputMaybe<TopicFotowebPigeUpdateInput>;
  where: TopicFotowebPigeUniqueFilterInput;
};


export type MutationUpdateTopicFotowebPigeIfExistsArgs = {
  data?: InputMaybe<TopicFotowebPigeUpdateInput>;
  where: TopicFotowebPigeUniqueFilterInput;
};


export type MutationUpdateTopicFotowebPigesArgs = {
  data?: InputMaybe<TopicFotowebPigeUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TopicFotowebPigeOrderingInput>>;
  where?: InputMaybe<TopicFotowebPigeFilterInput>;
};


export type MutationUpdateUnitArgs = {
  data?: InputMaybe<UnitUpdateInput>;
  where: UnitUniqueFilterInput;
};


export type MutationUpdateUnitIfExistsArgs = {
  data?: InputMaybe<UnitUpdateInput>;
  where: UnitUniqueFilterInput;
};


export type MutationUpdateUnitsArgs = {
  data?: InputMaybe<UnitUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<UnitOrderingInput>>;
  where?: InputMaybe<UnitFilterInput>;
};


export type MutationUpdateWebsiteArgs = {
  data?: InputMaybe<WebsiteUpdateInput>;
  where: WebsiteUniqueFilterInput;
};


export type MutationUpdateWebsiteIfExistsArgs = {
  data?: InputMaybe<WebsiteUpdateInput>;
  where: WebsiteUniqueFilterInput;
};


export type MutationUpdateWebsitesArgs = {
  data?: InputMaybe<WebsiteUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<WebsiteOrderingInput>>;
  where?: InputMaybe<WebsiteFilterInput>;
};


export type MutationUpsertAdvertisementArgs = {
  create: AdvertisementCreationInput;
  update?: InputMaybe<AdvertisementUpdateInput>;
  where: AdvertisementUniqueFilterInput;
};


export type MutationUpsertArticleTemplateArgs = {
  create: ArticleTemplateCreationInput;
  update?: InputMaybe<ArticleTemplateUpdateInput>;
  where: ArticleTemplateUniqueFilterInput;
};


export type MutationUpsertAssignmentArgs = {
  create: AssignmentCreationInput;
  update?: InputMaybe<AssignmentUpdateInput>;
  where: AssignmentUniqueFilterInput;
};


export type MutationUpsertAttachmentArgs = {
  create: AttachmentCreationInput;
  update?: InputMaybe<AttachmentUpdateInput>;
  where: AttachmentUniqueFilterInput;
};


export type MutationUpsertBrandArgs = {
  create: BrandCreationInput;
  update?: InputMaybe<BrandUpdateInput>;
  where: BrandUniqueFilterInput;
};


export type MutationUpsertCenshareTraceArgs = {
  create: CenshareTraceCreationInput;
  update?: InputMaybe<CenshareTraceUpdateInput>;
  where: CenshareTraceUniqueFilterInput;
};


export type MutationUpsertFileArgs = {
  create: FileCreationInput;
  update?: InputMaybe<FileUpdateInput>;
  where: FileUniqueFilterInput;
};


export type MutationUpsertLayoutArgs = {
  create: LayoutCreationInput;
  update?: InputMaybe<LayoutUpdateInput>;
  where: LayoutUniqueFilterInput;
};


export type MutationUpsertLayoutAssetArgs = {
  create: LayoutAssetCreationInput;
  update?: InputMaybe<LayoutAssetUpdateInput>;
  where: LayoutAssetUniqueFilterInput;
};


export type MutationUpsertMockupArgs = {
  create: MockupCreationInput;
  update?: InputMaybe<MockupUpdateInput>;
  where: MockupUniqueFilterInput;
};


export type MutationUpsertPrintHeadingArgs = {
  create: PrintHeadingCreationInput;
  update?: InputMaybe<PrintHeadingUpdateInput>;
  where: PrintHeadingUniqueFilterInput;
};


export type MutationUpsertPrintHeadingPrintTemplateArgs = {
  create: PrintHeadingPrintTemplateCreationInput;
  update?: InputMaybe<PrintHeadingPrintTemplateUpdateInput>;
  where: PrintHeadingPrintTemplateUniqueFilterInput;
};


export type MutationUpsertPrintIssueArgs = {
  create: PrintIssueCreationInput;
  update?: InputMaybe<PrintIssueUpdateInput>;
  where: PrintIssueUniqueFilterInput;
};


export type MutationUpsertPrintIssueRailroadArgs = {
  create: PrintIssueRailroadCreationInput;
  update?: InputMaybe<PrintIssueRailroadUpdateInput>;
  where: PrintIssueRailroadUniqueFilterInput;
};


export type MutationUpsertPrintPublicationArgs = {
  create: PrintPublicationCreationInput;
  update?: InputMaybe<PrintPublicationUpdateInput>;
  where: PrintPublicationUniqueFilterInput;
};


export type MutationUpsertPrintTemplateArgs = {
  create: PrintTemplateCreationInput;
  update?: InputMaybe<PrintTemplateUpdateInput>;
  where: PrintTemplateUniqueFilterInput;
};


export type MutationUpsertRailroadPageArgs = {
  create: RailroadPageCreationInput;
  update?: InputMaybe<RailroadPageUpdateInput>;
  where: RailroadPageUniqueFilterInput;
};


export type MutationUpsertRawArticleArgs = {
  create: RawArticleCreationInput;
  update?: InputMaybe<RawArticleUpdateInput>;
  where: RawArticleUniqueFilterInput;
};


export type MutationUpsertRawArticleVersionArgs = {
  create: RawArticleVersionCreationInput;
  update?: InputMaybe<RawArticleVersionUpdateInput>;
  where: RawArticleVersionUniqueFilterInput;
};


export type MutationUpsertSubjectArgs = {
  create: SubjectCreationInput;
  update?: InputMaybe<SubjectUpdateInput>;
  where: SubjectUniqueFilterInput;
};


export type MutationUpsertSubjectCategoryArgs = {
  create: SubjectCategoryCreationInput;
  update?: InputMaybe<SubjectCategoryUpdateInput>;
  where: SubjectCategoryUniqueFilterInput;
};


export type MutationUpsertSubSubjectArgs = {
  create: SubSubjectCreationInput;
  update?: InputMaybe<SubSubjectUpdateInput>;
  where: SubSubjectUniqueFilterInput;
};


export type MutationUpsertTopicFotowebPigeArgs = {
  create: TopicFotowebPigeCreationInput;
  update?: InputMaybe<TopicFotowebPigeUpdateInput>;
  where: TopicFotowebPigeUniqueFilterInput;
};


export type MutationUpsertUnitArgs = {
  create: UnitCreationInput;
  update?: InputMaybe<UnitUpdateInput>;
  where: UnitUniqueFilterInput;
};


export type MutationUpsertWebsiteArgs = {
  create: WebsiteCreationInput;
  update?: InputMaybe<WebsiteUpdateInput>;
  where: WebsiteUniqueFilterInput;
};

/** The "Advertisement" node's creation */
export type AdvertisementCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<AdvertisementCreationLayoutAssetsInput>;
  printIssue?: InputMaybe<AdvertisementCreationPrintIssueInput>;
  printPublication?: InputMaybe<AdvertisementCreationPrintPublicationInput>;
  versions?: InputMaybe<AdvertisementCreationVersionsInput>;
};

export type AdvertisementCreationLayoutAssetsInput = {
  create?: InputMaybe<Array<LayoutAssetCreationWithoutAdvertisementInput>>;
};

/** The "LayoutAsset" node's creation */
export type LayoutAssetCreationWithoutAdvertisementInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  file?: InputMaybe<LayoutAssetCreationFileInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layout: LayoutAssetCreationLayoutInput;
  mockup?: InputMaybe<LayoutAssetCreationMockupInput>;
  order: Scalars['UnsignedInt']['input'];
  printHeading?: InputMaybe<LayoutAssetCreationPrintHeadingInput>;
};

export type LayoutAssetCreationFileInput = {
  /** Connect a "File" to a new "LayoutAsset" through the "LayoutAsset.file" edge, throw an error if it does not exist. */
  connect?: InputMaybe<FileUniqueFilterInput>;
  /** Connect a "File" to a new "LayoutAsset" through the "LayoutAsset.file" edge, if it exists. */
  connectIfExists?: InputMaybe<FileUniqueFilterInput>;
  /** Create a "File" and connect it to a new "LayoutAsset" through the "LayoutAsset.file" edge. */
  create?: InputMaybe<FileCreationInput>;
  /** Create a "File" if it does not exist, and connect it to a new "LayoutAsset" through the "LayoutAsset.file" edge. */
  createIfNotExists?: InputMaybe<LayoutAssetCreationFileCreateIfNotExistsInput>;
};

/** The "File" node's creation */
export type FileCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<FileCreationLayoutAssetsInput>;
  printIssue?: InputMaybe<FileCreationPrintIssueInput>;
  printPublication?: InputMaybe<FileCreationPrintPublicationInput>;
  versions?: InputMaybe<FileCreationVersionsInput>;
};

export type FileCreationLayoutAssetsInput = {
  create?: InputMaybe<Array<LayoutAssetCreationWithoutFileInput>>;
};

/** The "LayoutAsset" node's creation */
export type LayoutAssetCreationWithoutFileInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisement?: InputMaybe<LayoutAssetCreationAdvertisementInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layout: LayoutAssetCreationLayoutInput;
  mockup?: InputMaybe<LayoutAssetCreationMockupInput>;
  order: Scalars['UnsignedInt']['input'];
  printHeading?: InputMaybe<LayoutAssetCreationPrintHeadingInput>;
};

export type LayoutAssetCreationAdvertisementInput = {
  /**
   * Connect an "Advertisement" to a new "LayoutAsset" through the
   * "LayoutAsset.advertisement" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<AdvertisementUniqueFilterInput>;
  /** Connect an "Advertisement" to a new "LayoutAsset" through the "LayoutAsset.advertisement" edge, if it exists. */
  connectIfExists?: InputMaybe<AdvertisementUniqueFilterInput>;
  /** Create an "Advertisement" and connect it to a new "LayoutAsset" through the "LayoutAsset.advertisement" edge. */
  create?: InputMaybe<AdvertisementCreationInput>;
  /**
   * Create an "Advertisement" if it does not exist, and connect it to a new
   * "LayoutAsset" through the "LayoutAsset.advertisement" edge.
   */
  createIfNotExists?: InputMaybe<LayoutAssetCreationAdvertisementCreateIfNotExistsInput>;
};

export type LayoutAssetCreationAdvertisementCreateIfNotExistsInput = {
  data: AdvertisementCreationInput;
  where: AdvertisementUniqueFilterInput;
};

export type LayoutAssetCreationLayoutInput = {
  /** Connect a "Layout" to a new "LayoutAsset" through the "LayoutAsset.layout" edge, throw an error if it does not exist. */
  connect?: InputMaybe<LayoutUniqueFilterInput>;
  /** Create a "Layout" and connect it to a new "LayoutAsset" through the "LayoutAsset.layout" edge. */
  create?: InputMaybe<LayoutCreationInput>;
  /** Create a "Layout" if it does not exist, and connect it to a new "LayoutAsset" through the "LayoutAsset.layout" edge. */
  createIfNotExists?: InputMaybe<LayoutAssetCreationLayoutCreateIfNotExistsInput>;
};

/** The "Layout" node's creation */
export type LayoutCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assets?: InputMaybe<LayoutCreationAssetsInput>;
  /** The layouts that are based on this one */
  children?: InputMaybe<LayoutCreationChildrenInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The layout this one is based on, if any */
  parent?: InputMaybe<LayoutCreationParentInput>;
  printIssue?: InputMaybe<LayoutCreationPrintIssueInput>;
  printPublication?: InputMaybe<LayoutCreationPrintPublicationInput>;
  title: Scalars['String']['input'];
};

export type LayoutCreationAssetsInput = {
  create?: InputMaybe<Array<LayoutAssetCreationWithoutLayoutInput>>;
};

/** The "LayoutAsset" node's creation */
export type LayoutAssetCreationWithoutLayoutInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisement?: InputMaybe<LayoutAssetCreationAdvertisementInput>;
  file?: InputMaybe<LayoutAssetCreationFileInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  mockup?: InputMaybe<LayoutAssetCreationMockupInput>;
  order: Scalars['UnsignedInt']['input'];
  printHeading?: InputMaybe<LayoutAssetCreationPrintHeadingInput>;
};

export type LayoutAssetCreationMockupInput = {
  /** Connect a "Mockup" to a new "LayoutAsset" through the "LayoutAsset.mockup" edge, throw an error if it does not exist. */
  connect?: InputMaybe<MockupUniqueFilterInput>;
  /** Connect a "Mockup" to a new "LayoutAsset" through the "LayoutAsset.mockup" edge, if it exists. */
  connectIfExists?: InputMaybe<MockupUniqueFilterInput>;
  /** Create a "Mockup" and connect it to a new "LayoutAsset" through the "LayoutAsset.mockup" edge. */
  create?: InputMaybe<MockupCreationInput>;
  /** Create a "Mockup" if it does not exist, and connect it to a new "LayoutAsset" through the "LayoutAsset.mockup" edge. */
  createIfNotExists?: InputMaybe<LayoutAssetCreationMockupCreateIfNotExistsInput>;
};

/** The "Mockup" node's creation */
export type MockupCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<MockupCreationLayoutAssetsInput>;
  printHeading?: InputMaybe<MockupCreationPrintHeadingInput>;
  printIssue?: InputMaybe<MockupCreationPrintIssueInput>;
  printPublication?: InputMaybe<MockupCreationPrintPublicationInput>;
  versions?: InputMaybe<MockupCreationVersionsInput>;
};

export type MockupCreationLayoutAssetsInput = {
  create?: InputMaybe<Array<LayoutAssetCreationWithoutMockupInput>>;
};

/** The "LayoutAsset" node's creation */
export type LayoutAssetCreationWithoutMockupInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisement?: InputMaybe<LayoutAssetCreationAdvertisementInput>;
  file?: InputMaybe<LayoutAssetCreationFileInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layout: LayoutAssetCreationLayoutInput;
  order: Scalars['UnsignedInt']['input'];
  printHeading?: InputMaybe<LayoutAssetCreationPrintHeadingInput>;
};

export type LayoutAssetCreationPrintHeadingInput = {
  /**
   * Connect a "PrintHeading" to a new "LayoutAsset" through the
   * "LayoutAsset.printHeading" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Connect a "PrintHeading" to a new "LayoutAsset" through the "LayoutAsset.printHeading" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Create a "PrintHeading" and connect it to a new "LayoutAsset" through the "LayoutAsset.printHeading" edge. */
  create?: InputMaybe<PrintHeadingCreationInput>;
  /**
   * Create a "PrintHeading" if it does not exist, and connect it to a new
   * "LayoutAsset" through the "LayoutAsset.printHeading" edge.
   */
  createIfNotExists?: InputMaybe<LayoutAssetCreationPrintHeadingCreateIfNotExistsInput>;
};

/** The "PrintHeading" node's creation */
export type PrintHeadingCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments?: InputMaybe<PrintHeadingCreationAssignmentsInput>;
  autoPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutomaticSubject?: Scalars['Boolean']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<PrintHeadingCreationLayoutAssetsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockup?: InputMaybe<PrintHeadingCreationMockupInput>;
  order: Scalars['UnsignedInt']['input'];
  printIssue: PrintHeadingCreationPrintIssueInput;
  printPublication?: InputMaybe<PrintHeadingCreationPrintPublicationInput>;
  printTemplates?: InputMaybe<PrintHeadingCreationPrintTemplatesInput>;
  title: Scalars['String']['input'];
};

export type PrintHeadingCreationAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutPrintHeadingInput>>;
};

/** The "Assignment" node's creation */
export type AssignmentCreationWithoutPrintHeadingInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplate?: InputMaybe<AssignmentCreationArticleTemplateInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssue?: InputMaybe<AssignmentCreationPrintIssueInput>;
  printPublication?: InputMaybe<AssignmentCreationPrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentCreationPrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentCreationRawArticleInput>;
  subject: AssignmentCreationSubjectInput;
  website?: InputMaybe<AssignmentCreationWebsiteInput>;
};

export type AssignmentCreationArticleTemplateInput = {
  /**
   * Connect an "ArticleTemplate" to a new "Assignment" through the
   * "Assignment.articleTemplate" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleTemplateUniqueFilterInput>;
  /** Connect an "ArticleTemplate" to a new "Assignment" through the "Assignment.articleTemplate" edge, if it exists. */
  connectIfExists?: InputMaybe<ArticleTemplateUniqueFilterInput>;
  /** Create an "ArticleTemplate" and connect it to a new "Assignment" through the "Assignment.articleTemplate" edge. */
  create?: InputMaybe<ArticleTemplateCreationInput>;
  /**
   * Create an "ArticleTemplate" if it does not exist, and connect it to a new
   * "Assignment" through the "Assignment.articleTemplate" edge.
   */
  createIfNotExists?: InputMaybe<AssignmentCreationArticleTemplateCreateIfNotExistsInput>;
};

/** The "ArticleTemplate" node's creation */
export type ArticleTemplateCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments?: InputMaybe<ArticleTemplateCreationAssignmentsInput>;
  /** The raw datas */
  block?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The article template label */
  label?: InputMaybe<Scalars['String']['input']>;
  printTemplate: ArticleTemplateCreationPrintTemplateInput;
};

export type ArticleTemplateCreationAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutArticleTemplateInput>>;
};

/** The "Assignment" node's creation */
export type AssignmentCreationWithoutArticleTemplateInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentCreationPrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentCreationPrintIssueInput>;
  printPublication?: InputMaybe<AssignmentCreationPrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentCreationPrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentCreationRawArticleInput>;
  subject: AssignmentCreationSubjectInput;
  website?: InputMaybe<AssignmentCreationWebsiteInput>;
};

export type AssignmentCreationPrintHeadingInput = {
  /**
   * Connect a "PrintHeading" to a new "Assignment" through the
   * "Assignment.printHeading" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Connect a "PrintHeading" to a new "Assignment" through the "Assignment.printHeading" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Create a "PrintHeading" and connect it to a new "Assignment" through the "Assignment.printHeading" edge. */
  create?: InputMaybe<PrintHeadingCreationInput>;
  /**
   * Create a "PrintHeading" if it does not exist, and connect it to a new
   * "Assignment" through the "Assignment.printHeading" edge.
   */
  createIfNotExists?: InputMaybe<AssignmentCreationPrintHeadingCreateIfNotExistsInput>;
};

export type AssignmentCreationPrintHeadingCreateIfNotExistsInput = {
  data: PrintHeadingCreationInput;
  where: PrintHeadingUniqueFilterInput;
};

export type AssignmentCreationPrintIssueInput = {
  /**
   * Connect a "PrintIssue" to a new "Assignment" through the
   * "Assignment.printIssue" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Connect a "PrintIssue" to a new "Assignment" through the "Assignment.printIssue" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to a new "Assignment" through the "Assignment.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /** Create a "PrintIssue" if it does not exist, and connect it to a new "Assignment" through the "Assignment.printIssue" edge. */
  createIfNotExists?: InputMaybe<AssignmentCreationPrintIssueCreateIfNotExistsInput>;
};

/** The "PrintIssue" node's creation */
export type PrintIssueCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisements?: InputMaybe<PrintIssueCreationAdvertisementsInput>;
  assignments?: InputMaybe<PrintIssueCreationAssignmentsInput>;
  files?: InputMaybe<PrintIssueCreationFilesInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layouts?: InputMaybe<PrintIssueCreationLayoutsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockups?: InputMaybe<PrintIssueCreationMockupsInput>;
  printHeadings?: InputMaybe<PrintIssueCreationPrintHeadingsInput>;
  printIssueRailroad?: InputMaybe<PrintIssueCreationPrintIssueRailroadInput>;
  printPublication: PrintIssueCreationPrintPublicationInput;
  title: Scalars['String']['input'];
};

export type PrintIssueCreationAdvertisementsInput = {
  create?: InputMaybe<Array<AdvertisementCreationWithoutPrintIssueInput>>;
};

/** The "Advertisement" node's creation */
export type AdvertisementCreationWithoutPrintIssueInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<AdvertisementCreationLayoutAssetsInput>;
  printPublication?: InputMaybe<AdvertisementCreationPrintPublicationInput>;
  versions?: InputMaybe<AdvertisementCreationVersionsInput>;
};

export type AdvertisementCreationPrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to a new "Advertisement" through the
   * "Advertisement.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to a new "Advertisement" through the "Advertisement.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to a new "Advertisement" through the "Advertisement.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to a new
   * "Advertisement" through the "Advertisement.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<AdvertisementCreationPrintPublicationCreateIfNotExistsInput>;
};

/** The "PrintPublication" node's creation */
export type PrintPublicationCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisements?: InputMaybe<PrintPublicationCreationAdvertisementsInput>;
  assignments?: InputMaybe<PrintPublicationCreationAssignmentsInput>;
  brand: PrintPublicationCreationBrandInput;
  files?: InputMaybe<PrintPublicationCreationFilesInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  key: Scalars['String']['input'];
  layouts?: InputMaybe<PrintPublicationCreationLayoutsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockups?: InputMaybe<PrintPublicationCreationMockupsInput>;
  printHeadings?: InputMaybe<PrintPublicationCreationPrintHeadingsInput>;
  printIssues?: InputMaybe<PrintPublicationCreationPrintIssuesInput>;
  title: Scalars['String']['input'];
};

export type PrintPublicationCreationAdvertisementsInput = {
  create?: InputMaybe<Array<AdvertisementCreationWithoutPrintPublicationInput>>;
};

/** The "Advertisement" node's creation */
export type AdvertisementCreationWithoutPrintPublicationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<AdvertisementCreationLayoutAssetsInput>;
  printIssue?: InputMaybe<AdvertisementCreationPrintIssueInput>;
  versions?: InputMaybe<AdvertisementCreationVersionsInput>;
};

export type AdvertisementCreationPrintIssueInput = {
  /**
   * Connect a "PrintIssue" to a new "Advertisement" through the
   * "Advertisement.printIssue" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Connect a "PrintIssue" to a new "Advertisement" through the "Advertisement.printIssue" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to a new "Advertisement" through the "Advertisement.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /**
   * Create a "PrintIssue" if it does not exist, and connect it to a new
   * "Advertisement" through the "Advertisement.printIssue" edge.
   */
  createIfNotExists?: InputMaybe<AdvertisementCreationPrintIssueCreateIfNotExistsInput>;
};

export type AdvertisementCreationPrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type AdvertisementCreationVersionsInput = {
  create?: InputMaybe<Array<AdvertisementVersionCreationWithoutAdvertisementInput>>;
};

/** The "AdvertisementVersion" node's creation */
export type AdvertisementVersionCreationWithoutAdvertisementInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  nextVersion?: InputMaybe<AdvertisementVersionCreationNextVersionInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  picbiId?: InputMaybe<Scalars['String']['input']>;
  previousVersion?: InputMaybe<AdvertisementVersionCreationPreviousVersionInput>;
  title: Scalars['String']['input'];
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type AdvertisementVersionCreationNextVersionInput = {
  create?: InputMaybe<AdvertisementVersionCreationWithoutPreviousVersionInput>;
};

/** The "AdvertisementVersion" node's creation */
export type AdvertisementVersionCreationWithoutPreviousVersionInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisement: AdvertisementVersionCreationAdvertisementInput;
  campaign?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  nextVersion?: InputMaybe<AdvertisementVersionCreationNextVersionInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  picbiId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type AdvertisementVersionCreationAdvertisementInput = {
  /**
   * Connect an "Advertisement" to a new "AdvertisementVersion" through the
   * "AdvertisementVersion.advertisement" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<AdvertisementUniqueFilterInput>;
  /**
   * Create an "Advertisement" and connect it to a new "AdvertisementVersion"
   * through the "AdvertisementVersion.advertisement" edge.
   */
  create?: InputMaybe<AdvertisementCreationInput>;
  /**
   * Create an "Advertisement" if it does not exist, and connect it to a new
   * "AdvertisementVersion" through the "AdvertisementVersion.advertisement" edge.
   */
  createIfNotExists?: InputMaybe<AdvertisementVersionCreationAdvertisementCreateIfNotExistsInput>;
};

export type AdvertisementVersionCreationAdvertisementCreateIfNotExistsInput = {
  data: AdvertisementCreationInput;
  where: AdvertisementUniqueFilterInput;
};

export type AdvertisementVersionCreationPreviousVersionInput = {
  /**
   * Connect an "AdvertisementVersion" to a new "AdvertisementVersion" through the
   * "AdvertisementVersion.previousVersion" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<AdvertisementVersionUniqueFilterInput>;
  /**
   * Connect an "AdvertisementVersion" to a new "AdvertisementVersion" through the
   * "AdvertisementVersion.previousVersion" edge, if it exists.
   */
  connectIfExists?: InputMaybe<AdvertisementVersionUniqueFilterInput>;
  /**
   * Create an "AdvertisementVersion" and connect it to a new
   * "AdvertisementVersion" through the "AdvertisementVersion.previousVersion" edge.
   */
  create?: InputMaybe<AdvertisementVersionCreationInput>;
  /**
   * Create an "AdvertisementVersion" if it does not exist, and connect it to a new
   * "AdvertisementVersion" through the "AdvertisementVersion.previousVersion" edge.
   */
  createIfNotExists?: InputMaybe<AdvertisementVersionCreationPreviousVersionCreateIfNotExistsInput>;
};

/** The "AdvertisementVersion" node's creation */
export type AdvertisementVersionCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisement: AdvertisementVersionCreationAdvertisementInput;
  campaign?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  nextVersion?: InputMaybe<AdvertisementVersionCreationNextVersionInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  picbiId?: InputMaybe<Scalars['String']['input']>;
  previousVersion?: InputMaybe<AdvertisementVersionCreationPreviousVersionInput>;
  title: Scalars['String']['input'];
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type AdvertisementVersionCreationPreviousVersionCreateIfNotExistsInput = {
  data: AdvertisementVersionCreationInput;
  where: AdvertisementVersionUniqueFilterInput;
};

export type PrintPublicationCreationAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutPrintPublicationInput>>;
};

/** The "Assignment" node's creation */
export type AssignmentCreationWithoutPrintPublicationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplate?: InputMaybe<AssignmentCreationArticleTemplateInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentCreationPrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentCreationPrintIssueInput>;
  printTemplate?: InputMaybe<AssignmentCreationPrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentCreationRawArticleInput>;
  subject: AssignmentCreationSubjectInput;
  website?: InputMaybe<AssignmentCreationWebsiteInput>;
};

export type AssignmentCreationPrintTemplateInput = {
  /**
   * Connect a "PrintTemplate" to a new "Assignment" through the
   * "Assignment.printTemplate" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintTemplateUniqueFilterInput>;
  /** Connect a "PrintTemplate" to a new "Assignment" through the "Assignment.printTemplate" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintTemplateUniqueFilterInput>;
  /** Create a "PrintTemplate" and connect it to a new "Assignment" through the "Assignment.printTemplate" edge. */
  create?: InputMaybe<PrintTemplateCreationInput>;
  /**
   * Create a "PrintTemplate" if it does not exist, and connect it to a new
   * "Assignment" through the "Assignment.printTemplate" edge.
   */
  createIfNotExists?: InputMaybe<AssignmentCreationPrintTemplateCreateIfNotExistsInput>;
};

/** The "PrintTemplate" node's creation */
export type PrintTemplateCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplates?: InputMaybe<PrintTemplateCreationArticleTemplatesInput>;
  assignments?: InputMaybe<PrintTemplateCreationAssignmentsInput>;
  /** KAMI extension data */
  data?: InputMaybe<Scalars['String']['input']>;
  /** KAMI extension version */
  extVersion?: InputMaybe<Scalars['String']['input']>;
  /** InDesign file name */
  filename: Scalars['String']['input'];
  /** InDesign file size */
  filesize?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** template label */
  label: Scalars['String']['input'];
  /** Template page count */
  pageCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeadings?: InputMaybe<PrintTemplateCreationPrintHeadingsInput>;
  /** associated S3 object id */
  S3ObjectId: Scalars['String']['input'];
  /** template type */
  type?: InputMaybe<TemplateType>;
};

export type PrintTemplateCreationArticleTemplatesInput = {
  create?: InputMaybe<Array<ArticleTemplateCreationWithoutPrintTemplateInput>>;
};

/** The "ArticleTemplate" node's creation */
export type ArticleTemplateCreationWithoutPrintTemplateInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments?: InputMaybe<ArticleTemplateCreationAssignmentsInput>;
  /** The raw datas */
  block?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The article template label */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type PrintTemplateCreationAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutPrintTemplateInput>>;
};

/** The "Assignment" node's creation */
export type AssignmentCreationWithoutPrintTemplateInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplate?: InputMaybe<AssignmentCreationArticleTemplateInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentCreationPrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentCreationPrintIssueInput>;
  printPublication?: InputMaybe<AssignmentCreationPrintPublicationInput>;
  rawArticle?: InputMaybe<AssignmentCreationRawArticleInput>;
  subject: AssignmentCreationSubjectInput;
  website?: InputMaybe<AssignmentCreationWebsiteInput>;
};

export type AssignmentCreationPrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to a new "Assignment" through the
   * "Assignment.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to a new "Assignment" through the "Assignment.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to a new "Assignment" through the "Assignment.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to a new
   * "Assignment" through the "Assignment.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<AssignmentCreationPrintPublicationCreateIfNotExistsInput>;
};

export type AssignmentCreationPrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type AssignmentCreationRawArticleInput = {
  /**
   * Connect a "RawArticle" to a new "Assignment" through the
   * "Assignment.rawArticle" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<RawArticleUniqueFilterInput>;
  /** Connect a "RawArticle" to a new "Assignment" through the "Assignment.rawArticle" edge, if it exists. */
  connectIfExists?: InputMaybe<RawArticleUniqueFilterInput>;
  /** Create a "RawArticle" and connect it to a new "Assignment" through the "Assignment.rawArticle" edge. */
  create?: InputMaybe<RawArticleCreationInput>;
  /** Create a "RawArticle" if it does not exist, and connect it to a new "Assignment" through the "Assignment.rawArticle" edge. */
  createIfNotExists?: InputMaybe<AssignmentCreationRawArticleCreateIfNotExistsInput>;
};

/** The "RawArticle" node's creation */
export type RawArticleCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignment?: InputMaybe<RawArticleCreationAssignmentInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versions?: InputMaybe<RawArticleCreationVersionsInput>;
};

export type RawArticleCreationAssignmentInput = {
  create?: InputMaybe<AssignmentCreationWithoutRawArticleInput>;
};

/** The "Assignment" node's creation */
export type AssignmentCreationWithoutRawArticleInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplate?: InputMaybe<AssignmentCreationArticleTemplateInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentCreationPrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentCreationPrintIssueInput>;
  printPublication?: InputMaybe<AssignmentCreationPrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentCreationPrintTemplateInput>;
  subject: AssignmentCreationSubjectInput;
  website?: InputMaybe<AssignmentCreationWebsiteInput>;
};

export type AssignmentCreationSubjectInput = {
  /** Connect a "Subject" to a new "Assignment" through the "Assignment.subject" edge, throw an error if it does not exist. */
  connect?: InputMaybe<SubjectUniqueFilterInput>;
  /** Create a "Subject" and connect it to a new "Assignment" through the "Assignment.subject" edge. */
  create?: InputMaybe<SubjectCreationInput>;
  /** Create a "Subject" if it does not exist, and connect it to a new "Assignment" through the "Assignment.subject" edge. */
  createIfNotExists?: InputMaybe<AssignmentCreationSubjectCreateIfNotExistsInput>;
};

/** The "Subject" node's creation */
export type SubjectCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments?: InputMaybe<SubjectCreationAssignmentsInput>;
  attachments?: InputMaybe<SubjectCreationAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  isAuto?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaRequest?: InputMaybe<Scalars['String']['input']>;
  subjectCategory?: InputMaybe<SubjectCreationSubjectCategoryInput>;
  subjectUsers?: InputMaybe<SubjectCreationSubjectUsersInput>;
  subSubjects?: InputMaybe<SubjectCreationSubSubjectsInput>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  unit: SubjectCreationUnitInput;
};

export type SubjectCreationAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutSubjectInput>>;
};

/** The "Assignment" node's creation */
export type AssignmentCreationWithoutSubjectInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplate?: InputMaybe<AssignmentCreationArticleTemplateInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentCreationPrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentCreationPrintIssueInput>;
  printPublication?: InputMaybe<AssignmentCreationPrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentCreationPrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentCreationRawArticleInput>;
  website?: InputMaybe<AssignmentCreationWebsiteInput>;
};

export type AssignmentCreationWebsiteInput = {
  /** Connect a "Website" to a new "Assignment" through the "Assignment.website" edge, throw an error if it does not exist. */
  connect?: InputMaybe<WebsiteUniqueFilterInput>;
  /** Connect a "Website" to a new "Assignment" through the "Assignment.website" edge, if it exists. */
  connectIfExists?: InputMaybe<WebsiteUniqueFilterInput>;
  /** Create a "Website" and connect it to a new "Assignment" through the "Assignment.website" edge. */
  create?: InputMaybe<WebsiteCreationInput>;
  /** Create a "Website" if it does not exist, and connect it to a new "Assignment" through the "Assignment.website" edge. */
  createIfNotExists?: InputMaybe<AssignmentCreationWebsiteCreateIfNotExistsInput>;
};

/** The "Website" node's creation */
export type WebsiteCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments?: InputMaybe<WebsiteCreationAssignmentsInput>;
  brand: WebsiteCreationBrandInput;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  key: Scalars['String']['input'];
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title: Scalars['String']['input'];
};

export type WebsiteCreationAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutWebsiteInput>>;
};

/** The "Assignment" node's creation */
export type AssignmentCreationWithoutWebsiteInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplate?: InputMaybe<AssignmentCreationArticleTemplateInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentCreationPrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentCreationPrintIssueInput>;
  printPublication?: InputMaybe<AssignmentCreationPrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentCreationPrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentCreationRawArticleInput>;
  subject: AssignmentCreationSubjectInput;
};

export type WebsiteCreationBrandInput = {
  /** Connect a "Brand" to a new "Website" through the "Website.brand" edge, throw an error if it does not exist. */
  connect?: InputMaybe<BrandUniqueFilterInput>;
  /** Create a "Brand" and connect it to a new "Website" through the "Website.brand" edge. */
  create?: InputMaybe<BrandCreationInput>;
  /** Create a "Brand" if it does not exist, and connect it to a new "Website" through the "Website.brand" edge. */
  createIfNotExists?: InputMaybe<WebsiteCreationBrandCreateIfNotExistsInput>;
};

/** The "Brand" node's creation */
export type BrandCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  printPublications?: InputMaybe<BrandCreationPrintPublicationsInput>;
  title: Scalars['String']['input'];
  unit: BrandCreationUnitInput;
  websites?: InputMaybe<BrandCreationWebsitesInput>;
};

export type BrandCreationPrintPublicationsInput = {
  create?: InputMaybe<Array<PrintPublicationCreationWithoutBrandInput>>;
};

/** The "PrintPublication" node's creation */
export type PrintPublicationCreationWithoutBrandInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisements?: InputMaybe<PrintPublicationCreationAdvertisementsInput>;
  assignments?: InputMaybe<PrintPublicationCreationAssignmentsInput>;
  files?: InputMaybe<PrintPublicationCreationFilesInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  key: Scalars['String']['input'];
  layouts?: InputMaybe<PrintPublicationCreationLayoutsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockups?: InputMaybe<PrintPublicationCreationMockupsInput>;
  printHeadings?: InputMaybe<PrintPublicationCreationPrintHeadingsInput>;
  printIssues?: InputMaybe<PrintPublicationCreationPrintIssuesInput>;
  title: Scalars['String']['input'];
};

export type PrintPublicationCreationFilesInput = {
  create?: InputMaybe<Array<FileCreationWithoutPrintPublicationInput>>;
};

/** The "File" node's creation */
export type FileCreationWithoutPrintPublicationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<FileCreationLayoutAssetsInput>;
  printIssue?: InputMaybe<FileCreationPrintIssueInput>;
  versions?: InputMaybe<FileCreationVersionsInput>;
};

export type FileCreationPrintIssueInput = {
  /** Connect a "PrintIssue" to a new "File" through the "File.printIssue" edge, throw an error if it does not exist. */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Connect a "PrintIssue" to a new "File" through the "File.printIssue" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to a new "File" through the "File.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /** Create a "PrintIssue" if it does not exist, and connect it to a new "File" through the "File.printIssue" edge. */
  createIfNotExists?: InputMaybe<FileCreationPrintIssueCreateIfNotExistsInput>;
};

export type FileCreationPrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type FileCreationVersionsInput = {
  create?: InputMaybe<Array<FileVersionCreationWithoutFileInput>>;
};

/** The "FileVersion" node's creation */
export type FileVersionCreationWithoutFileInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  nextVersion?: InputMaybe<FileVersionCreationNextVersionInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  previousVersion?: InputMaybe<FileVersionCreationPreviousVersionInput>;
  title: Scalars['String']['input'];
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type FileVersionCreationNextVersionInput = {
  create?: InputMaybe<FileVersionCreationWithoutPreviousVersionInput>;
};

/** The "FileVersion" node's creation */
export type FileVersionCreationWithoutPreviousVersionInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  file: FileVersionCreationFileInput;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  nextVersion?: InputMaybe<FileVersionCreationNextVersionInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type FileVersionCreationFileInput = {
  /** Connect a "File" to a new "FileVersion" through the "FileVersion.file" edge, throw an error if it does not exist. */
  connect?: InputMaybe<FileUniqueFilterInput>;
  /** Create a "File" and connect it to a new "FileVersion" through the "FileVersion.file" edge. */
  create?: InputMaybe<FileCreationInput>;
  /** Create a "File" if it does not exist, and connect it to a new "FileVersion" through the "FileVersion.file" edge. */
  createIfNotExists?: InputMaybe<FileVersionCreationFileCreateIfNotExistsInput>;
};

export type FileVersionCreationFileCreateIfNotExistsInput = {
  data: FileCreationInput;
  where: FileUniqueFilterInput;
};

export type FileVersionCreationPreviousVersionInput = {
  /**
   * Connect a "FileVersion" to a new "FileVersion" through the
   * "FileVersion.previousVersion" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<FileVersionUniqueFilterInput>;
  /** Connect a "FileVersion" to a new "FileVersion" through the "FileVersion.previousVersion" edge, if it exists. */
  connectIfExists?: InputMaybe<FileVersionUniqueFilterInput>;
  /** Create a "FileVersion" and connect it to a new "FileVersion" through the "FileVersion.previousVersion" edge. */
  create?: InputMaybe<FileVersionCreationInput>;
  /**
   * Create a "FileVersion" if it does not exist, and connect it to a new
   * "FileVersion" through the "FileVersion.previousVersion" edge.
   */
  createIfNotExists?: InputMaybe<FileVersionCreationPreviousVersionCreateIfNotExistsInput>;
};

/** The "FileVersion" node's creation */
export type FileVersionCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  file: FileVersionCreationFileInput;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  nextVersion?: InputMaybe<FileVersionCreationNextVersionInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  previousVersion?: InputMaybe<FileVersionCreationPreviousVersionInput>;
  title: Scalars['String']['input'];
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type FileVersionCreationPreviousVersionCreateIfNotExistsInput = {
  data: FileVersionCreationInput;
  where: FileVersionUniqueFilterInput;
};

export type PrintPublicationCreationLayoutsInput = {
  create?: InputMaybe<Array<LayoutCreationWithoutPrintPublicationInput>>;
};

/** The "Layout" node's creation */
export type LayoutCreationWithoutPrintPublicationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assets?: InputMaybe<LayoutCreationAssetsInput>;
  /** The layouts that are based on this one */
  children?: InputMaybe<LayoutCreationChildrenInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The layout this one is based on, if any */
  parent?: InputMaybe<LayoutCreationParentInput>;
  printIssue?: InputMaybe<LayoutCreationPrintIssueInput>;
  title: Scalars['String']['input'];
};

export type LayoutCreationChildrenInput = {
  create?: InputMaybe<Array<LayoutCreationWithoutParentInput>>;
};

/** The "Layout" node's creation */
export type LayoutCreationWithoutParentInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assets?: InputMaybe<LayoutCreationAssetsInput>;
  /** The layouts that are based on this one */
  children?: InputMaybe<LayoutCreationChildrenInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  printIssue?: InputMaybe<LayoutCreationPrintIssueInput>;
  printPublication?: InputMaybe<LayoutCreationPrintPublicationInput>;
  title: Scalars['String']['input'];
};

export type LayoutCreationPrintIssueInput = {
  /** Connect a "PrintIssue" to a new "Layout" through the "Layout.printIssue" edge, throw an error if it does not exist. */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Connect a "PrintIssue" to a new "Layout" through the "Layout.printIssue" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to a new "Layout" through the "Layout.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /** Create a "PrintIssue" if it does not exist, and connect it to a new "Layout" through the "Layout.printIssue" edge. */
  createIfNotExists?: InputMaybe<LayoutCreationPrintIssueCreateIfNotExistsInput>;
};

export type LayoutCreationPrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type LayoutCreationPrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to a new "Layout" through the
   * "Layout.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to a new "Layout" through the "Layout.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to a new "Layout" through the "Layout.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to a new
   * "Layout" through the "Layout.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<LayoutCreationPrintPublicationCreateIfNotExistsInput>;
};

export type LayoutCreationPrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type LayoutCreationParentInput = {
  /** Connect a "Layout" to a new "Layout" through the "Layout.parent" edge, throw an error if it does not exist. */
  connect?: InputMaybe<LayoutUniqueFilterInput>;
  /** Connect a "Layout" to a new "Layout" through the "Layout.parent" edge, if it exists. */
  connectIfExists?: InputMaybe<LayoutUniqueFilterInput>;
  /** Create a "Layout" and connect it to a new "Layout" through the "Layout.parent" edge. */
  create?: InputMaybe<LayoutCreationInput>;
  /** Create a "Layout" if it does not exist, and connect it to a new "Layout" through the "Layout.parent" edge. */
  createIfNotExists?: InputMaybe<LayoutCreationParentCreateIfNotExistsInput>;
};

export type LayoutCreationParentCreateIfNotExistsInput = {
  data: LayoutCreationInput;
  where: LayoutUniqueFilterInput;
};

export type PrintPublicationCreationMockupsInput = {
  create?: InputMaybe<Array<MockupCreationWithoutPrintPublicationInput>>;
};

/** The "Mockup" node's creation */
export type MockupCreationWithoutPrintPublicationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<MockupCreationLayoutAssetsInput>;
  printHeading?: InputMaybe<MockupCreationPrintHeadingInput>;
  printIssue?: InputMaybe<MockupCreationPrintIssueInput>;
  versions?: InputMaybe<MockupCreationVersionsInput>;
};

export type MockupCreationPrintHeadingInput = {
  /** Connect a "PrintHeading" to a new "Mockup" through the "Mockup.printHeading" edge, throw an error if it does not exist. */
  connect?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Connect a "PrintHeading" to a new "Mockup" through the "Mockup.printHeading" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Create a "PrintHeading" and connect it to a new "Mockup" through the "Mockup.printHeading" edge. */
  create?: InputMaybe<PrintHeadingCreationInput>;
  /** Create a "PrintHeading" if it does not exist, and connect it to a new "Mockup" through the "Mockup.printHeading" edge. */
  createIfNotExists?: InputMaybe<MockupCreationPrintHeadingCreateIfNotExistsInput>;
};

export type MockupCreationPrintHeadingCreateIfNotExistsInput = {
  data: PrintHeadingCreationInput;
  where: PrintHeadingUniqueFilterInput;
};

export type MockupCreationPrintIssueInput = {
  /** Connect a "PrintIssue" to a new "Mockup" through the "Mockup.printIssue" edge, throw an error if it does not exist. */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Connect a "PrintIssue" to a new "Mockup" through the "Mockup.printIssue" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to a new "Mockup" through the "Mockup.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /** Create a "PrintIssue" if it does not exist, and connect it to a new "Mockup" through the "Mockup.printIssue" edge. */
  createIfNotExists?: InputMaybe<MockupCreationPrintIssueCreateIfNotExistsInput>;
};

export type MockupCreationPrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type MockupCreationVersionsInput = {
  create?: InputMaybe<Array<MockupVersionCreationWithoutMockupInput>>;
};

/** The "MockupVersion" node's creation */
export type MockupVersionCreationWithoutMockupInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  nextVersion?: InputMaybe<MockupVersionCreationNextVersionInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  previousVersion?: InputMaybe<MockupVersionCreationPreviousVersionInput>;
  title: Scalars['String']['input'];
};

export type MockupVersionCreationNextVersionInput = {
  create?: InputMaybe<MockupVersionCreationWithoutPreviousVersionInput>;
};

/** The "MockupVersion" node's creation */
export type MockupVersionCreationWithoutPreviousVersionInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  mockup: MockupVersionCreationMockupInput;
  nextVersion?: InputMaybe<MockupVersionCreationNextVersionInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type MockupVersionCreationMockupInput = {
  /** Connect a "Mockup" to a new "MockupVersion" through the "MockupVersion.mockup" edge, throw an error if it does not exist. */
  connect?: InputMaybe<MockupUniqueFilterInput>;
  /** Create a "Mockup" and connect it to a new "MockupVersion" through the "MockupVersion.mockup" edge. */
  create?: InputMaybe<MockupCreationInput>;
  /** Create a "Mockup" if it does not exist, and connect it to a new "MockupVersion" through the "MockupVersion.mockup" edge. */
  createIfNotExists?: InputMaybe<MockupVersionCreationMockupCreateIfNotExistsInput>;
};

export type MockupVersionCreationMockupCreateIfNotExistsInput = {
  data: MockupCreationInput;
  where: MockupUniqueFilterInput;
};

export type MockupVersionCreationPreviousVersionInput = {
  /**
   * Connect a "MockupVersion" to a new "MockupVersion" through the
   * "MockupVersion.previousVersion" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<MockupVersionUniqueFilterInput>;
  /** Connect a "MockupVersion" to a new "MockupVersion" through the "MockupVersion.previousVersion" edge, if it exists. */
  connectIfExists?: InputMaybe<MockupVersionUniqueFilterInput>;
  /** Create a "MockupVersion" and connect it to a new "MockupVersion" through the "MockupVersion.previousVersion" edge. */
  create?: InputMaybe<MockupVersionCreationInput>;
  /**
   * Create a "MockupVersion" if it does not exist, and connect it to a new
   * "MockupVersion" through the "MockupVersion.previousVersion" edge.
   */
  createIfNotExists?: InputMaybe<MockupVersionCreationPreviousVersionCreateIfNotExistsInput>;
};

/** The "MockupVersion" node's creation */
export type MockupVersionCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  mockup: MockupVersionCreationMockupInput;
  nextVersion?: InputMaybe<MockupVersionCreationNextVersionInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  previousVersion?: InputMaybe<MockupVersionCreationPreviousVersionInput>;
  title: Scalars['String']['input'];
};

export type MockupVersionCreationPreviousVersionCreateIfNotExistsInput = {
  data: MockupVersionCreationInput;
  where: MockupVersionUniqueFilterInput;
};

export type PrintPublicationCreationPrintHeadingsInput = {
  create?: InputMaybe<Array<PrintHeadingCreationWithoutPrintPublicationInput>>;
};

/** The "PrintHeading" node's creation */
export type PrintHeadingCreationWithoutPrintPublicationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments?: InputMaybe<PrintHeadingCreationAssignmentsInput>;
  autoPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutomaticSubject?: Scalars['Boolean']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<PrintHeadingCreationLayoutAssetsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockup?: InputMaybe<PrintHeadingCreationMockupInput>;
  order: Scalars['UnsignedInt']['input'];
  printIssue: PrintHeadingCreationPrintIssueInput;
  printTemplates?: InputMaybe<PrintHeadingCreationPrintTemplatesInput>;
  title: Scalars['String']['input'];
};

export type PrintHeadingCreationLayoutAssetsInput = {
  create?: InputMaybe<Array<LayoutAssetCreationWithoutPrintHeadingInput>>;
};

/** The "LayoutAsset" node's creation */
export type LayoutAssetCreationWithoutPrintHeadingInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisement?: InputMaybe<LayoutAssetCreationAdvertisementInput>;
  file?: InputMaybe<LayoutAssetCreationFileInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layout: LayoutAssetCreationLayoutInput;
  mockup?: InputMaybe<LayoutAssetCreationMockupInput>;
  order: Scalars['UnsignedInt']['input'];
};

export type PrintHeadingCreationMockupInput = {
  create?: InputMaybe<MockupCreationWithoutPrintHeadingInput>;
};

/** The "Mockup" node's creation */
export type MockupCreationWithoutPrintHeadingInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<MockupCreationLayoutAssetsInput>;
  printIssue?: InputMaybe<MockupCreationPrintIssueInput>;
  printPublication?: InputMaybe<MockupCreationPrintPublicationInput>;
  versions?: InputMaybe<MockupCreationVersionsInput>;
};

export type MockupCreationPrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to a new "Mockup" through the
   * "Mockup.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to a new "Mockup" through the "Mockup.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to a new "Mockup" through the "Mockup.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to a new
   * "Mockup" through the "Mockup.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<MockupCreationPrintPublicationCreateIfNotExistsInput>;
};

export type MockupCreationPrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type PrintHeadingCreationPrintIssueInput = {
  /**
   * Connect a "PrintIssue" to a new "PrintHeading" through the
   * "PrintHeading.printIssue" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to a new "PrintHeading" through the "PrintHeading.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /**
   * Create a "PrintIssue" if it does not exist, and connect it to a new
   * "PrintHeading" through the "PrintHeading.printIssue" edge.
   */
  createIfNotExists?: InputMaybe<PrintHeadingCreationPrintIssueCreateIfNotExistsInput>;
};

export type PrintHeadingCreationPrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type PrintHeadingCreationPrintTemplatesInput = {
  create?: InputMaybe<Array<PrintHeadingPrintTemplateCreationWithoutPrintHeadingInput>>;
};

/** The "PrintHeadingPrintTemplate" node's creation */
export type PrintHeadingPrintTemplateCreationWithoutPrintHeadingInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  active?: Scalars['Boolean']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  printTemplate: PrintHeadingPrintTemplateCreationPrintTemplateInput;
};

export type PrintHeadingPrintTemplateCreationPrintTemplateInput = {
  /**
   * Connect a "PrintTemplate" to a new "PrintHeadingPrintTemplate" through the
   * "PrintHeadingPrintTemplate.printTemplate" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintTemplateUniqueFilterInput>;
  /**
   * Create a "PrintTemplate" and connect it to a new "PrintHeadingPrintTemplate"
   * through the "PrintHeadingPrintTemplate.printTemplate" edge.
   */
  create?: InputMaybe<PrintTemplateCreationInput>;
  /**
   * Create a "PrintTemplate" if it does not exist, and connect it to a new
   * "PrintHeadingPrintTemplate" through the
   * "PrintHeadingPrintTemplate.printTemplate" edge.
   */
  createIfNotExists?: InputMaybe<PrintHeadingPrintTemplateCreationPrintTemplateCreateIfNotExistsInput>;
};

export type PrintHeadingPrintTemplateCreationPrintTemplateCreateIfNotExistsInput = {
  data: PrintTemplateCreationInput;
  where: PrintTemplateUniqueFilterInput;
};

export type PrintPublicationCreationPrintIssuesInput = {
  create?: InputMaybe<Array<PrintIssueCreationWithoutPrintPublicationInput>>;
};

/** The "PrintIssue" node's creation */
export type PrintIssueCreationWithoutPrintPublicationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisements?: InputMaybe<PrintIssueCreationAdvertisementsInput>;
  assignments?: InputMaybe<PrintIssueCreationAssignmentsInput>;
  files?: InputMaybe<PrintIssueCreationFilesInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layouts?: InputMaybe<PrintIssueCreationLayoutsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockups?: InputMaybe<PrintIssueCreationMockupsInput>;
  printHeadings?: InputMaybe<PrintIssueCreationPrintHeadingsInput>;
  printIssueRailroad?: InputMaybe<PrintIssueCreationPrintIssueRailroadInput>;
  title: Scalars['String']['input'];
};

export type PrintIssueCreationAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutPrintIssueInput>>;
};

/** The "Assignment" node's creation */
export type AssignmentCreationWithoutPrintIssueInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplate?: InputMaybe<AssignmentCreationArticleTemplateInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentCreationPrintHeadingInput>;
  printPublication?: InputMaybe<AssignmentCreationPrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentCreationPrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentCreationRawArticleInput>;
  subject: AssignmentCreationSubjectInput;
  website?: InputMaybe<AssignmentCreationWebsiteInput>;
};

export type PrintIssueCreationFilesInput = {
  create?: InputMaybe<Array<FileCreationWithoutPrintIssueInput>>;
};

/** The "File" node's creation */
export type FileCreationWithoutPrintIssueInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<FileCreationLayoutAssetsInput>;
  printPublication?: InputMaybe<FileCreationPrintPublicationInput>;
  versions?: InputMaybe<FileCreationVersionsInput>;
};

export type FileCreationPrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to a new "File" through the
   * "File.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to a new "File" through the "File.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to a new "File" through the "File.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /** Create a "PrintPublication" if it does not exist, and connect it to a new "File" through the "File.printPublication" edge. */
  createIfNotExists?: InputMaybe<FileCreationPrintPublicationCreateIfNotExistsInput>;
};

export type FileCreationPrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type PrintIssueCreationLayoutsInput = {
  create?: InputMaybe<Array<LayoutCreationWithoutPrintIssueInput>>;
};

/** The "Layout" node's creation */
export type LayoutCreationWithoutPrintIssueInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assets?: InputMaybe<LayoutCreationAssetsInput>;
  /** The layouts that are based on this one */
  children?: InputMaybe<LayoutCreationChildrenInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The layout this one is based on, if any */
  parent?: InputMaybe<LayoutCreationParentInput>;
  printPublication?: InputMaybe<LayoutCreationPrintPublicationInput>;
  title: Scalars['String']['input'];
};

export type PrintIssueCreationMockupsInput = {
  create?: InputMaybe<Array<MockupCreationWithoutPrintIssueInput>>;
};

/** The "Mockup" node's creation */
export type MockupCreationWithoutPrintIssueInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<MockupCreationLayoutAssetsInput>;
  printHeading?: InputMaybe<MockupCreationPrintHeadingInput>;
  printPublication?: InputMaybe<MockupCreationPrintPublicationInput>;
  versions?: InputMaybe<MockupCreationVersionsInput>;
};

export type PrintIssueCreationPrintHeadingsInput = {
  create?: InputMaybe<Array<PrintHeadingCreationWithoutPrintIssueInput>>;
};

/** The "PrintHeading" node's creation */
export type PrintHeadingCreationWithoutPrintIssueInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments?: InputMaybe<PrintHeadingCreationAssignmentsInput>;
  autoPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutomaticSubject?: Scalars['Boolean']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layoutAssets?: InputMaybe<PrintHeadingCreationLayoutAssetsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockup?: InputMaybe<PrintHeadingCreationMockupInput>;
  order: Scalars['UnsignedInt']['input'];
  printPublication?: InputMaybe<PrintHeadingCreationPrintPublicationInput>;
  printTemplates?: InputMaybe<PrintHeadingCreationPrintTemplatesInput>;
  title: Scalars['String']['input'];
};

export type PrintHeadingCreationPrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to a new "PrintHeading" through the
   * "PrintHeading.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to a new "PrintHeading" through the "PrintHeading.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to a new "PrintHeading" through the "PrintHeading.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to a new
   * "PrintHeading" through the "PrintHeading.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<PrintHeadingCreationPrintPublicationCreateIfNotExistsInput>;
};

export type PrintHeadingCreationPrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type PrintIssueCreationPrintIssueRailroadInput = {
  create?: InputMaybe<PrintIssueRailroadCreationWithoutPrintIssueInput>;
};

/** The "PrintIssueRailroad" node's creation */
export type PrintIssueRailroadCreationWithoutPrintIssueInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  censhareCreationDate?: InputMaybe<Scalars['DateTime']['input']>;
  censhareUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  name: Scalars['String']['input'];
  pageCount: Scalars['UnsignedInt']['input'];
  publicationDate: Scalars['DateTime']['input'];
  railroadPages?: InputMaybe<PrintIssueRailroadCreationRailroadPagesInput>;
};

export type PrintIssueRailroadCreationRailroadPagesInput = {
  create?: InputMaybe<Array<RailroadPageCreationWithoutPrintIssueRailroadInput>>;
};

/** The "RailroadPage" node's creation */
export type RailroadPageCreationWithoutPrintIssueRailroadInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  indesignFilename: Scalars['String']['input'];
  number: Scalars['UnsignedInt']['input'];
  visual: Scalars['String']['input'];
  workflowName: Scalars['String']['input'];
  workflowStage: Scalars['String']['input'];
};

export type BrandCreationUnitInput = {
  /** Connect a "Unit" to a new "Brand" through the "Brand.unit" edge, throw an error if it does not exist. */
  connect?: InputMaybe<UnitUniqueFilterInput>;
  /** Create a "Unit" and connect it to a new "Brand" through the "Brand.unit" edge. */
  create?: InputMaybe<UnitCreationInput>;
  /** Create a "Unit" if it does not exist, and connect it to a new "Brand" through the "Brand.unit" edge. */
  createIfNotExists?: InputMaybe<BrandCreationUnitCreateIfNotExistsInput>;
};

/** The "Unit" node's creation */
export type UnitCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brands?: InputMaybe<UnitCreationBrandsInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  subjectCategories?: InputMaybe<UnitCreationSubjectCategoriesInput>;
  subjects?: InputMaybe<UnitCreationSubjectsInput>;
  title: Scalars['String']['input'];
};

export type UnitCreationBrandsInput = {
  create?: InputMaybe<Array<BrandCreationWithoutUnitInput>>;
};

/** The "Brand" node's creation */
export type BrandCreationWithoutUnitInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  printPublications?: InputMaybe<BrandCreationPrintPublicationsInput>;
  title: Scalars['String']['input'];
  websites?: InputMaybe<BrandCreationWebsitesInput>;
};

export type BrandCreationWebsitesInput = {
  create?: InputMaybe<Array<WebsiteCreationWithoutBrandInput>>;
};

/** The "Website" node's creation */
export type WebsiteCreationWithoutBrandInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments?: InputMaybe<WebsiteCreationAssignmentsInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  key: Scalars['String']['input'];
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title: Scalars['String']['input'];
};

export type UnitCreationSubjectCategoriesInput = {
  create?: InputMaybe<Array<SubjectCategoryCreationWithoutUnitInput>>;
};

/** The "SubjectCategory" node's creation */
export type SubjectCategoryCreationWithoutUnitInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** This category's children */
  children?: InputMaybe<SubjectCategoryCreationChildrenInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  parent?: InputMaybe<SubjectCategoryCreationParentInput>;
  subjects?: InputMaybe<SubjectCategoryCreationSubjectsInput>;
  title: Scalars['String']['input'];
};

export type SubjectCategoryCreationChildrenInput = {
  create?: InputMaybe<Array<SubjectCategoryCreationWithoutParentInput>>;
};

/** The "SubjectCategory" node's creation */
export type SubjectCategoryCreationWithoutParentInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** This category's children */
  children?: InputMaybe<SubjectCategoryCreationChildrenInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjects?: InputMaybe<SubjectCategoryCreationSubjectsInput>;
  title: Scalars['String']['input'];
  unit: SubjectCategoryCreationUnitInput;
};

export type SubjectCategoryCreationSubjectsInput = {
  create?: InputMaybe<Array<SubjectCreationWithoutSubjectCategoryInput>>;
};

/** The "Subject" node's creation */
export type SubjectCreationWithoutSubjectCategoryInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments?: InputMaybe<SubjectCreationAssignmentsInput>;
  attachments?: InputMaybe<SubjectCreationAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  isAuto?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaRequest?: InputMaybe<Scalars['String']['input']>;
  subjectUsers?: InputMaybe<SubjectCreationSubjectUsersInput>;
  subSubjects?: InputMaybe<SubjectCreationSubSubjectsInput>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  unit: SubjectCreationUnitInput;
};

export type SubjectCreationAttachmentsInput = {
  create?: InputMaybe<Array<AttachmentCreationWithoutSubjectInput>>;
};

/** The "Attachment" node's creation */
export type AttachmentCreationWithoutSubjectInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** update from S3 */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** update from S3 */
  etag?: InputMaybe<Scalars['String']['input']>;
  /** sent from the front */
  filename: Scalars['String']['input'];
  /** update from S3 */
  filesize?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** update from S3 */
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectCreationSubjectUsersInput = {
  create?: InputMaybe<Array<SubjectUserCreationWithoutSubjectInput>>;
};

/** The "SubjectUser" node's creation */
export type SubjectUserCreationWithoutSubjectInput = {
  userId: Scalars['UUIDv4']['input'];
};

export type SubjectCreationSubSubjectsInput = {
  create?: InputMaybe<Array<SubSubjectCreationWithoutSubjectInput>>;
};

/** The "SubSubject" node's creation */
export type SubSubjectCreationWithoutSubjectInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  title: Scalars['String']['input'];
};

export type SubjectCreationUnitInput = {
  /** Connect a "Unit" to a new "Subject" through the "Subject.unit" edge, throw an error if it does not exist. */
  connect?: InputMaybe<UnitUniqueFilterInput>;
  /** Create a "Unit" and connect it to a new "Subject" through the "Subject.unit" edge. */
  create?: InputMaybe<UnitCreationInput>;
  /** Create a "Unit" if it does not exist, and connect it to a new "Subject" through the "Subject.unit" edge. */
  createIfNotExists?: InputMaybe<SubjectCreationUnitCreateIfNotExistsInput>;
};

export type SubjectCreationUnitCreateIfNotExistsInput = {
  data: UnitCreationInput;
  where: UnitUniqueFilterInput;
};

export type SubjectCategoryCreationUnitInput = {
  /** Connect a "Unit" to a new "SubjectCategory" through the "SubjectCategory.unit" edge, throw an error if it does not exist. */
  connect?: InputMaybe<UnitUniqueFilterInput>;
  /** Create a "Unit" and connect it to a new "SubjectCategory" through the "SubjectCategory.unit" edge. */
  create?: InputMaybe<UnitCreationInput>;
  /** Create a "Unit" if it does not exist, and connect it to a new "SubjectCategory" through the "SubjectCategory.unit" edge. */
  createIfNotExists?: InputMaybe<SubjectCategoryCreationUnitCreateIfNotExistsInput>;
};

export type SubjectCategoryCreationUnitCreateIfNotExistsInput = {
  data: UnitCreationInput;
  where: UnitUniqueFilterInput;
};

export type SubjectCategoryCreationParentInput = {
  /**
   * Connect a "SubjectCategory" to a new "SubjectCategory" through the
   * "SubjectCategory.parent" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<SubjectCategoryUniqueFilterInput>;
  /** Connect a "SubjectCategory" to a new "SubjectCategory" through the "SubjectCategory.parent" edge, if it exists. */
  connectIfExists?: InputMaybe<SubjectCategoryUniqueFilterInput>;
  /** Create a "SubjectCategory" and connect it to a new "SubjectCategory" through the "SubjectCategory.parent" edge. */
  create?: InputMaybe<SubjectCategoryCreationInput>;
  /**
   * Create a "SubjectCategory" if it does not exist, and connect it to a new
   * "SubjectCategory" through the "SubjectCategory.parent" edge.
   */
  createIfNotExists?: InputMaybe<SubjectCategoryCreationParentCreateIfNotExistsInput>;
};

/** The "SubjectCategory" node's creation */
export type SubjectCategoryCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** This category's children */
  children?: InputMaybe<SubjectCategoryCreationChildrenInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  parent?: InputMaybe<SubjectCategoryCreationParentInput>;
  subjects?: InputMaybe<SubjectCategoryCreationSubjectsInput>;
  title: Scalars['String']['input'];
  unit: SubjectCategoryCreationUnitInput;
};

export type SubjectCategoryCreationParentCreateIfNotExistsInput = {
  data: SubjectCategoryCreationInput;
  where: SubjectCategoryUniqueFilterInput;
};

export type UnitCreationSubjectsInput = {
  create?: InputMaybe<Array<SubjectCreationWithoutUnitInput>>;
};

/** The "Subject" node's creation */
export type SubjectCreationWithoutUnitInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  assignments?: InputMaybe<SubjectCreationAssignmentsInput>;
  attachments?: InputMaybe<SubjectCreationAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  isAuto?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaRequest?: InputMaybe<Scalars['String']['input']>;
  subjectCategory?: InputMaybe<SubjectCreationSubjectCategoryInput>;
  subjectUsers?: InputMaybe<SubjectCreationSubjectUsersInput>;
  subSubjects?: InputMaybe<SubjectCreationSubSubjectsInput>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type SubjectCreationSubjectCategoryInput = {
  /**
   * Connect a "SubjectCategory" to a new "Subject" through the
   * "Subject.subjectCategory" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<SubjectCategoryUniqueFilterInput>;
  /** Connect a "SubjectCategory" to a new "Subject" through the "Subject.subjectCategory" edge, if it exists. */
  connectIfExists?: InputMaybe<SubjectCategoryUniqueFilterInput>;
  /** Create a "SubjectCategory" and connect it to a new "Subject" through the "Subject.subjectCategory" edge. */
  create?: InputMaybe<SubjectCategoryCreationInput>;
  /**
   * Create a "SubjectCategory" if it does not exist, and connect it to a new
   * "Subject" through the "Subject.subjectCategory" edge.
   */
  createIfNotExists?: InputMaybe<SubjectCreationSubjectCategoryCreateIfNotExistsInput>;
};

export type SubjectCreationSubjectCategoryCreateIfNotExistsInput = {
  data: SubjectCategoryCreationInput;
  where: SubjectCategoryUniqueFilterInput;
};

export type BrandCreationUnitCreateIfNotExistsInput = {
  data: UnitCreationInput;
  where: UnitUniqueFilterInput;
};

export type WebsiteCreationBrandCreateIfNotExistsInput = {
  data: BrandCreationInput;
  where: BrandUniqueFilterInput;
};

export type AssignmentCreationWebsiteCreateIfNotExistsInput = {
  data: WebsiteCreationInput;
  where: WebsiteUniqueFilterInput;
};

export type AssignmentCreationSubjectCreateIfNotExistsInput = {
  data: SubjectCreationInput;
  where: SubjectUniqueFilterInput;
};

export type RawArticleCreationVersionsInput = {
  create?: InputMaybe<Array<RawArticleVersionCreationWithoutRawArticleInput>>;
};

/** The "RawArticleVersion" node's creation */
export type RawArticleVersionCreationWithoutRawArticleInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned to the version */
  editorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  forkChilrens?: InputMaybe<RawArticleVersionCreationForkChilrensInput>;
  forkOf?: InputMaybe<RawArticleVersionCreationForkOfInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** An array of left over Draft content */
  leftOver?: InputMaybe<Scalars['String']['input']>;
  nextVersion?: InputMaybe<RawArticleVersionCreationNextVersionInput>;
  previousVersion?: InputMaybe<RawArticleVersionCreationPreviousVersionInput>;
  signature?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RawArticleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RawArticleVersionCreationForkChilrensInput = {
  create?: InputMaybe<Array<RawArticleVersionCreationWithoutForkOfInput>>;
};

/** The "RawArticleVersion" node's creation */
export type RawArticleVersionCreationWithoutForkOfInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned to the version */
  editorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  forkChilrens?: InputMaybe<RawArticleVersionCreationForkChilrensInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** An array of left over Draft content */
  leftOver?: InputMaybe<Scalars['String']['input']>;
  nextVersion?: InputMaybe<RawArticleVersionCreationNextVersionInput>;
  previousVersion?: InputMaybe<RawArticleVersionCreationPreviousVersionInput>;
  rawArticle: RawArticleVersionCreationRawArticleInput;
  signature?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RawArticleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RawArticleVersionCreationNextVersionInput = {
  create?: InputMaybe<RawArticleVersionCreationWithoutPreviousVersionInput>;
};

/** The "RawArticleVersion" node's creation */
export type RawArticleVersionCreationWithoutPreviousVersionInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned to the version */
  editorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  forkChilrens?: InputMaybe<RawArticleVersionCreationForkChilrensInput>;
  forkOf?: InputMaybe<RawArticleVersionCreationForkOfInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** An array of left over Draft content */
  leftOver?: InputMaybe<Scalars['String']['input']>;
  nextVersion?: InputMaybe<RawArticleVersionCreationNextVersionInput>;
  rawArticle: RawArticleVersionCreationRawArticleInput;
  signature?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RawArticleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RawArticleVersionCreationForkOfInput = {
  /**
   * Connect a "RawArticleVersion" to a new "RawArticleVersion" through the
   * "RawArticleVersion.forkOf" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<RawArticleVersionUniqueFilterInput>;
  /** Connect a "RawArticleVersion" to a new "RawArticleVersion" through the "RawArticleVersion.forkOf" edge, if it exists. */
  connectIfExists?: InputMaybe<RawArticleVersionUniqueFilterInput>;
  /** Create a "RawArticleVersion" and connect it to a new "RawArticleVersion" through the "RawArticleVersion.forkOf" edge. */
  create?: InputMaybe<RawArticleVersionCreationInput>;
  /**
   * Create a "RawArticleVersion" if it does not exist, and connect it to a new
   * "RawArticleVersion" through the "RawArticleVersion.forkOf" edge.
   */
  createIfNotExists?: InputMaybe<RawArticleVersionCreationForkOfCreateIfNotExistsInput>;
};

/** The "RawArticleVersion" node's creation */
export type RawArticleVersionCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned to the version */
  editorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  forkChilrens?: InputMaybe<RawArticleVersionCreationForkChilrensInput>;
  forkOf?: InputMaybe<RawArticleVersionCreationForkOfInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** An array of left over Draft content */
  leftOver?: InputMaybe<Scalars['String']['input']>;
  nextVersion?: InputMaybe<RawArticleVersionCreationNextVersionInput>;
  previousVersion?: InputMaybe<RawArticleVersionCreationPreviousVersionInput>;
  rawArticle: RawArticleVersionCreationRawArticleInput;
  signature?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RawArticleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RawArticleVersionCreationPreviousVersionInput = {
  /**
   * Connect a "RawArticleVersion" to a new "RawArticleVersion" through the
   * "RawArticleVersion.previousVersion" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<RawArticleVersionUniqueFilterInput>;
  /**
   * Connect a "RawArticleVersion" to a new "RawArticleVersion" through the
   * "RawArticleVersion.previousVersion" edge, if it exists.
   */
  connectIfExists?: InputMaybe<RawArticleVersionUniqueFilterInput>;
  /**
   * Create a "RawArticleVersion" and connect it to a new "RawArticleVersion"
   * through the "RawArticleVersion.previousVersion" edge.
   */
  create?: InputMaybe<RawArticleVersionCreationInput>;
  /**
   * Create a "RawArticleVersion" if it does not exist, and connect it to a new
   * "RawArticleVersion" through the "RawArticleVersion.previousVersion" edge.
   */
  createIfNotExists?: InputMaybe<RawArticleVersionCreationPreviousVersionCreateIfNotExistsInput>;
};

export type RawArticleVersionCreationPreviousVersionCreateIfNotExistsInput = {
  data: RawArticleVersionCreationInput;
  where: RawArticleVersionUniqueFilterInput;
};

export type RawArticleVersionCreationRawArticleInput = {
  /**
   * Connect a "RawArticle" to a new "RawArticleVersion" through the
   * "RawArticleVersion.rawArticle" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<RawArticleUniqueFilterInput>;
  /** Create a "RawArticle" and connect it to a new "RawArticleVersion" through the "RawArticleVersion.rawArticle" edge. */
  create?: InputMaybe<RawArticleCreationInput>;
  /**
   * Create a "RawArticle" if it does not exist, and connect it to a new
   * "RawArticleVersion" through the "RawArticleVersion.rawArticle" edge.
   */
  createIfNotExists?: InputMaybe<RawArticleVersionCreationRawArticleCreateIfNotExistsInput>;
};

export type RawArticleVersionCreationRawArticleCreateIfNotExistsInput = {
  data: RawArticleCreationInput;
  where: RawArticleUniqueFilterInput;
};

export type RawArticleVersionCreationForkOfCreateIfNotExistsInput = {
  data: RawArticleVersionCreationInput;
  where: RawArticleVersionUniqueFilterInput;
};

export type AssignmentCreationRawArticleCreateIfNotExistsInput = {
  data: RawArticleCreationInput;
  where: RawArticleUniqueFilterInput;
};

export type PrintTemplateCreationPrintHeadingsInput = {
  create?: InputMaybe<Array<PrintHeadingPrintTemplateCreationWithoutPrintTemplateInput>>;
};

/** The "PrintHeadingPrintTemplate" node's creation */
export type PrintHeadingPrintTemplateCreationWithoutPrintTemplateInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  active?: Scalars['Boolean']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  printHeading: PrintHeadingPrintTemplateCreationPrintHeadingInput;
};

export type PrintHeadingPrintTemplateCreationPrintHeadingInput = {
  /**
   * Connect a "PrintHeading" to a new "PrintHeadingPrintTemplate" through the
   * "PrintHeadingPrintTemplate.printHeading" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /**
   * Create a "PrintHeading" and connect it to a new "PrintHeadingPrintTemplate"
   * through the "PrintHeadingPrintTemplate.printHeading" edge.
   */
  create?: InputMaybe<PrintHeadingCreationInput>;
  /**
   * Create a "PrintHeading" if it does not exist, and connect it to a new
   * "PrintHeadingPrintTemplate" through the
   * "PrintHeadingPrintTemplate.printHeading" edge.
   */
  createIfNotExists?: InputMaybe<PrintHeadingPrintTemplateCreationPrintHeadingCreateIfNotExistsInput>;
};

export type PrintHeadingPrintTemplateCreationPrintHeadingCreateIfNotExistsInput = {
  data: PrintHeadingCreationInput;
  where: PrintHeadingUniqueFilterInput;
};

export type AssignmentCreationPrintTemplateCreateIfNotExistsInput = {
  data: PrintTemplateCreationInput;
  where: PrintTemplateUniqueFilterInput;
};

export type PrintPublicationCreationBrandInput = {
  /**
   * Connect a "Brand" to a new "PrintPublication" through the
   * "PrintPublication.brand" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<BrandUniqueFilterInput>;
  /** Create a "Brand" and connect it to a new "PrintPublication" through the "PrintPublication.brand" edge. */
  create?: InputMaybe<BrandCreationInput>;
  /**
   * Create a "Brand" if it does not exist, and connect it to a new
   * "PrintPublication" through the "PrintPublication.brand" edge.
   */
  createIfNotExists?: InputMaybe<PrintPublicationCreationBrandCreateIfNotExistsInput>;
};

export type PrintPublicationCreationBrandCreateIfNotExistsInput = {
  data: BrandCreationInput;
  where: BrandUniqueFilterInput;
};

export type AdvertisementCreationPrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type PrintIssueCreationPrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to a new "PrintIssue" through the
   * "PrintIssue.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to a new "PrintIssue" through the "PrintIssue.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to a new
   * "PrintIssue" through the "PrintIssue.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<PrintIssueCreationPrintPublicationCreateIfNotExistsInput>;
};

export type PrintIssueCreationPrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type AssignmentCreationPrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type ArticleTemplateCreationPrintTemplateInput = {
  /**
   * Connect a "PrintTemplate" to a new "ArticleTemplate" through the
   * "ArticleTemplate.printTemplate" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintTemplateUniqueFilterInput>;
  /** Create a "PrintTemplate" and connect it to a new "ArticleTemplate" through the "ArticleTemplate.printTemplate" edge. */
  create?: InputMaybe<PrintTemplateCreationInput>;
  /**
   * Create a "PrintTemplate" if it does not exist, and connect it to a new
   * "ArticleTemplate" through the "ArticleTemplate.printTemplate" edge.
   */
  createIfNotExists?: InputMaybe<ArticleTemplateCreationPrintTemplateCreateIfNotExistsInput>;
};

export type ArticleTemplateCreationPrintTemplateCreateIfNotExistsInput = {
  data: PrintTemplateCreationInput;
  where: PrintTemplateUniqueFilterInput;
};

export type AssignmentCreationArticleTemplateCreateIfNotExistsInput = {
  data: ArticleTemplateCreationInput;
  where: ArticleTemplateUniqueFilterInput;
};

export type LayoutAssetCreationPrintHeadingCreateIfNotExistsInput = {
  data: PrintHeadingCreationInput;
  where: PrintHeadingUniqueFilterInput;
};

export type LayoutAssetCreationMockupCreateIfNotExistsInput = {
  data: MockupCreationInput;
  where: MockupUniqueFilterInput;
};

export type LayoutAssetCreationLayoutCreateIfNotExistsInput = {
  data: LayoutCreationInput;
  where: LayoutUniqueFilterInput;
};

export type LayoutAssetCreationFileCreateIfNotExistsInput = {
  data: FileCreationInput;
  where: FileUniqueFilterInput;
};

/** The "Assignment" node's creation */
export type AssignmentCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleTemplate?: InputMaybe<AssignmentCreationArticleTemplateInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentCreationPrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentCreationPrintIssueInput>;
  printPublication?: InputMaybe<AssignmentCreationPrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentCreationPrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentCreationRawArticleInput>;
  subject: AssignmentCreationSubjectInput;
  website?: InputMaybe<AssignmentCreationWebsiteInput>;
};

/** The "Attachment" node's creation */
export type AttachmentCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** update from S3 */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** update from S3 */
  etag?: InputMaybe<Scalars['String']['input']>;
  /** sent from the front */
  filename: Scalars['String']['input'];
  /** update from S3 */
  filesize?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  subject: AttachmentCreationSubjectInput;
  /** update from S3 */
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentCreationSubjectInput = {
  /** Connect a "Subject" to a new "Attachment" through the "Attachment.subject" edge, throw an error if it does not exist. */
  connect?: InputMaybe<SubjectUniqueFilterInput>;
  /** Create a "Subject" and connect it to a new "Attachment" through the "Attachment.subject" edge. */
  create?: InputMaybe<SubjectCreationInput>;
  /** Create a "Subject" if it does not exist, and connect it to a new "Attachment" through the "Attachment.subject" edge. */
  createIfNotExists?: InputMaybe<AttachmentCreationSubjectCreateIfNotExistsInput>;
};

export type AttachmentCreationSubjectCreateIfNotExistsInput = {
  data: SubjectCreationInput;
  where: SubjectUniqueFilterInput;
};

/** The "CenshareTrace" node's creation */
export type CenshareTraceCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** The censhare used api */
  api: Scalars['String']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** http call query params */
  params: Scalars['String']['input'];
  /** http call payload */
  payload?: InputMaybe<Scalars['String']['input']>;
  /** http call (xml) raw response */
  rawResponse: Scalars['String']['input'];
  /** http call response code */
  responseCode?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "LayoutAsset" node's creation */
export type LayoutAssetCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  advertisement?: InputMaybe<LayoutAssetCreationAdvertisementInput>;
  file?: InputMaybe<LayoutAssetCreationFileInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  layout: LayoutAssetCreationLayoutInput;
  mockup?: InputMaybe<LayoutAssetCreationMockupInput>;
  order: Scalars['UnsignedInt']['input'];
  printHeading?: InputMaybe<LayoutAssetCreationPrintHeadingInput>;
};

/** The "PrintHeadingPrintTemplate" node's creation */
export type PrintHeadingPrintTemplateCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  active?: Scalars['Boolean']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  printHeading: PrintHeadingPrintTemplateCreationPrintHeadingInput;
  printTemplate: PrintHeadingPrintTemplateCreationPrintTemplateInput;
};

/** The "PrintIssueRailroad" node's creation */
export type PrintIssueRailroadCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  censhareCreationDate?: InputMaybe<Scalars['DateTime']['input']>;
  censhareUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  name: Scalars['String']['input'];
  pageCount: Scalars['UnsignedInt']['input'];
  printIssue: PrintIssueRailroadCreationPrintIssueInput;
  publicationDate: Scalars['DateTime']['input'];
  railroadPages?: InputMaybe<PrintIssueRailroadCreationRailroadPagesInput>;
};

export type PrintIssueRailroadCreationPrintIssueInput = {
  /**
   * Connect a "PrintIssue" to a new "PrintIssueRailroad" through the
   * "PrintIssueRailroad.printIssue" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to a new "PrintIssueRailroad" through the "PrintIssueRailroad.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /**
   * Create a "PrintIssue" if it does not exist, and connect it to a new
   * "PrintIssueRailroad" through the "PrintIssueRailroad.printIssue" edge.
   */
  createIfNotExists?: InputMaybe<PrintIssueRailroadCreationPrintIssueCreateIfNotExistsInput>;
};

export type PrintIssueRailroadCreationPrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

/** The "RailroadPage" node's creation */
export type RailroadPageCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  indesignFilename: Scalars['String']['input'];
  number: Scalars['UnsignedInt']['input'];
  printIssueRailroad: RailroadPageCreationPrintIssueRailroadInput;
  visual: Scalars['String']['input'];
  workflowName: Scalars['String']['input'];
  workflowStage: Scalars['String']['input'];
};

export type RailroadPageCreationPrintIssueRailroadInput = {
  /**
   * Connect a "PrintIssueRailroad" to a new "RailroadPage" through the
   * "RailroadPage.printIssueRailroad" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintIssueRailroadUniqueFilterInput>;
  /** Create a "PrintIssueRailroad" and connect it to a new "RailroadPage" through the "RailroadPage.printIssueRailroad" edge. */
  create?: InputMaybe<PrintIssueRailroadCreationInput>;
  /**
   * Create a "PrintIssueRailroad" if it does not exist, and connect it to a new
   * "RailroadPage" through the "RailroadPage.printIssueRailroad" edge.
   */
  createIfNotExists?: InputMaybe<RailroadPageCreationPrintIssueRailroadCreateIfNotExistsInput>;
};

export type RailroadPageCreationPrintIssueRailroadCreateIfNotExistsInput = {
  data: PrintIssueRailroadCreationInput;
  where: PrintIssueRailroadUniqueFilterInput;
};

/** The "SubjectUser" node's creation */
export type SubjectUserCreationInput = {
  subject: SubjectUserCreationSubjectInput;
  userId: Scalars['UUIDv4']['input'];
};

export type SubjectUserCreationSubjectInput = {
  /** Connect a "Subject" to a new "SubjectUser" through the "SubjectUser.subject" edge, throw an error if it does not exist. */
  connect?: InputMaybe<SubjectUniqueFilterInput>;
  /** Create a "Subject" and connect it to a new "SubjectUser" through the "SubjectUser.subject" edge. */
  create?: InputMaybe<SubjectCreationInput>;
  /** Create a "Subject" if it does not exist, and connect it to a new "SubjectUser" through the "SubjectUser.subject" edge. */
  createIfNotExists?: InputMaybe<SubjectUserCreationSubjectCreateIfNotExistsInput>;
};

export type SubjectUserCreationSubjectCreateIfNotExistsInput = {
  data: SubjectCreationInput;
  where: SubjectUniqueFilterInput;
};

/** The "SubSubject" node's creation */
export type SubSubjectCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  subject: SubSubjectCreationSubjectInput;
  title: Scalars['String']['input'];
};

export type SubSubjectCreationSubjectInput = {
  /** Connect a "Subject" to a new "SubSubject" through the "SubSubject.subject" edge, throw an error if it does not exist. */
  connect?: InputMaybe<SubjectUniqueFilterInput>;
  /** Create a "Subject" and connect it to a new "SubSubject" through the "SubSubject.subject" edge. */
  create?: InputMaybe<SubjectCreationInput>;
  /** Create a "Subject" if it does not exist, and connect it to a new "SubSubject" through the "SubSubject.subject" edge. */
  createIfNotExists?: InputMaybe<SubSubjectCreationSubjectCreateIfNotExistsInput>;
};

export type SubSubjectCreationSubjectCreateIfNotExistsInput = {
  data: SubjectCreationInput;
  where: SubjectUniqueFilterInput;
};

/** The "TopicFotowebPige" node's creation */
export type TopicFotowebPigeCreationInput = {
  /** The private ID */
  _id?: InputMaybe<Scalars['UnsignedInt']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fotowebId: Scalars['String']['input'];
  headline?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  priceLevel?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle: Scalars['String']['input'];
  printPublicationKey: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type EmailRawArticleResultType = {
  __typename?: 'EmailRawArticleResultType';
  success: Scalars['Boolean']['output'];
};

export type EmailSubjectResultType = {
  __typename?: 'EmailSubjectResultType';
  success: Scalars['Boolean']['output'];
};

export type ExportPrintIssueToCenshareResultType = {
  __typename?: 'ExportPrintIssueToCenshareResultType';
  message: Scalars['String']['output'];
};

export type ExportToCenshareResultType = {
  __typename?: 'ExportToCenshareResultType';
  message: Scalars['String']['output'];
};

/** The "Advertisement" node's update */
export type AdvertisementUpdateInput = {
  layoutAssets?: InputMaybe<AdvertisementUpdateLayoutAssetsInput>;
  printIssue?: InputMaybe<AdvertisementUpdatePrintIssueInput>;
  printPublication?: InputMaybe<AdvertisementUpdatePrintPublicationInput>;
  versions?: InputMaybe<AdvertisementUpdateVersionsInput>;
};

export type AdvertisementUpdateLayoutAssetsInput = {
  create?: InputMaybe<Array<LayoutAssetCreationWithoutAdvertisementInput>>;
  createIfNotExists?: InputMaybe<Array<AdvertisementUpdateLayoutAssetsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<LayoutAssetUniqueFilterWithoutAdvertisementInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<LayoutAssetUniqueFilterWithoutAdvertisementInput>>;
  deleteMany?: InputMaybe<LayoutAssetFilterInput>;
  update?: InputMaybe<Array<AdvertisementUpdateLayoutAssetsUpdateInput>>;
  updateAll?: InputMaybe<LayoutAssetUpdateWithoutAdvertisementInput>;
  updateIfExists?: InputMaybe<Array<AdvertisementUpdateLayoutAssetsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<AdvertisementUpdateLayoutAssetsUpdateManyInput>>;
  upsert?: InputMaybe<Array<AdvertisementUpdateLayoutAssetsUpsertInput>>;
};

export type AdvertisementUpdateLayoutAssetsCreateIfNotExistsInput = {
  data: LayoutAssetCreationWithoutAdvertisementInput;
  where: LayoutAssetUniqueFilterWithoutAdvertisementInput;
};

/** Given an "advertisement", identifies exactly one "LayoutAsset" by "layout" */
export type LayoutAssetUniqueFilterWithoutAdvertisementInput = {
  layout: LayoutUniqueFilterInput;
};

export type AdvertisementUpdateLayoutAssetsUpdateInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutAdvertisementInput>;
  where: LayoutAssetUniqueFilterWithoutAdvertisementInput;
};

/** The "LayoutAsset" node's update */
export type LayoutAssetUpdateWithoutAdvertisementInput = {
  file?: InputMaybe<LayoutAssetUpdateFileInput>;
  layout?: InputMaybe<LayoutAssetUpdateLayoutInput>;
  mockup?: InputMaybe<LayoutAssetUpdateMockupInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<LayoutAssetUpdatePrintHeadingInput>;
};

export type LayoutAssetUpdateFileInput = {
  /** Connect a "File" to an existing "LayoutAsset" through the "LayoutAsset.file" edge, throw an error if it does not exist. */
  connect?: InputMaybe<FileUniqueFilterInput>;
  /** Connect a "File" to an existing "LayoutAsset" through the "LayoutAsset.file" edge, if it exists. */
  connectIfExists?: InputMaybe<FileUniqueFilterInput>;
  /** Create a "File" and connect it to an existing "LayoutAsset" through the "LayoutAsset.file" edge. */
  create?: InputMaybe<FileCreationInput>;
  /** Create a "File" if it does not exist, and connect it to an existing "LayoutAsset" through the "LayoutAsset.file" edge. */
  createIfNotExists?: InputMaybe<LayoutAssetUpdateFileCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "File", throw an error if the "LayoutAsset.file" edge does not exist. */
  update?: InputMaybe<FileUpdateInput>;
  /** Update the connected "File", if the "LayoutAsset.file" edge exists. */
  updateIfExists?: InputMaybe<FileUpdateInput>;
};

export type LayoutAssetUpdateFileCreateIfNotExistsInput = {
  data: FileCreationInput;
  where: FileUniqueFilterInput;
};

/** The "File" node's update */
export type FileUpdateInput = {
  layoutAssets?: InputMaybe<FileUpdateLayoutAssetsInput>;
  printIssue?: InputMaybe<FileUpdatePrintIssueInput>;
  printPublication?: InputMaybe<FileUpdatePrintPublicationInput>;
  versions?: InputMaybe<FileUpdateVersionsInput>;
};

export type FileUpdateLayoutAssetsInput = {
  create?: InputMaybe<Array<LayoutAssetCreationWithoutFileInput>>;
  createIfNotExists?: InputMaybe<Array<FileUpdateLayoutAssetsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<LayoutAssetUniqueFilterWithoutFileInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<LayoutAssetUniqueFilterWithoutFileInput>>;
  deleteMany?: InputMaybe<LayoutAssetFilterInput>;
  update?: InputMaybe<Array<FileUpdateLayoutAssetsUpdateInput>>;
  updateAll?: InputMaybe<LayoutAssetUpdateWithoutFileInput>;
  updateIfExists?: InputMaybe<Array<FileUpdateLayoutAssetsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<FileUpdateLayoutAssetsUpdateManyInput>>;
  upsert?: InputMaybe<Array<FileUpdateLayoutAssetsUpsertInput>>;
};

export type FileUpdateLayoutAssetsCreateIfNotExistsInput = {
  data: LayoutAssetCreationWithoutFileInput;
  where: LayoutAssetUniqueFilterWithoutFileInput;
};

/** Given a "file", identifies exactly one "LayoutAsset" by "layout" */
export type LayoutAssetUniqueFilterWithoutFileInput = {
  layout: LayoutUniqueFilterInput;
};

export type FileUpdateLayoutAssetsUpdateInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutFileInput>;
  where: LayoutAssetUniqueFilterWithoutFileInput;
};

/** The "LayoutAsset" node's update */
export type LayoutAssetUpdateWithoutFileInput = {
  advertisement?: InputMaybe<LayoutAssetUpdateAdvertisementInput>;
  layout?: InputMaybe<LayoutAssetUpdateLayoutInput>;
  mockup?: InputMaybe<LayoutAssetUpdateMockupInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<LayoutAssetUpdatePrintHeadingInput>;
};

export type LayoutAssetUpdateAdvertisementInput = {
  /**
   * Connect an "Advertisement" to an existing "LayoutAsset" through the
   * "LayoutAsset.advertisement" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<AdvertisementUniqueFilterInput>;
  /** Connect an "Advertisement" to an existing "LayoutAsset" through the "LayoutAsset.advertisement" edge, if it exists. */
  connectIfExists?: InputMaybe<AdvertisementUniqueFilterInput>;
  /** Create an "Advertisement" and connect it to an existing "LayoutAsset" through the "LayoutAsset.advertisement" edge. */
  create?: InputMaybe<AdvertisementCreationInput>;
  /**
   * Create an "Advertisement" if it does not exist, and connect it to an existing
   * "LayoutAsset" through the "LayoutAsset.advertisement" edge.
   */
  createIfNotExists?: InputMaybe<LayoutAssetUpdateAdvertisementCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "Advertisement", throw an error if the "LayoutAsset.advertisement" edge does not exist. */
  update?: InputMaybe<AdvertisementUpdateInput>;
  /** Update the connected "Advertisement", if the "LayoutAsset.advertisement" edge exists. */
  updateIfExists?: InputMaybe<AdvertisementUpdateInput>;
};

export type LayoutAssetUpdateAdvertisementCreateIfNotExistsInput = {
  data: AdvertisementCreationInput;
  where: AdvertisementUniqueFilterInput;
};

export type LayoutAssetUpdateLayoutInput = {
  /**
   * Connect a "Layout" to an existing "LayoutAsset" through the
   * "LayoutAsset.layout" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<LayoutUniqueFilterInput>;
  /** Create a "Layout" and connect it to an existing "LayoutAsset" through the "LayoutAsset.layout" edge. */
  create?: InputMaybe<LayoutCreationInput>;
  /** Create a "Layout" if it does not exist, and connect it to an existing "LayoutAsset" through the "LayoutAsset.layout" edge. */
  createIfNotExists?: InputMaybe<LayoutAssetUpdateLayoutCreateIfNotExistsInput>;
  /** Update the connected "Layout", throw an error if the "LayoutAsset.layout" edge does not exist. */
  update?: InputMaybe<LayoutUpdateInput>;
};

export type LayoutAssetUpdateLayoutCreateIfNotExistsInput = {
  data: LayoutCreationInput;
  where: LayoutUniqueFilterInput;
};

/** The "Layout" node's update */
export type LayoutUpdateInput = {
  assets?: InputMaybe<LayoutUpdateAssetsInput>;
  /** The layouts that are based on this one */
  children?: InputMaybe<LayoutUpdateChildrenInput>;
  /** The layout this one is based on, if any */
  parent?: InputMaybe<LayoutUpdateParentInput>;
  printIssue?: InputMaybe<LayoutUpdatePrintIssueInput>;
  printPublication?: InputMaybe<LayoutUpdatePrintPublicationInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LayoutUpdateAssetsInput = {
  create?: InputMaybe<Array<LayoutAssetCreationWithoutLayoutInput>>;
  createIfNotExists?: InputMaybe<Array<LayoutUpdateAssetsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<LayoutAssetUniqueFilterWithoutLayoutInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<LayoutAssetUniqueFilterWithoutLayoutInput>>;
  deleteMany?: InputMaybe<LayoutAssetFilterInput>;
  update?: InputMaybe<Array<LayoutUpdateAssetsUpdateInput>>;
  updateAll?: InputMaybe<LayoutAssetUpdateWithoutLayoutInput>;
  updateIfExists?: InputMaybe<Array<LayoutUpdateAssetsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<LayoutUpdateAssetsUpdateManyInput>>;
  upsert?: InputMaybe<Array<LayoutUpdateAssetsUpsertInput>>;
};

export type LayoutUpdateAssetsCreateIfNotExistsInput = {
  data: LayoutAssetCreationWithoutLayoutInput;
  where: LayoutAssetUniqueFilterWithoutLayoutInput;
};

/** Given a "layout", identifies exactly one "LayoutAsset" by "order", "printHeading", "mockup", "file" or "advertisement" */
export type LayoutAssetUniqueFilterWithoutLayoutInput = {
  advertisement?: InputMaybe<AdvertisementUniqueFilterInput>;
  file?: InputMaybe<FileUniqueFilterInput>;
  mockup?: InputMaybe<MockupUniqueFilterInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<PrintHeadingUniqueFilterInput>;
};

export type LayoutUpdateAssetsUpdateInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutLayoutInput>;
  where: LayoutAssetUniqueFilterWithoutLayoutInput;
};

/** The "LayoutAsset" node's update */
export type LayoutAssetUpdateWithoutLayoutInput = {
  advertisement?: InputMaybe<LayoutAssetUpdateAdvertisementInput>;
  file?: InputMaybe<LayoutAssetUpdateFileInput>;
  mockup?: InputMaybe<LayoutAssetUpdateMockupInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<LayoutAssetUpdatePrintHeadingInput>;
};

export type LayoutAssetUpdateMockupInput = {
  /**
   * Connect a "Mockup" to an existing "LayoutAsset" through the
   * "LayoutAsset.mockup" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<MockupUniqueFilterInput>;
  /** Connect a "Mockup" to an existing "LayoutAsset" through the "LayoutAsset.mockup" edge, if it exists. */
  connectIfExists?: InputMaybe<MockupUniqueFilterInput>;
  /** Create a "Mockup" and connect it to an existing "LayoutAsset" through the "LayoutAsset.mockup" edge. */
  create?: InputMaybe<MockupCreationInput>;
  /** Create a "Mockup" if it does not exist, and connect it to an existing "LayoutAsset" through the "LayoutAsset.mockup" edge. */
  createIfNotExists?: InputMaybe<LayoutAssetUpdateMockupCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "Mockup", throw an error if the "LayoutAsset.mockup" edge does not exist. */
  update?: InputMaybe<MockupUpdateInput>;
  /** Update the connected "Mockup", if the "LayoutAsset.mockup" edge exists. */
  updateIfExists?: InputMaybe<MockupUpdateInput>;
};

export type LayoutAssetUpdateMockupCreateIfNotExistsInput = {
  data: MockupCreationInput;
  where: MockupUniqueFilterInput;
};

/** The "Mockup" node's update */
export type MockupUpdateInput = {
  layoutAssets?: InputMaybe<MockupUpdateLayoutAssetsInput>;
  printHeading?: InputMaybe<MockupUpdatePrintHeadingInput>;
  printIssue?: InputMaybe<MockupUpdatePrintIssueInput>;
  printPublication?: InputMaybe<MockupUpdatePrintPublicationInput>;
  versions?: InputMaybe<MockupUpdateVersionsInput>;
};

export type MockupUpdateLayoutAssetsInput = {
  create?: InputMaybe<Array<LayoutAssetCreationWithoutMockupInput>>;
  createIfNotExists?: InputMaybe<Array<MockupUpdateLayoutAssetsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<LayoutAssetUniqueFilterWithoutMockupInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<LayoutAssetUniqueFilterWithoutMockupInput>>;
  deleteMany?: InputMaybe<LayoutAssetFilterInput>;
  update?: InputMaybe<Array<MockupUpdateLayoutAssetsUpdateInput>>;
  updateAll?: InputMaybe<LayoutAssetUpdateWithoutMockupInput>;
  updateIfExists?: InputMaybe<Array<MockupUpdateLayoutAssetsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<MockupUpdateLayoutAssetsUpdateManyInput>>;
  upsert?: InputMaybe<Array<MockupUpdateLayoutAssetsUpsertInput>>;
};

export type MockupUpdateLayoutAssetsCreateIfNotExistsInput = {
  data: LayoutAssetCreationWithoutMockupInput;
  where: LayoutAssetUniqueFilterWithoutMockupInput;
};

/** Given a "mockup", identifies exactly one "LayoutAsset" by "layout" */
export type LayoutAssetUniqueFilterWithoutMockupInput = {
  layout: LayoutUniqueFilterInput;
};

export type MockupUpdateLayoutAssetsUpdateInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutMockupInput>;
  where: LayoutAssetUniqueFilterWithoutMockupInput;
};

/** The "LayoutAsset" node's update */
export type LayoutAssetUpdateWithoutMockupInput = {
  advertisement?: InputMaybe<LayoutAssetUpdateAdvertisementInput>;
  file?: InputMaybe<LayoutAssetUpdateFileInput>;
  layout?: InputMaybe<LayoutAssetUpdateLayoutInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<LayoutAssetUpdatePrintHeadingInput>;
};

export type LayoutAssetUpdatePrintHeadingInput = {
  /**
   * Connect a "PrintHeading" to an existing "LayoutAsset" through the
   * "LayoutAsset.printHeading" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Connect a "PrintHeading" to an existing "LayoutAsset" through the "LayoutAsset.printHeading" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Create a "PrintHeading" and connect it to an existing "LayoutAsset" through the "LayoutAsset.printHeading" edge. */
  create?: InputMaybe<PrintHeadingCreationInput>;
  /**
   * Create a "PrintHeading" if it does not exist, and connect it to an existing
   * "LayoutAsset" through the "LayoutAsset.printHeading" edge.
   */
  createIfNotExists?: InputMaybe<LayoutAssetUpdatePrintHeadingCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintHeading", throw an error if the "LayoutAsset.printHeading" edge does not exist. */
  update?: InputMaybe<PrintHeadingUpdateInput>;
  /** Update the connected "PrintHeading", if the "LayoutAsset.printHeading" edge exists. */
  updateIfExists?: InputMaybe<PrintHeadingUpdateInput>;
};

export type LayoutAssetUpdatePrintHeadingCreateIfNotExistsInput = {
  data: PrintHeadingCreationInput;
  where: PrintHeadingUniqueFilterInput;
};

/** The "PrintHeading" node's update */
export type PrintHeadingUpdateInput = {
  assignments?: InputMaybe<PrintHeadingUpdateAssignmentsInput>;
  autoPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutomaticSubject?: InputMaybe<Scalars['Boolean']['input']>;
  layoutAssets?: InputMaybe<PrintHeadingUpdateLayoutAssetsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockup?: InputMaybe<PrintHeadingUpdateMockupInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssue?: InputMaybe<PrintHeadingUpdatePrintIssueInput>;
  printPublication?: InputMaybe<PrintHeadingUpdatePrintPublicationInput>;
  printTemplates?: InputMaybe<PrintHeadingUpdatePrintTemplatesInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrintHeadingUpdateAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutPrintHeadingInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<AssignmentFilterInput>;
  updateAll?: InputMaybe<AssignmentUpdateWithoutPrintHeadingInput>;
  updateMany?: InputMaybe<Array<PrintHeadingUpdateAssignmentsUpdateManyInput>>;
};

/** The "Assignment" node's update */
export type AssignmentUpdateWithoutPrintHeadingInput = {
  articleTemplate?: InputMaybe<AssignmentUpdateArticleTemplateInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssue?: InputMaybe<AssignmentUpdatePrintIssueInput>;
  printPublication?: InputMaybe<AssignmentUpdatePrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentUpdatePrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentUpdateRawArticleInput>;
  subject?: InputMaybe<AssignmentUpdateSubjectInput>;
  website?: InputMaybe<AssignmentUpdateWebsiteInput>;
};

export type AssignmentUpdateArticleTemplateInput = {
  /**
   * Connect an "ArticleTemplate" to an existing "Assignment" through the
   * "Assignment.articleTemplate" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleTemplateUniqueFilterInput>;
  /** Connect an "ArticleTemplate" to an existing "Assignment" through the "Assignment.articleTemplate" edge, if it exists. */
  connectIfExists?: InputMaybe<ArticleTemplateUniqueFilterInput>;
  /** Create an "ArticleTemplate" and connect it to an existing "Assignment" through the "Assignment.articleTemplate" edge. */
  create?: InputMaybe<ArticleTemplateCreationInput>;
  /**
   * Create an "ArticleTemplate" if it does not exist, and connect it to an
   * existing "Assignment" through the "Assignment.articleTemplate" edge.
   */
  createIfNotExists?: InputMaybe<AssignmentUpdateArticleTemplateCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "ArticleTemplate", throw an error if the "Assignment.articleTemplate" edge does not exist. */
  update?: InputMaybe<ArticleTemplateUpdateInput>;
  /** Update the connected "ArticleTemplate", if the "Assignment.articleTemplate" edge exists. */
  updateIfExists?: InputMaybe<ArticleTemplateUpdateInput>;
};

export type AssignmentUpdateArticleTemplateCreateIfNotExistsInput = {
  data: ArticleTemplateCreationInput;
  where: ArticleTemplateUniqueFilterInput;
};

/** The "ArticleTemplate" node's update */
export type ArticleTemplateUpdateInput = {
  assignments?: InputMaybe<ArticleTemplateUpdateAssignmentsInput>;
  /** The raw datas */
  block?: InputMaybe<Scalars['String']['input']>;
  /** The article template label */
  label?: InputMaybe<Scalars['String']['input']>;
  printTemplate?: InputMaybe<ArticleTemplateUpdatePrintTemplateInput>;
};

export type ArticleTemplateUpdateAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutArticleTemplateInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<AssignmentFilterInput>;
  updateAll?: InputMaybe<AssignmentUpdateWithoutArticleTemplateInput>;
  updateMany?: InputMaybe<Array<ArticleTemplateUpdateAssignmentsUpdateManyInput>>;
};

/** The "Assignment" node's update */
export type AssignmentUpdateWithoutArticleTemplateInput = {
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentUpdatePrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentUpdatePrintIssueInput>;
  printPublication?: InputMaybe<AssignmentUpdatePrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentUpdatePrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentUpdateRawArticleInput>;
  subject?: InputMaybe<AssignmentUpdateSubjectInput>;
  website?: InputMaybe<AssignmentUpdateWebsiteInput>;
};

export type AssignmentUpdatePrintHeadingInput = {
  /**
   * Connect a "PrintHeading" to an existing "Assignment" through the
   * "Assignment.printHeading" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Connect a "PrintHeading" to an existing "Assignment" through the "Assignment.printHeading" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Create a "PrintHeading" and connect it to an existing "Assignment" through the "Assignment.printHeading" edge. */
  create?: InputMaybe<PrintHeadingCreationInput>;
  /**
   * Create a "PrintHeading" if it does not exist, and connect it to an existing
   * "Assignment" through the "Assignment.printHeading" edge.
   */
  createIfNotExists?: InputMaybe<AssignmentUpdatePrintHeadingCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintHeading", throw an error if the "Assignment.printHeading" edge does not exist. */
  update?: InputMaybe<PrintHeadingUpdateInput>;
  /** Update the connected "PrintHeading", if the "Assignment.printHeading" edge exists. */
  updateIfExists?: InputMaybe<PrintHeadingUpdateInput>;
};

export type AssignmentUpdatePrintHeadingCreateIfNotExistsInput = {
  data: PrintHeadingCreationInput;
  where: PrintHeadingUniqueFilterInput;
};

export type AssignmentUpdatePrintIssueInput = {
  /**
   * Connect a "PrintIssue" to an existing "Assignment" through the
   * "Assignment.printIssue" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Connect a "PrintIssue" to an existing "Assignment" through the "Assignment.printIssue" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to an existing "Assignment" through the "Assignment.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /**
   * Create a "PrintIssue" if it does not exist, and connect it to an existing
   * "Assignment" through the "Assignment.printIssue" edge.
   */
  createIfNotExists?: InputMaybe<AssignmentUpdatePrintIssueCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintIssue", throw an error if the "Assignment.printIssue" edge does not exist. */
  update?: InputMaybe<PrintIssueUpdateInput>;
  /** Update the connected "PrintIssue", if the "Assignment.printIssue" edge exists. */
  updateIfExists?: InputMaybe<PrintIssueUpdateInput>;
};

export type AssignmentUpdatePrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

/** The "PrintIssue" node's update */
export type PrintIssueUpdateInput = {
  advertisements?: InputMaybe<PrintIssueUpdateAdvertisementsInput>;
  assignments?: InputMaybe<PrintIssueUpdateAssignmentsInput>;
  files?: InputMaybe<PrintIssueUpdateFilesInput>;
  layouts?: InputMaybe<PrintIssueUpdateLayoutsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockups?: InputMaybe<PrintIssueUpdateMockupsInput>;
  printHeadings?: InputMaybe<PrintIssueUpdatePrintHeadingsInput>;
  printIssueRailroad?: InputMaybe<PrintIssueUpdatePrintIssueRailroadInput>;
  printPublication?: InputMaybe<PrintIssueUpdatePrintPublicationInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrintIssueUpdateAdvertisementsInput = {
  create?: InputMaybe<Array<AdvertisementCreationWithoutPrintIssueInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<AdvertisementFilterInput>;
  updateAll?: InputMaybe<AdvertisementUpdateWithoutPrintIssueInput>;
  updateMany?: InputMaybe<Array<PrintIssueUpdateAdvertisementsUpdateManyInput>>;
};

/** The "Advertisement" node's update */
export type AdvertisementUpdateWithoutPrintIssueInput = {
  layoutAssets?: InputMaybe<AdvertisementUpdateLayoutAssetsInput>;
  printPublication?: InputMaybe<AdvertisementUpdatePrintPublicationInput>;
  versions?: InputMaybe<AdvertisementUpdateVersionsInput>;
};

export type AdvertisementUpdatePrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to an existing "Advertisement" through the
   * "Advertisement.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /**
   * Connect a "PrintPublication" to an existing "Advertisement" through the
   * "Advertisement.printPublication" edge, if it exists.
   */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /**
   * Create a "PrintPublication" and connect it to an existing "Advertisement"
   * through the "Advertisement.printPublication" edge.
   */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to an
   * existing "Advertisement" through the "Advertisement.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<AdvertisementUpdatePrintPublicationCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintPublication", throw an error if the "Advertisement.printPublication" edge does not exist. */
  update?: InputMaybe<PrintPublicationUpdateInput>;
  /** Update the connected "PrintPublication", if the "Advertisement.printPublication" edge exists. */
  updateIfExists?: InputMaybe<PrintPublicationUpdateInput>;
};

export type AdvertisementUpdatePrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

/** The "PrintPublication" node's update */
export type PrintPublicationUpdateInput = {
  advertisements?: InputMaybe<PrintPublicationUpdateAdvertisementsInput>;
  assignments?: InputMaybe<PrintPublicationUpdateAssignmentsInput>;
  brand?: InputMaybe<PrintPublicationUpdateBrandInput>;
  files?: InputMaybe<PrintPublicationUpdateFilesInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  layouts?: InputMaybe<PrintPublicationUpdateLayoutsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockups?: InputMaybe<PrintPublicationUpdateMockupsInput>;
  printHeadings?: InputMaybe<PrintPublicationUpdatePrintHeadingsInput>;
  printIssues?: InputMaybe<PrintPublicationUpdatePrintIssuesInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrintPublicationUpdateAdvertisementsInput = {
  create?: InputMaybe<Array<AdvertisementCreationWithoutPrintPublicationInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<AdvertisementFilterInput>;
  updateAll?: InputMaybe<AdvertisementUpdateWithoutPrintPublicationInput>;
  updateMany?: InputMaybe<Array<PrintPublicationUpdateAdvertisementsUpdateManyInput>>;
};

/** The "Advertisement" node's update */
export type AdvertisementUpdateWithoutPrintPublicationInput = {
  layoutAssets?: InputMaybe<AdvertisementUpdateLayoutAssetsInput>;
  printIssue?: InputMaybe<AdvertisementUpdatePrintIssueInput>;
  versions?: InputMaybe<AdvertisementUpdateVersionsInput>;
};

export type AdvertisementUpdatePrintIssueInput = {
  /**
   * Connect a "PrintIssue" to an existing "Advertisement" through the
   * "Advertisement.printIssue" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Connect a "PrintIssue" to an existing "Advertisement" through the "Advertisement.printIssue" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to an existing "Advertisement" through the "Advertisement.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /**
   * Create a "PrintIssue" if it does not exist, and connect it to an existing
   * "Advertisement" through the "Advertisement.printIssue" edge.
   */
  createIfNotExists?: InputMaybe<AdvertisementUpdatePrintIssueCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintIssue", throw an error if the "Advertisement.printIssue" edge does not exist. */
  update?: InputMaybe<PrintIssueUpdateInput>;
  /** Update the connected "PrintIssue", if the "Advertisement.printIssue" edge exists. */
  updateIfExists?: InputMaybe<PrintIssueUpdateInput>;
};

export type AdvertisementUpdatePrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type AdvertisementUpdateVersionsInput = {
  create?: InputMaybe<Array<AdvertisementVersionCreationWithoutAdvertisementInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<AdvertisementVersionFilterInput>;
};

export type PrintPublicationUpdateAdvertisementsUpdateManyInput = {
  data?: InputMaybe<AdvertisementUpdateWithoutPrintPublicationInput>;
  where?: InputMaybe<AdvertisementFilterInput>;
};

export type PrintPublicationUpdateAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutPrintPublicationInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<AssignmentFilterInput>;
  updateAll?: InputMaybe<AssignmentUpdateWithoutPrintPublicationInput>;
  updateMany?: InputMaybe<Array<PrintPublicationUpdateAssignmentsUpdateManyInput>>;
};

/** The "Assignment" node's update */
export type AssignmentUpdateWithoutPrintPublicationInput = {
  articleTemplate?: InputMaybe<AssignmentUpdateArticleTemplateInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentUpdatePrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentUpdatePrintIssueInput>;
  printTemplate?: InputMaybe<AssignmentUpdatePrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentUpdateRawArticleInput>;
  subject?: InputMaybe<AssignmentUpdateSubjectInput>;
  website?: InputMaybe<AssignmentUpdateWebsiteInput>;
};

export type AssignmentUpdatePrintTemplateInput = {
  /**
   * Connect a "PrintTemplate" to an existing "Assignment" through the
   * "Assignment.printTemplate" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintTemplateUniqueFilterInput>;
  /** Connect a "PrintTemplate" to an existing "Assignment" through the "Assignment.printTemplate" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintTemplateUniqueFilterInput>;
  /** Create a "PrintTemplate" and connect it to an existing "Assignment" through the "Assignment.printTemplate" edge. */
  create?: InputMaybe<PrintTemplateCreationInput>;
  /**
   * Create a "PrintTemplate" if it does not exist, and connect it to an existing
   * "Assignment" through the "Assignment.printTemplate" edge.
   */
  createIfNotExists?: InputMaybe<AssignmentUpdatePrintTemplateCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintTemplate", throw an error if the "Assignment.printTemplate" edge does not exist. */
  update?: InputMaybe<PrintTemplateUpdateInput>;
  /** Update the connected "PrintTemplate", if the "Assignment.printTemplate" edge exists. */
  updateIfExists?: InputMaybe<PrintTemplateUpdateInput>;
};

export type AssignmentUpdatePrintTemplateCreateIfNotExistsInput = {
  data: PrintTemplateCreationInput;
  where: PrintTemplateUniqueFilterInput;
};

/** The "PrintTemplate" node's update */
export type PrintTemplateUpdateInput = {
  articleTemplates?: InputMaybe<PrintTemplateUpdateArticleTemplatesInput>;
  assignments?: InputMaybe<PrintTemplateUpdateAssignmentsInput>;
  /** InDesign file size */
  filesize?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** template label */
  label?: InputMaybe<Scalars['String']['input']>;
  printHeadings?: InputMaybe<PrintTemplateUpdatePrintHeadingsInput>;
  /** template type */
  type?: InputMaybe<TemplateType>;
};

export type PrintTemplateUpdateArticleTemplatesInput = {
  create?: InputMaybe<Array<ArticleTemplateCreationWithoutPrintTemplateInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<ArticleTemplateFilterInput>;
  updateAll?: InputMaybe<ArticleTemplateUpdateWithoutPrintTemplateInput>;
  updateMany?: InputMaybe<Array<PrintTemplateUpdateArticleTemplatesUpdateManyInput>>;
};

/** The "ArticleTemplate" node's update */
export type ArticleTemplateUpdateWithoutPrintTemplateInput = {
  assignments?: InputMaybe<ArticleTemplateUpdateAssignmentsInput>;
  /** The raw datas */
  block?: InputMaybe<Scalars['String']['input']>;
  /** The article template label */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type PrintTemplateUpdateArticleTemplatesUpdateManyInput = {
  data?: InputMaybe<ArticleTemplateUpdateWithoutPrintTemplateInput>;
  where?: InputMaybe<ArticleTemplateFilterInput>;
};

export type PrintTemplateUpdateAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutPrintTemplateInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<AssignmentFilterInput>;
  updateAll?: InputMaybe<AssignmentUpdateWithoutPrintTemplateInput>;
  updateMany?: InputMaybe<Array<PrintTemplateUpdateAssignmentsUpdateManyInput>>;
};

/** The "Assignment" node's update */
export type AssignmentUpdateWithoutPrintTemplateInput = {
  articleTemplate?: InputMaybe<AssignmentUpdateArticleTemplateInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentUpdatePrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentUpdatePrintIssueInput>;
  printPublication?: InputMaybe<AssignmentUpdatePrintPublicationInput>;
  rawArticle?: InputMaybe<AssignmentUpdateRawArticleInput>;
  subject?: InputMaybe<AssignmentUpdateSubjectInput>;
  website?: InputMaybe<AssignmentUpdateWebsiteInput>;
};

export type AssignmentUpdatePrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to an existing "Assignment" through the
   * "Assignment.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to an existing "Assignment" through the "Assignment.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to an existing "Assignment" through the "Assignment.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to an
   * existing "Assignment" through the "Assignment.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<AssignmentUpdatePrintPublicationCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintPublication", throw an error if the "Assignment.printPublication" edge does not exist. */
  update?: InputMaybe<PrintPublicationUpdateInput>;
  /** Update the connected "PrintPublication", if the "Assignment.printPublication" edge exists. */
  updateIfExists?: InputMaybe<PrintPublicationUpdateInput>;
};

export type AssignmentUpdatePrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type AssignmentUpdateRawArticleInput = {
  /**
   * Connect a "RawArticle" to an existing "Assignment" through the
   * "Assignment.rawArticle" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<RawArticleUniqueFilterInput>;
  /** Connect a "RawArticle" to an existing "Assignment" through the "Assignment.rawArticle" edge, if it exists. */
  connectIfExists?: InputMaybe<RawArticleUniqueFilterInput>;
  /** Create a "RawArticle" and connect it to an existing "Assignment" through the "Assignment.rawArticle" edge. */
  create?: InputMaybe<RawArticleCreationInput>;
  /**
   * Create a "RawArticle" if it does not exist, and connect it to an existing
   * "Assignment" through the "Assignment.rawArticle" edge.
   */
  createIfNotExists?: InputMaybe<AssignmentUpdateRawArticleCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "RawArticle", throw an error if the "Assignment.rawArticle" edge does not exist. */
  update?: InputMaybe<RawArticleUpdateInput>;
  /** Update the connected "RawArticle", if the "Assignment.rawArticle" edge exists. */
  updateIfExists?: InputMaybe<RawArticleUpdateInput>;
};

export type AssignmentUpdateRawArticleCreateIfNotExistsInput = {
  data: RawArticleCreationInput;
  where: RawArticleUniqueFilterInput;
};

/** The "RawArticle" node's update */
export type RawArticleUpdateInput = {
  assignment?: InputMaybe<RawArticleUpdateAssignmentInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  versions?: InputMaybe<RawArticleUpdateVersionsInput>;
};

export type RawArticleUpdateAssignmentInput = {
  create?: InputMaybe<AssignmentCreationWithoutRawArticleInput>;
  createIfNotExists?: InputMaybe<AssignmentCreationWithoutRawArticleInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<AssignmentUpdateWithoutRawArticleInput>;
  updateIfExists?: InputMaybe<AssignmentUpdateWithoutRawArticleInput>;
  upsert?: InputMaybe<RawArticleUpdateAssignmentUpsertInput>;
};

/** The "Assignment" node's update */
export type AssignmentUpdateWithoutRawArticleInput = {
  articleTemplate?: InputMaybe<AssignmentUpdateArticleTemplateInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentUpdatePrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentUpdatePrintIssueInput>;
  printPublication?: InputMaybe<AssignmentUpdatePrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentUpdatePrintTemplateInput>;
  subject?: InputMaybe<AssignmentUpdateSubjectInput>;
  website?: InputMaybe<AssignmentUpdateWebsiteInput>;
};

export type AssignmentUpdateSubjectInput = {
  /**
   * Connect a "Subject" to an existing "Assignment" through the
   * "Assignment.subject" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<SubjectUniqueFilterInput>;
  /** Create a "Subject" and connect it to an existing "Assignment" through the "Assignment.subject" edge. */
  create?: InputMaybe<SubjectCreationInput>;
  /** Create a "Subject" if it does not exist, and connect it to an existing "Assignment" through the "Assignment.subject" edge. */
  createIfNotExists?: InputMaybe<AssignmentUpdateSubjectCreateIfNotExistsInput>;
  /** Update the connected "Subject", throw an error if the "Assignment.subject" edge does not exist. */
  update?: InputMaybe<SubjectUpdateInput>;
};

export type AssignmentUpdateSubjectCreateIfNotExistsInput = {
  data: SubjectCreationInput;
  where: SubjectUniqueFilterInput;
};

/** The "Subject" node's update */
export type SubjectUpdateInput = {
  assignments?: InputMaybe<SubjectUpdateAssignmentsInput>;
  attachments?: InputMaybe<SubjectUpdateAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isAuto?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaRequest?: InputMaybe<Scalars['String']['input']>;
  subjectCategory?: InputMaybe<SubjectUpdateSubjectCategoryInput>;
  subjectUsers?: InputMaybe<SubjectUpdateSubjectUsersInput>;
  subSubjects?: InputMaybe<SubjectUpdateSubSubjectsInput>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<SubjectUpdateUnitInput>;
};

export type SubjectUpdateAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutSubjectInput>>;
  createIfNotExists?: InputMaybe<Array<SubjectUpdateAssignmentsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<AssignmentUniqueFilterWithoutSubjectInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<AssignmentUniqueFilterWithoutSubjectInput>>;
  deleteMany?: InputMaybe<AssignmentFilterInput>;
  update?: InputMaybe<Array<SubjectUpdateAssignmentsUpdateInput>>;
  updateAll?: InputMaybe<AssignmentUpdateWithoutSubjectInput>;
  updateIfExists?: InputMaybe<Array<SubjectUpdateAssignmentsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<SubjectUpdateAssignmentsUpdateManyInput>>;
  upsert?: InputMaybe<Array<SubjectUpdateAssignmentsUpsertInput>>;
};

export type SubjectUpdateAssignmentsCreateIfNotExistsInput = {
  data: AssignmentCreationWithoutSubjectInput;
  where: AssignmentUniqueFilterWithoutSubjectInput;
};

/** Given a "subject", identifies exactly one "Assignment" by "legacyId" */
export type AssignmentUniqueFilterWithoutSubjectInput = {
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type SubjectUpdateAssignmentsUpdateInput = {
  data?: InputMaybe<AssignmentUpdateWithoutSubjectInput>;
  where: AssignmentUniqueFilterWithoutSubjectInput;
};

/** The "Assignment" node's update */
export type AssignmentUpdateWithoutSubjectInput = {
  articleTemplate?: InputMaybe<AssignmentUpdateArticleTemplateInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentUpdatePrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentUpdatePrintIssueInput>;
  printPublication?: InputMaybe<AssignmentUpdatePrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentUpdatePrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentUpdateRawArticleInput>;
  website?: InputMaybe<AssignmentUpdateWebsiteInput>;
};

export type AssignmentUpdateWebsiteInput = {
  /**
   * Connect a "Website" to an existing "Assignment" through the
   * "Assignment.website" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<WebsiteUniqueFilterInput>;
  /** Connect a "Website" to an existing "Assignment" through the "Assignment.website" edge, if it exists. */
  connectIfExists?: InputMaybe<WebsiteUniqueFilterInput>;
  /** Create a "Website" and connect it to an existing "Assignment" through the "Assignment.website" edge. */
  create?: InputMaybe<WebsiteCreationInput>;
  /** Create a "Website" if it does not exist, and connect it to an existing "Assignment" through the "Assignment.website" edge. */
  createIfNotExists?: InputMaybe<AssignmentUpdateWebsiteCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "Website", throw an error if the "Assignment.website" edge does not exist. */
  update?: InputMaybe<WebsiteUpdateInput>;
  /** Update the connected "Website", if the "Assignment.website" edge exists. */
  updateIfExists?: InputMaybe<WebsiteUpdateInput>;
};

export type AssignmentUpdateWebsiteCreateIfNotExistsInput = {
  data: WebsiteCreationInput;
  where: WebsiteUniqueFilterInput;
};

/** The "Website" node's update */
export type WebsiteUpdateInput = {
  assignments?: InputMaybe<WebsiteUpdateAssignmentsInput>;
  brand?: InputMaybe<WebsiteUpdateBrandInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type WebsiteUpdateAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutWebsiteInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<AssignmentFilterInput>;
  updateAll?: InputMaybe<AssignmentUpdateWithoutWebsiteInput>;
  updateMany?: InputMaybe<Array<WebsiteUpdateAssignmentsUpdateManyInput>>;
};

/** The "Assignment" node's update */
export type AssignmentUpdateWithoutWebsiteInput = {
  articleTemplate?: InputMaybe<AssignmentUpdateArticleTemplateInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentUpdatePrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentUpdatePrintIssueInput>;
  printPublication?: InputMaybe<AssignmentUpdatePrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentUpdatePrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentUpdateRawArticleInput>;
  subject?: InputMaybe<AssignmentUpdateSubjectInput>;
};

export type WebsiteUpdateAssignmentsUpdateManyInput = {
  data?: InputMaybe<AssignmentUpdateWithoutWebsiteInput>;
  where?: InputMaybe<AssignmentFilterInput>;
};

export type WebsiteUpdateBrandInput = {
  /** Connect a "Brand" to an existing "Website" through the "Website.brand" edge, throw an error if it does not exist. */
  connect?: InputMaybe<BrandUniqueFilterInput>;
  /** Create a "Brand" and connect it to an existing "Website" through the "Website.brand" edge. */
  create?: InputMaybe<BrandCreationInput>;
  /** Create a "Brand" if it does not exist, and connect it to an existing "Website" through the "Website.brand" edge. */
  createIfNotExists?: InputMaybe<WebsiteUpdateBrandCreateIfNotExistsInput>;
  /** Update the connected "Brand", throw an error if the "Website.brand" edge does not exist. */
  update?: InputMaybe<BrandUpdateInput>;
};

export type WebsiteUpdateBrandCreateIfNotExistsInput = {
  data: BrandCreationInput;
  where: BrandUniqueFilterInput;
};

/** The "Brand" node's update */
export type BrandUpdateInput = {
  printPublications?: InputMaybe<BrandUpdatePrintPublicationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<BrandUpdateUnitInput>;
  websites?: InputMaybe<BrandUpdateWebsitesInput>;
};

export type BrandUpdatePrintPublicationsInput = {
  create?: InputMaybe<Array<PrintPublicationCreationWithoutBrandInput>>;
  createIfNotExists?: InputMaybe<Array<BrandUpdatePrintPublicationsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<PrintPublicationUniqueFilterWithoutBrandInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<PrintPublicationUniqueFilterWithoutBrandInput>>;
  deleteMany?: InputMaybe<PrintPublicationFilterInput>;
  update?: InputMaybe<Array<BrandUpdatePrintPublicationsUpdateInput>>;
  updateAll?: InputMaybe<PrintPublicationUpdateWithoutBrandInput>;
  updateIfExists?: InputMaybe<Array<BrandUpdatePrintPublicationsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<BrandUpdatePrintPublicationsUpdateManyInput>>;
  upsert?: InputMaybe<Array<BrandUpdatePrintPublicationsUpsertInput>>;
};

export type BrandUpdatePrintPublicationsCreateIfNotExistsInput = {
  data: PrintPublicationCreationWithoutBrandInput;
  where: PrintPublicationUniqueFilterWithoutBrandInput;
};

/** Given a "brand", identifies exactly one "PrintPublication" by "legacyId" or "title" */
export type PrintPublicationUniqueFilterWithoutBrandInput = {
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUpdatePrintPublicationsUpdateInput = {
  data?: InputMaybe<PrintPublicationUpdateWithoutBrandInput>;
  where: PrintPublicationUniqueFilterWithoutBrandInput;
};

/** The "PrintPublication" node's update */
export type PrintPublicationUpdateWithoutBrandInput = {
  advertisements?: InputMaybe<PrintPublicationUpdateAdvertisementsInput>;
  assignments?: InputMaybe<PrintPublicationUpdateAssignmentsInput>;
  files?: InputMaybe<PrintPublicationUpdateFilesInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  layouts?: InputMaybe<PrintPublicationUpdateLayoutsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockups?: InputMaybe<PrintPublicationUpdateMockupsInput>;
  printHeadings?: InputMaybe<PrintPublicationUpdatePrintHeadingsInput>;
  printIssues?: InputMaybe<PrintPublicationUpdatePrintIssuesInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrintPublicationUpdateFilesInput = {
  create?: InputMaybe<Array<FileCreationWithoutPrintPublicationInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<FileFilterInput>;
  updateAll?: InputMaybe<FileUpdateWithoutPrintPublicationInput>;
  updateMany?: InputMaybe<Array<PrintPublicationUpdateFilesUpdateManyInput>>;
};

/** The "File" node's update */
export type FileUpdateWithoutPrintPublicationInput = {
  layoutAssets?: InputMaybe<FileUpdateLayoutAssetsInput>;
  printIssue?: InputMaybe<FileUpdatePrintIssueInput>;
  versions?: InputMaybe<FileUpdateVersionsInput>;
};

export type FileUpdatePrintIssueInput = {
  /** Connect a "PrintIssue" to an existing "File" through the "File.printIssue" edge, throw an error if it does not exist. */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Connect a "PrintIssue" to an existing "File" through the "File.printIssue" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to an existing "File" through the "File.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /** Create a "PrintIssue" if it does not exist, and connect it to an existing "File" through the "File.printIssue" edge. */
  createIfNotExists?: InputMaybe<FileUpdatePrintIssueCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintIssue", throw an error if the "File.printIssue" edge does not exist. */
  update?: InputMaybe<PrintIssueUpdateInput>;
  /** Update the connected "PrintIssue", if the "File.printIssue" edge exists. */
  updateIfExists?: InputMaybe<PrintIssueUpdateInput>;
};

export type FileUpdatePrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type FileUpdateVersionsInput = {
  create?: InputMaybe<Array<FileVersionCreationWithoutFileInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<FileVersionFilterInput>;
};

export type PrintPublicationUpdateFilesUpdateManyInput = {
  data?: InputMaybe<FileUpdateWithoutPrintPublicationInput>;
  where?: InputMaybe<FileFilterInput>;
};

export type PrintPublicationUpdateLayoutsInput = {
  create?: InputMaybe<Array<LayoutCreationWithoutPrintPublicationInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<LayoutFilterInput>;
  updateAll?: InputMaybe<LayoutUpdateWithoutPrintPublicationInput>;
  updateMany?: InputMaybe<Array<PrintPublicationUpdateLayoutsUpdateManyInput>>;
};

/** The "Layout" node's update */
export type LayoutUpdateWithoutPrintPublicationInput = {
  assets?: InputMaybe<LayoutUpdateAssetsInput>;
  /** The layouts that are based on this one */
  children?: InputMaybe<LayoutUpdateChildrenInput>;
  /** The layout this one is based on, if any */
  parent?: InputMaybe<LayoutUpdateParentInput>;
  printIssue?: InputMaybe<LayoutUpdatePrintIssueInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LayoutUpdateChildrenInput = {
  create?: InputMaybe<Array<LayoutCreationWithoutParentInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<LayoutFilterInput>;
  updateAll?: InputMaybe<LayoutUpdateWithoutParentInput>;
  updateMany?: InputMaybe<Array<LayoutUpdateChildrenUpdateManyInput>>;
};

/** The "Layout" node's update */
export type LayoutUpdateWithoutParentInput = {
  assets?: InputMaybe<LayoutUpdateAssetsInput>;
  /** The layouts that are based on this one */
  children?: InputMaybe<LayoutUpdateChildrenInput>;
  printIssue?: InputMaybe<LayoutUpdatePrintIssueInput>;
  printPublication?: InputMaybe<LayoutUpdatePrintPublicationInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LayoutUpdatePrintIssueInput = {
  /** Connect a "PrintIssue" to an existing "Layout" through the "Layout.printIssue" edge, throw an error if it does not exist. */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Connect a "PrintIssue" to an existing "Layout" through the "Layout.printIssue" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to an existing "Layout" through the "Layout.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /** Create a "PrintIssue" if it does not exist, and connect it to an existing "Layout" through the "Layout.printIssue" edge. */
  createIfNotExists?: InputMaybe<LayoutUpdatePrintIssueCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintIssue", throw an error if the "Layout.printIssue" edge does not exist. */
  update?: InputMaybe<PrintIssueUpdateInput>;
  /** Update the connected "PrintIssue", if the "Layout.printIssue" edge exists. */
  updateIfExists?: InputMaybe<PrintIssueUpdateInput>;
};

export type LayoutUpdatePrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type LayoutUpdatePrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to an existing "Layout" through the
   * "Layout.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to an existing "Layout" through the "Layout.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to an existing "Layout" through the "Layout.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to an
   * existing "Layout" through the "Layout.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<LayoutUpdatePrintPublicationCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintPublication", throw an error if the "Layout.printPublication" edge does not exist. */
  update?: InputMaybe<PrintPublicationUpdateInput>;
  /** Update the connected "PrintPublication", if the "Layout.printPublication" edge exists. */
  updateIfExists?: InputMaybe<PrintPublicationUpdateInput>;
};

export type LayoutUpdatePrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type LayoutUpdateChildrenUpdateManyInput = {
  data?: InputMaybe<LayoutUpdateWithoutParentInput>;
  where?: InputMaybe<LayoutFilterInput>;
};

export type LayoutUpdateParentInput = {
  /** Connect a "Layout" to an existing "Layout" through the "Layout.parent" edge, throw an error if it does not exist. */
  connect?: InputMaybe<LayoutUniqueFilterInput>;
  /** Connect a "Layout" to an existing "Layout" through the "Layout.parent" edge, if it exists. */
  connectIfExists?: InputMaybe<LayoutUniqueFilterInput>;
  /** Create a "Layout" and connect it to an existing "Layout" through the "Layout.parent" edge. */
  create?: InputMaybe<LayoutCreationInput>;
  /** Create a "Layout" if it does not exist, and connect it to an existing "Layout" through the "Layout.parent" edge. */
  createIfNotExists?: InputMaybe<LayoutUpdateParentCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "Layout", throw an error if the "Layout.parent" edge does not exist. */
  update?: InputMaybe<LayoutUpdateInput>;
  /** Update the connected "Layout", if the "Layout.parent" edge exists. */
  updateIfExists?: InputMaybe<LayoutUpdateInput>;
};

export type LayoutUpdateParentCreateIfNotExistsInput = {
  data: LayoutCreationInput;
  where: LayoutUniqueFilterInput;
};

export type PrintPublicationUpdateLayoutsUpdateManyInput = {
  data?: InputMaybe<LayoutUpdateWithoutPrintPublicationInput>;
  where?: InputMaybe<LayoutFilterInput>;
};

export type PrintPublicationUpdateMockupsInput = {
  create?: InputMaybe<Array<MockupCreationWithoutPrintPublicationInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<MockupFilterInput>;
  updateAll?: InputMaybe<MockupUpdateWithoutPrintPublicationInput>;
  updateMany?: InputMaybe<Array<PrintPublicationUpdateMockupsUpdateManyInput>>;
};

/** The "Mockup" node's update */
export type MockupUpdateWithoutPrintPublicationInput = {
  layoutAssets?: InputMaybe<MockupUpdateLayoutAssetsInput>;
  printHeading?: InputMaybe<MockupUpdatePrintHeadingInput>;
  printIssue?: InputMaybe<MockupUpdatePrintIssueInput>;
  versions?: InputMaybe<MockupUpdateVersionsInput>;
};

export type MockupUpdatePrintHeadingInput = {
  /**
   * Connect a "PrintHeading" to an existing "Mockup" through the
   * "Mockup.printHeading" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Connect a "PrintHeading" to an existing "Mockup" through the "Mockup.printHeading" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /** Create a "PrintHeading" and connect it to an existing "Mockup" through the "Mockup.printHeading" edge. */
  create?: InputMaybe<PrintHeadingCreationInput>;
  /**
   * Create a "PrintHeading" if it does not exist, and connect it to an existing
   * "Mockup" through the "Mockup.printHeading" edge.
   */
  createIfNotExists?: InputMaybe<MockupUpdatePrintHeadingCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintHeading", throw an error if the "Mockup.printHeading" edge does not exist. */
  update?: InputMaybe<PrintHeadingUpdateInput>;
  /** Update the connected "PrintHeading", if the "Mockup.printHeading" edge exists. */
  updateIfExists?: InputMaybe<PrintHeadingUpdateInput>;
};

export type MockupUpdatePrintHeadingCreateIfNotExistsInput = {
  data: PrintHeadingCreationInput;
  where: PrintHeadingUniqueFilterInput;
};

export type MockupUpdatePrintIssueInput = {
  /** Connect a "PrintIssue" to an existing "Mockup" through the "Mockup.printIssue" edge, throw an error if it does not exist. */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Connect a "PrintIssue" to an existing "Mockup" through the "Mockup.printIssue" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to an existing "Mockup" through the "Mockup.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /** Create a "PrintIssue" if it does not exist, and connect it to an existing "Mockup" through the "Mockup.printIssue" edge. */
  createIfNotExists?: InputMaybe<MockupUpdatePrintIssueCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintIssue", throw an error if the "Mockup.printIssue" edge does not exist. */
  update?: InputMaybe<PrintIssueUpdateInput>;
  /** Update the connected "PrintIssue", if the "Mockup.printIssue" edge exists. */
  updateIfExists?: InputMaybe<PrintIssueUpdateInput>;
};

export type MockupUpdatePrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type MockupUpdateVersionsInput = {
  create?: InputMaybe<Array<MockupVersionCreationWithoutMockupInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<MockupVersionFilterInput>;
};

export type PrintPublicationUpdateMockupsUpdateManyInput = {
  data?: InputMaybe<MockupUpdateWithoutPrintPublicationInput>;
  where?: InputMaybe<MockupFilterInput>;
};

export type PrintPublicationUpdatePrintHeadingsInput = {
  create?: InputMaybe<Array<PrintHeadingCreationWithoutPrintPublicationInput>>;
  createIfNotExists?: InputMaybe<Array<PrintPublicationUpdatePrintHeadingsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<PrintHeadingUniqueFilterWithoutPrintPublicationInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<PrintHeadingUniqueFilterWithoutPrintPublicationInput>>;
  deleteMany?: InputMaybe<PrintHeadingFilterInput>;
  update?: InputMaybe<Array<PrintPublicationUpdatePrintHeadingsUpdateInput>>;
  updateAll?: InputMaybe<PrintHeadingUpdateWithoutPrintPublicationInput>;
  updateIfExists?: InputMaybe<Array<PrintPublicationUpdatePrintHeadingsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<PrintPublicationUpdatePrintHeadingsUpdateManyInput>>;
  upsert?: InputMaybe<Array<PrintPublicationUpdatePrintHeadingsUpsertInput>>;
};

export type PrintPublicationUpdatePrintHeadingsCreateIfNotExistsInput = {
  data: PrintHeadingCreationWithoutPrintPublicationInput;
  where: PrintHeadingUniqueFilterWithoutPrintPublicationInput;
};

/** Given a "printPublication", identifies exactly one "PrintHeading" by "title" */
export type PrintHeadingUniqueFilterWithoutPrintPublicationInput = {
  title: Scalars['String']['input'];
};

export type PrintPublicationUpdatePrintHeadingsUpdateInput = {
  data?: InputMaybe<PrintHeadingUpdateWithoutPrintPublicationInput>;
  where: PrintHeadingUniqueFilterWithoutPrintPublicationInput;
};

/** The "PrintHeading" node's update */
export type PrintHeadingUpdateWithoutPrintPublicationInput = {
  assignments?: InputMaybe<PrintHeadingUpdateAssignmentsInput>;
  autoPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutomaticSubject?: InputMaybe<Scalars['Boolean']['input']>;
  layoutAssets?: InputMaybe<PrintHeadingUpdateLayoutAssetsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockup?: InputMaybe<PrintHeadingUpdateMockupInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssue?: InputMaybe<PrintHeadingUpdatePrintIssueInput>;
  printTemplates?: InputMaybe<PrintHeadingUpdatePrintTemplatesInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrintHeadingUpdateLayoutAssetsInput = {
  create?: InputMaybe<Array<LayoutAssetCreationWithoutPrintHeadingInput>>;
  createIfNotExists?: InputMaybe<Array<PrintHeadingUpdateLayoutAssetsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<LayoutAssetUniqueFilterWithoutPrintHeadingInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<LayoutAssetUniqueFilterWithoutPrintHeadingInput>>;
  deleteMany?: InputMaybe<LayoutAssetFilterInput>;
  update?: InputMaybe<Array<PrintHeadingUpdateLayoutAssetsUpdateInput>>;
  updateAll?: InputMaybe<LayoutAssetUpdateWithoutPrintHeadingInput>;
  updateIfExists?: InputMaybe<Array<PrintHeadingUpdateLayoutAssetsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<PrintHeadingUpdateLayoutAssetsUpdateManyInput>>;
  upsert?: InputMaybe<Array<PrintHeadingUpdateLayoutAssetsUpsertInput>>;
};

export type PrintHeadingUpdateLayoutAssetsCreateIfNotExistsInput = {
  data: LayoutAssetCreationWithoutPrintHeadingInput;
  where: LayoutAssetUniqueFilterWithoutPrintHeadingInput;
};

/** Given a "printHeading", identifies exactly one "LayoutAsset" by "layout" */
export type LayoutAssetUniqueFilterWithoutPrintHeadingInput = {
  layout: LayoutUniqueFilterInput;
};

export type PrintHeadingUpdateLayoutAssetsUpdateInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutPrintHeadingInput>;
  where: LayoutAssetUniqueFilterWithoutPrintHeadingInput;
};

/** The "LayoutAsset" node's update */
export type LayoutAssetUpdateWithoutPrintHeadingInput = {
  advertisement?: InputMaybe<LayoutAssetUpdateAdvertisementInput>;
  file?: InputMaybe<LayoutAssetUpdateFileInput>;
  layout?: InputMaybe<LayoutAssetUpdateLayoutInput>;
  mockup?: InputMaybe<LayoutAssetUpdateMockupInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type PrintHeadingUpdateLayoutAssetsUpdateIfExistsInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutPrintHeadingInput>;
  where: LayoutAssetUniqueFilterWithoutPrintHeadingInput;
};

export type PrintHeadingUpdateLayoutAssetsUpdateManyInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutPrintHeadingInput>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};

export type PrintHeadingUpdateLayoutAssetsUpsertInput = {
  create: LayoutAssetCreationWithoutPrintHeadingInput;
  update?: InputMaybe<LayoutAssetUpdateWithoutPrintHeadingInput>;
  where: LayoutAssetUniqueFilterWithoutPrintHeadingInput;
};

export type PrintHeadingUpdateMockupInput = {
  create?: InputMaybe<MockupCreationWithoutPrintHeadingInput>;
  createIfNotExists?: InputMaybe<MockupCreationWithoutPrintHeadingInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MockupUpdateWithoutPrintHeadingInput>;
  updateIfExists?: InputMaybe<MockupUpdateWithoutPrintHeadingInput>;
  upsert?: InputMaybe<PrintHeadingUpdateMockupUpsertInput>;
};

/** The "Mockup" node's update */
export type MockupUpdateWithoutPrintHeadingInput = {
  layoutAssets?: InputMaybe<MockupUpdateLayoutAssetsInput>;
  printIssue?: InputMaybe<MockupUpdatePrintIssueInput>;
  printPublication?: InputMaybe<MockupUpdatePrintPublicationInput>;
  versions?: InputMaybe<MockupUpdateVersionsInput>;
};

export type MockupUpdatePrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to an existing "Mockup" through the
   * "Mockup.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to an existing "Mockup" through the "Mockup.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to an existing "Mockup" through the "Mockup.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to an
   * existing "Mockup" through the "Mockup.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<MockupUpdatePrintPublicationCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintPublication", throw an error if the "Mockup.printPublication" edge does not exist. */
  update?: InputMaybe<PrintPublicationUpdateInput>;
  /** Update the connected "PrintPublication", if the "Mockup.printPublication" edge exists. */
  updateIfExists?: InputMaybe<PrintPublicationUpdateInput>;
};

export type MockupUpdatePrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type PrintHeadingUpdateMockupUpsertInput = {
  create: MockupCreationWithoutPrintHeadingInput;
  update?: InputMaybe<MockupUpdateWithoutPrintHeadingInput>;
};

export type PrintHeadingUpdatePrintIssueInput = {
  /**
   * Connect a "PrintIssue" to an existing "PrintHeading" through the
   * "PrintHeading.printIssue" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to an existing "PrintHeading" through the "PrintHeading.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /**
   * Create a "PrintIssue" if it does not exist, and connect it to an existing
   * "PrintHeading" through the "PrintHeading.printIssue" edge.
   */
  createIfNotExists?: InputMaybe<PrintHeadingUpdatePrintIssueCreateIfNotExistsInput>;
  /** Update the connected "PrintIssue", throw an error if the "PrintHeading.printIssue" edge does not exist. */
  update?: InputMaybe<PrintIssueUpdateInput>;
};

export type PrintHeadingUpdatePrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

export type PrintHeadingUpdatePrintTemplatesInput = {
  create?: InputMaybe<Array<PrintHeadingPrintTemplateCreationWithoutPrintHeadingInput>>;
  createIfNotExists?: InputMaybe<Array<PrintHeadingUpdatePrintTemplatesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<PrintHeadingPrintTemplateUniqueFilterWithoutPrintHeadingInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<PrintHeadingPrintTemplateUniqueFilterWithoutPrintHeadingInput>>;
  deleteMany?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  update?: InputMaybe<Array<PrintHeadingUpdatePrintTemplatesUpdateInput>>;
  updateAll?: InputMaybe<PrintHeadingPrintTemplateUpdateWithoutPrintHeadingInput>;
  updateIfExists?: InputMaybe<Array<PrintHeadingUpdatePrintTemplatesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<PrintHeadingUpdatePrintTemplatesUpdateManyInput>>;
  upsert?: InputMaybe<Array<PrintHeadingUpdatePrintTemplatesUpsertInput>>;
};

export type PrintHeadingUpdatePrintTemplatesCreateIfNotExistsInput = {
  data: PrintHeadingPrintTemplateCreationWithoutPrintHeadingInput;
  where: PrintHeadingPrintTemplateUniqueFilterWithoutPrintHeadingInput;
};

/** Given a "printHeading", identifies exactly one "PrintHeadingPrintTemplate" by "printTemplate" */
export type PrintHeadingPrintTemplateUniqueFilterWithoutPrintHeadingInput = {
  printTemplate: PrintTemplateUniqueFilterInput;
};

export type PrintHeadingUpdatePrintTemplatesUpdateInput = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateWithoutPrintHeadingInput>;
  where: PrintHeadingPrintTemplateUniqueFilterWithoutPrintHeadingInput;
};

/** The "PrintHeadingPrintTemplate" node's update */
export type PrintHeadingPrintTemplateUpdateWithoutPrintHeadingInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  printTemplate?: InputMaybe<PrintHeadingPrintTemplateUpdatePrintTemplateInput>;
};

export type PrintHeadingPrintTemplateUpdatePrintTemplateInput = {
  /**
   * Connect a "PrintTemplate" to an existing "PrintHeadingPrintTemplate" through
   * the "PrintHeadingPrintTemplate.printTemplate" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintTemplateUniqueFilterInput>;
  /**
   * Create a "PrintTemplate" and connect it to an existing
   * "PrintHeadingPrintTemplate" through the
   * "PrintHeadingPrintTemplate.printTemplate" edge.
   */
  create?: InputMaybe<PrintTemplateCreationInput>;
  /**
   * Create a "PrintTemplate" if it does not exist, and connect it to an existing
   * "PrintHeadingPrintTemplate" through the
   * "PrintHeadingPrintTemplate.printTemplate" edge.
   */
  createIfNotExists?: InputMaybe<PrintHeadingPrintTemplateUpdatePrintTemplateCreateIfNotExistsInput>;
  /** Update the connected "PrintTemplate", throw an error if the "PrintHeadingPrintTemplate.printTemplate" edge does not exist. */
  update?: InputMaybe<PrintTemplateUpdateInput>;
};

export type PrintHeadingPrintTemplateUpdatePrintTemplateCreateIfNotExistsInput = {
  data: PrintTemplateCreationInput;
  where: PrintTemplateUniqueFilterInput;
};

export type PrintHeadingUpdatePrintTemplatesUpdateIfExistsInput = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateWithoutPrintHeadingInput>;
  where: PrintHeadingPrintTemplateUniqueFilterWithoutPrintHeadingInput;
};

export type PrintHeadingUpdatePrintTemplatesUpdateManyInput = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateWithoutPrintHeadingInput>;
  where?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
};

export type PrintHeadingUpdatePrintTemplatesUpsertInput = {
  create: PrintHeadingPrintTemplateCreationWithoutPrintHeadingInput;
  update?: InputMaybe<PrintHeadingPrintTemplateUpdateWithoutPrintHeadingInput>;
  where: PrintHeadingPrintTemplateUniqueFilterWithoutPrintHeadingInput;
};

export type PrintPublicationUpdatePrintHeadingsUpdateIfExistsInput = {
  data?: InputMaybe<PrintHeadingUpdateWithoutPrintPublicationInput>;
  where: PrintHeadingUniqueFilterWithoutPrintPublicationInput;
};

export type PrintPublicationUpdatePrintHeadingsUpdateManyInput = {
  data?: InputMaybe<PrintHeadingUpdateWithoutPrintPublicationInput>;
  where?: InputMaybe<PrintHeadingFilterInput>;
};

export type PrintPublicationUpdatePrintHeadingsUpsertInput = {
  create: PrintHeadingCreationWithoutPrintPublicationInput;
  update?: InputMaybe<PrintHeadingUpdateWithoutPrintPublicationInput>;
  where: PrintHeadingUniqueFilterWithoutPrintPublicationInput;
};

export type PrintPublicationUpdatePrintIssuesInput = {
  create?: InputMaybe<Array<PrintIssueCreationWithoutPrintPublicationInput>>;
  createIfNotExists?: InputMaybe<Array<PrintPublicationUpdatePrintIssuesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<PrintIssueUniqueFilterWithoutPrintPublicationInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<PrintIssueUniqueFilterWithoutPrintPublicationInput>>;
  deleteMany?: InputMaybe<PrintIssueFilterInput>;
  update?: InputMaybe<Array<PrintPublicationUpdatePrintIssuesUpdateInput>>;
  updateAll?: InputMaybe<PrintIssueUpdateWithoutPrintPublicationInput>;
  updateIfExists?: InputMaybe<Array<PrintPublicationUpdatePrintIssuesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<PrintPublicationUpdatePrintIssuesUpdateManyInput>>;
  upsert?: InputMaybe<Array<PrintPublicationUpdatePrintIssuesUpsertInput>>;
};

export type PrintPublicationUpdatePrintIssuesCreateIfNotExistsInput = {
  data: PrintIssueCreationWithoutPrintPublicationInput;
  where: PrintIssueUniqueFilterWithoutPrintPublicationInput;
};

/** Given a "printPublication", identifies exactly one "PrintIssue" by "legacyId" or "title" */
export type PrintIssueUniqueFilterWithoutPrintPublicationInput = {
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrintPublicationUpdatePrintIssuesUpdateInput = {
  data?: InputMaybe<PrintIssueUpdateWithoutPrintPublicationInput>;
  where: PrintIssueUniqueFilterWithoutPrintPublicationInput;
};

/** The "PrintIssue" node's update */
export type PrintIssueUpdateWithoutPrintPublicationInput = {
  advertisements?: InputMaybe<PrintIssueUpdateAdvertisementsInput>;
  assignments?: InputMaybe<PrintIssueUpdateAssignmentsInput>;
  files?: InputMaybe<PrintIssueUpdateFilesInput>;
  layouts?: InputMaybe<PrintIssueUpdateLayoutsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockups?: InputMaybe<PrintIssueUpdateMockupsInput>;
  printHeadings?: InputMaybe<PrintIssueUpdatePrintHeadingsInput>;
  printIssueRailroad?: InputMaybe<PrintIssueUpdatePrintIssueRailroadInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrintIssueUpdateAssignmentsInput = {
  create?: InputMaybe<Array<AssignmentCreationWithoutPrintIssueInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<AssignmentFilterInput>;
  updateAll?: InputMaybe<AssignmentUpdateWithoutPrintIssueInput>;
  updateMany?: InputMaybe<Array<PrintIssueUpdateAssignmentsUpdateManyInput>>;
};

/** The "Assignment" node's update */
export type AssignmentUpdateWithoutPrintIssueInput = {
  articleTemplate?: InputMaybe<AssignmentUpdateArticleTemplateInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentUpdatePrintHeadingInput>;
  printPublication?: InputMaybe<AssignmentUpdatePrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentUpdatePrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentUpdateRawArticleInput>;
  subject?: InputMaybe<AssignmentUpdateSubjectInput>;
  website?: InputMaybe<AssignmentUpdateWebsiteInput>;
};

export type PrintIssueUpdateAssignmentsUpdateManyInput = {
  data?: InputMaybe<AssignmentUpdateWithoutPrintIssueInput>;
  where?: InputMaybe<AssignmentFilterInput>;
};

export type PrintIssueUpdateFilesInput = {
  create?: InputMaybe<Array<FileCreationWithoutPrintIssueInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<FileFilterInput>;
  updateAll?: InputMaybe<FileUpdateWithoutPrintIssueInput>;
  updateMany?: InputMaybe<Array<PrintIssueUpdateFilesUpdateManyInput>>;
};

/** The "File" node's update */
export type FileUpdateWithoutPrintIssueInput = {
  layoutAssets?: InputMaybe<FileUpdateLayoutAssetsInput>;
  printPublication?: InputMaybe<FileUpdatePrintPublicationInput>;
  versions?: InputMaybe<FileUpdateVersionsInput>;
};

export type FileUpdatePrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to an existing "File" through the
   * "File.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to an existing "File" through the "File.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to an existing "File" through the "File.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to an
   * existing "File" through the "File.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<FileUpdatePrintPublicationCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintPublication", throw an error if the "File.printPublication" edge does not exist. */
  update?: InputMaybe<PrintPublicationUpdateInput>;
  /** Update the connected "PrintPublication", if the "File.printPublication" edge exists. */
  updateIfExists?: InputMaybe<PrintPublicationUpdateInput>;
};

export type FileUpdatePrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type PrintIssueUpdateFilesUpdateManyInput = {
  data?: InputMaybe<FileUpdateWithoutPrintIssueInput>;
  where?: InputMaybe<FileFilterInput>;
};

export type PrintIssueUpdateLayoutsInput = {
  create?: InputMaybe<Array<LayoutCreationWithoutPrintIssueInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<LayoutFilterInput>;
  updateAll?: InputMaybe<LayoutUpdateWithoutPrintIssueInput>;
  updateMany?: InputMaybe<Array<PrintIssueUpdateLayoutsUpdateManyInput>>;
};

/** The "Layout" node's update */
export type LayoutUpdateWithoutPrintIssueInput = {
  assets?: InputMaybe<LayoutUpdateAssetsInput>;
  /** The layouts that are based on this one */
  children?: InputMaybe<LayoutUpdateChildrenInput>;
  /** The layout this one is based on, if any */
  parent?: InputMaybe<LayoutUpdateParentInput>;
  printPublication?: InputMaybe<LayoutUpdatePrintPublicationInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrintIssueUpdateLayoutsUpdateManyInput = {
  data?: InputMaybe<LayoutUpdateWithoutPrintIssueInput>;
  where?: InputMaybe<LayoutFilterInput>;
};

export type PrintIssueUpdateMockupsInput = {
  create?: InputMaybe<Array<MockupCreationWithoutPrintIssueInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<MockupFilterInput>;
  updateAll?: InputMaybe<MockupUpdateWithoutPrintIssueInput>;
  updateMany?: InputMaybe<Array<PrintIssueUpdateMockupsUpdateManyInput>>;
};

/** The "Mockup" node's update */
export type MockupUpdateWithoutPrintIssueInput = {
  layoutAssets?: InputMaybe<MockupUpdateLayoutAssetsInput>;
  printHeading?: InputMaybe<MockupUpdatePrintHeadingInput>;
  printPublication?: InputMaybe<MockupUpdatePrintPublicationInput>;
  versions?: InputMaybe<MockupUpdateVersionsInput>;
};

export type PrintIssueUpdateMockupsUpdateManyInput = {
  data?: InputMaybe<MockupUpdateWithoutPrintIssueInput>;
  where?: InputMaybe<MockupFilterInput>;
};

export type PrintIssueUpdatePrintHeadingsInput = {
  create?: InputMaybe<Array<PrintHeadingCreationWithoutPrintIssueInput>>;
  createIfNotExists?: InputMaybe<Array<PrintIssueUpdatePrintHeadingsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<PrintHeadingUniqueFilterWithoutPrintIssueInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<PrintHeadingUniqueFilterWithoutPrintIssueInput>>;
  deleteMany?: InputMaybe<PrintHeadingFilterInput>;
  update?: InputMaybe<Array<PrintIssueUpdatePrintHeadingsUpdateInput>>;
  updateAll?: InputMaybe<PrintHeadingUpdateWithoutPrintIssueInput>;
  updateIfExists?: InputMaybe<Array<PrintIssueUpdatePrintHeadingsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<PrintIssueUpdatePrintHeadingsUpdateManyInput>>;
  upsert?: InputMaybe<Array<PrintIssueUpdatePrintHeadingsUpsertInput>>;
};

export type PrintIssueUpdatePrintHeadingsCreateIfNotExistsInput = {
  data: PrintHeadingCreationWithoutPrintIssueInput;
  where: PrintHeadingUniqueFilterWithoutPrintIssueInput;
};

/** Given a "printIssue", identifies exactly one "PrintHeading" by "legacyId" or "title" */
export type PrintHeadingUniqueFilterWithoutPrintIssueInput = {
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrintIssueUpdatePrintHeadingsUpdateInput = {
  data?: InputMaybe<PrintHeadingUpdateWithoutPrintIssueInput>;
  where: PrintHeadingUniqueFilterWithoutPrintIssueInput;
};

/** The "PrintHeading" node's update */
export type PrintHeadingUpdateWithoutPrintIssueInput = {
  assignments?: InputMaybe<PrintHeadingUpdateAssignmentsInput>;
  autoPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutomaticSubject?: InputMaybe<Scalars['Boolean']['input']>;
  layoutAssets?: InputMaybe<PrintHeadingUpdateLayoutAssetsInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mockup?: InputMaybe<PrintHeadingUpdateMockupInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printPublication?: InputMaybe<PrintHeadingUpdatePrintPublicationInput>;
  printTemplates?: InputMaybe<PrintHeadingUpdatePrintTemplatesInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrintHeadingUpdatePrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to an existing "PrintHeading" through the
   * "PrintHeading.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Connect a "PrintPublication" to an existing "PrintHeading" through the "PrintHeading.printPublication" edge, if it exists. */
  connectIfExists?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to an existing "PrintHeading" through the "PrintHeading.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to an
   * existing "PrintHeading" through the "PrintHeading.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<PrintHeadingUpdatePrintPublicationCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "PrintPublication", throw an error if the "PrintHeading.printPublication" edge does not exist. */
  update?: InputMaybe<PrintPublicationUpdateInput>;
  /** Update the connected "PrintPublication", if the "PrintHeading.printPublication" edge exists. */
  updateIfExists?: InputMaybe<PrintPublicationUpdateInput>;
};

export type PrintHeadingUpdatePrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type PrintIssueUpdatePrintHeadingsUpdateIfExistsInput = {
  data?: InputMaybe<PrintHeadingUpdateWithoutPrintIssueInput>;
  where: PrintHeadingUniqueFilterWithoutPrintIssueInput;
};

export type PrintIssueUpdatePrintHeadingsUpdateManyInput = {
  data?: InputMaybe<PrintHeadingUpdateWithoutPrintIssueInput>;
  where?: InputMaybe<PrintHeadingFilterInput>;
};

export type PrintIssueUpdatePrintHeadingsUpsertInput = {
  create: PrintHeadingCreationWithoutPrintIssueInput;
  update?: InputMaybe<PrintHeadingUpdateWithoutPrintIssueInput>;
  where: PrintHeadingUniqueFilterWithoutPrintIssueInput;
};

export type PrintIssueUpdatePrintIssueRailroadInput = {
  create?: InputMaybe<PrintIssueRailroadCreationWithoutPrintIssueInput>;
  createIfNotExists?: InputMaybe<PrintIssueRailroadCreationWithoutPrintIssueInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<PrintIssueRailroadUpdateWithoutPrintIssueInput>;
  updateIfExists?: InputMaybe<PrintIssueRailroadUpdateWithoutPrintIssueInput>;
  upsert?: InputMaybe<PrintIssueUpdatePrintIssueRailroadUpsertInput>;
};

/** The "PrintIssueRailroad" node's update */
export type PrintIssueRailroadUpdateWithoutPrintIssueInput = {
  censhareCreationDate?: InputMaybe<Scalars['DateTime']['input']>;
  censhareUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  railroadPages?: InputMaybe<PrintIssueRailroadUpdateRailroadPagesInput>;
};

export type PrintIssueRailroadUpdateRailroadPagesInput = {
  create?: InputMaybe<Array<RailroadPageCreationWithoutPrintIssueRailroadInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<RailroadPageFilterInput>;
  updateAll?: InputMaybe<RailroadPageUpdateWithoutPrintIssueRailroadInput>;
  updateMany?: InputMaybe<Array<PrintIssueRailroadUpdateRailroadPagesUpdateManyInput>>;
};

/** The "RailroadPage" node's update */
export type RailroadPageUpdateWithoutPrintIssueRailroadInput = {
  indesignFilename?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['UnsignedInt']['input']>;
  visual?: InputMaybe<Scalars['String']['input']>;
  workflowName?: InputMaybe<Scalars['String']['input']>;
  workflowStage?: InputMaybe<Scalars['String']['input']>;
};

export type PrintIssueRailroadUpdateRailroadPagesUpdateManyInput = {
  data?: InputMaybe<RailroadPageUpdateWithoutPrintIssueRailroadInput>;
  where?: InputMaybe<RailroadPageFilterInput>;
};

export type PrintIssueUpdatePrintIssueRailroadUpsertInput = {
  create: PrintIssueRailroadCreationWithoutPrintIssueInput;
  update?: InputMaybe<PrintIssueRailroadUpdateWithoutPrintIssueInput>;
};

export type PrintPublicationUpdatePrintIssuesUpdateIfExistsInput = {
  data?: InputMaybe<PrintIssueUpdateWithoutPrintPublicationInput>;
  where: PrintIssueUniqueFilterWithoutPrintPublicationInput;
};

export type PrintPublicationUpdatePrintIssuesUpdateManyInput = {
  data?: InputMaybe<PrintIssueUpdateWithoutPrintPublicationInput>;
  where?: InputMaybe<PrintIssueFilterInput>;
};

export type PrintPublicationUpdatePrintIssuesUpsertInput = {
  create: PrintIssueCreationWithoutPrintPublicationInput;
  update?: InputMaybe<PrintIssueUpdateWithoutPrintPublicationInput>;
  where: PrintIssueUniqueFilterWithoutPrintPublicationInput;
};

export type BrandUpdatePrintPublicationsUpdateIfExistsInput = {
  data?: InputMaybe<PrintPublicationUpdateWithoutBrandInput>;
  where: PrintPublicationUniqueFilterWithoutBrandInput;
};

export type BrandUpdatePrintPublicationsUpdateManyInput = {
  data?: InputMaybe<PrintPublicationUpdateWithoutBrandInput>;
  where?: InputMaybe<PrintPublicationFilterInput>;
};

export type BrandUpdatePrintPublicationsUpsertInput = {
  create: PrintPublicationCreationWithoutBrandInput;
  update?: InputMaybe<PrintPublicationUpdateWithoutBrandInput>;
  where: PrintPublicationUniqueFilterWithoutBrandInput;
};

export type BrandUpdateUnitInput = {
  /** Connect a "Unit" to an existing "Brand" through the "Brand.unit" edge, throw an error if it does not exist. */
  connect?: InputMaybe<UnitUniqueFilterInput>;
  /** Create a "Unit" and connect it to an existing "Brand" through the "Brand.unit" edge. */
  create?: InputMaybe<UnitCreationInput>;
  /** Create a "Unit" if it does not exist, and connect it to an existing "Brand" through the "Brand.unit" edge. */
  createIfNotExists?: InputMaybe<BrandUpdateUnitCreateIfNotExistsInput>;
  /** Update the connected "Unit", throw an error if the "Brand.unit" edge does not exist. */
  update?: InputMaybe<UnitUpdateInput>;
};

export type BrandUpdateUnitCreateIfNotExistsInput = {
  data: UnitCreationInput;
  where: UnitUniqueFilterInput;
};

/** The "Unit" node's update */
export type UnitUpdateInput = {
  brands?: InputMaybe<UnitUpdateBrandsInput>;
  subjectCategories?: InputMaybe<UnitUpdateSubjectCategoriesInput>;
  subjects?: InputMaybe<UnitUpdateSubjectsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UnitUpdateBrandsInput = {
  create?: InputMaybe<Array<BrandCreationWithoutUnitInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<BrandFilterInput>;
  updateAll?: InputMaybe<BrandUpdateWithoutUnitInput>;
  updateMany?: InputMaybe<Array<UnitUpdateBrandsUpdateManyInput>>;
};

/** The "Brand" node's update */
export type BrandUpdateWithoutUnitInput = {
  printPublications?: InputMaybe<BrandUpdatePrintPublicationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  websites?: InputMaybe<BrandUpdateWebsitesInput>;
};

export type BrandUpdateWebsitesInput = {
  create?: InputMaybe<Array<WebsiteCreationWithoutBrandInput>>;
  createIfNotExists?: InputMaybe<Array<BrandUpdateWebsitesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<WebsiteUniqueFilterWithoutBrandInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<WebsiteUniqueFilterWithoutBrandInput>>;
  deleteMany?: InputMaybe<WebsiteFilterInput>;
  update?: InputMaybe<Array<BrandUpdateWebsitesUpdateInput>>;
  updateAll?: InputMaybe<WebsiteUpdateWithoutBrandInput>;
  updateIfExists?: InputMaybe<Array<BrandUpdateWebsitesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<BrandUpdateWebsitesUpdateManyInput>>;
  upsert?: InputMaybe<Array<BrandUpdateWebsitesUpsertInput>>;
};

export type BrandUpdateWebsitesCreateIfNotExistsInput = {
  data: WebsiteCreationWithoutBrandInput;
  where: WebsiteUniqueFilterWithoutBrandInput;
};

/** Given a "brand", identifies exactly one "Website" by "legacyId" or "title" */
export type WebsiteUniqueFilterWithoutBrandInput = {
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUpdateWebsitesUpdateInput = {
  data?: InputMaybe<WebsiteUpdateWithoutBrandInput>;
  where: WebsiteUniqueFilterWithoutBrandInput;
};

/** The "Website" node's update */
export type WebsiteUpdateWithoutBrandInput = {
  assignments?: InputMaybe<WebsiteUpdateAssignmentsInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BrandUpdateWebsitesUpdateIfExistsInput = {
  data?: InputMaybe<WebsiteUpdateWithoutBrandInput>;
  where: WebsiteUniqueFilterWithoutBrandInput;
};

export type BrandUpdateWebsitesUpdateManyInput = {
  data?: InputMaybe<WebsiteUpdateWithoutBrandInput>;
  where?: InputMaybe<WebsiteFilterInput>;
};

export type BrandUpdateWebsitesUpsertInput = {
  create: WebsiteCreationWithoutBrandInput;
  update?: InputMaybe<WebsiteUpdateWithoutBrandInput>;
  where: WebsiteUniqueFilterWithoutBrandInput;
};

export type UnitUpdateBrandsUpdateManyInput = {
  data?: InputMaybe<BrandUpdateWithoutUnitInput>;
  where?: InputMaybe<BrandFilterInput>;
};

export type UnitUpdateSubjectCategoriesInput = {
  create?: InputMaybe<Array<SubjectCategoryCreationWithoutUnitInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<SubjectCategoryFilterInput>;
  updateAll?: InputMaybe<SubjectCategoryUpdateWithoutUnitInput>;
  updateMany?: InputMaybe<Array<UnitUpdateSubjectCategoriesUpdateManyInput>>;
};

/** The "SubjectCategory" node's update */
export type SubjectCategoryUpdateWithoutUnitInput = {
  /** This category's children */
  children?: InputMaybe<SubjectCategoryUpdateChildrenInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  parent?: InputMaybe<SubjectCategoryUpdateParentInput>;
  subjects?: InputMaybe<SubjectCategoryUpdateSubjectsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectCategoryUpdateChildrenInput = {
  create?: InputMaybe<Array<SubjectCategoryCreationWithoutParentInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<SubjectCategoryFilterInput>;
  updateAll?: InputMaybe<SubjectCategoryUpdateWithoutParentInput>;
  updateMany?: InputMaybe<Array<SubjectCategoryUpdateChildrenUpdateManyInput>>;
};

/** The "SubjectCategory" node's update */
export type SubjectCategoryUpdateWithoutParentInput = {
  /** This category's children */
  children?: InputMaybe<SubjectCategoryUpdateChildrenInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  subjects?: InputMaybe<SubjectCategoryUpdateSubjectsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<SubjectCategoryUpdateUnitInput>;
};

export type SubjectCategoryUpdateSubjectsInput = {
  create?: InputMaybe<Array<SubjectCreationWithoutSubjectCategoryInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<SubjectFilterInput>;
  updateAll?: InputMaybe<SubjectUpdateWithoutSubjectCategoryInput>;
  updateMany?: InputMaybe<Array<SubjectCategoryUpdateSubjectsUpdateManyInput>>;
};

/** The "Subject" node's update */
export type SubjectUpdateWithoutSubjectCategoryInput = {
  assignments?: InputMaybe<SubjectUpdateAssignmentsInput>;
  attachments?: InputMaybe<SubjectUpdateAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isAuto?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaRequest?: InputMaybe<Scalars['String']['input']>;
  subjectUsers?: InputMaybe<SubjectUpdateSubjectUsersInput>;
  subSubjects?: InputMaybe<SubjectUpdateSubSubjectsInput>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<SubjectUpdateUnitInput>;
};

export type SubjectUpdateAttachmentsInput = {
  create?: InputMaybe<Array<AttachmentCreationWithoutSubjectInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<AttachmentFilterInput>;
  updateAll?: InputMaybe<AttachmentUpdateWithoutSubjectInput>;
  updateMany?: InputMaybe<Array<SubjectUpdateAttachmentsUpdateManyInput>>;
};

/** The "Attachment" node's update */
export type AttachmentUpdateWithoutSubjectInput = {
  /** update from S3 */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** update from S3 */
  etag?: InputMaybe<Scalars['String']['input']>;
  /** sent from the front */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** update from S3 */
  filesize?: InputMaybe<Scalars['UnsignedInt']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** update from S3 */
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectUpdateAttachmentsUpdateManyInput = {
  data?: InputMaybe<AttachmentUpdateWithoutSubjectInput>;
  where?: InputMaybe<AttachmentFilterInput>;
};

export type SubjectUpdateSubjectUsersInput = {
  create?: InputMaybe<Array<SubjectUserCreationWithoutSubjectInput>>;
  createIfNotExists?: InputMaybe<Array<SubjectUpdateSubjectUsersCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<SubjectUserUniqueFilterWithoutSubjectInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<SubjectUserUniqueFilterWithoutSubjectInput>>;
  deleteMany?: InputMaybe<SubjectUserFilterInput>;
};

export type SubjectUpdateSubjectUsersCreateIfNotExistsInput = {
  data: SubjectUserCreationWithoutSubjectInput;
  where: SubjectUserUniqueFilterWithoutSubjectInput;
};

/** Given a "subject", identifies exactly one "SubjectUser" by "userId" */
export type SubjectUserUniqueFilterWithoutSubjectInput = {
  userId: Scalars['UUIDv4']['input'];
};

export type SubjectUpdateSubSubjectsInput = {
  create?: InputMaybe<Array<SubSubjectCreationWithoutSubjectInput>>;
  createIfNotExists?: InputMaybe<Array<SubjectUpdateSubSubjectsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<SubSubjectUniqueFilterWithoutSubjectInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<SubSubjectUniqueFilterWithoutSubjectInput>>;
  deleteMany?: InputMaybe<SubSubjectFilterInput>;
  update?: InputMaybe<Array<SubjectUpdateSubSubjectsUpdateInput>>;
  updateAll?: InputMaybe<SubSubjectUpdateWithoutSubjectInput>;
  updateIfExists?: InputMaybe<Array<SubjectUpdateSubSubjectsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<SubjectUpdateSubSubjectsUpdateManyInput>>;
  upsert?: InputMaybe<Array<SubjectUpdateSubSubjectsUpsertInput>>;
};

export type SubjectUpdateSubSubjectsCreateIfNotExistsInput = {
  data: SubSubjectCreationWithoutSubjectInput;
  where: SubSubjectUniqueFilterWithoutSubjectInput;
};

/** Given a "subject", identifies exactly one "SubSubject" by "title" */
export type SubSubjectUniqueFilterWithoutSubjectInput = {
  title: Scalars['String']['input'];
};

export type SubjectUpdateSubSubjectsUpdateInput = {
  data?: InputMaybe<SubSubjectUpdateWithoutSubjectInput>;
  where: SubSubjectUniqueFilterWithoutSubjectInput;
};

/** The "SubSubject" node's update */
export type SubSubjectUpdateWithoutSubjectInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectUpdateSubSubjectsUpdateIfExistsInput = {
  data?: InputMaybe<SubSubjectUpdateWithoutSubjectInput>;
  where: SubSubjectUniqueFilterWithoutSubjectInput;
};

export type SubjectUpdateSubSubjectsUpdateManyInput = {
  data?: InputMaybe<SubSubjectUpdateWithoutSubjectInput>;
  where?: InputMaybe<SubSubjectFilterInput>;
};

export type SubjectUpdateSubSubjectsUpsertInput = {
  create: SubSubjectCreationWithoutSubjectInput;
  update?: InputMaybe<SubSubjectUpdateWithoutSubjectInput>;
  where: SubSubjectUniqueFilterWithoutSubjectInput;
};

export type SubjectUpdateUnitInput = {
  /** Connect a "Unit" to an existing "Subject" through the "Subject.unit" edge, throw an error if it does not exist. */
  connect?: InputMaybe<UnitUniqueFilterInput>;
  /** Create a "Unit" and connect it to an existing "Subject" through the "Subject.unit" edge. */
  create?: InputMaybe<UnitCreationInput>;
  /** Create a "Unit" if it does not exist, and connect it to an existing "Subject" through the "Subject.unit" edge. */
  createIfNotExists?: InputMaybe<SubjectUpdateUnitCreateIfNotExistsInput>;
  /** Update the connected "Unit", throw an error if the "Subject.unit" edge does not exist. */
  update?: InputMaybe<UnitUpdateInput>;
};

export type SubjectUpdateUnitCreateIfNotExistsInput = {
  data: UnitCreationInput;
  where: UnitUniqueFilterInput;
};

export type SubjectCategoryUpdateSubjectsUpdateManyInput = {
  data?: InputMaybe<SubjectUpdateWithoutSubjectCategoryInput>;
  where?: InputMaybe<SubjectFilterInput>;
};

export type SubjectCategoryUpdateUnitInput = {
  /**
   * Connect a "Unit" to an existing "SubjectCategory" through the
   * "SubjectCategory.unit" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<UnitUniqueFilterInput>;
  /** Create a "Unit" and connect it to an existing "SubjectCategory" through the "SubjectCategory.unit" edge. */
  create?: InputMaybe<UnitCreationInput>;
  /**
   * Create a "Unit" if it does not exist, and connect it to an existing
   * "SubjectCategory" through the "SubjectCategory.unit" edge.
   */
  createIfNotExists?: InputMaybe<SubjectCategoryUpdateUnitCreateIfNotExistsInput>;
  /** Update the connected "Unit", throw an error if the "SubjectCategory.unit" edge does not exist. */
  update?: InputMaybe<UnitUpdateInput>;
};

export type SubjectCategoryUpdateUnitCreateIfNotExistsInput = {
  data: UnitCreationInput;
  where: UnitUniqueFilterInput;
};

export type SubjectCategoryUpdateChildrenUpdateManyInput = {
  data?: InputMaybe<SubjectCategoryUpdateWithoutParentInput>;
  where?: InputMaybe<SubjectCategoryFilterInput>;
};

export type SubjectCategoryUpdateParentInput = {
  /**
   * Connect a "SubjectCategory" to an existing "SubjectCategory" through the
   * "SubjectCategory.parent" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<SubjectCategoryUniqueFilterInput>;
  /** Connect a "SubjectCategory" to an existing "SubjectCategory" through the "SubjectCategory.parent" edge, if it exists. */
  connectIfExists?: InputMaybe<SubjectCategoryUniqueFilterInput>;
  /** Create a "SubjectCategory" and connect it to an existing "SubjectCategory" through the "SubjectCategory.parent" edge. */
  create?: InputMaybe<SubjectCategoryCreationInput>;
  /**
   * Create a "SubjectCategory" if it does not exist, and connect it to an existing
   * "SubjectCategory" through the "SubjectCategory.parent" edge.
   */
  createIfNotExists?: InputMaybe<SubjectCategoryUpdateParentCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "SubjectCategory", throw an error if the "SubjectCategory.parent" edge does not exist. */
  update?: InputMaybe<SubjectCategoryUpdateInput>;
  /** Update the connected "SubjectCategory", if the "SubjectCategory.parent" edge exists. */
  updateIfExists?: InputMaybe<SubjectCategoryUpdateInput>;
};

export type SubjectCategoryUpdateParentCreateIfNotExistsInput = {
  data: SubjectCategoryCreationInput;
  where: SubjectCategoryUniqueFilterInput;
};

/** The "SubjectCategory" node's update */
export type SubjectCategoryUpdateInput = {
  /** This category's children */
  children?: InputMaybe<SubjectCategoryUpdateChildrenInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  parent?: InputMaybe<SubjectCategoryUpdateParentInput>;
  subjects?: InputMaybe<SubjectCategoryUpdateSubjectsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<SubjectCategoryUpdateUnitInput>;
};

export type UnitUpdateSubjectCategoriesUpdateManyInput = {
  data?: InputMaybe<SubjectCategoryUpdateWithoutUnitInput>;
  where?: InputMaybe<SubjectCategoryFilterInput>;
};

export type UnitUpdateSubjectsInput = {
  create?: InputMaybe<Array<SubjectCreationWithoutUnitInput>>;
  createIfNotExists?: InputMaybe<Array<UnitUpdateSubjectsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<SubjectUniqueFilterWithoutUnitInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<SubjectUniqueFilterWithoutUnitInput>>;
  deleteMany?: InputMaybe<SubjectFilterInput>;
  update?: InputMaybe<Array<UnitUpdateSubjectsUpdateInput>>;
  updateAll?: InputMaybe<SubjectUpdateWithoutUnitInput>;
  updateIfExists?: InputMaybe<Array<UnitUpdateSubjectsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<UnitUpdateSubjectsUpdateManyInput>>;
  upsert?: InputMaybe<Array<UnitUpdateSubjectsUpsertInput>>;
};

export type UnitUpdateSubjectsCreateIfNotExistsInput = {
  data: SubjectCreationWithoutUnitInput;
  where: SubjectUniqueFilterWithoutUnitInput;
};

/** Given a "unit", identifies exactly one "Subject" by "title" or "legacyId" */
export type SubjectUniqueFilterWithoutUnitInput = {
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UnitUpdateSubjectsUpdateInput = {
  data?: InputMaybe<SubjectUpdateWithoutUnitInput>;
  where: SubjectUniqueFilterWithoutUnitInput;
};

/** The "Subject" node's update */
export type SubjectUpdateWithoutUnitInput = {
  assignments?: InputMaybe<SubjectUpdateAssignmentsInput>;
  attachments?: InputMaybe<SubjectUpdateAttachmentsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  isAuto?: InputMaybe<Scalars['Boolean']['input']>;
  isClassified?: InputMaybe<Scalars['Boolean']['input']>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaRequest?: InputMaybe<Scalars['String']['input']>;
  subjectCategory?: InputMaybe<SubjectUpdateSubjectCategoryInput>;
  subjectUsers?: InputMaybe<SubjectUpdateSubjectUsersInput>;
  subSubjects?: InputMaybe<SubjectUpdateSubSubjectsInput>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectUpdateSubjectCategoryInput = {
  /**
   * Connect a "SubjectCategory" to an existing "Subject" through the
   * "Subject.subjectCategory" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<SubjectCategoryUniqueFilterInput>;
  /** Connect a "SubjectCategory" to an existing "Subject" through the "Subject.subjectCategory" edge, if it exists. */
  connectIfExists?: InputMaybe<SubjectCategoryUniqueFilterInput>;
  /** Create a "SubjectCategory" and connect it to an existing "Subject" through the "Subject.subjectCategory" edge. */
  create?: InputMaybe<SubjectCategoryCreationInput>;
  /**
   * Create a "SubjectCategory" if it does not exist, and connect it to an existing
   * "Subject" through the "Subject.subjectCategory" edge.
   */
  createIfNotExists?: InputMaybe<SubjectUpdateSubjectCategoryCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "SubjectCategory", throw an error if the "Subject.subjectCategory" edge does not exist. */
  update?: InputMaybe<SubjectCategoryUpdateInput>;
  /** Update the connected "SubjectCategory", if the "Subject.subjectCategory" edge exists. */
  updateIfExists?: InputMaybe<SubjectCategoryUpdateInput>;
};

export type SubjectUpdateSubjectCategoryCreateIfNotExistsInput = {
  data: SubjectCategoryCreationInput;
  where: SubjectCategoryUniqueFilterInput;
};

export type UnitUpdateSubjectsUpdateIfExistsInput = {
  data?: InputMaybe<SubjectUpdateWithoutUnitInput>;
  where: SubjectUniqueFilterWithoutUnitInput;
};

export type UnitUpdateSubjectsUpdateManyInput = {
  data?: InputMaybe<SubjectUpdateWithoutUnitInput>;
  where?: InputMaybe<SubjectFilterInput>;
};

export type UnitUpdateSubjectsUpsertInput = {
  create: SubjectCreationWithoutUnitInput;
  update?: InputMaybe<SubjectUpdateWithoutUnitInput>;
  where: SubjectUniqueFilterWithoutUnitInput;
};

export type SubjectUpdateAssignmentsUpdateIfExistsInput = {
  data?: InputMaybe<AssignmentUpdateWithoutSubjectInput>;
  where: AssignmentUniqueFilterWithoutSubjectInput;
};

export type SubjectUpdateAssignmentsUpdateManyInput = {
  data?: InputMaybe<AssignmentUpdateWithoutSubjectInput>;
  where?: InputMaybe<AssignmentFilterInput>;
};

export type SubjectUpdateAssignmentsUpsertInput = {
  create: AssignmentCreationWithoutSubjectInput;
  update?: InputMaybe<AssignmentUpdateWithoutSubjectInput>;
  where: AssignmentUniqueFilterWithoutSubjectInput;
};

export type RawArticleUpdateAssignmentUpsertInput = {
  create: AssignmentCreationWithoutRawArticleInput;
  update?: InputMaybe<AssignmentUpdateWithoutRawArticleInput>;
};

export type RawArticleUpdateVersionsInput = {
  create?: InputMaybe<Array<RawArticleVersionCreationWithoutRawArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<RawArticleVersionFilterInput>;
  updateAll?: InputMaybe<RawArticleVersionUpdateWithoutRawArticleInput>;
  updateMany?: InputMaybe<Array<RawArticleUpdateVersionsUpdateManyInput>>;
};

/** The "RawArticleVersion" node's update */
export type RawArticleVersionUpdateWithoutRawArticleInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned to the version */
  editorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  forkChilrens?: InputMaybe<RawArticleVersionUpdateForkChilrensInput>;
  forkOf?: InputMaybe<RawArticleVersionUpdateForkOfInput>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** An array of left over Draft content */
  leftOver?: InputMaybe<Scalars['String']['input']>;
  nextVersion?: InputMaybe<RawArticleVersionUpdateNextVersionInput>;
  previousVersion?: InputMaybe<RawArticleVersionUpdatePreviousVersionInput>;
  signature?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RawArticleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RawArticleVersionUpdateForkChilrensInput = {
  create?: InputMaybe<Array<RawArticleVersionCreationWithoutForkOfInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<RawArticleVersionFilterInput>;
  updateAll?: InputMaybe<RawArticleVersionUpdateWithoutForkOfInput>;
  updateMany?: InputMaybe<Array<RawArticleVersionUpdateForkChilrensUpdateManyInput>>;
};

/** The "RawArticleVersion" node's update */
export type RawArticleVersionUpdateWithoutForkOfInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned to the version */
  editorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  forkChilrens?: InputMaybe<RawArticleVersionUpdateForkChilrensInput>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** An array of left over Draft content */
  leftOver?: InputMaybe<Scalars['String']['input']>;
  nextVersion?: InputMaybe<RawArticleVersionUpdateNextVersionInput>;
  previousVersion?: InputMaybe<RawArticleVersionUpdatePreviousVersionInput>;
  rawArticle?: InputMaybe<RawArticleVersionUpdateRawArticleInput>;
  signature?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RawArticleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RawArticleVersionUpdateNextVersionInput = {
  create?: InputMaybe<RawArticleVersionCreationWithoutPreviousVersionInput>;
  createIfNotExists?: InputMaybe<RawArticleVersionCreationWithoutPreviousVersionInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<RawArticleVersionUpdateWithoutPreviousVersionInput>;
  updateIfExists?: InputMaybe<RawArticleVersionUpdateWithoutPreviousVersionInput>;
  upsert?: InputMaybe<RawArticleVersionUpdateNextVersionUpsertInput>;
};

/** The "RawArticleVersion" node's update */
export type RawArticleVersionUpdateWithoutPreviousVersionInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned to the version */
  editorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  forkChilrens?: InputMaybe<RawArticleVersionUpdateForkChilrensInput>;
  forkOf?: InputMaybe<RawArticleVersionUpdateForkOfInput>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** An array of left over Draft content */
  leftOver?: InputMaybe<Scalars['String']['input']>;
  nextVersion?: InputMaybe<RawArticleVersionUpdateNextVersionInput>;
  rawArticle?: InputMaybe<RawArticleVersionUpdateRawArticleInput>;
  signature?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RawArticleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RawArticleVersionUpdateForkOfInput = {
  /**
   * Connect a "RawArticleVersion" to an existing "RawArticleVersion" through the
   * "RawArticleVersion.forkOf" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<RawArticleVersionUniqueFilterInput>;
  /**
   * Connect a "RawArticleVersion" to an existing "RawArticleVersion" through the
   * "RawArticleVersion.forkOf" edge, if it exists.
   */
  connectIfExists?: InputMaybe<RawArticleVersionUniqueFilterInput>;
  /**
   * Create a "RawArticleVersion" and connect it to an existing "RawArticleVersion"
   * through the "RawArticleVersion.forkOf" edge.
   */
  create?: InputMaybe<RawArticleVersionCreationInput>;
  /**
   * Create a "RawArticleVersion" if it does not exist, and connect it to an
   * existing "RawArticleVersion" through the "RawArticleVersion.forkOf" edge.
   */
  createIfNotExists?: InputMaybe<RawArticleVersionUpdateForkOfCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "RawArticleVersion", throw an error if the "RawArticleVersion.forkOf" edge does not exist. */
  update?: InputMaybe<RawArticleVersionUpdateInput>;
  /** Update the connected "RawArticleVersion", if the "RawArticleVersion.forkOf" edge exists. */
  updateIfExists?: InputMaybe<RawArticleVersionUpdateInput>;
};

export type RawArticleVersionUpdateForkOfCreateIfNotExistsInput = {
  data: RawArticleVersionCreationInput;
  where: RawArticleVersionUniqueFilterInput;
};

/** The "RawArticleVersion" node's update */
export type RawArticleVersionUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned to the version */
  editorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  forkChilrens?: InputMaybe<RawArticleVersionUpdateForkChilrensInput>;
  forkOf?: InputMaybe<RawArticleVersionUpdateForkOfInput>;
  lead?: InputMaybe<Scalars['String']['input']>;
  /** An array of left over Draft content */
  leftOver?: InputMaybe<Scalars['String']['input']>;
  nextVersion?: InputMaybe<RawArticleVersionUpdateNextVersionInput>;
  previousVersion?: InputMaybe<RawArticleVersionUpdatePreviousVersionInput>;
  rawArticle?: InputMaybe<RawArticleVersionUpdateRawArticleInput>;
  signature?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RawArticleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RawArticleVersionUpdatePreviousVersionInput = {
  /**
   * Connect a "RawArticleVersion" to an existing "RawArticleVersion" through the
   * "RawArticleVersion.previousVersion" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<RawArticleVersionUniqueFilterInput>;
  /**
   * Connect a "RawArticleVersion" to an existing "RawArticleVersion" through the
   * "RawArticleVersion.previousVersion" edge, if it exists.
   */
  connectIfExists?: InputMaybe<RawArticleVersionUniqueFilterInput>;
  /**
   * Create a "RawArticleVersion" and connect it to an existing "RawArticleVersion"
   * through the "RawArticleVersion.previousVersion" edge.
   */
  create?: InputMaybe<RawArticleVersionCreationInput>;
  /**
   * Create a "RawArticleVersion" if it does not exist, and connect it to an
   * existing "RawArticleVersion" through the "RawArticleVersion.previousVersion" edge.
   */
  createIfNotExists?: InputMaybe<RawArticleVersionUpdatePreviousVersionCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "RawArticleVersion", throw an error if the "RawArticleVersion.previousVersion" edge does not exist. */
  update?: InputMaybe<RawArticleVersionUpdateInput>;
  /** Update the connected "RawArticleVersion", if the "RawArticleVersion.previousVersion" edge exists. */
  updateIfExists?: InputMaybe<RawArticleVersionUpdateInput>;
};

export type RawArticleVersionUpdatePreviousVersionCreateIfNotExistsInput = {
  data: RawArticleVersionCreationInput;
  where: RawArticleVersionUniqueFilterInput;
};

export type RawArticleVersionUpdateRawArticleInput = {
  /**
   * Connect a "RawArticle" to an existing "RawArticleVersion" through the
   * "RawArticleVersion.rawArticle" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<RawArticleUniqueFilterInput>;
  /** Create a "RawArticle" and connect it to an existing "RawArticleVersion" through the "RawArticleVersion.rawArticle" edge. */
  create?: InputMaybe<RawArticleCreationInput>;
  /**
   * Create a "RawArticle" if it does not exist, and connect it to an existing
   * "RawArticleVersion" through the "RawArticleVersion.rawArticle" edge.
   */
  createIfNotExists?: InputMaybe<RawArticleVersionUpdateRawArticleCreateIfNotExistsInput>;
  /** Update the connected "RawArticle", throw an error if the "RawArticleVersion.rawArticle" edge does not exist. */
  update?: InputMaybe<RawArticleUpdateInput>;
};

export type RawArticleVersionUpdateRawArticleCreateIfNotExistsInput = {
  data: RawArticleCreationInput;
  where: RawArticleUniqueFilterInput;
};

export type RawArticleVersionUpdateNextVersionUpsertInput = {
  create: RawArticleVersionCreationWithoutPreviousVersionInput;
  update?: InputMaybe<RawArticleVersionUpdateWithoutPreviousVersionInput>;
};

export type RawArticleVersionUpdateForkChilrensUpdateManyInput = {
  data?: InputMaybe<RawArticleVersionUpdateWithoutForkOfInput>;
  where?: InputMaybe<RawArticleVersionFilterInput>;
};

export type RawArticleUpdateVersionsUpdateManyInput = {
  data?: InputMaybe<RawArticleVersionUpdateWithoutRawArticleInput>;
  where?: InputMaybe<RawArticleVersionFilterInput>;
};

export type PrintTemplateUpdateAssignmentsUpdateManyInput = {
  data?: InputMaybe<AssignmentUpdateWithoutPrintTemplateInput>;
  where?: InputMaybe<AssignmentFilterInput>;
};

export type PrintTemplateUpdatePrintHeadingsInput = {
  create?: InputMaybe<Array<PrintHeadingPrintTemplateCreationWithoutPrintTemplateInput>>;
  createIfNotExists?: InputMaybe<Array<PrintTemplateUpdatePrintHeadingsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<PrintHeadingPrintTemplateUniqueFilterWithoutPrintTemplateInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<PrintHeadingPrintTemplateUniqueFilterWithoutPrintTemplateInput>>;
  deleteMany?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
  update?: InputMaybe<Array<PrintTemplateUpdatePrintHeadingsUpdateInput>>;
  updateAll?: InputMaybe<PrintHeadingPrintTemplateUpdateWithoutPrintTemplateInput>;
  updateIfExists?: InputMaybe<Array<PrintTemplateUpdatePrintHeadingsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<PrintTemplateUpdatePrintHeadingsUpdateManyInput>>;
  upsert?: InputMaybe<Array<PrintTemplateUpdatePrintHeadingsUpsertInput>>;
};

export type PrintTemplateUpdatePrintHeadingsCreateIfNotExistsInput = {
  data: PrintHeadingPrintTemplateCreationWithoutPrintTemplateInput;
  where: PrintHeadingPrintTemplateUniqueFilterWithoutPrintTemplateInput;
};

/** Given a "printTemplate", identifies exactly one "PrintHeadingPrintTemplate" by "printHeading" */
export type PrintHeadingPrintTemplateUniqueFilterWithoutPrintTemplateInput = {
  printHeading: PrintHeadingUniqueFilterInput;
};

export type PrintTemplateUpdatePrintHeadingsUpdateInput = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateWithoutPrintTemplateInput>;
  where: PrintHeadingPrintTemplateUniqueFilterWithoutPrintTemplateInput;
};

/** The "PrintHeadingPrintTemplate" node's update */
export type PrintHeadingPrintTemplateUpdateWithoutPrintTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  printHeading?: InputMaybe<PrintHeadingPrintTemplateUpdatePrintHeadingInput>;
};

export type PrintHeadingPrintTemplateUpdatePrintHeadingInput = {
  /**
   * Connect a "PrintHeading" to an existing "PrintHeadingPrintTemplate" through
   * the "PrintHeadingPrintTemplate.printHeading" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintHeadingUniqueFilterInput>;
  /**
   * Create a "PrintHeading" and connect it to an existing
   * "PrintHeadingPrintTemplate" through the
   * "PrintHeadingPrintTemplate.printHeading" edge.
   */
  create?: InputMaybe<PrintHeadingCreationInput>;
  /**
   * Create a "PrintHeading" if it does not exist, and connect it to an existing
   * "PrintHeadingPrintTemplate" through the
   * "PrintHeadingPrintTemplate.printHeading" edge.
   */
  createIfNotExists?: InputMaybe<PrintHeadingPrintTemplateUpdatePrintHeadingCreateIfNotExistsInput>;
  /** Update the connected "PrintHeading", throw an error if the "PrintHeadingPrintTemplate.printHeading" edge does not exist. */
  update?: InputMaybe<PrintHeadingUpdateInput>;
};

export type PrintHeadingPrintTemplateUpdatePrintHeadingCreateIfNotExistsInput = {
  data: PrintHeadingCreationInput;
  where: PrintHeadingUniqueFilterInput;
};

export type PrintTemplateUpdatePrintHeadingsUpdateIfExistsInput = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateWithoutPrintTemplateInput>;
  where: PrintHeadingPrintTemplateUniqueFilterWithoutPrintTemplateInput;
};

export type PrintTemplateUpdatePrintHeadingsUpdateManyInput = {
  data?: InputMaybe<PrintHeadingPrintTemplateUpdateWithoutPrintTemplateInput>;
  where?: InputMaybe<PrintHeadingPrintTemplateFilterInput>;
};

export type PrintTemplateUpdatePrintHeadingsUpsertInput = {
  create: PrintHeadingPrintTemplateCreationWithoutPrintTemplateInput;
  update?: InputMaybe<PrintHeadingPrintTemplateUpdateWithoutPrintTemplateInput>;
  where: PrintHeadingPrintTemplateUniqueFilterWithoutPrintTemplateInput;
};

export type PrintPublicationUpdateAssignmentsUpdateManyInput = {
  data?: InputMaybe<AssignmentUpdateWithoutPrintPublicationInput>;
  where?: InputMaybe<AssignmentFilterInput>;
};

export type PrintPublicationUpdateBrandInput = {
  /**
   * Connect a "Brand" to an existing "PrintPublication" through the
   * "PrintPublication.brand" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<BrandUniqueFilterInput>;
  /** Create a "Brand" and connect it to an existing "PrintPublication" through the "PrintPublication.brand" edge. */
  create?: InputMaybe<BrandCreationInput>;
  /**
   * Create a "Brand" if it does not exist, and connect it to an existing
   * "PrintPublication" through the "PrintPublication.brand" edge.
   */
  createIfNotExists?: InputMaybe<PrintPublicationUpdateBrandCreateIfNotExistsInput>;
  /** Update the connected "Brand", throw an error if the "PrintPublication.brand" edge does not exist. */
  update?: InputMaybe<BrandUpdateInput>;
};

export type PrintPublicationUpdateBrandCreateIfNotExistsInput = {
  data: BrandCreationInput;
  where: BrandUniqueFilterInput;
};

export type PrintIssueUpdateAdvertisementsUpdateManyInput = {
  data?: InputMaybe<AdvertisementUpdateWithoutPrintIssueInput>;
  where?: InputMaybe<AdvertisementFilterInput>;
};

export type PrintIssueUpdatePrintPublicationInput = {
  /**
   * Connect a "PrintPublication" to an existing "PrintIssue" through the
   * "PrintIssue.printPublication" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintPublicationUniqueFilterInput>;
  /** Create a "PrintPublication" and connect it to an existing "PrintIssue" through the "PrintIssue.printPublication" edge. */
  create?: InputMaybe<PrintPublicationCreationInput>;
  /**
   * Create a "PrintPublication" if it does not exist, and connect it to an
   * existing "PrintIssue" through the "PrintIssue.printPublication" edge.
   */
  createIfNotExists?: InputMaybe<PrintIssueUpdatePrintPublicationCreateIfNotExistsInput>;
  /** Update the connected "PrintPublication", throw an error if the "PrintIssue.printPublication" edge does not exist. */
  update?: InputMaybe<PrintPublicationUpdateInput>;
};

export type PrintIssueUpdatePrintPublicationCreateIfNotExistsInput = {
  data: PrintPublicationCreationInput;
  where: PrintPublicationUniqueFilterInput;
};

export type ArticleTemplateUpdateAssignmentsUpdateManyInput = {
  data?: InputMaybe<AssignmentUpdateWithoutArticleTemplateInput>;
  where?: InputMaybe<AssignmentFilterInput>;
};

export type ArticleTemplateUpdatePrintTemplateInput = {
  /**
   * Connect a "PrintTemplate" to an existing "ArticleTemplate" through the
   * "ArticleTemplate.printTemplate" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintTemplateUniqueFilterInput>;
  /** Create a "PrintTemplate" and connect it to an existing "ArticleTemplate" through the "ArticleTemplate.printTemplate" edge. */
  create?: InputMaybe<PrintTemplateCreationInput>;
  /**
   * Create a "PrintTemplate" if it does not exist, and connect it to an existing
   * "ArticleTemplate" through the "ArticleTemplate.printTemplate" edge.
   */
  createIfNotExists?: InputMaybe<ArticleTemplateUpdatePrintTemplateCreateIfNotExistsInput>;
  /** Update the connected "PrintTemplate", throw an error if the "ArticleTemplate.printTemplate" edge does not exist. */
  update?: InputMaybe<PrintTemplateUpdateInput>;
};

export type ArticleTemplateUpdatePrintTemplateCreateIfNotExistsInput = {
  data: PrintTemplateCreationInput;
  where: PrintTemplateUniqueFilterInput;
};

export type PrintHeadingUpdateAssignmentsUpdateManyInput = {
  data?: InputMaybe<AssignmentUpdateWithoutPrintHeadingInput>;
  where?: InputMaybe<AssignmentFilterInput>;
};

export type MockupUpdateLayoutAssetsUpdateIfExistsInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutMockupInput>;
  where: LayoutAssetUniqueFilterWithoutMockupInput;
};

export type MockupUpdateLayoutAssetsUpdateManyInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutMockupInput>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};

export type MockupUpdateLayoutAssetsUpsertInput = {
  create: LayoutAssetCreationWithoutMockupInput;
  update?: InputMaybe<LayoutAssetUpdateWithoutMockupInput>;
  where: LayoutAssetUniqueFilterWithoutMockupInput;
};

export type LayoutUpdateAssetsUpdateIfExistsInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutLayoutInput>;
  where: LayoutAssetUniqueFilterWithoutLayoutInput;
};

export type LayoutUpdateAssetsUpdateManyInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutLayoutInput>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};

export type LayoutUpdateAssetsUpsertInput = {
  create: LayoutAssetCreationWithoutLayoutInput;
  update?: InputMaybe<LayoutAssetUpdateWithoutLayoutInput>;
  where: LayoutAssetUniqueFilterWithoutLayoutInput;
};

export type FileUpdateLayoutAssetsUpdateIfExistsInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutFileInput>;
  where: LayoutAssetUniqueFilterWithoutFileInput;
};

export type FileUpdateLayoutAssetsUpdateManyInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutFileInput>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};

export type FileUpdateLayoutAssetsUpsertInput = {
  create: LayoutAssetCreationWithoutFileInput;
  update?: InputMaybe<LayoutAssetUpdateWithoutFileInput>;
  where: LayoutAssetUniqueFilterWithoutFileInput;
};

export type AdvertisementUpdateLayoutAssetsUpdateIfExistsInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutAdvertisementInput>;
  where: LayoutAssetUniqueFilterWithoutAdvertisementInput;
};

export type AdvertisementUpdateLayoutAssetsUpdateManyInput = {
  data?: InputMaybe<LayoutAssetUpdateWithoutAdvertisementInput>;
  where?: InputMaybe<LayoutAssetFilterInput>;
};

export type AdvertisementUpdateLayoutAssetsUpsertInput = {
  create: LayoutAssetCreationWithoutAdvertisementInput;
  update?: InputMaybe<LayoutAssetUpdateWithoutAdvertisementInput>;
  where: LayoutAssetUniqueFilterWithoutAdvertisementInput;
};

/** The "Assignment" node's update */
export type AssignmentUpdateInput = {
  articleTemplate?: InputMaybe<AssignmentUpdateArticleTemplateInput>;
  /** The legacy ID */
  legacyId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  mediaSearchStatus?: InputMaybe<MediaSearchStatus>;
  pageNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<AssignmentUpdatePrintHeadingInput>;
  printIssue?: InputMaybe<AssignmentUpdatePrintIssueInput>;
  printPublication?: InputMaybe<AssignmentUpdatePrintPublicationInput>;
  printTemplate?: InputMaybe<AssignmentUpdatePrintTemplateInput>;
  rawArticle?: InputMaybe<AssignmentUpdateRawArticleInput>;
  subject?: InputMaybe<AssignmentUpdateSubjectInput>;
  website?: InputMaybe<AssignmentUpdateWebsiteInput>;
};

/** The "Attachment" node's update */
export type AttachmentUpdateInput = {
  /** update from S3 */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** update from S3 */
  etag?: InputMaybe<Scalars['String']['input']>;
  /** sent from the front */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** update from S3 */
  filesize?: InputMaybe<Scalars['UnsignedInt']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<AttachmentUpdateSubjectInput>;
  /** update from S3 */
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentUpdateSubjectInput = {
  /**
   * Connect a "Subject" to an existing "Attachment" through the
   * "Attachment.subject" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<SubjectUniqueFilterInput>;
  /** Create a "Subject" and connect it to an existing "Attachment" through the "Attachment.subject" edge. */
  create?: InputMaybe<SubjectCreationInput>;
  /** Create a "Subject" if it does not exist, and connect it to an existing "Attachment" through the "Attachment.subject" edge. */
  createIfNotExists?: InputMaybe<AttachmentUpdateSubjectCreateIfNotExistsInput>;
  /** Update the connected "Subject", throw an error if the "Attachment.subject" edge does not exist. */
  update?: InputMaybe<SubjectUpdateInput>;
};

export type AttachmentUpdateSubjectCreateIfNotExistsInput = {
  data: SubjectCreationInput;
  where: SubjectUniqueFilterInput;
};

/** The "CenshareTrace" node's update */
export type CenshareTraceUpdateInput = {
  /** The censhare used api */
  api?: InputMaybe<Scalars['String']['input']>;
  /** http call query params */
  params?: InputMaybe<Scalars['String']['input']>;
  /** http call payload */
  payload?: InputMaybe<Scalars['String']['input']>;
  /** http call (xml) raw response */
  rawResponse?: InputMaybe<Scalars['String']['input']>;
  /** http call response code */
  responseCode?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "LayoutAsset" node's update */
export type LayoutAssetUpdateInput = {
  advertisement?: InputMaybe<LayoutAssetUpdateAdvertisementInput>;
  file?: InputMaybe<LayoutAssetUpdateFileInput>;
  layout?: InputMaybe<LayoutAssetUpdateLayoutInput>;
  mockup?: InputMaybe<LayoutAssetUpdateMockupInput>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printHeading?: InputMaybe<LayoutAssetUpdatePrintHeadingInput>;
};

/** The "PrintHeadingPrintTemplate" node's update */
export type PrintHeadingPrintTemplateUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  printHeading?: InputMaybe<PrintHeadingPrintTemplateUpdatePrintHeadingInput>;
  printTemplate?: InputMaybe<PrintHeadingPrintTemplateUpdatePrintTemplateInput>;
};

/** The "PrintIssueRailroad" node's update */
export type PrintIssueRailroadUpdateInput = {
  censhareCreationDate?: InputMaybe<Scalars['DateTime']['input']>;
  censhareUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssue?: InputMaybe<PrintIssueRailroadUpdatePrintIssueInput>;
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
  railroadPages?: InputMaybe<PrintIssueRailroadUpdateRailroadPagesInput>;
};

export type PrintIssueRailroadUpdatePrintIssueInput = {
  /**
   * Connect a "PrintIssue" to an existing "PrintIssueRailroad" through the
   * "PrintIssueRailroad.printIssue" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintIssueUniqueFilterInput>;
  /** Create a "PrintIssue" and connect it to an existing "PrintIssueRailroad" through the "PrintIssueRailroad.printIssue" edge. */
  create?: InputMaybe<PrintIssueCreationInput>;
  /**
   * Create a "PrintIssue" if it does not exist, and connect it to an existing
   * "PrintIssueRailroad" through the "PrintIssueRailroad.printIssue" edge.
   */
  createIfNotExists?: InputMaybe<PrintIssueRailroadUpdatePrintIssueCreateIfNotExistsInput>;
  /** Update the connected "PrintIssue", throw an error if the "PrintIssueRailroad.printIssue" edge does not exist. */
  update?: InputMaybe<PrintIssueUpdateInput>;
};

export type PrintIssueRailroadUpdatePrintIssueCreateIfNotExistsInput = {
  data: PrintIssueCreationInput;
  where: PrintIssueUniqueFilterInput;
};

/** The "RailroadPage" node's update */
export type RailroadPageUpdateInput = {
  indesignFilename?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['UnsignedInt']['input']>;
  printIssueRailroad?: InputMaybe<RailroadPageUpdatePrintIssueRailroadInput>;
  visual?: InputMaybe<Scalars['String']['input']>;
  workflowName?: InputMaybe<Scalars['String']['input']>;
  workflowStage?: InputMaybe<Scalars['String']['input']>;
};

export type RailroadPageUpdatePrintIssueRailroadInput = {
  /**
   * Connect a "PrintIssueRailroad" to an existing "RailroadPage" through the
   * "RailroadPage.printIssueRailroad" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PrintIssueRailroadUniqueFilterInput>;
  /**
   * Create a "PrintIssueRailroad" and connect it to an existing "RailroadPage"
   * through the "RailroadPage.printIssueRailroad" edge.
   */
  create?: InputMaybe<PrintIssueRailroadCreationInput>;
  /**
   * Create a "PrintIssueRailroad" if it does not exist, and connect it to an
   * existing "RailroadPage" through the "RailroadPage.printIssueRailroad" edge.
   */
  createIfNotExists?: InputMaybe<RailroadPageUpdatePrintIssueRailroadCreateIfNotExistsInput>;
  /** Update the connected "PrintIssueRailroad", throw an error if the "RailroadPage.printIssueRailroad" edge does not exist. */
  update?: InputMaybe<PrintIssueRailroadUpdateInput>;
};

export type RailroadPageUpdatePrintIssueRailroadCreateIfNotExistsInput = {
  data: PrintIssueRailroadCreationInput;
  where: PrintIssueRailroadUniqueFilterInput;
};

/** The "SubSubject" node's update */
export type SubSubjectUpdateInput = {
  subject?: InputMaybe<SubSubjectUpdateSubjectInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubSubjectUpdateSubjectInput = {
  /**
   * Connect a "Subject" to an existing "SubSubject" through the
   * "SubSubject.subject" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<SubjectUniqueFilterInput>;
  /** Create a "Subject" and connect it to an existing "SubSubject" through the "SubSubject.subject" edge. */
  create?: InputMaybe<SubjectCreationInput>;
  /** Create a "Subject" if it does not exist, and connect it to an existing "SubSubject" through the "SubSubject.subject" edge. */
  createIfNotExists?: InputMaybe<SubSubjectUpdateSubjectCreateIfNotExistsInput>;
  /** Update the connected "Subject", throw an error if the "SubSubject.subject" edge does not exist. */
  update?: InputMaybe<SubjectUpdateInput>;
};

export type SubSubjectUpdateSubjectCreateIfNotExistsInput = {
  data: SubjectCreationInput;
  where: SubjectUniqueFilterInput;
};

/** The "TopicFotowebPige" node's update */
export type TopicFotowebPigeUpdateInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fotowebId?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  priceLevel?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type GetAssignmentsLinkToTopicQuery_query_assignments_Assignment_rawArticle_RawArticle_lastVersion_RawArticleVersion = {
  __typename?: 'RawArticleVersion',
  title?: string | null
};

export type GetAssignmentsLinkToTopicQuery_query_assignments_Assignment_rawArticle_RawArticle = {
  __typename?: 'RawArticle',
  id: string,
  lastVersion?: GetAssignmentsLinkToTopicQuery_query_assignments_Assignment_rawArticle_RawArticle_lastVersion_RawArticleVersion | null
};

export type GetAssignmentsLinkToTopicQuery_query_assignments_Assignment_printHeading_PrintHeading_printIssue_PrintIssue_printPublication_PrintPublication = {
  __typename?: 'PrintPublication',
  title: string
};

export type GetAssignmentsLinkToTopicQuery_query_assignments_Assignment_printHeading_PrintHeading_printIssue_PrintIssue = {
  __typename?: 'PrintIssue',
  title: string,
  printPublication: GetAssignmentsLinkToTopicQuery_query_assignments_Assignment_printHeading_PrintHeading_printIssue_PrintIssue_printPublication_PrintPublication
};

export type GetAssignmentsLinkToTopicQuery_query_assignments_Assignment_printHeading_PrintHeading = {
  __typename?: 'PrintHeading',
  title: string,
  printIssue: GetAssignmentsLinkToTopicQuery_query_assignments_Assignment_printHeading_PrintHeading_printIssue_PrintIssue
};

export type GetAssignmentsLinkToTopicQuery_query_assignments_Assignment = {
  __typename?: 'Assignment',
  id: string,
  rawArticle?: GetAssignmentsLinkToTopicQuery_query_assignments_Assignment_rawArticle_RawArticle | null,
  printHeading?: GetAssignmentsLinkToTopicQuery_query_assignments_Assignment_printHeading_PrintHeading | null
};

export type GetAssignmentsLinkToTopicQuery_query = {
  __typename?: 'query',
  assignments: Array<GetAssignmentsLinkToTopicQuery_query_assignments_Assignment>
};


export type GetAssignmentsLinkToTopicQueryVariables = Exact<{
  where?: InputMaybe<AssignmentFilterInput>;
  orderBy?: InputMaybe<Array<AssignmentOrderingInput> | AssignmentOrderingInput>;
  offset?: InputMaybe<Scalars['UnsignedInt']['input']>;
  limit: Scalars['UnsignedInt']['input'];
}>;


export type GetAssignmentsLinkToTopicQuery = GetAssignmentsLinkToTopicQuery_query;

export type GetAssignmentsForDuplicationQuery_query_assignments_Assignment_subject_Subject = {
  __typename?: 'Subject',
  id: string,
  title: string
};

export type GetAssignmentsForDuplicationQuery_query_assignments_Assignment_rawArticle_RawArticle_lastVersion_RawArticleVersion = {
  __typename?: 'RawArticleVersion',
  id: string
};

export type GetAssignmentsForDuplicationQuery_query_assignments_Assignment_rawArticle_RawArticle = {
  __typename?: 'RawArticle',
  id: string,
  lastVersion?: GetAssignmentsForDuplicationQuery_query_assignments_Assignment_rawArticle_RawArticle_lastVersion_RawArticleVersion | null
};

export type GetAssignmentsForDuplicationQuery_query_assignments_Assignment_printHeading_PrintHeading_printIssue_PrintIssue_printPublication_PrintPublication = {
  __typename?: 'PrintPublication',
  title: string
};

export type GetAssignmentsForDuplicationQuery_query_assignments_Assignment_printHeading_PrintHeading_printIssue_PrintIssue = {
  __typename?: 'PrintIssue',
  title: string,
  printPublication: GetAssignmentsForDuplicationQuery_query_assignments_Assignment_printHeading_PrintHeading_printIssue_PrintIssue_printPublication_PrintPublication
};

export type GetAssignmentsForDuplicationQuery_query_assignments_Assignment_printHeading_PrintHeading = {
  __typename?: 'PrintHeading',
  title: string,
  printIssue: GetAssignmentsForDuplicationQuery_query_assignments_Assignment_printHeading_PrintHeading_printIssue_PrintIssue
};

export type GetAssignmentsForDuplicationQuery_query_assignments_Assignment = {
  __typename?: 'Assignment',
  id: string,
  subject: GetAssignmentsForDuplicationQuery_query_assignments_Assignment_subject_Subject,
  rawArticle?: GetAssignmentsForDuplicationQuery_query_assignments_Assignment_rawArticle_RawArticle | null,
  printHeading?: GetAssignmentsForDuplicationQuery_query_assignments_Assignment_printHeading_PrintHeading | null
};

export type GetAssignmentsForDuplicationQuery_query = {
  __typename?: 'query',
  assignments: Array<GetAssignmentsForDuplicationQuery_query_assignments_Assignment>
};


export type GetAssignmentsForDuplicationQueryVariables = Exact<{
  where?: InputMaybe<AssignmentFilterInput>;
  orderBy?: InputMaybe<Array<AssignmentOrderingInput> | AssignmentOrderingInput>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  first: Scalars['UnsignedInt']['input'];
}>;


export type GetAssignmentsForDuplicationQuery = GetAssignmentsForDuplicationQuery_query;

export type GetPrintPublicationsForDuplicationQuery_query_printPublications_PrintPublication = {
  __typename?: 'PrintPublication',
  id: string,
  title: string
};

export type GetPrintPublicationsForDuplicationQuery_query = {
  __typename?: 'query',
  printPublications: Array<GetPrintPublicationsForDuplicationQuery_query_printPublications_PrintPublication>
};


export type GetPrintPublicationsForDuplicationQueryVariables = Exact<{
  where?: InputMaybe<PrintPublicationFilterInput>;
  orderBy?: InputMaybe<Array<PrintPublicationOrderingInput> | PrintPublicationOrderingInput>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  first: Scalars['UnsignedInt']['input'];
}>;


export type GetPrintPublicationsForDuplicationQuery = GetPrintPublicationsForDuplicationQuery_query;

export type GetPrintIssuesForDuplicationQuery_query_printIssues_PrintIssue = {
  __typename?: 'PrintIssue',
  id: string,
  title: string
};

export type GetPrintIssuesForDuplicationQuery_query = {
  __typename?: 'query',
  printIssues: Array<GetPrintIssuesForDuplicationQuery_query_printIssues_PrintIssue>
};


export type GetPrintIssuesForDuplicationQueryVariables = Exact<{
  where?: InputMaybe<PrintIssueFilterInput>;
  orderBy?: InputMaybe<Array<PrintIssueOrderingInput> | PrintIssueOrderingInput>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  first: Scalars['UnsignedInt']['input'];
}>;


export type GetPrintIssuesForDuplicationQuery = GetPrintIssuesForDuplicationQuery_query;

export type GetPrintHeadingsForDuplicationQuery_query_printHeadings_PrintHeading = {
  __typename?: 'PrintHeading',
  id: string,
  title: string
};

export type GetPrintHeadingsForDuplicationQuery_query = {
  __typename?: 'query',
  printHeadings: Array<GetPrintHeadingsForDuplicationQuery_query_printHeadings_PrintHeading>
};


export type GetPrintHeadingsForDuplicationQueryVariables = Exact<{
  where?: InputMaybe<PrintHeadingFilterInput>;
  orderBy?: InputMaybe<Array<PrintHeadingOrderingInput> | PrintHeadingOrderingInput>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  first: Scalars['UnsignedInt']['input'];
}>;


export type GetPrintHeadingsForDuplicationQuery = GetPrintHeadingsForDuplicationQuery_query;

export type GetUnitsForDuplicationQuery_query_units_Unit = {
  __typename?: 'Unit',
  id: string
};

export type GetUnitsForDuplicationQuery_query = {
  __typename?: 'query',
  units: Array<GetUnitsForDuplicationQuery_query_units_Unit>
};


export type GetUnitsForDuplicationQueryVariables = Exact<{
  where?: InputMaybe<UnitFilterInput>;
  orderBy?: InputMaybe<Array<UnitOrderingInput> | UnitOrderingInput>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  first: Scalars['UnsignedInt']['input'];
}>;


export type GetUnitsForDuplicationQuery = GetUnitsForDuplicationQuery_query;

export type CreateSubjectForDuplicationMutation_mutation_createSubject_Subject_assignments_Assignment = {
  __typename?: 'Assignment',
  id: string
};

export type CreateSubjectForDuplicationMutation_mutation_createSubject_Subject = {
  __typename?: 'Subject',
  assignments: Array<CreateSubjectForDuplicationMutation_mutation_createSubject_Subject_assignments_Assignment>
};

export type CreateSubjectForDuplicationMutation_mutation = {
  __typename?: 'mutation',
  createSubject: CreateSubjectForDuplicationMutation_mutation_createSubject_Subject
};


export type CreateSubjectForDuplicationMutationVariables = Exact<{
  data: SubjectCreationInput;
}>;


export type CreateSubjectForDuplicationMutation = CreateSubjectForDuplicationMutation_mutation;

export type UpdateAssignmentForDuplicationMutation_mutation_updateAssignment_Assignment = {
  __typename?: 'Assignment',
  id: string
};

export type UpdateAssignmentForDuplicationMutation_mutation = {
  __typename?: 'mutation',
  updateAssignment: UpdateAssignmentForDuplicationMutation_mutation_updateAssignment_Assignment
};


export type UpdateAssignmentForDuplicationMutationVariables = Exact<{
  data: AssignmentUpdateInput;
  where: AssignmentUniqueFilterInput;
}>;


export type UpdateAssignmentForDuplicationMutation = UpdateAssignmentForDuplicationMutation_mutation;

export type AssignmentFragmentFragment_Assignment_subject_Subject = {
  __typename?: 'Subject',
  id: string,
  title: string
};

export type AssignmentFragmentFragment = {
  __typename?: 'Assignment',
  id: string,
  subject: AssignmentFragmentFragment_Assignment_subject_Subject
};

export type ArticleForm_RawArticleVersionFragmentFragment_RawArticleVersion_editor_User = {
  __typename?: 'User',
  id: string,
  name: string,
  avatarUrl?: string | null
};

export type ArticleForm_RawArticleVersionFragmentFragment = {
  __typename?: 'RawArticleVersion',
  allowedStatuses: Array<RawArticleStatus>,
  id: string,
  title?: string | null,
  lead?: string | null,
  body?: string | null,
  signature?: string | null,
  status: RawArticleStatus,
  createdAt: string,
  textIsReadOnly: boolean,
  editor?: ArticleForm_RawArticleVersionFragmentFragment_RawArticleVersion_editor_User | null
};

export type GetAssignmentQuery_query_assignment_Assignment = {
  __typename?: 'Assignment',
  id: string,
  subject: AssignmentFragmentFragment_Assignment_subject_Subject
};

export type GetAssignmentQuery_query = {
  __typename?: 'query',
  assignment: GetAssignmentQuery_query_assignment_Assignment
};


export type GetAssignmentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetAssignmentQuery = GetAssignmentQuery_query;

export type GetRawArticleQuery_query_rawArticle_RawArticle_assignment_Assignment = {
  __typename?: 'Assignment',
  id: string,
  subject: AssignmentFragmentFragment_Assignment_subject_Subject
};

export type GetRawArticleQuery_query_rawArticle_RawArticle_versions_RawArticleVersion = {
  __typename?: 'RawArticleVersion',
  allowedStatuses: Array<RawArticleStatus>,
  id: string,
  title?: string | null,
  lead?: string | null,
  body?: string | null,
  signature?: string | null,
  status: RawArticleStatus,
  createdAt: string,
  textIsReadOnly: boolean,
  editor?: ArticleForm_RawArticleVersionFragmentFragment_RawArticleVersion_editor_User | null
};

export type GetRawArticleQuery_query_rawArticle_RawArticle = {
  __typename?: 'RawArticle',
  id: string,
  assignment?: GetRawArticleQuery_query_rawArticle_RawArticle_assignment_Assignment | null,
  versions: Array<GetRawArticleQuery_query_rawArticle_RawArticle_versions_RawArticleVersion>
};

export type GetRawArticleQuery_query = {
  __typename?: 'query',
  rawArticle: GetRawArticleQuery_query_rawArticle_RawArticle
};


export type GetRawArticleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  versionId: Scalars['UUID']['input'];
}>;


export type GetRawArticleQuery = GetRawArticleQuery_query;

export const AssignmentFragmentFragmentDoc = gql`
    fragment AssignmentFragment on Assignment {
  id
  subject {
    id
    title
  }
}
    `;
export const ArticleForm_RawArticleVersionFragmentFragmentDoc = gql`
    fragment ArticleForm_RawArticleVersionFragment on RawArticleVersion {
  allowedStatuses
  id
  title
  lead
  body
  signature
  status
  createdAt
  editor {
    id
    name
    avatarUrl
  }
  textIsReadOnly
}
    `;
export const GetAssignmentsLinkToTopicDocument = gql`
    query GetAssignmentsLinkToTopic($where: AssignmentFilterInput, $orderBy: [AssignmentOrderingInput!], $offset: UnsignedInt, $limit: UnsignedInt!) {
  assignments(where: $where, orderBy: $orderBy, skip: $offset, first: $limit) {
    id
    rawArticle {
      id
      lastVersion {
        title
      }
    }
    printHeading {
      title
      printIssue {
        title
        printPublication {
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetAssignmentsLinkToTopicQuery__
 *
 * To run a query within a React component, call `useGetAssignmentsLinkToTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentsLinkToTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentsLinkToTopicQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAssignmentsLinkToTopicQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentsLinkToTopicQuery, GetAssignmentsLinkToTopicQueryVariables> & ({ variables: GetAssignmentsLinkToTopicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentsLinkToTopicQuery, GetAssignmentsLinkToTopicQueryVariables>(GetAssignmentsLinkToTopicDocument, options);
      }
export function useGetAssignmentsLinkToTopicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentsLinkToTopicQuery, GetAssignmentsLinkToTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentsLinkToTopicQuery, GetAssignmentsLinkToTopicQueryVariables>(GetAssignmentsLinkToTopicDocument, options);
        }
export function useGetAssignmentsLinkToTopicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentsLinkToTopicQuery, GetAssignmentsLinkToTopicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentsLinkToTopicQuery, GetAssignmentsLinkToTopicQueryVariables>(GetAssignmentsLinkToTopicDocument, options);
        }
export type GetAssignmentsLinkToTopicQueryHookResult = ReturnType<typeof useGetAssignmentsLinkToTopicQuery>;
export type GetAssignmentsLinkToTopicLazyQueryHookResult = ReturnType<typeof useGetAssignmentsLinkToTopicLazyQuery>;
export type GetAssignmentsLinkToTopicSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentsLinkToTopicSuspenseQuery>;
export type GetAssignmentsLinkToTopicQueryResult = Apollo.QueryResult<GetAssignmentsLinkToTopicQuery, GetAssignmentsLinkToTopicQueryVariables>;
export const GetAssignmentsForDuplicationDocument = gql`
    query GetAssignmentsForDuplication($where: AssignmentFilterInput, $orderBy: [AssignmentOrderingInput!], $skip: UnsignedInt, $first: UnsignedInt!) {
  assignments(where: $where, orderBy: $orderBy, skip: $skip, first: $first) {
    id
    subject {
      id
      title
    }
    rawArticle {
      id
      lastVersion {
        id
      }
    }
    printHeading {
      title
      printIssue {
        title
        printPublication {
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetAssignmentsForDuplicationQuery__
 *
 * To run a query within a React component, call `useGetAssignmentsForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentsForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentsForDuplicationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetAssignmentsForDuplicationQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentsForDuplicationQuery, GetAssignmentsForDuplicationQueryVariables> & ({ variables: GetAssignmentsForDuplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentsForDuplicationQuery, GetAssignmentsForDuplicationQueryVariables>(GetAssignmentsForDuplicationDocument, options);
      }
export function useGetAssignmentsForDuplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentsForDuplicationQuery, GetAssignmentsForDuplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentsForDuplicationQuery, GetAssignmentsForDuplicationQueryVariables>(GetAssignmentsForDuplicationDocument, options);
        }
export function useGetAssignmentsForDuplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentsForDuplicationQuery, GetAssignmentsForDuplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentsForDuplicationQuery, GetAssignmentsForDuplicationQueryVariables>(GetAssignmentsForDuplicationDocument, options);
        }
export type GetAssignmentsForDuplicationQueryHookResult = ReturnType<typeof useGetAssignmentsForDuplicationQuery>;
export type GetAssignmentsForDuplicationLazyQueryHookResult = ReturnType<typeof useGetAssignmentsForDuplicationLazyQuery>;
export type GetAssignmentsForDuplicationSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentsForDuplicationSuspenseQuery>;
export type GetAssignmentsForDuplicationQueryResult = Apollo.QueryResult<GetAssignmentsForDuplicationQuery, GetAssignmentsForDuplicationQueryVariables>;
export const GetPrintPublicationsForDuplicationDocument = gql`
    query GetPrintPublicationsForDuplication($where: PrintPublicationFilterInput, $orderBy: [PrintPublicationOrderingInput!], $skip: UnsignedInt, $first: UnsignedInt!) {
  printPublications(where: $where, orderBy: $orderBy, skip: $skip, first: $first) {
    id
    title
  }
}
    `;

/**
 * __useGetPrintPublicationsForDuplicationQuery__
 *
 * To run a query within a React component, call `useGetPrintPublicationsForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintPublicationsForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintPublicationsForDuplicationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetPrintPublicationsForDuplicationQuery(baseOptions: Apollo.QueryHookOptions<GetPrintPublicationsForDuplicationQuery, GetPrintPublicationsForDuplicationQueryVariables> & ({ variables: GetPrintPublicationsForDuplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrintPublicationsForDuplicationQuery, GetPrintPublicationsForDuplicationQueryVariables>(GetPrintPublicationsForDuplicationDocument, options);
      }
export function useGetPrintPublicationsForDuplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrintPublicationsForDuplicationQuery, GetPrintPublicationsForDuplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrintPublicationsForDuplicationQuery, GetPrintPublicationsForDuplicationQueryVariables>(GetPrintPublicationsForDuplicationDocument, options);
        }
export function useGetPrintPublicationsForDuplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrintPublicationsForDuplicationQuery, GetPrintPublicationsForDuplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrintPublicationsForDuplicationQuery, GetPrintPublicationsForDuplicationQueryVariables>(GetPrintPublicationsForDuplicationDocument, options);
        }
export type GetPrintPublicationsForDuplicationQueryHookResult = ReturnType<typeof useGetPrintPublicationsForDuplicationQuery>;
export type GetPrintPublicationsForDuplicationLazyQueryHookResult = ReturnType<typeof useGetPrintPublicationsForDuplicationLazyQuery>;
export type GetPrintPublicationsForDuplicationSuspenseQueryHookResult = ReturnType<typeof useGetPrintPublicationsForDuplicationSuspenseQuery>;
export type GetPrintPublicationsForDuplicationQueryResult = Apollo.QueryResult<GetPrintPublicationsForDuplicationQuery, GetPrintPublicationsForDuplicationQueryVariables>;
export const GetPrintIssuesForDuplicationDocument = gql`
    query GetPrintIssuesForDuplication($where: PrintIssueFilterInput, $orderBy: [PrintIssueOrderingInput!], $skip: UnsignedInt, $first: UnsignedInt!) {
  printIssues(where: $where, orderBy: $orderBy, skip: $skip, first: $first) {
    id
    title
  }
}
    `;

/**
 * __useGetPrintIssuesForDuplicationQuery__
 *
 * To run a query within a React component, call `useGetPrintIssuesForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintIssuesForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintIssuesForDuplicationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetPrintIssuesForDuplicationQuery(baseOptions: Apollo.QueryHookOptions<GetPrintIssuesForDuplicationQuery, GetPrintIssuesForDuplicationQueryVariables> & ({ variables: GetPrintIssuesForDuplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrintIssuesForDuplicationQuery, GetPrintIssuesForDuplicationQueryVariables>(GetPrintIssuesForDuplicationDocument, options);
      }
export function useGetPrintIssuesForDuplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrintIssuesForDuplicationQuery, GetPrintIssuesForDuplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrintIssuesForDuplicationQuery, GetPrintIssuesForDuplicationQueryVariables>(GetPrintIssuesForDuplicationDocument, options);
        }
export function useGetPrintIssuesForDuplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrintIssuesForDuplicationQuery, GetPrintIssuesForDuplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrintIssuesForDuplicationQuery, GetPrintIssuesForDuplicationQueryVariables>(GetPrintIssuesForDuplicationDocument, options);
        }
export type GetPrintIssuesForDuplicationQueryHookResult = ReturnType<typeof useGetPrintIssuesForDuplicationQuery>;
export type GetPrintIssuesForDuplicationLazyQueryHookResult = ReturnType<typeof useGetPrintIssuesForDuplicationLazyQuery>;
export type GetPrintIssuesForDuplicationSuspenseQueryHookResult = ReturnType<typeof useGetPrintIssuesForDuplicationSuspenseQuery>;
export type GetPrintIssuesForDuplicationQueryResult = Apollo.QueryResult<GetPrintIssuesForDuplicationQuery, GetPrintIssuesForDuplicationQueryVariables>;
export const GetPrintHeadingsForDuplicationDocument = gql`
    query GetPrintHeadingsForDuplication($where: PrintHeadingFilterInput, $orderBy: [PrintHeadingOrderingInput!], $skip: UnsignedInt, $first: UnsignedInt!) {
  printHeadings(where: $where, orderBy: $orderBy, skip: $skip, first: $first) {
    id
    title
  }
}
    `;

/**
 * __useGetPrintHeadingsForDuplicationQuery__
 *
 * To run a query within a React component, call `useGetPrintHeadingsForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintHeadingsForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintHeadingsForDuplicationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetPrintHeadingsForDuplicationQuery(baseOptions: Apollo.QueryHookOptions<GetPrintHeadingsForDuplicationQuery, GetPrintHeadingsForDuplicationQueryVariables> & ({ variables: GetPrintHeadingsForDuplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrintHeadingsForDuplicationQuery, GetPrintHeadingsForDuplicationQueryVariables>(GetPrintHeadingsForDuplicationDocument, options);
      }
export function useGetPrintHeadingsForDuplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrintHeadingsForDuplicationQuery, GetPrintHeadingsForDuplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrintHeadingsForDuplicationQuery, GetPrintHeadingsForDuplicationQueryVariables>(GetPrintHeadingsForDuplicationDocument, options);
        }
export function useGetPrintHeadingsForDuplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrintHeadingsForDuplicationQuery, GetPrintHeadingsForDuplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrintHeadingsForDuplicationQuery, GetPrintHeadingsForDuplicationQueryVariables>(GetPrintHeadingsForDuplicationDocument, options);
        }
export type GetPrintHeadingsForDuplicationQueryHookResult = ReturnType<typeof useGetPrintHeadingsForDuplicationQuery>;
export type GetPrintHeadingsForDuplicationLazyQueryHookResult = ReturnType<typeof useGetPrintHeadingsForDuplicationLazyQuery>;
export type GetPrintHeadingsForDuplicationSuspenseQueryHookResult = ReturnType<typeof useGetPrintHeadingsForDuplicationSuspenseQuery>;
export type GetPrintHeadingsForDuplicationQueryResult = Apollo.QueryResult<GetPrintHeadingsForDuplicationQuery, GetPrintHeadingsForDuplicationQueryVariables>;
export const GetUnitsForDuplicationDocument = gql`
    query GetUnitsForDuplication($where: UnitFilterInput, $orderBy: [UnitOrderingInput!], $skip: UnsignedInt, $first: UnsignedInt!) {
  units(where: $where, orderBy: $orderBy, skip: $skip, first: $first) {
    id
  }
}
    `;

/**
 * __useGetUnitsForDuplicationQuery__
 *
 * To run a query within a React component, call `useGetUnitsForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsForDuplicationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetUnitsForDuplicationQuery(baseOptions: Apollo.QueryHookOptions<GetUnitsForDuplicationQuery, GetUnitsForDuplicationQueryVariables> & ({ variables: GetUnitsForDuplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsForDuplicationQuery, GetUnitsForDuplicationQueryVariables>(GetUnitsForDuplicationDocument, options);
      }
export function useGetUnitsForDuplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsForDuplicationQuery, GetUnitsForDuplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsForDuplicationQuery, GetUnitsForDuplicationQueryVariables>(GetUnitsForDuplicationDocument, options);
        }
export function useGetUnitsForDuplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsForDuplicationQuery, GetUnitsForDuplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitsForDuplicationQuery, GetUnitsForDuplicationQueryVariables>(GetUnitsForDuplicationDocument, options);
        }
export type GetUnitsForDuplicationQueryHookResult = ReturnType<typeof useGetUnitsForDuplicationQuery>;
export type GetUnitsForDuplicationLazyQueryHookResult = ReturnType<typeof useGetUnitsForDuplicationLazyQuery>;
export type GetUnitsForDuplicationSuspenseQueryHookResult = ReturnType<typeof useGetUnitsForDuplicationSuspenseQuery>;
export type GetUnitsForDuplicationQueryResult = Apollo.QueryResult<GetUnitsForDuplicationQuery, GetUnitsForDuplicationQueryVariables>;
export const CreateSubjectForDuplicationDocument = gql`
    mutation CreateSubjectForDuplication($data: SubjectCreationInput!) {
  createSubject(data: $data) {
    assignments(first: 1) {
      id
    }
  }
}
    `;
export type CreateSubjectForDuplicationMutationFn = Apollo.MutationFunction<CreateSubjectForDuplicationMutation, CreateSubjectForDuplicationMutationVariables>;

/**
 * __useCreateSubjectForDuplicationMutation__
 *
 * To run a mutation, you first call `useCreateSubjectForDuplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubjectForDuplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubjectForDuplicationMutation, { data, loading, error }] = useCreateSubjectForDuplicationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSubjectForDuplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubjectForDuplicationMutation, CreateSubjectForDuplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubjectForDuplicationMutation, CreateSubjectForDuplicationMutationVariables>(CreateSubjectForDuplicationDocument, options);
      }
export type CreateSubjectForDuplicationMutationHookResult = ReturnType<typeof useCreateSubjectForDuplicationMutation>;
export type CreateSubjectForDuplicationMutationResult = Apollo.MutationResult<CreateSubjectForDuplicationMutation>;
export type CreateSubjectForDuplicationMutationOptions = Apollo.BaseMutationOptions<CreateSubjectForDuplicationMutation, CreateSubjectForDuplicationMutationVariables>;
export const UpdateAssignmentForDuplicationDocument = gql`
    mutation UpdateAssignmentForDuplication($data: AssignmentUpdateInput!, $where: AssignmentUniqueFilterInput!) {
  updateAssignment(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateAssignmentForDuplicationMutationFn = Apollo.MutationFunction<UpdateAssignmentForDuplicationMutation, UpdateAssignmentForDuplicationMutationVariables>;

/**
 * __useUpdateAssignmentForDuplicationMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentForDuplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentForDuplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentForDuplicationMutation, { data, loading, error }] = useUpdateAssignmentForDuplicationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateAssignmentForDuplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentForDuplicationMutation, UpdateAssignmentForDuplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentForDuplicationMutation, UpdateAssignmentForDuplicationMutationVariables>(UpdateAssignmentForDuplicationDocument, options);
      }
export type UpdateAssignmentForDuplicationMutationHookResult = ReturnType<typeof useUpdateAssignmentForDuplicationMutation>;
export type UpdateAssignmentForDuplicationMutationResult = Apollo.MutationResult<UpdateAssignmentForDuplicationMutation>;
export type UpdateAssignmentForDuplicationMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentForDuplicationMutation, UpdateAssignmentForDuplicationMutationVariables>;
export const GetAssignmentDocument = gql`
    query GetAssignment($id: UUID) {
  assignment(where: {id: $id}) {
    ...AssignmentFragment
  }
}
    ${AssignmentFragmentFragmentDoc}`;

/**
 * __useGetAssignmentQuery__
 *
 * To run a query within a React component, call `useGetAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssignmentQuery(baseOptions?: Apollo.QueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(GetAssignmentDocument, options);
      }
export function useGetAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(GetAssignmentDocument, options);
        }
export function useGetAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(GetAssignmentDocument, options);
        }
export type GetAssignmentQueryHookResult = ReturnType<typeof useGetAssignmentQuery>;
export type GetAssignmentLazyQueryHookResult = ReturnType<typeof useGetAssignmentLazyQuery>;
export type GetAssignmentSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentSuspenseQuery>;
export type GetAssignmentQueryResult = Apollo.QueryResult<GetAssignmentQuery, GetAssignmentQueryVariables>;
export const GetRawArticleDocument = gql`
    query GetRawArticle($id: UUID!, $versionId: UUID!) {
  rawArticle(where: {id: $id}) {
    id
    assignment {
      ...AssignmentFragment
    }
    versions(first: 10, where: {id: $versionId}) {
      ...ArticleForm_RawArticleVersionFragment
    }
  }
}
    ${AssignmentFragmentFragmentDoc}
${ArticleForm_RawArticleVersionFragmentFragmentDoc}`;

/**
 * __useGetRawArticleQuery__
 *
 * To run a query within a React component, call `useGetRawArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRawArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRawArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useGetRawArticleQuery(baseOptions: Apollo.QueryHookOptions<GetRawArticleQuery, GetRawArticleQueryVariables> & ({ variables: GetRawArticleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRawArticleQuery, GetRawArticleQueryVariables>(GetRawArticleDocument, options);
      }
export function useGetRawArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRawArticleQuery, GetRawArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRawArticleQuery, GetRawArticleQueryVariables>(GetRawArticleDocument, options);
        }
export function useGetRawArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRawArticleQuery, GetRawArticleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRawArticleQuery, GetRawArticleQueryVariables>(GetRawArticleDocument, options);
        }
export type GetRawArticleQueryHookResult = ReturnType<typeof useGetRawArticleQuery>;
export type GetRawArticleLazyQueryHookResult = ReturnType<typeof useGetRawArticleLazyQuery>;
export type GetRawArticleSuspenseQueryHookResult = ReturnType<typeof useGetRawArticleSuspenseQuery>;
export type GetRawArticleQueryResult = Apollo.QueryResult<GetRawArticleQuery, GetRawArticleQueryVariables>;